
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire77dd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire77dd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5aRSq", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hi5z5"));

});
parcelRegister("hi5z5", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $c9686f2ae6fd93b8$export$ffb0004e005737fa; }, function (v) { return $c9686f2ae6fd93b8$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $c9686f2ae6fd93b8$export$34b9dba7ce09269b; }, function (v) { return $c9686f2ae6fd93b8$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $c9686f2ae6fd93b8$export$25062201e9e25d76; }, function (v) { return $c9686f2ae6fd93b8$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9686f2ae6fd93b8$export$ffb0004e005737fa;
var $c9686f2ae6fd93b8$export$34b9dba7ce09269b;
var $c9686f2ae6fd93b8$export$25062201e9e25d76;
"use strict";

var $4Iuzv = parcelRequire("4Iuzv");
var $c9686f2ae6fd93b8$var$k = Symbol.for("react.element"), $c9686f2ae6fd93b8$var$l = Symbol.for("react.fragment"), $c9686f2ae6fd93b8$var$m = Object.prototype.hasOwnProperty, $c9686f2ae6fd93b8$var$n = $4Iuzv.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $c9686f2ae6fd93b8$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c9686f2ae6fd93b8$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$c9686f2ae6fd93b8$var$m.call(a, b) && !$c9686f2ae6fd93b8$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $c9686f2ae6fd93b8$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $c9686f2ae6fd93b8$var$n.current
    };
}
$c9686f2ae6fd93b8$export$ffb0004e005737fa = $c9686f2ae6fd93b8$var$l;
$c9686f2ae6fd93b8$export$34b9dba7ce09269b = $c9686f2ae6fd93b8$var$q;
$c9686f2ae6fd93b8$export$25062201e9e25d76 = $c9686f2ae6fd93b8$var$q;

});
parcelRegister("4Iuzv", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ip19S"));

});
parcelRegister("ip19S", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $d65b75cac4e2d5f6$export$dca3b0875bd9a954; }, function (v) { return $d65b75cac4e2d5f6$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $d65b75cac4e2d5f6$export$16fa2f45be04daa8; }, function (v) { return $d65b75cac4e2d5f6$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $d65b75cac4e2d5f6$export$ffb0004e005737fa; }, function (v) { return $d65b75cac4e2d5f6$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $d65b75cac4e2d5f6$export$e2c29f18771995cb; }, function (v) { return $d65b75cac4e2d5f6$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $d65b75cac4e2d5f6$export$221d75b3f55bb0bd; }, function (v) { return $d65b75cac4e2d5f6$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $d65b75cac4e2d5f6$export$5f8d39834fd61797; }, function (v) { return $d65b75cac4e2d5f6$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $d65b75cac4e2d5f6$export$74bf444e3cd11ea5; }, function (v) { return $d65b75cac4e2d5f6$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $d65b75cac4e2d5f6$export$ae55be85d98224ed; }, function (v) { return $d65b75cac4e2d5f6$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $d65b75cac4e2d5f6$export$e530037191fcd5d7; }, function (v) { return $d65b75cac4e2d5f6$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $d65b75cac4e2d5f6$export$fd42f52fd3ae1109; }, function (v) { return $d65b75cac4e2d5f6$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $d65b75cac4e2d5f6$export$c8a8987d4410bf2d; }, function (v) { return $d65b75cac4e2d5f6$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $d65b75cac4e2d5f6$export$d38cd72104c1f0e9; }, function (v) { return $d65b75cac4e2d5f6$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $d65b75cac4e2d5f6$export$7d1e3a5e95ceca43; }, function (v) { return $d65b75cac4e2d5f6$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $d65b75cac4e2d5f6$export$257a8862b851cb5b; }, function (v) { return $d65b75cac4e2d5f6$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $d65b75cac4e2d5f6$export$a8257692ac88316c; }, function (v) { return $d65b75cac4e2d5f6$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $d65b75cac4e2d5f6$export$488013bae63b21da; }, function (v) { return $d65b75cac4e2d5f6$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $d65b75cac4e2d5f6$export$7c73462e0d25e514; }, function (v) { return $d65b75cac4e2d5f6$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $d65b75cac4e2d5f6$export$7568632d0d33d16d; }, function (v) { return $d65b75cac4e2d5f6$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $d65b75cac4e2d5f6$export$88948ce120ea2619; }, function (v) { return $d65b75cac4e2d5f6$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $d65b75cac4e2d5f6$export$35808ee640e87ca7; }, function (v) { return $d65b75cac4e2d5f6$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $d65b75cac4e2d5f6$export$fae74005e78b1a27; }, function (v) { return $d65b75cac4e2d5f6$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $d65b75cac4e2d5f6$export$dc8fbce3eb94dc1e; }, function (v) { return $d65b75cac4e2d5f6$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $d65b75cac4e2d5f6$export$6a7bc4e911dc01cf; }, function (v) { return $d65b75cac4e2d5f6$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $d65b75cac4e2d5f6$export$6d9c69b0de29b591; }, function (v) { return $d65b75cac4e2d5f6$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $d65b75cac4e2d5f6$export$f680877a34711e37; }, function (v) { return $d65b75cac4e2d5f6$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $d65b75cac4e2d5f6$export$d5a552a76deda3c2; }, function (v) { return $d65b75cac4e2d5f6$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $d65b75cac4e2d5f6$export$aaabe4eda9ed9969; }, function (v) { return $d65b75cac4e2d5f6$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $d65b75cac4e2d5f6$export$e5c5a5f917a5871c; }, function (v) { return $d65b75cac4e2d5f6$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $d65b75cac4e2d5f6$export$1538c33de8887b59; }, function (v) { return $d65b75cac4e2d5f6$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $d65b75cac4e2d5f6$export$13e3392192263954; }, function (v) { return $d65b75cac4e2d5f6$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $d65b75cac4e2d5f6$export$b8f5890fc79d6aca; }, function (v) { return $d65b75cac4e2d5f6$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $d65b75cac4e2d5f6$export$60241385465d0a34; }, function (v) { return $d65b75cac4e2d5f6$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $d65b75cac4e2d5f6$export$306c0aa65ff9ec16; }, function (v) { return $d65b75cac4e2d5f6$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $d65b75cac4e2d5f6$export$7b286972b8d8ccbf; }, function (v) { return $d65b75cac4e2d5f6$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $d65b75cac4e2d5f6$export$83d89fbfd8236492; }, function (v) { return $d65b75cac4e2d5f6$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d65b75cac4e2d5f6$export$dca3b0875bd9a954;
var $d65b75cac4e2d5f6$export$16fa2f45be04daa8;
var $d65b75cac4e2d5f6$export$ffb0004e005737fa;
var $d65b75cac4e2d5f6$export$e2c29f18771995cb;
var $d65b75cac4e2d5f6$export$221d75b3f55bb0bd;
var $d65b75cac4e2d5f6$export$5f8d39834fd61797;
var $d65b75cac4e2d5f6$export$74bf444e3cd11ea5;
var $d65b75cac4e2d5f6$export$ae55be85d98224ed;
var $d65b75cac4e2d5f6$export$e530037191fcd5d7;
var $d65b75cac4e2d5f6$export$fd42f52fd3ae1109;
var $d65b75cac4e2d5f6$export$c8a8987d4410bf2d;
var $d65b75cac4e2d5f6$export$d38cd72104c1f0e9;
var $d65b75cac4e2d5f6$export$7d1e3a5e95ceca43;
var $d65b75cac4e2d5f6$export$257a8862b851cb5b;
var $d65b75cac4e2d5f6$export$a8257692ac88316c;
var $d65b75cac4e2d5f6$export$488013bae63b21da;
var $d65b75cac4e2d5f6$export$7c73462e0d25e514;
var $d65b75cac4e2d5f6$export$7568632d0d33d16d;
var $d65b75cac4e2d5f6$export$88948ce120ea2619;
var $d65b75cac4e2d5f6$export$35808ee640e87ca7;
var $d65b75cac4e2d5f6$export$fae74005e78b1a27;
var $d65b75cac4e2d5f6$export$dc8fbce3eb94dc1e;
var $d65b75cac4e2d5f6$export$6a7bc4e911dc01cf;
var $d65b75cac4e2d5f6$export$6d9c69b0de29b591;
var $d65b75cac4e2d5f6$export$f680877a34711e37;
var $d65b75cac4e2d5f6$export$d5a552a76deda3c2;
var $d65b75cac4e2d5f6$export$aaabe4eda9ed9969;
var $d65b75cac4e2d5f6$export$e5c5a5f917a5871c;
var $d65b75cac4e2d5f6$export$1538c33de8887b59;
var $d65b75cac4e2d5f6$export$13e3392192263954;
var $d65b75cac4e2d5f6$export$b8f5890fc79d6aca;
var $d65b75cac4e2d5f6$export$60241385465d0a34;
var $d65b75cac4e2d5f6$export$306c0aa65ff9ec16;
var $d65b75cac4e2d5f6$export$7b286972b8d8ccbf;
var $d65b75cac4e2d5f6$export$83d89fbfd8236492;
"use strict";
var $d65b75cac4e2d5f6$var$l = Symbol.for("react.element"), $d65b75cac4e2d5f6$var$n = Symbol.for("react.portal"), $d65b75cac4e2d5f6$var$p = Symbol.for("react.fragment"), $d65b75cac4e2d5f6$var$q = Symbol.for("react.strict_mode"), $d65b75cac4e2d5f6$var$r = Symbol.for("react.profiler"), $d65b75cac4e2d5f6$var$t = Symbol.for("react.provider"), $d65b75cac4e2d5f6$var$u = Symbol.for("react.context"), $d65b75cac4e2d5f6$var$v = Symbol.for("react.forward_ref"), $d65b75cac4e2d5f6$var$w = Symbol.for("react.suspense"), $d65b75cac4e2d5f6$var$x = Symbol.for("react.memo"), $d65b75cac4e2d5f6$var$y = Symbol.for("react.lazy"), $d65b75cac4e2d5f6$var$z = Symbol.iterator;
function $d65b75cac4e2d5f6$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $d65b75cac4e2d5f6$var$z && a[$d65b75cac4e2d5f6$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $d65b75cac4e2d5f6$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $d65b75cac4e2d5f6$var$C = Object.assign, $d65b75cac4e2d5f6$var$D = {};
function $d65b75cac4e2d5f6$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $d65b75cac4e2d5f6$var$D;
    this.updater = e || $d65b75cac4e2d5f6$var$B;
}
$d65b75cac4e2d5f6$var$E.prototype.isReactComponent = {};
$d65b75cac4e2d5f6$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$d65b75cac4e2d5f6$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $d65b75cac4e2d5f6$var$F() {}
$d65b75cac4e2d5f6$var$F.prototype = $d65b75cac4e2d5f6$var$E.prototype;
function $d65b75cac4e2d5f6$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $d65b75cac4e2d5f6$var$D;
    this.updater = e || $d65b75cac4e2d5f6$var$B;
}
var $d65b75cac4e2d5f6$var$H = $d65b75cac4e2d5f6$var$G.prototype = new $d65b75cac4e2d5f6$var$F;
$d65b75cac4e2d5f6$var$H.constructor = $d65b75cac4e2d5f6$var$G;
$d65b75cac4e2d5f6$var$C($d65b75cac4e2d5f6$var$H, $d65b75cac4e2d5f6$var$E.prototype);
$d65b75cac4e2d5f6$var$H.isPureReactComponent = !0;
var $d65b75cac4e2d5f6$var$I = Array.isArray, $d65b75cac4e2d5f6$var$J = Object.prototype.hasOwnProperty, $d65b75cac4e2d5f6$var$K = {
    current: null
}, $d65b75cac4e2d5f6$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d65b75cac4e2d5f6$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$d65b75cac4e2d5f6$var$J.call(b, d) && !$d65b75cac4e2d5f6$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $d65b75cac4e2d5f6$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $d65b75cac4e2d5f6$var$K.current
    };
}
function $d65b75cac4e2d5f6$var$N(a, b) {
    return {
        $$typeof: $d65b75cac4e2d5f6$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $d65b75cac4e2d5f6$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $d65b75cac4e2d5f6$var$l;
}
function $d65b75cac4e2d5f6$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $d65b75cac4e2d5f6$var$P = /\/+/g;
function $d65b75cac4e2d5f6$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $d65b75cac4e2d5f6$var$escape("" + a.key) : b.toString(36);
}
function $d65b75cac4e2d5f6$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $d65b75cac4e2d5f6$var$l:
                case $d65b75cac4e2d5f6$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $d65b75cac4e2d5f6$var$Q(h, 0) : d, $d65b75cac4e2d5f6$var$I(c) ? (e = "", null != a && (e = a.replace($d65b75cac4e2d5f6$var$P, "$&/") + "/"), $d65b75cac4e2d5f6$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($d65b75cac4e2d5f6$var$O(c) && (c = $d65b75cac4e2d5f6$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($d65b75cac4e2d5f6$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($d65b75cac4e2d5f6$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $d65b75cac4e2d5f6$var$Q(k, g);
        h += $d65b75cac4e2d5f6$var$R(k, b, e, f, c);
    }
    else if (f = $d65b75cac4e2d5f6$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $d65b75cac4e2d5f6$var$Q(k, g++), h += $d65b75cac4e2d5f6$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $d65b75cac4e2d5f6$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $d65b75cac4e2d5f6$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $d65b75cac4e2d5f6$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $d65b75cac4e2d5f6$var$U = {
    current: null
}, $d65b75cac4e2d5f6$var$V = {
    transition: null
}, $d65b75cac4e2d5f6$var$W = {
    ReactCurrentDispatcher: $d65b75cac4e2d5f6$var$U,
    ReactCurrentBatchConfig: $d65b75cac4e2d5f6$var$V,
    ReactCurrentOwner: $d65b75cac4e2d5f6$var$K
};
$d65b75cac4e2d5f6$export$dca3b0875bd9a954 = {
    map: $d65b75cac4e2d5f6$var$S,
    forEach: function(a, b, e) {
        $d65b75cac4e2d5f6$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $d65b75cac4e2d5f6$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $d65b75cac4e2d5f6$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$d65b75cac4e2d5f6$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$d65b75cac4e2d5f6$export$16fa2f45be04daa8 = $d65b75cac4e2d5f6$var$E;
$d65b75cac4e2d5f6$export$ffb0004e005737fa = $d65b75cac4e2d5f6$var$p;
$d65b75cac4e2d5f6$export$e2c29f18771995cb = $d65b75cac4e2d5f6$var$r;
$d65b75cac4e2d5f6$export$221d75b3f55bb0bd = $d65b75cac4e2d5f6$var$G;
$d65b75cac4e2d5f6$export$5f8d39834fd61797 = $d65b75cac4e2d5f6$var$q;
$d65b75cac4e2d5f6$export$74bf444e3cd11ea5 = $d65b75cac4e2d5f6$var$w;
$d65b75cac4e2d5f6$export$ae55be85d98224ed = $d65b75cac4e2d5f6$var$W;
$d65b75cac4e2d5f6$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $d65b75cac4e2d5f6$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $d65b75cac4e2d5f6$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$d65b75cac4e2d5f6$var$J.call(b, f) && !$d65b75cac4e2d5f6$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $d65b75cac4e2d5f6$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$d65b75cac4e2d5f6$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $d65b75cac4e2d5f6$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $d65b75cac4e2d5f6$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$d65b75cac4e2d5f6$export$c8a8987d4410bf2d = $d65b75cac4e2d5f6$var$M;
$d65b75cac4e2d5f6$export$d38cd72104c1f0e9 = function(a) {
    var b = $d65b75cac4e2d5f6$var$M.bind(null, a);
    b.type = a;
    return b;
};
$d65b75cac4e2d5f6$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$d65b75cac4e2d5f6$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $d65b75cac4e2d5f6$var$v,
        render: a
    };
};
$d65b75cac4e2d5f6$export$a8257692ac88316c = $d65b75cac4e2d5f6$var$O;
$d65b75cac4e2d5f6$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $d65b75cac4e2d5f6$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $d65b75cac4e2d5f6$var$T
    };
};
$d65b75cac4e2d5f6$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $d65b75cac4e2d5f6$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$d65b75cac4e2d5f6$export$7568632d0d33d16d = function(a) {
    var b = $d65b75cac4e2d5f6$var$V.transition;
    $d65b75cac4e2d5f6$var$V.transition = {};
    try {
        a();
    } finally{
        $d65b75cac4e2d5f6$var$V.transition = b;
    }
};
$d65b75cac4e2d5f6$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$d65b75cac4e2d5f6$export$35808ee640e87ca7 = function(a, b) {
    return $d65b75cac4e2d5f6$var$U.current.useCallback(a, b);
};
$d65b75cac4e2d5f6$export$fae74005e78b1a27 = function(a) {
    return $d65b75cac4e2d5f6$var$U.current.useContext(a);
};
$d65b75cac4e2d5f6$export$dc8fbce3eb94dc1e = function() {};
$d65b75cac4e2d5f6$export$6a7bc4e911dc01cf = function(a) {
    return $d65b75cac4e2d5f6$var$U.current.useDeferredValue(a);
};
$d65b75cac4e2d5f6$export$6d9c69b0de29b591 = function(a, b) {
    return $d65b75cac4e2d5f6$var$U.current.useEffect(a, b);
};
$d65b75cac4e2d5f6$export$f680877a34711e37 = function() {
    return $d65b75cac4e2d5f6$var$U.current.useId();
};
$d65b75cac4e2d5f6$export$d5a552a76deda3c2 = function(a, b, e) {
    return $d65b75cac4e2d5f6$var$U.current.useImperativeHandle(a, b, e);
};
$d65b75cac4e2d5f6$export$aaabe4eda9ed9969 = function(a, b) {
    return $d65b75cac4e2d5f6$var$U.current.useInsertionEffect(a, b);
};
$d65b75cac4e2d5f6$export$e5c5a5f917a5871c = function(a, b) {
    return $d65b75cac4e2d5f6$var$U.current.useLayoutEffect(a, b);
};
$d65b75cac4e2d5f6$export$1538c33de8887b59 = function(a, b) {
    return $d65b75cac4e2d5f6$var$U.current.useMemo(a, b);
};
$d65b75cac4e2d5f6$export$13e3392192263954 = function(a, b, e) {
    return $d65b75cac4e2d5f6$var$U.current.useReducer(a, b, e);
};
$d65b75cac4e2d5f6$export$b8f5890fc79d6aca = function(a) {
    return $d65b75cac4e2d5f6$var$U.current.useRef(a);
};
$d65b75cac4e2d5f6$export$60241385465d0a34 = function(a) {
    return $d65b75cac4e2d5f6$var$U.current.useState(a);
};
$d65b75cac4e2d5f6$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $d65b75cac4e2d5f6$var$U.current.useSyncExternalStore(a, b, e);
};
$d65b75cac4e2d5f6$export$7b286972b8d8ccbf = function() {
    return $d65b75cac4e2d5f6$var$U.current.useTransition();
};
$d65b75cac4e2d5f6$export$83d89fbfd8236492 = "18.2.0";

});




parcelRegister("68oCn", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $477696120c5741dc$export$ae55be85d98224ed; }, function (v) { return $477696120c5741dc$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $477696120c5741dc$export$d39a5bbd09211389; }, function (v) { return $477696120c5741dc$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $477696120c5741dc$export$882461b6382ed46c; }, function (v) { return $477696120c5741dc$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $477696120c5741dc$export$466bfc07425424d5; }, function (v) { return $477696120c5741dc$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $477696120c5741dc$export$cd75ccfd720a3cd4; }, function (v) { return $477696120c5741dc$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $477696120c5741dc$export$fa8d919ba61d84db; }, function (v) { return $477696120c5741dc$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $477696120c5741dc$export$757ceba2d55c277e; }, function (v) { return $477696120c5741dc$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $477696120c5741dc$export$b3890eb0ae9dca99; }, function (v) { return $477696120c5741dc$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $477696120c5741dc$export$502457920280e6be; }, function (v) { return $477696120c5741dc$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $477696120c5741dc$export$c78a37762a8d58e1; }, function (v) { return $477696120c5741dc$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $477696120c5741dc$export$dc54d992c10e8a18; }, function (v) { return $477696120c5741dc$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $477696120c5741dc$export$83d89fbfd8236492; }, function (v) { return $477696120c5741dc$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $477696120c5741dc$export$ae55be85d98224ed;
var $477696120c5741dc$export$d39a5bbd09211389;
var $477696120c5741dc$export$882461b6382ed46c;
var $477696120c5741dc$export$466bfc07425424d5;
var $477696120c5741dc$export$cd75ccfd720a3cd4;
var $477696120c5741dc$export$fa8d919ba61d84db;
var $477696120c5741dc$export$757ceba2d55c277e;
var $477696120c5741dc$export$b3890eb0ae9dca99;
var $477696120c5741dc$export$502457920280e6be;
var $477696120c5741dc$export$c78a37762a8d58e1;
var $477696120c5741dc$export$dc54d992c10e8a18;
var $477696120c5741dc$export$83d89fbfd8236492;
"use strict";

var $4Iuzv = parcelRequire("4Iuzv");

var $1c3ne = parcelRequire("1c3ne");
function $477696120c5741dc$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $477696120c5741dc$var$da = new Set, $477696120c5741dc$var$ea = {};
function $477696120c5741dc$var$fa(a, b) {
    $477696120c5741dc$var$ha(a, b);
    $477696120c5741dc$var$ha(a + "Capture", b);
}
function $477696120c5741dc$var$ha(a, b) {
    $477696120c5741dc$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$477696120c5741dc$var$da.add(b[a]);
}
var $477696120c5741dc$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $477696120c5741dc$var$ja = Object.prototype.hasOwnProperty, $477696120c5741dc$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $477696120c5741dc$var$la = {}, $477696120c5741dc$var$ma = {};
function $477696120c5741dc$var$oa(a) {
    if ($477696120c5741dc$var$ja.call($477696120c5741dc$var$ma, a)) return !0;
    if ($477696120c5741dc$var$ja.call($477696120c5741dc$var$la, a)) return !1;
    if ($477696120c5741dc$var$ka.test(a)) return $477696120c5741dc$var$ma[a] = !0;
    $477696120c5741dc$var$la[a] = !0;
    return !1;
}
function $477696120c5741dc$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $477696120c5741dc$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $477696120c5741dc$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $477696120c5741dc$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $477696120c5741dc$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $477696120c5741dc$var$z[b] = new $477696120c5741dc$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $477696120c5741dc$var$ra = /[\-:]([a-z])/g;
function $477696120c5741dc$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($477696120c5741dc$var$ra, $477696120c5741dc$var$sa);
    $477696120c5741dc$var$z[b] = new $477696120c5741dc$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($477696120c5741dc$var$ra, $477696120c5741dc$var$sa);
    $477696120c5741dc$var$z[b] = new $477696120c5741dc$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($477696120c5741dc$var$ra, $477696120c5741dc$var$sa);
    $477696120c5741dc$var$z[b] = new $477696120c5741dc$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$477696120c5741dc$var$z.xlinkHref = new $477696120c5741dc$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $477696120c5741dc$var$ta(a, b, c, d) {
    var e = $477696120c5741dc$var$z.hasOwnProperty(b) ? $477696120c5741dc$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $477696120c5741dc$var$qa(b, c, e, d) && (c = null), d || null === e ? $477696120c5741dc$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $477696120c5741dc$var$ua = $4Iuzv.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $477696120c5741dc$var$va = Symbol.for("react.element"), $477696120c5741dc$var$wa = Symbol.for("react.portal"), $477696120c5741dc$var$ya = Symbol.for("react.fragment"), $477696120c5741dc$var$za = Symbol.for("react.strict_mode"), $477696120c5741dc$var$Aa = Symbol.for("react.profiler"), $477696120c5741dc$var$Ba = Symbol.for("react.provider"), $477696120c5741dc$var$Ca = Symbol.for("react.context"), $477696120c5741dc$var$Da = Symbol.for("react.forward_ref"), $477696120c5741dc$var$Ea = Symbol.for("react.suspense"), $477696120c5741dc$var$Fa = Symbol.for("react.suspense_list"), $477696120c5741dc$var$Ga = Symbol.for("react.memo"), $477696120c5741dc$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $477696120c5741dc$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $477696120c5741dc$var$Ja = Symbol.iterator;
function $477696120c5741dc$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $477696120c5741dc$var$Ja && a[$477696120c5741dc$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $477696120c5741dc$var$A = Object.assign, $477696120c5741dc$var$La;
function $477696120c5741dc$var$Ma(a) {
    if (void 0 === $477696120c5741dc$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $477696120c5741dc$var$La = b && b[1] || "";
    }
    return "\n" + $477696120c5741dc$var$La + a;
}
var $477696120c5741dc$var$Na = !1;
function $477696120c5741dc$var$Oa(a, b) {
    if (!a || $477696120c5741dc$var$Na) return "";
    $477696120c5741dc$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $477696120c5741dc$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $477696120c5741dc$var$Ma(a) : "";
}
function $477696120c5741dc$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $477696120c5741dc$var$Ma(a.type);
        case 16:
            return $477696120c5741dc$var$Ma("Lazy");
        case 13:
            return $477696120c5741dc$var$Ma("Suspense");
        case 19:
            return $477696120c5741dc$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $477696120c5741dc$var$Oa(a.type, !1), a;
        case 11:
            return a = $477696120c5741dc$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $477696120c5741dc$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $477696120c5741dc$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $477696120c5741dc$var$ya:
            return "Fragment";
        case $477696120c5741dc$var$wa:
            return "Portal";
        case $477696120c5741dc$var$Aa:
            return "Profiler";
        case $477696120c5741dc$var$za:
            return "StrictMode";
        case $477696120c5741dc$var$Ea:
            return "Suspense";
        case $477696120c5741dc$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $477696120c5741dc$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $477696120c5741dc$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $477696120c5741dc$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $477696120c5741dc$var$Ga:
            return b = a.displayName || null, null !== b ? b : $477696120c5741dc$var$Qa(a.type) || "Memo";
        case $477696120c5741dc$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $477696120c5741dc$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $477696120c5741dc$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $477696120c5741dc$var$Qa(b);
        case 8:
            return b === $477696120c5741dc$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $477696120c5741dc$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $477696120c5741dc$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $477696120c5741dc$var$Ua(a) {
    var b = $477696120c5741dc$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $477696120c5741dc$var$Va(a) {
    a._valueTracker || (a._valueTracker = $477696120c5741dc$var$Ua(a));
}
function $477696120c5741dc$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $477696120c5741dc$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $477696120c5741dc$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $477696120c5741dc$var$Ya(a, b) {
    var c = b.checked;
    return $477696120c5741dc$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $477696120c5741dc$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $477696120c5741dc$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $477696120c5741dc$var$ab(a, b) {
    b = b.checked;
    null != b && $477696120c5741dc$var$ta(a, "checked", b, !1);
}
function $477696120c5741dc$var$bb(a, b) {
    $477696120c5741dc$var$ab(a, b);
    var c = $477696120c5741dc$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $477696120c5741dc$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $477696120c5741dc$var$cb(a, b.type, $477696120c5741dc$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $477696120c5741dc$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $477696120c5741dc$var$cb(a, b, c) {
    if ("number" !== b || $477696120c5741dc$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $477696120c5741dc$var$eb = Array.isArray;
function $477696120c5741dc$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $477696120c5741dc$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $477696120c5741dc$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($477696120c5741dc$var$p(91));
    return $477696120c5741dc$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $477696120c5741dc$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($477696120c5741dc$var$p(92));
            if ($477696120c5741dc$var$eb(c)) {
                if (1 < c.length) throw Error($477696120c5741dc$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $477696120c5741dc$var$Sa(c)
    };
}
function $477696120c5741dc$var$ib(a, b) {
    var c = $477696120c5741dc$var$Sa(b.value), d = $477696120c5741dc$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $477696120c5741dc$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $477696120c5741dc$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $477696120c5741dc$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $477696120c5741dc$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $477696120c5741dc$var$mb, $477696120c5741dc$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $477696120c5741dc$var$mb = $477696120c5741dc$var$mb || document.createElement("div");
        $477696120c5741dc$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $477696120c5741dc$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $477696120c5741dc$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $477696120c5741dc$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $477696120c5741dc$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($477696120c5741dc$var$pb).forEach(function(a) {
    $477696120c5741dc$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $477696120c5741dc$var$pb[b] = $477696120c5741dc$var$pb[a];
    });
});
function $477696120c5741dc$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $477696120c5741dc$var$pb.hasOwnProperty(a) && $477696120c5741dc$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $477696120c5741dc$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $477696120c5741dc$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $477696120c5741dc$var$tb = $477696120c5741dc$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $477696120c5741dc$var$ub(a, b) {
    if (b) {
        if ($477696120c5741dc$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($477696120c5741dc$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($477696120c5741dc$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($477696120c5741dc$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($477696120c5741dc$var$p(62));
    }
}
function $477696120c5741dc$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $477696120c5741dc$var$wb = null;
function $477696120c5741dc$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $477696120c5741dc$var$yb = null, $477696120c5741dc$var$zb = null, $477696120c5741dc$var$Ab = null;
function $477696120c5741dc$var$Bb(a) {
    if (a = $477696120c5741dc$var$Cb(a)) {
        if ("function" !== typeof $477696120c5741dc$var$yb) throw Error($477696120c5741dc$var$p(280));
        var b = a.stateNode;
        b && (b = $477696120c5741dc$var$Db(b), $477696120c5741dc$var$yb(a.stateNode, a.type, b));
    }
}
function $477696120c5741dc$var$Eb(a) {
    $477696120c5741dc$var$zb ? $477696120c5741dc$var$Ab ? $477696120c5741dc$var$Ab.push(a) : $477696120c5741dc$var$Ab = [
        a
    ] : $477696120c5741dc$var$zb = a;
}
function $477696120c5741dc$var$Fb() {
    if ($477696120c5741dc$var$zb) {
        var a = $477696120c5741dc$var$zb, b = $477696120c5741dc$var$Ab;
        $477696120c5741dc$var$Ab = $477696120c5741dc$var$zb = null;
        $477696120c5741dc$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$477696120c5741dc$var$Bb(b[a]);
    }
}
function $477696120c5741dc$var$Gb(a, b) {
    return a(b);
}
function $477696120c5741dc$var$Hb() {}
var $477696120c5741dc$var$Ib = !1;
function $477696120c5741dc$var$Jb(a, b, c) {
    if ($477696120c5741dc$var$Ib) return a(b, c);
    $477696120c5741dc$var$Ib = !0;
    try {
        return $477696120c5741dc$var$Gb(a, b, c);
    } finally{
        if ($477696120c5741dc$var$Ib = !1, null !== $477696120c5741dc$var$zb || null !== $477696120c5741dc$var$Ab) $477696120c5741dc$var$Hb(), $477696120c5741dc$var$Fb();
    }
}
function $477696120c5741dc$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $477696120c5741dc$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($477696120c5741dc$var$p(231, b, typeof c));
    return c;
}
var $477696120c5741dc$var$Lb = !1;
if ($477696120c5741dc$var$ia) try {
    var $477696120c5741dc$var$Mb = {};
    Object.defineProperty($477696120c5741dc$var$Mb, "passive", {
        get: function() {
            $477696120c5741dc$var$Lb = !0;
        }
    });
    window.addEventListener("test", $477696120c5741dc$var$Mb, $477696120c5741dc$var$Mb);
    window.removeEventListener("test", $477696120c5741dc$var$Mb, $477696120c5741dc$var$Mb);
} catch (a) {
    $477696120c5741dc$var$Lb = !1;
}
function $477696120c5741dc$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $477696120c5741dc$var$Ob = !1, $477696120c5741dc$var$Pb = null, $477696120c5741dc$var$Qb = !1, $477696120c5741dc$var$Rb = null, $477696120c5741dc$var$Sb = {
    onError: function(a) {
        $477696120c5741dc$var$Ob = !0;
        $477696120c5741dc$var$Pb = a;
    }
};
function $477696120c5741dc$var$Tb(a, b, c, d, e, f, g, h, k) {
    $477696120c5741dc$var$Ob = !1;
    $477696120c5741dc$var$Pb = null;
    $477696120c5741dc$var$Nb.apply($477696120c5741dc$var$Sb, arguments);
}
function $477696120c5741dc$var$Ub(a, b, c, d, e, f, g, h, k) {
    $477696120c5741dc$var$Tb.apply(this, arguments);
    if ($477696120c5741dc$var$Ob) {
        if ($477696120c5741dc$var$Ob) {
            var l = $477696120c5741dc$var$Pb;
            $477696120c5741dc$var$Ob = !1;
            $477696120c5741dc$var$Pb = null;
        } else throw Error($477696120c5741dc$var$p(198));
        $477696120c5741dc$var$Qb || ($477696120c5741dc$var$Qb = !0, $477696120c5741dc$var$Rb = l);
    }
}
function $477696120c5741dc$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $477696120c5741dc$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $477696120c5741dc$var$Xb(a) {
    if ($477696120c5741dc$var$Vb(a) !== a) throw Error($477696120c5741dc$var$p(188));
}
function $477696120c5741dc$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $477696120c5741dc$var$Vb(a);
        if (null === b) throw Error($477696120c5741dc$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $477696120c5741dc$var$Xb(e), a;
                if (f === d) return $477696120c5741dc$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($477696120c5741dc$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($477696120c5741dc$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($477696120c5741dc$var$p(190));
    }
    if (3 !== c.tag) throw Error($477696120c5741dc$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $477696120c5741dc$var$Zb(a) {
    a = $477696120c5741dc$var$Yb(a);
    return null !== a ? $477696120c5741dc$var$$b(a) : null;
}
function $477696120c5741dc$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $477696120c5741dc$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $477696120c5741dc$var$ac = $1c3ne.unstable_scheduleCallback, $477696120c5741dc$var$bc = $1c3ne.unstable_cancelCallback, $477696120c5741dc$var$cc = $1c3ne.unstable_shouldYield, $477696120c5741dc$var$dc = $1c3ne.unstable_requestPaint, $477696120c5741dc$var$B = $1c3ne.unstable_now, $477696120c5741dc$var$ec = $1c3ne.unstable_getCurrentPriorityLevel, $477696120c5741dc$var$fc = $1c3ne.unstable_ImmediatePriority, $477696120c5741dc$var$gc = $1c3ne.unstable_UserBlockingPriority, $477696120c5741dc$var$hc = $1c3ne.unstable_NormalPriority, $477696120c5741dc$var$ic = $1c3ne.unstable_LowPriority, $477696120c5741dc$var$jc = $1c3ne.unstable_IdlePriority, $477696120c5741dc$var$kc = null, $477696120c5741dc$var$lc = null;
function $477696120c5741dc$var$mc(a) {
    if ($477696120c5741dc$var$lc && "function" === typeof $477696120c5741dc$var$lc.onCommitFiberRoot) try {
        $477696120c5741dc$var$lc.onCommitFiberRoot($477696120c5741dc$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $477696120c5741dc$var$oc = Math.clz32 ? Math.clz32 : $477696120c5741dc$var$nc, $477696120c5741dc$var$pc = Math.log, $477696120c5741dc$var$qc = Math.LN2;
function $477696120c5741dc$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($477696120c5741dc$var$pc(a) / $477696120c5741dc$var$qc | 0) | 0;
}
var $477696120c5741dc$var$rc = 64, $477696120c5741dc$var$sc = 4194304;
function $477696120c5741dc$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $477696120c5741dc$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $477696120c5741dc$var$tc(h) : (f &= g, 0 !== f && (d = $477696120c5741dc$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $477696120c5741dc$var$tc(g) : 0 !== f && (d = $477696120c5741dc$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $477696120c5741dc$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $477696120c5741dc$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $477696120c5741dc$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $477696120c5741dc$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $477696120c5741dc$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $477696120c5741dc$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $477696120c5741dc$var$yc() {
    var a = $477696120c5741dc$var$rc;
    $477696120c5741dc$var$rc <<= 1;
    0 === ($477696120c5741dc$var$rc & 4194240) && ($477696120c5741dc$var$rc = 64);
    return a;
}
function $477696120c5741dc$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $477696120c5741dc$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $477696120c5741dc$var$oc(b);
    a[b] = c;
}
function $477696120c5741dc$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $477696120c5741dc$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $477696120c5741dc$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $477696120c5741dc$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $477696120c5741dc$var$C = 0;
function $477696120c5741dc$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $477696120c5741dc$var$Ec, $477696120c5741dc$var$Fc, $477696120c5741dc$var$Gc, $477696120c5741dc$var$Hc, $477696120c5741dc$var$Ic, $477696120c5741dc$var$Jc = !1, $477696120c5741dc$var$Kc = [], $477696120c5741dc$var$Lc = null, $477696120c5741dc$var$Mc = null, $477696120c5741dc$var$Nc = null, $477696120c5741dc$var$Oc = new Map, $477696120c5741dc$var$Pc = new Map, $477696120c5741dc$var$Qc = [], $477696120c5741dc$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $477696120c5741dc$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $477696120c5741dc$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $477696120c5741dc$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $477696120c5741dc$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $477696120c5741dc$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $477696120c5741dc$var$Pc.delete(b.pointerId);
    }
}
function $477696120c5741dc$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $477696120c5741dc$var$Cb(b), null !== b && $477696120c5741dc$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $477696120c5741dc$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $477696120c5741dc$var$Lc = $477696120c5741dc$var$Tc($477696120c5741dc$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $477696120c5741dc$var$Mc = $477696120c5741dc$var$Tc($477696120c5741dc$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $477696120c5741dc$var$Nc = $477696120c5741dc$var$Tc($477696120c5741dc$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $477696120c5741dc$var$Oc.set(f, $477696120c5741dc$var$Tc($477696120c5741dc$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $477696120c5741dc$var$Pc.set(f, $477696120c5741dc$var$Tc($477696120c5741dc$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $477696120c5741dc$var$Vc(a) {
    var b = $477696120c5741dc$var$Wc(a.target);
    if (null !== b) {
        var c = $477696120c5741dc$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $477696120c5741dc$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $477696120c5741dc$var$Ic(a.priority, function() {
                        $477696120c5741dc$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $477696120c5741dc$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $477696120c5741dc$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $477696120c5741dc$var$wb = d;
            c.target.dispatchEvent(d);
            $477696120c5741dc$var$wb = null;
        } else return b = $477696120c5741dc$var$Cb(c), null !== b && $477696120c5741dc$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $477696120c5741dc$var$Zc(a, b, c) {
    $477696120c5741dc$var$Xc(a) && c.delete(b);
}
function $477696120c5741dc$var$$c() {
    $477696120c5741dc$var$Jc = !1;
    null !== $477696120c5741dc$var$Lc && $477696120c5741dc$var$Xc($477696120c5741dc$var$Lc) && ($477696120c5741dc$var$Lc = null);
    null !== $477696120c5741dc$var$Mc && $477696120c5741dc$var$Xc($477696120c5741dc$var$Mc) && ($477696120c5741dc$var$Mc = null);
    null !== $477696120c5741dc$var$Nc && $477696120c5741dc$var$Xc($477696120c5741dc$var$Nc) && ($477696120c5741dc$var$Nc = null);
    $477696120c5741dc$var$Oc.forEach($477696120c5741dc$var$Zc);
    $477696120c5741dc$var$Pc.forEach($477696120c5741dc$var$Zc);
}
function $477696120c5741dc$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $477696120c5741dc$var$Jc || ($477696120c5741dc$var$Jc = !0, $1c3ne.unstable_scheduleCallback($1c3ne.unstable_NormalPriority, $477696120c5741dc$var$$c)));
}
function $477696120c5741dc$var$bd(a) {
    function b(b) {
        return $477696120c5741dc$var$ad(b, a);
    }
    if (0 < $477696120c5741dc$var$Kc.length) {
        $477696120c5741dc$var$ad($477696120c5741dc$var$Kc[0], a);
        for(var c = 1; c < $477696120c5741dc$var$Kc.length; c++){
            var d = $477696120c5741dc$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $477696120c5741dc$var$Lc && $477696120c5741dc$var$ad($477696120c5741dc$var$Lc, a);
    null !== $477696120c5741dc$var$Mc && $477696120c5741dc$var$ad($477696120c5741dc$var$Mc, a);
    null !== $477696120c5741dc$var$Nc && $477696120c5741dc$var$ad($477696120c5741dc$var$Nc, a);
    $477696120c5741dc$var$Oc.forEach(b);
    $477696120c5741dc$var$Pc.forEach(b);
    for(c = 0; c < $477696120c5741dc$var$Qc.length; c++)d = $477696120c5741dc$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $477696120c5741dc$var$Qc.length && (c = $477696120c5741dc$var$Qc[0], null === c.blockedOn);)$477696120c5741dc$var$Vc(c), null === c.blockedOn && $477696120c5741dc$var$Qc.shift();
}
var $477696120c5741dc$var$cd = $477696120c5741dc$var$ua.ReactCurrentBatchConfig, $477696120c5741dc$var$dd = !0;
function $477696120c5741dc$var$ed(a, b, c, d) {
    var e = $477696120c5741dc$var$C, f = $477696120c5741dc$var$cd.transition;
    $477696120c5741dc$var$cd.transition = null;
    try {
        $477696120c5741dc$var$C = 1, $477696120c5741dc$var$fd(a, b, c, d);
    } finally{
        $477696120c5741dc$var$C = e, $477696120c5741dc$var$cd.transition = f;
    }
}
function $477696120c5741dc$var$gd(a, b, c, d) {
    var e = $477696120c5741dc$var$C, f = $477696120c5741dc$var$cd.transition;
    $477696120c5741dc$var$cd.transition = null;
    try {
        $477696120c5741dc$var$C = 4, $477696120c5741dc$var$fd(a, b, c, d);
    } finally{
        $477696120c5741dc$var$C = e, $477696120c5741dc$var$cd.transition = f;
    }
}
function $477696120c5741dc$var$fd(a, b, c, d) {
    if ($477696120c5741dc$var$dd) {
        var e = $477696120c5741dc$var$Yc(a, b, c, d);
        if (null === e) $477696120c5741dc$var$hd(a, b, d, $477696120c5741dc$var$id, c), $477696120c5741dc$var$Sc(a, d);
        else if ($477696120c5741dc$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($477696120c5741dc$var$Sc(a, d), b & 4 && -1 < $477696120c5741dc$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $477696120c5741dc$var$Cb(e);
                null !== f && $477696120c5741dc$var$Ec(f);
                f = $477696120c5741dc$var$Yc(a, b, c, d);
                null === f && $477696120c5741dc$var$hd(a, b, d, $477696120c5741dc$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $477696120c5741dc$var$hd(a, b, d, null, c);
    }
}
var $477696120c5741dc$var$id = null;
function $477696120c5741dc$var$Yc(a, b, c, d) {
    $477696120c5741dc$var$id = null;
    a = $477696120c5741dc$var$xb(d);
    a = $477696120c5741dc$var$Wc(a);
    if (null !== a) {
        if (b = $477696120c5741dc$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $477696120c5741dc$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $477696120c5741dc$var$id = a;
    return null;
}
function $477696120c5741dc$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($477696120c5741dc$var$ec()){
                case $477696120c5741dc$var$fc:
                    return 1;
                case $477696120c5741dc$var$gc:
                    return 4;
                case $477696120c5741dc$var$hc:
                case $477696120c5741dc$var$ic:
                    return 16;
                case $477696120c5741dc$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $477696120c5741dc$var$kd = null, $477696120c5741dc$var$ld = null, $477696120c5741dc$var$md = null;
function $477696120c5741dc$var$nd() {
    if ($477696120c5741dc$var$md) return $477696120c5741dc$var$md;
    var a, b = $477696120c5741dc$var$ld, c = b.length, d, e = "value" in $477696120c5741dc$var$kd ? $477696120c5741dc$var$kd.value : $477696120c5741dc$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $477696120c5741dc$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $477696120c5741dc$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $477696120c5741dc$var$pd() {
    return !0;
}
function $477696120c5741dc$var$qd() {
    return !1;
}
function $477696120c5741dc$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $477696120c5741dc$var$pd : $477696120c5741dc$var$qd;
        this.isPropagationStopped = $477696120c5741dc$var$qd;
        return this;
    }
    $477696120c5741dc$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $477696120c5741dc$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $477696120c5741dc$var$pd);
        },
        persist: function() {},
        isPersistent: $477696120c5741dc$var$pd
    });
    return b;
}
var $477696120c5741dc$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $477696120c5741dc$var$td = $477696120c5741dc$var$rd($477696120c5741dc$var$sd), $477696120c5741dc$var$ud = $477696120c5741dc$var$A({}, $477696120c5741dc$var$sd, {
    view: 0,
    detail: 0
}), $477696120c5741dc$var$vd = $477696120c5741dc$var$rd($477696120c5741dc$var$ud), $477696120c5741dc$var$wd, $477696120c5741dc$var$xd, $477696120c5741dc$var$yd, $477696120c5741dc$var$Ad = $477696120c5741dc$var$A({}, $477696120c5741dc$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $477696120c5741dc$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $477696120c5741dc$var$yd && ($477696120c5741dc$var$yd && "mousemove" === a.type ? ($477696120c5741dc$var$wd = a.screenX - $477696120c5741dc$var$yd.screenX, $477696120c5741dc$var$xd = a.screenY - $477696120c5741dc$var$yd.screenY) : $477696120c5741dc$var$xd = $477696120c5741dc$var$wd = 0, $477696120c5741dc$var$yd = a);
        return $477696120c5741dc$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $477696120c5741dc$var$xd;
    }
}), $477696120c5741dc$var$Bd = $477696120c5741dc$var$rd($477696120c5741dc$var$Ad), $477696120c5741dc$var$Cd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$Ad, {
    dataTransfer: 0
}), $477696120c5741dc$var$Dd = $477696120c5741dc$var$rd($477696120c5741dc$var$Cd), $477696120c5741dc$var$Ed = $477696120c5741dc$var$A({}, $477696120c5741dc$var$ud, {
    relatedTarget: 0
}), $477696120c5741dc$var$Fd = $477696120c5741dc$var$rd($477696120c5741dc$var$Ed), $477696120c5741dc$var$Gd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $477696120c5741dc$var$Hd = $477696120c5741dc$var$rd($477696120c5741dc$var$Gd), $477696120c5741dc$var$Id = $477696120c5741dc$var$A({}, $477696120c5741dc$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $477696120c5741dc$var$Jd = $477696120c5741dc$var$rd($477696120c5741dc$var$Id), $477696120c5741dc$var$Kd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$sd, {
    data: 0
}), $477696120c5741dc$var$Ld = $477696120c5741dc$var$rd($477696120c5741dc$var$Kd), $477696120c5741dc$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $477696120c5741dc$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $477696120c5741dc$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $477696120c5741dc$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $477696120c5741dc$var$Od[a]) ? !!b[a] : !1;
}
function $477696120c5741dc$var$zd() {
    return $477696120c5741dc$var$Pd;
}
var $477696120c5741dc$var$Qd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $477696120c5741dc$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $477696120c5741dc$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $477696120c5741dc$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $477696120c5741dc$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $477696120c5741dc$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $477696120c5741dc$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $477696120c5741dc$var$Rd = $477696120c5741dc$var$rd($477696120c5741dc$var$Qd), $477696120c5741dc$var$Sd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $477696120c5741dc$var$Td = $477696120c5741dc$var$rd($477696120c5741dc$var$Sd), $477696120c5741dc$var$Ud = $477696120c5741dc$var$A({}, $477696120c5741dc$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $477696120c5741dc$var$zd
}), $477696120c5741dc$var$Vd = $477696120c5741dc$var$rd($477696120c5741dc$var$Ud), $477696120c5741dc$var$Wd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $477696120c5741dc$var$Xd = $477696120c5741dc$var$rd($477696120c5741dc$var$Wd), $477696120c5741dc$var$Yd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $477696120c5741dc$var$Zd = $477696120c5741dc$var$rd($477696120c5741dc$var$Yd), $477696120c5741dc$var$$d = [
    9,
    13,
    27,
    32
], $477696120c5741dc$var$ae = $477696120c5741dc$var$ia && "CompositionEvent" in window, $477696120c5741dc$var$be = null;
$477696120c5741dc$var$ia && "documentMode" in document && ($477696120c5741dc$var$be = document.documentMode);
var $477696120c5741dc$var$ce = $477696120c5741dc$var$ia && "TextEvent" in window && !$477696120c5741dc$var$be, $477696120c5741dc$var$de = $477696120c5741dc$var$ia && (!$477696120c5741dc$var$ae || $477696120c5741dc$var$be && 8 < $477696120c5741dc$var$be && 11 >= $477696120c5741dc$var$be), $477696120c5741dc$var$ee = String.fromCharCode(32), $477696120c5741dc$var$fe = !1;
function $477696120c5741dc$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $477696120c5741dc$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $477696120c5741dc$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $477696120c5741dc$var$ie = !1;
function $477696120c5741dc$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $477696120c5741dc$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $477696120c5741dc$var$fe = !0;
            return $477696120c5741dc$var$ee;
        case "textInput":
            return a = b.data, a === $477696120c5741dc$var$ee && $477696120c5741dc$var$fe ? null : a;
        default:
            return null;
    }
}
function $477696120c5741dc$var$ke(a, b) {
    if ($477696120c5741dc$var$ie) return "compositionend" === a || !$477696120c5741dc$var$ae && $477696120c5741dc$var$ge(a, b) ? (a = $477696120c5741dc$var$nd(), $477696120c5741dc$var$md = $477696120c5741dc$var$ld = $477696120c5741dc$var$kd = null, $477696120c5741dc$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $477696120c5741dc$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $477696120c5741dc$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $477696120c5741dc$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$477696120c5741dc$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $477696120c5741dc$var$ne(a, b, c, d) {
    $477696120c5741dc$var$Eb(d);
    b = $477696120c5741dc$var$oe(b, "onChange");
    0 < b.length && (c = new $477696120c5741dc$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $477696120c5741dc$var$pe = null, $477696120c5741dc$var$qe = null;
function $477696120c5741dc$var$re(a) {
    $477696120c5741dc$var$se(a, 0);
}
function $477696120c5741dc$var$te(a) {
    var b = $477696120c5741dc$var$ue(a);
    if ($477696120c5741dc$var$Wa(b)) return a;
}
function $477696120c5741dc$var$ve(a, b) {
    if ("change" === a) return b;
}
var $477696120c5741dc$var$we = !1;
if ($477696120c5741dc$var$ia) {
    var $477696120c5741dc$var$xe;
    if ($477696120c5741dc$var$ia) {
        var $477696120c5741dc$var$ye = "oninput" in document;
        if (!$477696120c5741dc$var$ye) {
            var $477696120c5741dc$var$ze = document.createElement("div");
            $477696120c5741dc$var$ze.setAttribute("oninput", "return;");
            $477696120c5741dc$var$ye = "function" === typeof $477696120c5741dc$var$ze.oninput;
        }
        $477696120c5741dc$var$xe = $477696120c5741dc$var$ye;
    } else $477696120c5741dc$var$xe = !1;
    $477696120c5741dc$var$we = $477696120c5741dc$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $477696120c5741dc$var$Ae() {
    $477696120c5741dc$var$pe && ($477696120c5741dc$var$pe.detachEvent("onpropertychange", $477696120c5741dc$var$Be), $477696120c5741dc$var$qe = $477696120c5741dc$var$pe = null);
}
function $477696120c5741dc$var$Be(a) {
    if ("value" === a.propertyName && $477696120c5741dc$var$te($477696120c5741dc$var$qe)) {
        var b = [];
        $477696120c5741dc$var$ne(b, $477696120c5741dc$var$qe, a, $477696120c5741dc$var$xb(a));
        $477696120c5741dc$var$Jb($477696120c5741dc$var$re, b);
    }
}
function $477696120c5741dc$var$Ce(a, b, c) {
    "focusin" === a ? ($477696120c5741dc$var$Ae(), $477696120c5741dc$var$pe = b, $477696120c5741dc$var$qe = c, $477696120c5741dc$var$pe.attachEvent("onpropertychange", $477696120c5741dc$var$Be)) : "focusout" === a && $477696120c5741dc$var$Ae();
}
function $477696120c5741dc$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $477696120c5741dc$var$te($477696120c5741dc$var$qe);
}
function $477696120c5741dc$var$Ee(a, b) {
    if ("click" === a) return $477696120c5741dc$var$te(b);
}
function $477696120c5741dc$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $477696120c5741dc$var$te(b);
}
function $477696120c5741dc$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $477696120c5741dc$var$He = "function" === typeof Object.is ? Object.is : $477696120c5741dc$var$Ge;
function $477696120c5741dc$var$Ie(a, b) {
    if ($477696120c5741dc$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$477696120c5741dc$var$ja.call(b, e) || !$477696120c5741dc$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $477696120c5741dc$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $477696120c5741dc$var$Ke(a, b) {
    var c = $477696120c5741dc$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $477696120c5741dc$var$Je(c);
    }
}
function $477696120c5741dc$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $477696120c5741dc$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $477696120c5741dc$var$Me() {
    for(var a = window, b = $477696120c5741dc$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $477696120c5741dc$var$Xa(a.document);
    }
    return b;
}
function $477696120c5741dc$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $477696120c5741dc$var$Oe(a) {
    var b = $477696120c5741dc$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $477696120c5741dc$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $477696120c5741dc$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $477696120c5741dc$var$Ke(c, f);
                var g = $477696120c5741dc$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $477696120c5741dc$var$Pe = $477696120c5741dc$var$ia && "documentMode" in document && 11 >= document.documentMode, $477696120c5741dc$var$Qe = null, $477696120c5741dc$var$Re = null, $477696120c5741dc$var$Se = null, $477696120c5741dc$var$Te = !1;
function $477696120c5741dc$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $477696120c5741dc$var$Te || null == $477696120c5741dc$var$Qe || $477696120c5741dc$var$Qe !== $477696120c5741dc$var$Xa(d) || (d = $477696120c5741dc$var$Qe, "selectionStart" in d && $477696120c5741dc$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $477696120c5741dc$var$Se && $477696120c5741dc$var$Ie($477696120c5741dc$var$Se, d) || ($477696120c5741dc$var$Se = d, d = $477696120c5741dc$var$oe($477696120c5741dc$var$Re, "onSelect"), 0 < d.length && (b = new $477696120c5741dc$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $477696120c5741dc$var$Qe)));
}
function $477696120c5741dc$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $477696120c5741dc$var$We = {
    animationend: $477696120c5741dc$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $477696120c5741dc$var$Ve("Animation", "AnimationIteration"),
    animationstart: $477696120c5741dc$var$Ve("Animation", "AnimationStart"),
    transitionend: $477696120c5741dc$var$Ve("Transition", "TransitionEnd")
}, $477696120c5741dc$var$Xe = {}, $477696120c5741dc$var$Ye = {};
$477696120c5741dc$var$ia && ($477696120c5741dc$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $477696120c5741dc$var$We.animationend.animation, delete $477696120c5741dc$var$We.animationiteration.animation, delete $477696120c5741dc$var$We.animationstart.animation), "TransitionEvent" in window || delete $477696120c5741dc$var$We.transitionend.transition);
function $477696120c5741dc$var$Ze(a) {
    if ($477696120c5741dc$var$Xe[a]) return $477696120c5741dc$var$Xe[a];
    if (!$477696120c5741dc$var$We[a]) return a;
    var b = $477696120c5741dc$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $477696120c5741dc$var$Ye) return $477696120c5741dc$var$Xe[a] = b[c];
    return a;
}
var $477696120c5741dc$var$$e = $477696120c5741dc$var$Ze("animationend"), $477696120c5741dc$var$af = $477696120c5741dc$var$Ze("animationiteration"), $477696120c5741dc$var$bf = $477696120c5741dc$var$Ze("animationstart"), $477696120c5741dc$var$cf = $477696120c5741dc$var$Ze("transitionend"), $477696120c5741dc$var$df = new Map, $477696120c5741dc$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $477696120c5741dc$var$ff(a, b) {
    $477696120c5741dc$var$df.set(a, b);
    $477696120c5741dc$var$fa(b, [
        a
    ]);
}
for(var $477696120c5741dc$var$gf = 0; $477696120c5741dc$var$gf < $477696120c5741dc$var$ef.length; $477696120c5741dc$var$gf++){
    var $477696120c5741dc$var$hf = $477696120c5741dc$var$ef[$477696120c5741dc$var$gf], $477696120c5741dc$var$jf = $477696120c5741dc$var$hf.toLowerCase(), $477696120c5741dc$var$kf = $477696120c5741dc$var$hf[0].toUpperCase() + $477696120c5741dc$var$hf.slice(1);
    $477696120c5741dc$var$ff($477696120c5741dc$var$jf, "on" + $477696120c5741dc$var$kf);
}
$477696120c5741dc$var$ff($477696120c5741dc$var$$e, "onAnimationEnd");
$477696120c5741dc$var$ff($477696120c5741dc$var$af, "onAnimationIteration");
$477696120c5741dc$var$ff($477696120c5741dc$var$bf, "onAnimationStart");
$477696120c5741dc$var$ff("dblclick", "onDoubleClick");
$477696120c5741dc$var$ff("focusin", "onFocus");
$477696120c5741dc$var$ff("focusout", "onBlur");
$477696120c5741dc$var$ff($477696120c5741dc$var$cf, "onTransitionEnd");
$477696120c5741dc$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$477696120c5741dc$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$477696120c5741dc$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$477696120c5741dc$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$477696120c5741dc$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$477696120c5741dc$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$477696120c5741dc$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$477696120c5741dc$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$477696120c5741dc$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$477696120c5741dc$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $477696120c5741dc$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $477696120c5741dc$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($477696120c5741dc$var$lf));
function $477696120c5741dc$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $477696120c5741dc$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $477696120c5741dc$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $477696120c5741dc$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $477696120c5741dc$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($477696120c5741dc$var$Qb) throw a = $477696120c5741dc$var$Rb, $477696120c5741dc$var$Qb = !1, $477696120c5741dc$var$Rb = null, a;
}
function $477696120c5741dc$var$D(a, b) {
    var c = b[$477696120c5741dc$var$of];
    void 0 === c && (c = b[$477696120c5741dc$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($477696120c5741dc$var$pf(b, a, 2, !1), c.add(d));
}
function $477696120c5741dc$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $477696120c5741dc$var$pf(c, a, d, b);
}
var $477696120c5741dc$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $477696120c5741dc$var$sf(a) {
    if (!a[$477696120c5741dc$var$rf]) {
        a[$477696120c5741dc$var$rf] = !0;
        $477696120c5741dc$var$da.forEach(function(b) {
            "selectionchange" !== b && ($477696120c5741dc$var$mf.has(b) || $477696120c5741dc$var$qf(b, !1, a), $477696120c5741dc$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$477696120c5741dc$var$rf] || (b[$477696120c5741dc$var$rf] = !0, $477696120c5741dc$var$qf("selectionchange", !1, b));
    }
}
function $477696120c5741dc$var$pf(a, b, c, d) {
    switch($477696120c5741dc$var$jd(b)){
        case 1:
            var e = $477696120c5741dc$var$ed;
            break;
        case 4:
            e = $477696120c5741dc$var$gd;
            break;
        default:
            e = $477696120c5741dc$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$477696120c5741dc$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $477696120c5741dc$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $477696120c5741dc$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $477696120c5741dc$var$Jb(function() {
        var d = f, e = $477696120c5741dc$var$xb(c), g = [];
        a: {
            var h = $477696120c5741dc$var$df.get(a);
            if (void 0 !== h) {
                var k = $477696120c5741dc$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $477696120c5741dc$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $477696120c5741dc$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $477696120c5741dc$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $477696120c5741dc$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $477696120c5741dc$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $477696120c5741dc$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $477696120c5741dc$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $477696120c5741dc$var$Vd;
                        break;
                    case $477696120c5741dc$var$$e:
                    case $477696120c5741dc$var$af:
                    case $477696120c5741dc$var$bf:
                        k = $477696120c5741dc$var$Hd;
                        break;
                    case $477696120c5741dc$var$cf:
                        k = $477696120c5741dc$var$Xd;
                        break;
                    case "scroll":
                        k = $477696120c5741dc$var$vd;
                        break;
                    case "wheel":
                        k = $477696120c5741dc$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $477696120c5741dc$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $477696120c5741dc$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $477696120c5741dc$var$Kb(w, x), null != F && t.push($477696120c5741dc$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $477696120c5741dc$var$wb && (n = c.relatedTarget || c.fromElement) && ($477696120c5741dc$var$Wc(n) || n[$477696120c5741dc$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $477696120c5741dc$var$Wc(n) : null, null !== n && (J = $477696120c5741dc$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $477696120c5741dc$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $477696120c5741dc$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $477696120c5741dc$var$ue(k);
                        u = null == n ? h : $477696120c5741dc$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $477696120c5741dc$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $477696120c5741dc$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $477696120c5741dc$var$vf(F))u++;
                            for(; 0 < w - u;)t = $477696120c5741dc$var$vf(t), w--;
                            for(; 0 < u - w;)x = $477696120c5741dc$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $477696120c5741dc$var$vf(t);
                                x = $477696120c5741dc$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $477696120c5741dc$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $477696120c5741dc$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $477696120c5741dc$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $477696120c5741dc$var$ve;
                else if ($477696120c5741dc$var$me(h)) {
                    if ($477696120c5741dc$var$we) na = $477696120c5741dc$var$Fe;
                    else {
                        na = $477696120c5741dc$var$De;
                        var xa = $477696120c5741dc$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $477696120c5741dc$var$Ee);
                if (na && (na = na(a, d))) {
                    $477696120c5741dc$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $477696120c5741dc$var$cb(h, "number", h.value);
            }
            xa = d ? $477696120c5741dc$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($477696120c5741dc$var$me(xa) || "true" === xa.contentEditable) $477696120c5741dc$var$Qe = xa, $477696120c5741dc$var$Re = d, $477696120c5741dc$var$Se = null;
                    break;
                case "focusout":
                    $477696120c5741dc$var$Se = $477696120c5741dc$var$Re = $477696120c5741dc$var$Qe = null;
                    break;
                case "mousedown":
                    $477696120c5741dc$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $477696120c5741dc$var$Te = !1;
                    $477696120c5741dc$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($477696120c5741dc$var$Pe) break;
                case "keydown":
                case "keyup":
                    $477696120c5741dc$var$Ue(g, c, e);
            }
            var $a;
            if ($477696120c5741dc$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $477696120c5741dc$var$ie ? $477696120c5741dc$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($477696120c5741dc$var$de && "ko" !== c.locale && ($477696120c5741dc$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $477696120c5741dc$var$ie && ($a = $477696120c5741dc$var$nd()) : ($477696120c5741dc$var$kd = e, $477696120c5741dc$var$ld = "value" in $477696120c5741dc$var$kd ? $477696120c5741dc$var$kd.value : $477696120c5741dc$var$kd.textContent, $477696120c5741dc$var$ie = !0)), xa = $477696120c5741dc$var$oe(d, ba), 0 < xa.length && (ba = new $477696120c5741dc$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $477696120c5741dc$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $477696120c5741dc$var$ce ? $477696120c5741dc$var$je(a, c) : $477696120c5741dc$var$ke(a, c)) d = $477696120c5741dc$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $477696120c5741dc$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $477696120c5741dc$var$se(g, b);
    });
}
function $477696120c5741dc$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $477696120c5741dc$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $477696120c5741dc$var$Kb(a, c), null != f && d.unshift($477696120c5741dc$var$tf(a, f, e)), f = $477696120c5741dc$var$Kb(a, b), null != f && d.push($477696120c5741dc$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $477696120c5741dc$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $477696120c5741dc$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $477696120c5741dc$var$Kb(c, f), null != k && g.unshift($477696120c5741dc$var$tf(c, k, h))) : e || (k = $477696120c5741dc$var$Kb(c, f), null != k && g.push($477696120c5741dc$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $477696120c5741dc$var$xf = /\r\n?/g, $477696120c5741dc$var$yf = /\u0000|\uFFFD/g;
function $477696120c5741dc$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($477696120c5741dc$var$xf, "\n").replace($477696120c5741dc$var$yf, "");
}
function $477696120c5741dc$var$Af(a, b, c) {
    b = $477696120c5741dc$var$zf(b);
    if ($477696120c5741dc$var$zf(a) !== b && c) throw Error($477696120c5741dc$var$p(425));
}
function $477696120c5741dc$var$Bf() {}
var $477696120c5741dc$var$Cf = null, $477696120c5741dc$var$Df = null;
function $477696120c5741dc$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $477696120c5741dc$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $477696120c5741dc$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $477696120c5741dc$var$Hf = "function" === typeof Promise ? Promise : void 0, $477696120c5741dc$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $477696120c5741dc$var$Hf ? function(a) {
    return $477696120c5741dc$var$Hf.resolve(null).then(a).catch($477696120c5741dc$var$If);
} : $477696120c5741dc$var$Ff;
function $477696120c5741dc$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $477696120c5741dc$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $477696120c5741dc$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $477696120c5741dc$var$bd(b);
}
function $477696120c5741dc$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $477696120c5741dc$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $477696120c5741dc$var$Nf = Math.random().toString(36).slice(2), $477696120c5741dc$var$Of = "__reactFiber$" + $477696120c5741dc$var$Nf, $477696120c5741dc$var$Pf = "__reactProps$" + $477696120c5741dc$var$Nf, $477696120c5741dc$var$uf = "__reactContainer$" + $477696120c5741dc$var$Nf, $477696120c5741dc$var$of = "__reactEvents$" + $477696120c5741dc$var$Nf, $477696120c5741dc$var$Qf = "__reactListeners$" + $477696120c5741dc$var$Nf, $477696120c5741dc$var$Rf = "__reactHandles$" + $477696120c5741dc$var$Nf;
function $477696120c5741dc$var$Wc(a) {
    var b = a[$477696120c5741dc$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$477696120c5741dc$var$uf] || c[$477696120c5741dc$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $477696120c5741dc$var$Mf(a); null !== a;){
                if (c = a[$477696120c5741dc$var$Of]) return c;
                a = $477696120c5741dc$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $477696120c5741dc$var$Cb(a) {
    a = a[$477696120c5741dc$var$Of] || a[$477696120c5741dc$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $477696120c5741dc$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($477696120c5741dc$var$p(33));
}
function $477696120c5741dc$var$Db(a) {
    return a[$477696120c5741dc$var$Pf] || null;
}
var $477696120c5741dc$var$Sf = [], $477696120c5741dc$var$Tf = -1;
function $477696120c5741dc$var$Uf(a) {
    return {
        current: a
    };
}
function $477696120c5741dc$var$E(a) {
    0 > $477696120c5741dc$var$Tf || (a.current = $477696120c5741dc$var$Sf[$477696120c5741dc$var$Tf], $477696120c5741dc$var$Sf[$477696120c5741dc$var$Tf] = null, $477696120c5741dc$var$Tf--);
}
function $477696120c5741dc$var$G(a, b) {
    $477696120c5741dc$var$Tf++;
    $477696120c5741dc$var$Sf[$477696120c5741dc$var$Tf] = a.current;
    a.current = b;
}
var $477696120c5741dc$var$Vf = {}, $477696120c5741dc$var$H = $477696120c5741dc$var$Uf($477696120c5741dc$var$Vf), $477696120c5741dc$var$Wf = $477696120c5741dc$var$Uf(!1), $477696120c5741dc$var$Xf = $477696120c5741dc$var$Vf;
function $477696120c5741dc$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $477696120c5741dc$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $477696120c5741dc$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $477696120c5741dc$var$$f() {
    $477696120c5741dc$var$E($477696120c5741dc$var$Wf);
    $477696120c5741dc$var$E($477696120c5741dc$var$H);
}
function $477696120c5741dc$var$ag(a, b, c) {
    if ($477696120c5741dc$var$H.current !== $477696120c5741dc$var$Vf) throw Error($477696120c5741dc$var$p(168));
    $477696120c5741dc$var$G($477696120c5741dc$var$H, b);
    $477696120c5741dc$var$G($477696120c5741dc$var$Wf, c);
}
function $477696120c5741dc$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($477696120c5741dc$var$p(108, $477696120c5741dc$var$Ra(a) || "Unknown", e));
    return $477696120c5741dc$var$A({}, c, d);
}
function $477696120c5741dc$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $477696120c5741dc$var$Vf;
    $477696120c5741dc$var$Xf = $477696120c5741dc$var$H.current;
    $477696120c5741dc$var$G($477696120c5741dc$var$H, a);
    $477696120c5741dc$var$G($477696120c5741dc$var$Wf, $477696120c5741dc$var$Wf.current);
    return !0;
}
function $477696120c5741dc$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($477696120c5741dc$var$p(169));
    c ? (a = $477696120c5741dc$var$bg(a, b, $477696120c5741dc$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $477696120c5741dc$var$E($477696120c5741dc$var$Wf), $477696120c5741dc$var$E($477696120c5741dc$var$H), $477696120c5741dc$var$G($477696120c5741dc$var$H, a)) : $477696120c5741dc$var$E($477696120c5741dc$var$Wf);
    $477696120c5741dc$var$G($477696120c5741dc$var$Wf, c);
}
var $477696120c5741dc$var$eg = null, $477696120c5741dc$var$fg = !1, $477696120c5741dc$var$gg = !1;
function $477696120c5741dc$var$hg(a) {
    null === $477696120c5741dc$var$eg ? $477696120c5741dc$var$eg = [
        a
    ] : $477696120c5741dc$var$eg.push(a);
}
function $477696120c5741dc$var$ig(a) {
    $477696120c5741dc$var$fg = !0;
    $477696120c5741dc$var$hg(a);
}
function $477696120c5741dc$var$jg() {
    if (!$477696120c5741dc$var$gg && null !== $477696120c5741dc$var$eg) {
        $477696120c5741dc$var$gg = !0;
        var a = 0, b = $477696120c5741dc$var$C;
        try {
            var c = $477696120c5741dc$var$eg;
            for($477696120c5741dc$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $477696120c5741dc$var$eg = null;
            $477696120c5741dc$var$fg = !1;
        } catch (e) {
            throw null !== $477696120c5741dc$var$eg && ($477696120c5741dc$var$eg = $477696120c5741dc$var$eg.slice(a + 1)), $477696120c5741dc$var$ac($477696120c5741dc$var$fc, $477696120c5741dc$var$jg), e;
        } finally{
            $477696120c5741dc$var$C = b, $477696120c5741dc$var$gg = !1;
        }
    }
    return null;
}
var $477696120c5741dc$var$kg = [], $477696120c5741dc$var$lg = 0, $477696120c5741dc$var$mg = null, $477696120c5741dc$var$ng = 0, $477696120c5741dc$var$og = [], $477696120c5741dc$var$pg = 0, $477696120c5741dc$var$qg = null, $477696120c5741dc$var$rg = 1, $477696120c5741dc$var$sg = "";
function $477696120c5741dc$var$tg(a, b) {
    $477696120c5741dc$var$kg[$477696120c5741dc$var$lg++] = $477696120c5741dc$var$ng;
    $477696120c5741dc$var$kg[$477696120c5741dc$var$lg++] = $477696120c5741dc$var$mg;
    $477696120c5741dc$var$mg = a;
    $477696120c5741dc$var$ng = b;
}
function $477696120c5741dc$var$ug(a, b, c) {
    $477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$rg;
    $477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$sg;
    $477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$qg;
    $477696120c5741dc$var$qg = a;
    var d = $477696120c5741dc$var$rg;
    a = $477696120c5741dc$var$sg;
    var e = 32 - $477696120c5741dc$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $477696120c5741dc$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $477696120c5741dc$var$rg = 1 << 32 - $477696120c5741dc$var$oc(b) + e | c << e | d;
        $477696120c5741dc$var$sg = f + a;
    } else $477696120c5741dc$var$rg = 1 << f | c << e | d, $477696120c5741dc$var$sg = a;
}
function $477696120c5741dc$var$vg(a) {
    null !== a.return && ($477696120c5741dc$var$tg(a, 1), $477696120c5741dc$var$ug(a, 1, 0));
}
function $477696120c5741dc$var$wg(a) {
    for(; a === $477696120c5741dc$var$mg;)$477696120c5741dc$var$mg = $477696120c5741dc$var$kg[--$477696120c5741dc$var$lg], $477696120c5741dc$var$kg[$477696120c5741dc$var$lg] = null, $477696120c5741dc$var$ng = $477696120c5741dc$var$kg[--$477696120c5741dc$var$lg], $477696120c5741dc$var$kg[$477696120c5741dc$var$lg] = null;
    for(; a === $477696120c5741dc$var$qg;)$477696120c5741dc$var$qg = $477696120c5741dc$var$og[--$477696120c5741dc$var$pg], $477696120c5741dc$var$og[$477696120c5741dc$var$pg] = null, $477696120c5741dc$var$sg = $477696120c5741dc$var$og[--$477696120c5741dc$var$pg], $477696120c5741dc$var$og[$477696120c5741dc$var$pg] = null, $477696120c5741dc$var$rg = $477696120c5741dc$var$og[--$477696120c5741dc$var$pg], $477696120c5741dc$var$og[$477696120c5741dc$var$pg] = null;
}
var $477696120c5741dc$var$xg = null, $477696120c5741dc$var$yg = null, $477696120c5741dc$var$I = !1, $477696120c5741dc$var$zg = null;
function $477696120c5741dc$var$Ag(a, b) {
    var c = $477696120c5741dc$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $477696120c5741dc$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $477696120c5741dc$var$xg = a, $477696120c5741dc$var$yg = $477696120c5741dc$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $477696120c5741dc$var$xg = a, $477696120c5741dc$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $477696120c5741dc$var$qg ? {
                id: $477696120c5741dc$var$rg,
                overflow: $477696120c5741dc$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $477696120c5741dc$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $477696120c5741dc$var$xg = a, $477696120c5741dc$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $477696120c5741dc$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $477696120c5741dc$var$Eg(a) {
    if ($477696120c5741dc$var$I) {
        var b = $477696120c5741dc$var$yg;
        if (b) {
            var c = b;
            if (!$477696120c5741dc$var$Cg(a, b)) {
                if ($477696120c5741dc$var$Dg(a)) throw Error($477696120c5741dc$var$p(418));
                b = $477696120c5741dc$var$Lf(c.nextSibling);
                var d = $477696120c5741dc$var$xg;
                b && $477696120c5741dc$var$Cg(a, b) ? $477696120c5741dc$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $477696120c5741dc$var$I = !1, $477696120c5741dc$var$xg = a);
            }
        } else {
            if ($477696120c5741dc$var$Dg(a)) throw Error($477696120c5741dc$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $477696120c5741dc$var$I = !1;
            $477696120c5741dc$var$xg = a;
        }
    }
}
function $477696120c5741dc$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $477696120c5741dc$var$xg = a;
}
function $477696120c5741dc$var$Gg(a) {
    if (a !== $477696120c5741dc$var$xg) return !1;
    if (!$477696120c5741dc$var$I) return $477696120c5741dc$var$Fg(a), $477696120c5741dc$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$477696120c5741dc$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $477696120c5741dc$var$yg)) {
        if ($477696120c5741dc$var$Dg(a)) throw $477696120c5741dc$var$Hg(), Error($477696120c5741dc$var$p(418));
        for(; b;)$477696120c5741dc$var$Ag(a, b), b = $477696120c5741dc$var$Lf(b.nextSibling);
    }
    $477696120c5741dc$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($477696120c5741dc$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $477696120c5741dc$var$yg = $477696120c5741dc$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $477696120c5741dc$var$yg = null;
        }
    } else $477696120c5741dc$var$yg = $477696120c5741dc$var$xg ? $477696120c5741dc$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $477696120c5741dc$var$Hg() {
    for(var a = $477696120c5741dc$var$yg; a;)a = $477696120c5741dc$var$Lf(a.nextSibling);
}
function $477696120c5741dc$var$Ig() {
    $477696120c5741dc$var$yg = $477696120c5741dc$var$xg = null;
    $477696120c5741dc$var$I = !1;
}
function $477696120c5741dc$var$Jg(a) {
    null === $477696120c5741dc$var$zg ? $477696120c5741dc$var$zg = [
        a
    ] : $477696120c5741dc$var$zg.push(a);
}
var $477696120c5741dc$var$Kg = $477696120c5741dc$var$ua.ReactCurrentBatchConfig;
function $477696120c5741dc$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $477696120c5741dc$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $477696120c5741dc$var$Mg = $477696120c5741dc$var$Uf(null), $477696120c5741dc$var$Ng = null, $477696120c5741dc$var$Og = null, $477696120c5741dc$var$Pg = null;
function $477696120c5741dc$var$Qg() {
    $477696120c5741dc$var$Pg = $477696120c5741dc$var$Og = $477696120c5741dc$var$Ng = null;
}
function $477696120c5741dc$var$Rg(a) {
    var b = $477696120c5741dc$var$Mg.current;
    $477696120c5741dc$var$E($477696120c5741dc$var$Mg);
    a._currentValue = b;
}
function $477696120c5741dc$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $477696120c5741dc$var$Tg(a, b) {
    $477696120c5741dc$var$Ng = a;
    $477696120c5741dc$var$Pg = $477696120c5741dc$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($477696120c5741dc$var$Ug = !0), a.firstContext = null);
}
function $477696120c5741dc$var$Vg(a) {
    var b = a._currentValue;
    if ($477696120c5741dc$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $477696120c5741dc$var$Og) {
            if (null === $477696120c5741dc$var$Ng) throw Error($477696120c5741dc$var$p(308));
            $477696120c5741dc$var$Og = a;
            $477696120c5741dc$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $477696120c5741dc$var$Og = $477696120c5741dc$var$Og.next = a;
    }
    return b;
}
var $477696120c5741dc$var$Wg = null;
function $477696120c5741dc$var$Xg(a) {
    null === $477696120c5741dc$var$Wg ? $477696120c5741dc$var$Wg = [
        a
    ] : $477696120c5741dc$var$Wg.push(a);
}
function $477696120c5741dc$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $477696120c5741dc$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $477696120c5741dc$var$Zg(a, d);
}
function $477696120c5741dc$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $477696120c5741dc$var$$g = !1;
function $477696120c5741dc$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $477696120c5741dc$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $477696120c5741dc$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $477696120c5741dc$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($477696120c5741dc$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $477696120c5741dc$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $477696120c5741dc$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $477696120c5741dc$var$Zg(a, c);
}
function $477696120c5741dc$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $477696120c5741dc$var$Cc(a, c);
    }
}
function $477696120c5741dc$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $477696120c5741dc$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $477696120c5741dc$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $477696120c5741dc$var$A({}, q, r);
                            break a;
                        case 2:
                            $477696120c5741dc$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $477696120c5741dc$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $477696120c5741dc$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($477696120c5741dc$var$p(191, e));
            e.call(d);
        }
    }
}
var $477696120c5741dc$var$jh = (new $4Iuzv.Component).refs;
function $477696120c5741dc$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $477696120c5741dc$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $477696120c5741dc$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $477696120c5741dc$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $477696120c5741dc$var$L(), e = $477696120c5741dc$var$lh(a), f = $477696120c5741dc$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $477696120c5741dc$var$dh(a, f, e);
        null !== b && ($477696120c5741dc$var$mh(b, a, e, d), $477696120c5741dc$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $477696120c5741dc$var$L(), e = $477696120c5741dc$var$lh(a), f = $477696120c5741dc$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $477696120c5741dc$var$dh(a, f, e);
        null !== b && ($477696120c5741dc$var$mh(b, a, e, d), $477696120c5741dc$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $477696120c5741dc$var$L(), d = $477696120c5741dc$var$lh(a), e = $477696120c5741dc$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $477696120c5741dc$var$dh(a, e, d);
        null !== b && ($477696120c5741dc$var$mh(b, a, d, c), $477696120c5741dc$var$eh(b, a, d));
    }
};
function $477696120c5741dc$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$477696120c5741dc$var$Ie(c, d) || !$477696120c5741dc$var$Ie(e, f) : !0;
}
function $477696120c5741dc$var$ph(a, b, c) {
    var d = !1, e = $477696120c5741dc$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $477696120c5741dc$var$Vg(f) : (e = $477696120c5741dc$var$Zf(b) ? $477696120c5741dc$var$Xf : $477696120c5741dc$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $477696120c5741dc$var$Yf(a, e) : $477696120c5741dc$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $477696120c5741dc$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $477696120c5741dc$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $477696120c5741dc$var$nh.enqueueReplaceState(b, b.state, null);
}
function $477696120c5741dc$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $477696120c5741dc$var$jh;
    $477696120c5741dc$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $477696120c5741dc$var$Vg(f) : (f = $477696120c5741dc$var$Zf(b) ? $477696120c5741dc$var$Xf : $477696120c5741dc$var$H.current, e.context = $477696120c5741dc$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($477696120c5741dc$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $477696120c5741dc$var$nh.enqueueReplaceState(e, e.state, null), $477696120c5741dc$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $477696120c5741dc$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($477696120c5741dc$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($477696120c5741dc$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $477696120c5741dc$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($477696120c5741dc$var$p(284));
        if (!c._owner) throw Error($477696120c5741dc$var$p(290, a));
    }
    return a;
}
function $477696120c5741dc$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($477696120c5741dc$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $477696120c5741dc$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $477696120c5741dc$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $477696120c5741dc$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $477696120c5741dc$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $477696120c5741dc$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $477696120c5741dc$var$Ha && $477696120c5741dc$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $477696120c5741dc$var$sh(a, b, c), d.return = a, d;
        d = $477696120c5741dc$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $477696120c5741dc$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $477696120c5741dc$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $477696120c5741dc$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $477696120c5741dc$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $477696120c5741dc$var$va:
                    return c = $477696120c5741dc$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $477696120c5741dc$var$sh(a, null, b), c.return = a, c;
                case $477696120c5741dc$var$wa:
                    return b = $477696120c5741dc$var$zh(b, a.mode, c), b.return = a, b;
                case $477696120c5741dc$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($477696120c5741dc$var$eb(b) || $477696120c5741dc$var$Ka(b)) return b = $477696120c5741dc$var$Ah(b, a.mode, c, null), b.return = a, b;
            $477696120c5741dc$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $477696120c5741dc$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $477696120c5741dc$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $477696120c5741dc$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($477696120c5741dc$var$eb(c) || $477696120c5741dc$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $477696120c5741dc$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $477696120c5741dc$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $477696120c5741dc$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $477696120c5741dc$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($477696120c5741dc$var$eb(d) || $477696120c5741dc$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $477696120c5741dc$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $477696120c5741dc$var$Ka(h);
        if ("function" !== typeof l) throw Error($477696120c5741dc$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($477696120c5741dc$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $477696120c5741dc$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $477696120c5741dc$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $477696120c5741dc$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $477696120c5741dc$var$Ha && $477696120c5741dc$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $477696120c5741dc$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $477696120c5741dc$var$ya ? (d = $477696120c5741dc$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $477696120c5741dc$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $477696120c5741dc$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $477696120c5741dc$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $477696120c5741dc$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $477696120c5741dc$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($477696120c5741dc$var$eb(f)) return n(a, d, f, h);
            if ($477696120c5741dc$var$Ka(f)) return t(a, d, f, h);
            $477696120c5741dc$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $477696120c5741dc$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $477696120c5741dc$var$Bh = $477696120c5741dc$var$vh(!0), $477696120c5741dc$var$Ch = $477696120c5741dc$var$vh(!1), $477696120c5741dc$var$Dh = {}, $477696120c5741dc$var$Eh = $477696120c5741dc$var$Uf($477696120c5741dc$var$Dh), $477696120c5741dc$var$Fh = $477696120c5741dc$var$Uf($477696120c5741dc$var$Dh), $477696120c5741dc$var$Gh = $477696120c5741dc$var$Uf($477696120c5741dc$var$Dh);
function $477696120c5741dc$var$Hh(a) {
    if (a === $477696120c5741dc$var$Dh) throw Error($477696120c5741dc$var$p(174));
    return a;
}
function $477696120c5741dc$var$Ih(a, b) {
    $477696120c5741dc$var$G($477696120c5741dc$var$Gh, b);
    $477696120c5741dc$var$G($477696120c5741dc$var$Fh, a);
    $477696120c5741dc$var$G($477696120c5741dc$var$Eh, $477696120c5741dc$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $477696120c5741dc$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $477696120c5741dc$var$lb(b, a);
    }
    $477696120c5741dc$var$E($477696120c5741dc$var$Eh);
    $477696120c5741dc$var$G($477696120c5741dc$var$Eh, b);
}
function $477696120c5741dc$var$Jh() {
    $477696120c5741dc$var$E($477696120c5741dc$var$Eh);
    $477696120c5741dc$var$E($477696120c5741dc$var$Fh);
    $477696120c5741dc$var$E($477696120c5741dc$var$Gh);
}
function $477696120c5741dc$var$Kh(a) {
    $477696120c5741dc$var$Hh($477696120c5741dc$var$Gh.current);
    var b = $477696120c5741dc$var$Hh($477696120c5741dc$var$Eh.current);
    var c = $477696120c5741dc$var$lb(b, a.type);
    b !== c && ($477696120c5741dc$var$G($477696120c5741dc$var$Fh, a), $477696120c5741dc$var$G($477696120c5741dc$var$Eh, c));
}
function $477696120c5741dc$var$Lh(a) {
    $477696120c5741dc$var$Fh.current === a && ($477696120c5741dc$var$E($477696120c5741dc$var$Eh), $477696120c5741dc$var$E($477696120c5741dc$var$Fh));
}
var $477696120c5741dc$var$M = $477696120c5741dc$var$Uf(0);
function $477696120c5741dc$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $477696120c5741dc$var$Nh = [];
function $477696120c5741dc$var$Oh() {
    for(var a = 0; a < $477696120c5741dc$var$Nh.length; a++)$477696120c5741dc$var$Nh[a]._workInProgressVersionPrimary = null;
    $477696120c5741dc$var$Nh.length = 0;
}
var $477696120c5741dc$var$Ph = $477696120c5741dc$var$ua.ReactCurrentDispatcher, $477696120c5741dc$var$Qh = $477696120c5741dc$var$ua.ReactCurrentBatchConfig, $477696120c5741dc$var$Rh = 0, $477696120c5741dc$var$N = null, $477696120c5741dc$var$O = null, $477696120c5741dc$var$P = null, $477696120c5741dc$var$Sh = !1, $477696120c5741dc$var$Th = !1, $477696120c5741dc$var$Uh = 0, $477696120c5741dc$var$Vh = 0;
function $477696120c5741dc$var$Q() {
    throw Error($477696120c5741dc$var$p(321));
}
function $477696120c5741dc$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$477696120c5741dc$var$He(a[c], b[c])) return !1;
    return !0;
}
function $477696120c5741dc$var$Xh(a, b, c, d, e, f) {
    $477696120c5741dc$var$Rh = f;
    $477696120c5741dc$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $477696120c5741dc$var$Ph.current = null === a || null === a.memoizedState ? $477696120c5741dc$var$Yh : $477696120c5741dc$var$Zh;
    a = c(d, e);
    if ($477696120c5741dc$var$Th) {
        f = 0;
        do {
            $477696120c5741dc$var$Th = !1;
            $477696120c5741dc$var$Uh = 0;
            if (25 <= f) throw Error($477696120c5741dc$var$p(301));
            f += 1;
            $477696120c5741dc$var$P = $477696120c5741dc$var$O = null;
            b.updateQueue = null;
            $477696120c5741dc$var$Ph.current = $477696120c5741dc$var$$h;
            a = c(d, e);
        }while ($477696120c5741dc$var$Th);
    }
    $477696120c5741dc$var$Ph.current = $477696120c5741dc$var$ai;
    b = null !== $477696120c5741dc$var$O && null !== $477696120c5741dc$var$O.next;
    $477696120c5741dc$var$Rh = 0;
    $477696120c5741dc$var$P = $477696120c5741dc$var$O = $477696120c5741dc$var$N = null;
    $477696120c5741dc$var$Sh = !1;
    if (b) throw Error($477696120c5741dc$var$p(300));
    return a;
}
function $477696120c5741dc$var$bi() {
    var a = 0 !== $477696120c5741dc$var$Uh;
    $477696120c5741dc$var$Uh = 0;
    return a;
}
function $477696120c5741dc$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $477696120c5741dc$var$P ? $477696120c5741dc$var$N.memoizedState = $477696120c5741dc$var$P = a : $477696120c5741dc$var$P = $477696120c5741dc$var$P.next = a;
    return $477696120c5741dc$var$P;
}
function $477696120c5741dc$var$di() {
    if (null === $477696120c5741dc$var$O) {
        var a = $477696120c5741dc$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $477696120c5741dc$var$O.next;
    var b = null === $477696120c5741dc$var$P ? $477696120c5741dc$var$N.memoizedState : $477696120c5741dc$var$P.next;
    if (null !== b) $477696120c5741dc$var$P = b, $477696120c5741dc$var$O = a;
    else {
        if (null === a) throw Error($477696120c5741dc$var$p(310));
        $477696120c5741dc$var$O = a;
        a = {
            memoizedState: $477696120c5741dc$var$O.memoizedState,
            baseState: $477696120c5741dc$var$O.baseState,
            baseQueue: $477696120c5741dc$var$O.baseQueue,
            queue: $477696120c5741dc$var$O.queue,
            next: null
        };
        null === $477696120c5741dc$var$P ? $477696120c5741dc$var$N.memoizedState = $477696120c5741dc$var$P = a : $477696120c5741dc$var$P = $477696120c5741dc$var$P.next = a;
    }
    return $477696120c5741dc$var$P;
}
function $477696120c5741dc$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $477696120c5741dc$var$fi(a) {
    var b = $477696120c5741dc$var$di(), c = b.queue;
    if (null === c) throw Error($477696120c5741dc$var$p(311));
    c.lastRenderedReducer = a;
    var d = $477696120c5741dc$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($477696120c5741dc$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $477696120c5741dc$var$N.lanes |= m;
                $477696120c5741dc$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $477696120c5741dc$var$He(d, b.memoizedState) || ($477696120c5741dc$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $477696120c5741dc$var$N.lanes |= f, $477696120c5741dc$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $477696120c5741dc$var$gi(a) {
    var b = $477696120c5741dc$var$di(), c = b.queue;
    if (null === c) throw Error($477696120c5741dc$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $477696120c5741dc$var$He(f, b.memoizedState) || ($477696120c5741dc$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $477696120c5741dc$var$hi() {}
function $477696120c5741dc$var$ii(a, b) {
    var c = $477696120c5741dc$var$N, d = $477696120c5741dc$var$di(), e = b(), f = !$477696120c5741dc$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $477696120c5741dc$var$Ug = !0);
    d = d.queue;
    $477696120c5741dc$var$ji($477696120c5741dc$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $477696120c5741dc$var$P && $477696120c5741dc$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $477696120c5741dc$var$li(9, $477696120c5741dc$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $477696120c5741dc$var$R) throw Error($477696120c5741dc$var$p(349));
        0 !== ($477696120c5741dc$var$Rh & 30) || $477696120c5741dc$var$ni(c, b, e);
    }
    return e;
}
function $477696120c5741dc$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $477696120c5741dc$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $477696120c5741dc$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $477696120c5741dc$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $477696120c5741dc$var$oi(b) && $477696120c5741dc$var$pi(a);
}
function $477696120c5741dc$var$ki(a, b, c) {
    return c(function() {
        $477696120c5741dc$var$oi(b) && $477696120c5741dc$var$pi(a);
    });
}
function $477696120c5741dc$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$477696120c5741dc$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $477696120c5741dc$var$pi(a) {
    var b = $477696120c5741dc$var$Zg(a, 1);
    null !== b && $477696120c5741dc$var$mh(b, a, 1, -1);
}
function $477696120c5741dc$var$qi(a) {
    var b = $477696120c5741dc$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $477696120c5741dc$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $477696120c5741dc$var$ri.bind(null, $477696120c5741dc$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $477696120c5741dc$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $477696120c5741dc$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $477696120c5741dc$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $477696120c5741dc$var$si() {
    return $477696120c5741dc$var$di().memoizedState;
}
function $477696120c5741dc$var$ti(a, b, c, d) {
    var e = $477696120c5741dc$var$ci();
    $477696120c5741dc$var$N.flags |= a;
    e.memoizedState = $477696120c5741dc$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $477696120c5741dc$var$ui(a, b, c, d) {
    var e = $477696120c5741dc$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $477696120c5741dc$var$O) {
        var g = $477696120c5741dc$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $477696120c5741dc$var$Wh(d, g.deps)) {
            e.memoizedState = $477696120c5741dc$var$li(b, c, f, d);
            return;
        }
    }
    $477696120c5741dc$var$N.flags |= a;
    e.memoizedState = $477696120c5741dc$var$li(1 | b, c, f, d);
}
function $477696120c5741dc$var$vi(a, b) {
    return $477696120c5741dc$var$ti(8390656, 8, a, b);
}
function $477696120c5741dc$var$ji(a, b) {
    return $477696120c5741dc$var$ui(2048, 8, a, b);
}
function $477696120c5741dc$var$wi(a, b) {
    return $477696120c5741dc$var$ui(4, 2, a, b);
}
function $477696120c5741dc$var$xi(a, b) {
    return $477696120c5741dc$var$ui(4, 4, a, b);
}
function $477696120c5741dc$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $477696120c5741dc$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $477696120c5741dc$var$ui(4, 4, $477696120c5741dc$var$yi.bind(null, b, a), c);
}
function $477696120c5741dc$var$Ai() {}
function $477696120c5741dc$var$Bi(a, b) {
    var c = $477696120c5741dc$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $477696120c5741dc$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $477696120c5741dc$var$Ci(a, b) {
    var c = $477696120c5741dc$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $477696120c5741dc$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $477696120c5741dc$var$Di(a, b, c) {
    if (0 === ($477696120c5741dc$var$Rh & 21)) return a.baseState && (a.baseState = !1, $477696120c5741dc$var$Ug = !0), a.memoizedState = c;
    $477696120c5741dc$var$He(c, b) || (c = $477696120c5741dc$var$yc(), $477696120c5741dc$var$N.lanes |= c, $477696120c5741dc$var$hh |= c, a.baseState = !0);
    return b;
}
function $477696120c5741dc$var$Ei(a, b) {
    var c = $477696120c5741dc$var$C;
    $477696120c5741dc$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $477696120c5741dc$var$Qh.transition;
    $477696120c5741dc$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $477696120c5741dc$var$C = c, $477696120c5741dc$var$Qh.transition = d;
    }
}
function $477696120c5741dc$var$Fi() {
    return $477696120c5741dc$var$di().memoizedState;
}
function $477696120c5741dc$var$Gi(a, b, c) {
    var d = $477696120c5741dc$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($477696120c5741dc$var$Hi(a)) $477696120c5741dc$var$Ii(b, c);
    else if (c = $477696120c5741dc$var$Yg(a, b, c, d), null !== c) {
        var e = $477696120c5741dc$var$L();
        $477696120c5741dc$var$mh(c, a, d, e);
        $477696120c5741dc$var$Ji(c, b, d);
    }
}
function $477696120c5741dc$var$ri(a, b, c) {
    var d = $477696120c5741dc$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($477696120c5741dc$var$Hi(a)) $477696120c5741dc$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($477696120c5741dc$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $477696120c5741dc$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $477696120c5741dc$var$Yg(a, b, e, d);
        null !== c && (e = $477696120c5741dc$var$L(), $477696120c5741dc$var$mh(c, a, d, e), $477696120c5741dc$var$Ji(c, b, d));
    }
}
function $477696120c5741dc$var$Hi(a) {
    var b = a.alternate;
    return a === $477696120c5741dc$var$N || null !== b && b === $477696120c5741dc$var$N;
}
function $477696120c5741dc$var$Ii(a, b) {
    $477696120c5741dc$var$Th = $477696120c5741dc$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $477696120c5741dc$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $477696120c5741dc$var$Cc(a, c);
    }
}
var $477696120c5741dc$var$ai = {
    readContext: $477696120c5741dc$var$Vg,
    useCallback: $477696120c5741dc$var$Q,
    useContext: $477696120c5741dc$var$Q,
    useEffect: $477696120c5741dc$var$Q,
    useImperativeHandle: $477696120c5741dc$var$Q,
    useInsertionEffect: $477696120c5741dc$var$Q,
    useLayoutEffect: $477696120c5741dc$var$Q,
    useMemo: $477696120c5741dc$var$Q,
    useReducer: $477696120c5741dc$var$Q,
    useRef: $477696120c5741dc$var$Q,
    useState: $477696120c5741dc$var$Q,
    useDebugValue: $477696120c5741dc$var$Q,
    useDeferredValue: $477696120c5741dc$var$Q,
    useTransition: $477696120c5741dc$var$Q,
    useMutableSource: $477696120c5741dc$var$Q,
    useSyncExternalStore: $477696120c5741dc$var$Q,
    useId: $477696120c5741dc$var$Q,
    unstable_isNewReconciler: !1
}, $477696120c5741dc$var$Yh = {
    readContext: $477696120c5741dc$var$Vg,
    useCallback: function(a, b) {
        $477696120c5741dc$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $477696120c5741dc$var$Vg,
    useEffect: $477696120c5741dc$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $477696120c5741dc$var$ti(4194308, 4, $477696120c5741dc$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $477696120c5741dc$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $477696120c5741dc$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $477696120c5741dc$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $477696120c5741dc$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $477696120c5741dc$var$Gi.bind(null, $477696120c5741dc$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $477696120c5741dc$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $477696120c5741dc$var$qi,
    useDebugValue: $477696120c5741dc$var$Ai,
    useDeferredValue: function(a) {
        return $477696120c5741dc$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $477696120c5741dc$var$qi(!1), b = a[0];
        a = $477696120c5741dc$var$Ei.bind(null, a[1]);
        $477696120c5741dc$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $477696120c5741dc$var$N, e = $477696120c5741dc$var$ci();
        if ($477696120c5741dc$var$I) {
            if (void 0 === c) throw Error($477696120c5741dc$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $477696120c5741dc$var$R) throw Error($477696120c5741dc$var$p(349));
            0 !== ($477696120c5741dc$var$Rh & 30) || $477696120c5741dc$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $477696120c5741dc$var$vi($477696120c5741dc$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $477696120c5741dc$var$li(9, $477696120c5741dc$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $477696120c5741dc$var$ci(), b = $477696120c5741dc$var$R.identifierPrefix;
        if ($477696120c5741dc$var$I) {
            var c = $477696120c5741dc$var$sg;
            var d = $477696120c5741dc$var$rg;
            c = (d & ~(1 << 32 - $477696120c5741dc$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $477696120c5741dc$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $477696120c5741dc$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $477696120c5741dc$var$Zh = {
    readContext: $477696120c5741dc$var$Vg,
    useCallback: $477696120c5741dc$var$Bi,
    useContext: $477696120c5741dc$var$Vg,
    useEffect: $477696120c5741dc$var$ji,
    useImperativeHandle: $477696120c5741dc$var$zi,
    useInsertionEffect: $477696120c5741dc$var$wi,
    useLayoutEffect: $477696120c5741dc$var$xi,
    useMemo: $477696120c5741dc$var$Ci,
    useReducer: $477696120c5741dc$var$fi,
    useRef: $477696120c5741dc$var$si,
    useState: function() {
        return $477696120c5741dc$var$fi($477696120c5741dc$var$ei);
    },
    useDebugValue: $477696120c5741dc$var$Ai,
    useDeferredValue: function(a) {
        var b = $477696120c5741dc$var$di();
        return $477696120c5741dc$var$Di(b, $477696120c5741dc$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $477696120c5741dc$var$fi($477696120c5741dc$var$ei)[0], b = $477696120c5741dc$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $477696120c5741dc$var$hi,
    useSyncExternalStore: $477696120c5741dc$var$ii,
    useId: $477696120c5741dc$var$Fi,
    unstable_isNewReconciler: !1
}, $477696120c5741dc$var$$h = {
    readContext: $477696120c5741dc$var$Vg,
    useCallback: $477696120c5741dc$var$Bi,
    useContext: $477696120c5741dc$var$Vg,
    useEffect: $477696120c5741dc$var$ji,
    useImperativeHandle: $477696120c5741dc$var$zi,
    useInsertionEffect: $477696120c5741dc$var$wi,
    useLayoutEffect: $477696120c5741dc$var$xi,
    useMemo: $477696120c5741dc$var$Ci,
    useReducer: $477696120c5741dc$var$gi,
    useRef: $477696120c5741dc$var$si,
    useState: function() {
        return $477696120c5741dc$var$gi($477696120c5741dc$var$ei);
    },
    useDebugValue: $477696120c5741dc$var$Ai,
    useDeferredValue: function(a) {
        var b = $477696120c5741dc$var$di();
        return null === $477696120c5741dc$var$O ? b.memoizedState = a : $477696120c5741dc$var$Di(b, $477696120c5741dc$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $477696120c5741dc$var$gi($477696120c5741dc$var$ei)[0], b = $477696120c5741dc$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $477696120c5741dc$var$hi,
    useSyncExternalStore: $477696120c5741dc$var$ii,
    useId: $477696120c5741dc$var$Fi,
    unstable_isNewReconciler: !1
};
function $477696120c5741dc$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $477696120c5741dc$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $477696120c5741dc$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $477696120c5741dc$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $477696120c5741dc$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $477696120c5741dc$var$Oi(a, b, c) {
    c = $477696120c5741dc$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $477696120c5741dc$var$Pi || ($477696120c5741dc$var$Pi = !0, $477696120c5741dc$var$Qi = d);
        $477696120c5741dc$var$Mi(a, b);
    };
    return c;
}
function $477696120c5741dc$var$Ri(a, b, c) {
    c = $477696120c5741dc$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $477696120c5741dc$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $477696120c5741dc$var$Mi(a, b);
        "function" !== typeof d && (null === $477696120c5741dc$var$Si ? $477696120c5741dc$var$Si = new Set([
            this
        ]) : $477696120c5741dc$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $477696120c5741dc$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $477696120c5741dc$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $477696120c5741dc$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $477696120c5741dc$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $477696120c5741dc$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $477696120c5741dc$var$ch(-1, 1), b.tag = 2, $477696120c5741dc$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $477696120c5741dc$var$Xi = $477696120c5741dc$var$ua.ReactCurrentOwner, $477696120c5741dc$var$Ug = !1;
function $477696120c5741dc$var$Yi(a, b, c, d) {
    b.child = null === a ? $477696120c5741dc$var$Ch(b, null, c, d) : $477696120c5741dc$var$Bh(b, a.child, c, d);
}
function $477696120c5741dc$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $477696120c5741dc$var$Tg(b, e);
    d = $477696120c5741dc$var$Xh(a, b, c, d, f, e);
    c = $477696120c5741dc$var$bi();
    if (null !== a && !$477696120c5741dc$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $477696120c5741dc$var$$i(a, b, e);
    $477696120c5741dc$var$I && c && $477696120c5741dc$var$vg(b);
    b.flags |= 1;
    $477696120c5741dc$var$Yi(a, b, d, e);
    return b.child;
}
function $477696120c5741dc$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$477696120c5741dc$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $477696120c5741dc$var$cj(a, b, f, d, e);
        a = $477696120c5741dc$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $477696120c5741dc$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $477696120c5741dc$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $477696120c5741dc$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $477696120c5741dc$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($477696120c5741dc$var$Ie(f, d) && a.ref === b.ref) {
            if ($477696120c5741dc$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($477696120c5741dc$var$Ug = !0);
            else return b.lanes = a.lanes, $477696120c5741dc$var$$i(a, b, e);
        }
    }
    return $477696120c5741dc$var$dj(a, b, c, d, e);
}
function $477696120c5741dc$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $477696120c5741dc$var$G($477696120c5741dc$var$fj, $477696120c5741dc$var$gj), $477696120c5741dc$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $477696120c5741dc$var$G($477696120c5741dc$var$fj, $477696120c5741dc$var$gj), $477696120c5741dc$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $477696120c5741dc$var$G($477696120c5741dc$var$fj, $477696120c5741dc$var$gj);
            $477696120c5741dc$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $477696120c5741dc$var$G($477696120c5741dc$var$fj, $477696120c5741dc$var$gj), $477696120c5741dc$var$gj |= d;
    $477696120c5741dc$var$Yi(a, b, e, c);
    return b.child;
}
function $477696120c5741dc$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $477696120c5741dc$var$dj(a, b, c, d, e) {
    var f = $477696120c5741dc$var$Zf(c) ? $477696120c5741dc$var$Xf : $477696120c5741dc$var$H.current;
    f = $477696120c5741dc$var$Yf(b, f);
    $477696120c5741dc$var$Tg(b, e);
    c = $477696120c5741dc$var$Xh(a, b, c, d, f, e);
    d = $477696120c5741dc$var$bi();
    if (null !== a && !$477696120c5741dc$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $477696120c5741dc$var$$i(a, b, e);
    $477696120c5741dc$var$I && d && $477696120c5741dc$var$vg(b);
    b.flags |= 1;
    $477696120c5741dc$var$Yi(a, b, c, e);
    return b.child;
}
function $477696120c5741dc$var$ij(a, b, c, d, e) {
    if ($477696120c5741dc$var$Zf(c)) {
        var f = !0;
        $477696120c5741dc$var$cg(b);
    } else f = !1;
    $477696120c5741dc$var$Tg(b, e);
    if (null === b.stateNode) $477696120c5741dc$var$jj(a, b), $477696120c5741dc$var$ph(b, c, d), $477696120c5741dc$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $477696120c5741dc$var$Vg(l) : (l = $477696120c5741dc$var$Zf(c) ? $477696120c5741dc$var$Xf : $477696120c5741dc$var$H.current, l = $477696120c5741dc$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $477696120c5741dc$var$qh(b, g, d, l);
        $477696120c5741dc$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $477696120c5741dc$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $477696120c5741dc$var$Wf.current || $477696120c5741dc$var$$g ? ("function" === typeof m && ($477696120c5741dc$var$kh(b, c, m, d), k = b.memoizedState), (h = $477696120c5741dc$var$$g || $477696120c5741dc$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $477696120c5741dc$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $477696120c5741dc$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $477696120c5741dc$var$Vg(k) : (k = $477696120c5741dc$var$Zf(c) ? $477696120c5741dc$var$Xf : $477696120c5741dc$var$H.current, k = $477696120c5741dc$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $477696120c5741dc$var$qh(b, g, d, k);
        $477696120c5741dc$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $477696120c5741dc$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $477696120c5741dc$var$Wf.current || $477696120c5741dc$var$$g ? ("function" === typeof y && ($477696120c5741dc$var$kh(b, c, y, d), n = b.memoizedState), (l = $477696120c5741dc$var$$g || $477696120c5741dc$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $477696120c5741dc$var$kj(a, b, c, d, f, e);
}
function $477696120c5741dc$var$kj(a, b, c, d, e, f) {
    $477696120c5741dc$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $477696120c5741dc$var$dg(b, c, !1), $477696120c5741dc$var$$i(a, b, f);
    d = b.stateNode;
    $477696120c5741dc$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $477696120c5741dc$var$Bh(b, a.child, null, f), b.child = $477696120c5741dc$var$Bh(b, null, h, f)) : $477696120c5741dc$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $477696120c5741dc$var$dg(b, c, !0);
    return b.child;
}
function $477696120c5741dc$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $477696120c5741dc$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $477696120c5741dc$var$ag(a, b.context, !1);
    $477696120c5741dc$var$Ih(a, b.containerInfo);
}
function $477696120c5741dc$var$mj(a, b, c, d, e) {
    $477696120c5741dc$var$Ig();
    $477696120c5741dc$var$Jg(e);
    b.flags |= 256;
    $477696120c5741dc$var$Yi(a, b, c, d);
    return b.child;
}
var $477696120c5741dc$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $477696120c5741dc$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $477696120c5741dc$var$pj(a, b, c) {
    var d = b.pendingProps, e = $477696120c5741dc$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $477696120c5741dc$var$G($477696120c5741dc$var$M, e & 1);
    if (null === a) {
        $477696120c5741dc$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $477696120c5741dc$var$qj(g, d, 0, null), a = $477696120c5741dc$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $477696120c5741dc$var$oj(c), b.memoizedState = $477696120c5741dc$var$nj, a) : $477696120c5741dc$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $477696120c5741dc$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $477696120c5741dc$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $477696120c5741dc$var$wh(h, f) : (f = $477696120c5741dc$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $477696120c5741dc$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $477696120c5741dc$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $477696120c5741dc$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $477696120c5741dc$var$rj(a, b) {
    b = $477696120c5741dc$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $477696120c5741dc$var$tj(a, b, c, d) {
    null !== d && $477696120c5741dc$var$Jg(d);
    $477696120c5741dc$var$Bh(b, a.child, null, c);
    a = $477696120c5741dc$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $477696120c5741dc$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $477696120c5741dc$var$Li(Error($477696120c5741dc$var$p(422))), $477696120c5741dc$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $477696120c5741dc$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $477696120c5741dc$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $477696120c5741dc$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $477696120c5741dc$var$oj(g);
        b.memoizedState = $477696120c5741dc$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $477696120c5741dc$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($477696120c5741dc$var$p(419));
        d = $477696120c5741dc$var$Li(f, d, void 0);
        return $477696120c5741dc$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($477696120c5741dc$var$Ug || h) {
        d = $477696120c5741dc$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $477696120c5741dc$var$Zg(a, e), $477696120c5741dc$var$mh(d, a, e, -1));
        }
        $477696120c5741dc$var$uj();
        d = $477696120c5741dc$var$Li(Error($477696120c5741dc$var$p(421)));
        return $477696120c5741dc$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $477696120c5741dc$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $477696120c5741dc$var$yg = $477696120c5741dc$var$Lf(e.nextSibling);
    $477696120c5741dc$var$xg = b;
    $477696120c5741dc$var$I = !0;
    $477696120c5741dc$var$zg = null;
    null !== a && ($477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$rg, $477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$sg, $477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$qg, $477696120c5741dc$var$rg = a.id, $477696120c5741dc$var$sg = a.overflow, $477696120c5741dc$var$qg = b);
    b = $477696120c5741dc$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $477696120c5741dc$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $477696120c5741dc$var$Sg(a.return, b, c);
}
function $477696120c5741dc$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $477696120c5741dc$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $477696120c5741dc$var$Yi(a, b, d.children, c);
    d = $477696120c5741dc$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $477696120c5741dc$var$wj(a, c, b);
            else if (19 === a.tag) $477696120c5741dc$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $477696120c5741dc$var$G($477696120c5741dc$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $477696120c5741dc$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $477696120c5741dc$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $477696120c5741dc$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $477696120c5741dc$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $477696120c5741dc$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $477696120c5741dc$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $477696120c5741dc$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $477696120c5741dc$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($477696120c5741dc$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $477696120c5741dc$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $477696120c5741dc$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $477696120c5741dc$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $477696120c5741dc$var$lj(b);
            $477696120c5741dc$var$Ig();
            break;
        case 5:
            $477696120c5741dc$var$Kh(b);
            break;
        case 1:
            $477696120c5741dc$var$Zf(b.type) && $477696120c5741dc$var$cg(b);
            break;
        case 4:
            $477696120c5741dc$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $477696120c5741dc$var$G($477696120c5741dc$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $477696120c5741dc$var$G($477696120c5741dc$var$M, $477696120c5741dc$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $477696120c5741dc$var$pj(a, b, c);
                $477696120c5741dc$var$G($477696120c5741dc$var$M, $477696120c5741dc$var$M.current & 1);
                a = $477696120c5741dc$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $477696120c5741dc$var$G($477696120c5741dc$var$M, $477696120c5741dc$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $477696120c5741dc$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $477696120c5741dc$var$G($477696120c5741dc$var$M, $477696120c5741dc$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $477696120c5741dc$var$ej(a, b, c);
    }
    return $477696120c5741dc$var$$i(a, b, c);
}
var $477696120c5741dc$var$Aj, $477696120c5741dc$var$Bj, $477696120c5741dc$var$Cj, $477696120c5741dc$var$Dj;
$477696120c5741dc$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$477696120c5741dc$var$Bj = function() {};
$477696120c5741dc$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $477696120c5741dc$var$Hh($477696120c5741dc$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $477696120c5741dc$var$Ya(a, e);
                d = $477696120c5741dc$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $477696120c5741dc$var$A({}, e, {
                    value: void 0
                });
                d = $477696120c5741dc$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $477696120c5741dc$var$gb(a, e);
                d = $477696120c5741dc$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $477696120c5741dc$var$Bf);
        }
        $477696120c5741dc$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($477696120c5741dc$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($477696120c5741dc$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $477696120c5741dc$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$477696120c5741dc$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $477696120c5741dc$var$Ej(a, b) {
    if (!$477696120c5741dc$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $477696120c5741dc$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $477696120c5741dc$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $477696120c5741dc$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $477696120c5741dc$var$S(b), null;
        case 1:
            return $477696120c5741dc$var$Zf(b.type) && $477696120c5741dc$var$$f(), $477696120c5741dc$var$S(b), null;
        case 3:
            d = b.stateNode;
            $477696120c5741dc$var$Jh();
            $477696120c5741dc$var$E($477696120c5741dc$var$Wf);
            $477696120c5741dc$var$E($477696120c5741dc$var$H);
            $477696120c5741dc$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $477696120c5741dc$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $477696120c5741dc$var$zg && ($477696120c5741dc$var$Gj($477696120c5741dc$var$zg), $477696120c5741dc$var$zg = null));
            $477696120c5741dc$var$Bj(a, b);
            $477696120c5741dc$var$S(b);
            return null;
        case 5:
            $477696120c5741dc$var$Lh(b);
            var e = $477696120c5741dc$var$Hh($477696120c5741dc$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $477696120c5741dc$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($477696120c5741dc$var$p(166));
                    $477696120c5741dc$var$S(b);
                    return null;
                }
                a = $477696120c5741dc$var$Hh($477696120c5741dc$var$Eh.current);
                if ($477696120c5741dc$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$477696120c5741dc$var$Of] = b;
                    d[$477696120c5741dc$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $477696120c5741dc$var$D("cancel", d);
                            $477696120c5741dc$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $477696120c5741dc$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $477696120c5741dc$var$lf.length; e++)$477696120c5741dc$var$D($477696120c5741dc$var$lf[e], d);
                            break;
                        case "source":
                            $477696120c5741dc$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $477696120c5741dc$var$D("error", d);
                            $477696120c5741dc$var$D("load", d);
                            break;
                        case "details":
                            $477696120c5741dc$var$D("toggle", d);
                            break;
                        case "input":
                            $477696120c5741dc$var$Za(d, f);
                            $477696120c5741dc$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $477696120c5741dc$var$D("invalid", d);
                            break;
                        case "textarea":
                            $477696120c5741dc$var$hb(d, f), $477696120c5741dc$var$D("invalid", d);
                    }
                    $477696120c5741dc$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $477696120c5741dc$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $477696120c5741dc$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $477696120c5741dc$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $477696120c5741dc$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $477696120c5741dc$var$Va(d);
                            $477696120c5741dc$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $477696120c5741dc$var$Va(d);
                            $477696120c5741dc$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $477696120c5741dc$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $477696120c5741dc$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$477696120c5741dc$var$Of] = b;
                    a[$477696120c5741dc$var$Pf] = d;
                    $477696120c5741dc$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $477696120c5741dc$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $477696120c5741dc$var$D("cancel", a);
                                $477696120c5741dc$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $477696120c5741dc$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $477696120c5741dc$var$lf.length; e++)$477696120c5741dc$var$D($477696120c5741dc$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $477696120c5741dc$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $477696120c5741dc$var$D("error", a);
                                $477696120c5741dc$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $477696120c5741dc$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $477696120c5741dc$var$Za(a, d);
                                e = $477696120c5741dc$var$Ya(a, d);
                                $477696120c5741dc$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $477696120c5741dc$var$A({}, d, {
                                    value: void 0
                                });
                                $477696120c5741dc$var$D("invalid", a);
                                break;
                            case "textarea":
                                $477696120c5741dc$var$hb(a, d);
                                e = $477696120c5741dc$var$gb(a, d);
                                $477696120c5741dc$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $477696120c5741dc$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $477696120c5741dc$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $477696120c5741dc$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $477696120c5741dc$var$ob(a, k) : "number" === typeof k && $477696120c5741dc$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($477696120c5741dc$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $477696120c5741dc$var$D("scroll", a) : null != k && $477696120c5741dc$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $477696120c5741dc$var$Va(a);
                                $477696120c5741dc$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $477696120c5741dc$var$Va(a);
                                $477696120c5741dc$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $477696120c5741dc$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $477696120c5741dc$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $477696120c5741dc$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $477696120c5741dc$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $477696120c5741dc$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $477696120c5741dc$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($477696120c5741dc$var$p(166));
                c = $477696120c5741dc$var$Hh($477696120c5741dc$var$Gh.current);
                $477696120c5741dc$var$Hh($477696120c5741dc$var$Eh.current);
                if ($477696120c5741dc$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$477696120c5741dc$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $477696120c5741dc$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $477696120c5741dc$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $477696120c5741dc$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$477696120c5741dc$var$Of] = b, b.stateNode = d;
            }
            $477696120c5741dc$var$S(b);
            return null;
        case 13:
            $477696120c5741dc$var$E($477696120c5741dc$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($477696120c5741dc$var$I && null !== $477696120c5741dc$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $477696120c5741dc$var$Hg(), $477696120c5741dc$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $477696120c5741dc$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($477696120c5741dc$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($477696120c5741dc$var$p(317));
                        f[$477696120c5741dc$var$Of] = b;
                    } else $477696120c5741dc$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $477696120c5741dc$var$S(b);
                    f = !1;
                } else null !== $477696120c5741dc$var$zg && ($477696120c5741dc$var$Gj($477696120c5741dc$var$zg), $477696120c5741dc$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($477696120c5741dc$var$M.current & 1) ? 0 === $477696120c5741dc$var$T && ($477696120c5741dc$var$T = 3) : $477696120c5741dc$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $477696120c5741dc$var$S(b);
            return null;
        case 4:
            return $477696120c5741dc$var$Jh(), $477696120c5741dc$var$Bj(a, b), null === a && $477696120c5741dc$var$sf(b.stateNode.containerInfo), $477696120c5741dc$var$S(b), null;
        case 10:
            return $477696120c5741dc$var$Rg(b.type._context), $477696120c5741dc$var$S(b), null;
        case 17:
            return $477696120c5741dc$var$Zf(b.type) && $477696120c5741dc$var$$f(), $477696120c5741dc$var$S(b), null;
        case 19:
            $477696120c5741dc$var$E($477696120c5741dc$var$M);
            f = b.memoizedState;
            if (null === f) return $477696120c5741dc$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $477696120c5741dc$var$Ej(f, !1);
                else {
                    if (0 !== $477696120c5741dc$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $477696120c5741dc$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $477696120c5741dc$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $477696120c5741dc$var$G($477696120c5741dc$var$M, $477696120c5741dc$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $477696120c5741dc$var$B() > $477696120c5741dc$var$Hj && (b.flags |= 128, d = !0, $477696120c5741dc$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $477696120c5741dc$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $477696120c5741dc$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$477696120c5741dc$var$I) return $477696120c5741dc$var$S(b), null;
                    } else 2 * $477696120c5741dc$var$B() - f.renderingStartTime > $477696120c5741dc$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $477696120c5741dc$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $477696120c5741dc$var$B(), b.sibling = null, c = $477696120c5741dc$var$M.current, $477696120c5741dc$var$G($477696120c5741dc$var$M, d ? c & 1 | 2 : c & 1), b;
            $477696120c5741dc$var$S(b);
            return null;
        case 22:
        case 23:
            return $477696120c5741dc$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($477696120c5741dc$var$gj & 1073741824) && ($477696120c5741dc$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $477696120c5741dc$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($477696120c5741dc$var$p(156, b.tag));
}
function $477696120c5741dc$var$Jj(a, b) {
    $477696120c5741dc$var$wg(b);
    switch(b.tag){
        case 1:
            return $477696120c5741dc$var$Zf(b.type) && $477696120c5741dc$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $477696120c5741dc$var$Jh(), $477696120c5741dc$var$E($477696120c5741dc$var$Wf), $477696120c5741dc$var$E($477696120c5741dc$var$H), $477696120c5741dc$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $477696120c5741dc$var$Lh(b), null;
        case 13:
            $477696120c5741dc$var$E($477696120c5741dc$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($477696120c5741dc$var$p(340));
                $477696120c5741dc$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $477696120c5741dc$var$E($477696120c5741dc$var$M), null;
        case 4:
            return $477696120c5741dc$var$Jh(), null;
        case 10:
            return $477696120c5741dc$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $477696120c5741dc$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $477696120c5741dc$var$Kj = !1, $477696120c5741dc$var$U = !1, $477696120c5741dc$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $477696120c5741dc$var$V = null;
function $477696120c5741dc$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $477696120c5741dc$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $477696120c5741dc$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $477696120c5741dc$var$W(a, b, d);
    }
}
var $477696120c5741dc$var$Oj = !1;
function $477696120c5741dc$var$Pj(a, b) {
    $477696120c5741dc$var$Cf = $477696120c5741dc$var$dd;
    a = $477696120c5741dc$var$Me();
    if ($477696120c5741dc$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $477696120c5741dc$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $477696120c5741dc$var$dd = !1;
    for($477696120c5741dc$var$V = b; null !== $477696120c5741dc$var$V;)if (b = $477696120c5741dc$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $477696120c5741dc$var$V = a;
    else for(; null !== $477696120c5741dc$var$V;){
        b = $477696120c5741dc$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $477696120c5741dc$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($477696120c5741dc$var$p(163));
            }
        } catch (F) {
            $477696120c5741dc$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $477696120c5741dc$var$V = a;
            break;
        }
        $477696120c5741dc$var$V = b.return;
    }
    n = $477696120c5741dc$var$Oj;
    $477696120c5741dc$var$Oj = !1;
    return n;
}
function $477696120c5741dc$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $477696120c5741dc$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $477696120c5741dc$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $477696120c5741dc$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $477696120c5741dc$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $477696120c5741dc$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$477696120c5741dc$var$Of], delete b[$477696120c5741dc$var$Pf], delete b[$477696120c5741dc$var$of], delete b[$477696120c5741dc$var$Qf], delete b[$477696120c5741dc$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $477696120c5741dc$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $477696120c5741dc$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $477696120c5741dc$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $477696120c5741dc$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $477696120c5741dc$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($477696120c5741dc$var$Wj(a, b, c), a = a.sibling; null !== a;)$477696120c5741dc$var$Wj(a, b, c), a = a.sibling;
}
function $477696120c5741dc$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($477696120c5741dc$var$Xj(a, b, c), a = a.sibling; null !== a;)$477696120c5741dc$var$Xj(a, b, c), a = a.sibling;
}
var $477696120c5741dc$var$X = null, $477696120c5741dc$var$Yj = !1;
function $477696120c5741dc$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$477696120c5741dc$var$ak(a, b, c), c = c.sibling;
}
function $477696120c5741dc$var$ak(a, b, c) {
    if ($477696120c5741dc$var$lc && "function" === typeof $477696120c5741dc$var$lc.onCommitFiberUnmount) try {
        $477696120c5741dc$var$lc.onCommitFiberUnmount($477696120c5741dc$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $477696120c5741dc$var$U || $477696120c5741dc$var$Mj(c, b);
        case 6:
            var d = $477696120c5741dc$var$X, e = $477696120c5741dc$var$Yj;
            $477696120c5741dc$var$X = null;
            $477696120c5741dc$var$Zj(a, b, c);
            $477696120c5741dc$var$X = d;
            $477696120c5741dc$var$Yj = e;
            null !== $477696120c5741dc$var$X && ($477696120c5741dc$var$Yj ? (a = $477696120c5741dc$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $477696120c5741dc$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $477696120c5741dc$var$X && ($477696120c5741dc$var$Yj ? (a = $477696120c5741dc$var$X, c = c.stateNode, 8 === a.nodeType ? $477696120c5741dc$var$Kf(a.parentNode, c) : 1 === a.nodeType && $477696120c5741dc$var$Kf(a, c), $477696120c5741dc$var$bd(a)) : $477696120c5741dc$var$Kf($477696120c5741dc$var$X, c.stateNode));
            break;
        case 4:
            d = $477696120c5741dc$var$X;
            e = $477696120c5741dc$var$Yj;
            $477696120c5741dc$var$X = c.stateNode.containerInfo;
            $477696120c5741dc$var$Yj = !0;
            $477696120c5741dc$var$Zj(a, b, c);
            $477696120c5741dc$var$X = d;
            $477696120c5741dc$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$477696120c5741dc$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $477696120c5741dc$var$Nj(c, b, g) : 0 !== (f & 4) && $477696120c5741dc$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $477696120c5741dc$var$Zj(a, b, c);
            break;
        case 1:
            if (!$477696120c5741dc$var$U && ($477696120c5741dc$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $477696120c5741dc$var$W(c, b, h);
            }
            $477696120c5741dc$var$Zj(a, b, c);
            break;
        case 21:
            $477696120c5741dc$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($477696120c5741dc$var$U = (d = $477696120c5741dc$var$U) || null !== c.memoizedState, $477696120c5741dc$var$Zj(a, b, c), $477696120c5741dc$var$U = d) : $477696120c5741dc$var$Zj(a, b, c);
            break;
        default:
            $477696120c5741dc$var$Zj(a, b, c);
    }
}
function $477696120c5741dc$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $477696120c5741dc$var$Lj);
        b.forEach(function(b) {
            var d = $477696120c5741dc$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $477696120c5741dc$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $477696120c5741dc$var$X = h.stateNode;
                        $477696120c5741dc$var$Yj = !1;
                        break a;
                    case 3:
                        $477696120c5741dc$var$X = h.stateNode.containerInfo;
                        $477696120c5741dc$var$Yj = !0;
                        break a;
                    case 4:
                        $477696120c5741dc$var$X = h.stateNode.containerInfo;
                        $477696120c5741dc$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $477696120c5741dc$var$X) throw Error($477696120c5741dc$var$p(160));
            $477696120c5741dc$var$ak(f, g, e);
            $477696120c5741dc$var$X = null;
            $477696120c5741dc$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $477696120c5741dc$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$477696120c5741dc$var$ek(b, a), b = b.sibling;
}
function $477696120c5741dc$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            if (d & 4) {
                try {
                    $477696120c5741dc$var$Qj(3, a, a.return), $477696120c5741dc$var$Rj(3, a);
                } catch (t) {
                    $477696120c5741dc$var$W(a, a.return, t);
                }
                try {
                    $477696120c5741dc$var$Qj(5, a, a.return);
                } catch (t) {
                    $477696120c5741dc$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            d & 512 && null !== c && $477696120c5741dc$var$Mj(c, c.return);
            break;
        case 5:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            d & 512 && null !== c && $477696120c5741dc$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $477696120c5741dc$var$ob(e, "");
                } catch (t) {
                    $477696120c5741dc$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $477696120c5741dc$var$ab(e, f);
                    $477696120c5741dc$var$vb(h, g);
                    var l = $477696120c5741dc$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $477696120c5741dc$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $477696120c5741dc$var$nb(e, q) : "children" === m ? $477696120c5741dc$var$ob(e, q) : $477696120c5741dc$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $477696120c5741dc$var$bb(e, f);
                            break;
                        case "textarea":
                            $477696120c5741dc$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $477696120c5741dc$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $477696120c5741dc$var$fb(e, !!f.multiple, f.defaultValue, !0) : $477696120c5741dc$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$477696120c5741dc$var$Pf] = f;
                } catch (t) {
                    $477696120c5741dc$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($477696120c5741dc$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $477696120c5741dc$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $477696120c5741dc$var$bd(b.containerInfo);
            } catch (t) {
                $477696120c5741dc$var$W(a, a.return, t);
            }
            break;
        case 4:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            break;
        case 13:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($477696120c5741dc$var$gk = $477696120c5741dc$var$B()));
            d & 4 && $477696120c5741dc$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($477696120c5741dc$var$U = (l = $477696120c5741dc$var$U) || m, $477696120c5741dc$var$dk(b, a), $477696120c5741dc$var$U = l) : $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($477696120c5741dc$var$V = a, m = a.child; null !== m;){
                    for(q = $477696120c5741dc$var$V = m; null !== $477696120c5741dc$var$V;){
                        r = $477696120c5741dc$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $477696120c5741dc$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $477696120c5741dc$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $477696120c5741dc$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $477696120c5741dc$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $477696120c5741dc$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $477696120c5741dc$var$V = y) : $477696120c5741dc$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $477696120c5741dc$var$rb("display", g));
                            } catch (t) {
                                $477696120c5741dc$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $477696120c5741dc$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            d & 4 && $477696120c5741dc$var$bk(a);
            break;
        case 21:
            break;
        default:
            $477696120c5741dc$var$dk(b, a), $477696120c5741dc$var$fk(a);
    }
}
function $477696120c5741dc$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($477696120c5741dc$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($477696120c5741dc$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($477696120c5741dc$var$ob(e, ""), d.flags &= -33);
                    var f = $477696120c5741dc$var$Vj(a);
                    $477696120c5741dc$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $477696120c5741dc$var$Vj(a);
                    $477696120c5741dc$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($477696120c5741dc$var$p(161));
            }
        } catch (k) {
            $477696120c5741dc$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $477696120c5741dc$var$ik(a, b, c) {
    $477696120c5741dc$var$V = a;
    $477696120c5741dc$var$jk(a, b, c);
}
function $477696120c5741dc$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $477696120c5741dc$var$V;){
        var e = $477696120c5741dc$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $477696120c5741dc$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $477696120c5741dc$var$U;
                h = $477696120c5741dc$var$Kj;
                var l = $477696120c5741dc$var$U;
                $477696120c5741dc$var$Kj = g;
                if (($477696120c5741dc$var$U = k) && !l) for($477696120c5741dc$var$V = e; null !== $477696120c5741dc$var$V;)g = $477696120c5741dc$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $477696120c5741dc$var$kk(e) : null !== k ? (k.return = g, $477696120c5741dc$var$V = k) : $477696120c5741dc$var$kk(e);
                for(; null !== f;)$477696120c5741dc$var$V = f, $477696120c5741dc$var$jk(f, b, c), f = f.sibling;
                $477696120c5741dc$var$V = e;
                $477696120c5741dc$var$Kj = h;
                $477696120c5741dc$var$U = l;
            }
            $477696120c5741dc$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $477696120c5741dc$var$V = f) : $477696120c5741dc$var$lk(a, b, c);
    }
}
function $477696120c5741dc$var$lk(a) {
    for(; null !== $477696120c5741dc$var$V;){
        var b = $477696120c5741dc$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $477696120c5741dc$var$U || $477696120c5741dc$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$477696120c5741dc$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $477696120c5741dc$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $477696120c5741dc$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $477696120c5741dc$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $477696120c5741dc$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($477696120c5741dc$var$p(163));
                }
                $477696120c5741dc$var$U || b.flags & 512 && $477696120c5741dc$var$Sj(b);
            } catch (r) {
                $477696120c5741dc$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $477696120c5741dc$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $477696120c5741dc$var$V = c;
            break;
        }
        $477696120c5741dc$var$V = b.return;
    }
}
function $477696120c5741dc$var$hk(a) {
    for(; null !== $477696120c5741dc$var$V;){
        var b = $477696120c5741dc$var$V;
        if (b === a) {
            $477696120c5741dc$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $477696120c5741dc$var$V = c;
            break;
        }
        $477696120c5741dc$var$V = b.return;
    }
}
function $477696120c5741dc$var$kk(a) {
    for(; null !== $477696120c5741dc$var$V;){
        var b = $477696120c5741dc$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $477696120c5741dc$var$Rj(4, b);
                    } catch (k) {
                        $477696120c5741dc$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $477696120c5741dc$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $477696120c5741dc$var$Sj(b);
                    } catch (k) {
                        $477696120c5741dc$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $477696120c5741dc$var$Sj(b);
                    } catch (k) {
                        $477696120c5741dc$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $477696120c5741dc$var$W(b, b.return, k);
        }
        if (b === a) {
            $477696120c5741dc$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $477696120c5741dc$var$V = h;
            break;
        }
        $477696120c5741dc$var$V = b.return;
    }
}
var $477696120c5741dc$var$mk = Math.ceil, $477696120c5741dc$var$nk = $477696120c5741dc$var$ua.ReactCurrentDispatcher, $477696120c5741dc$var$ok = $477696120c5741dc$var$ua.ReactCurrentOwner, $477696120c5741dc$var$pk = $477696120c5741dc$var$ua.ReactCurrentBatchConfig, $477696120c5741dc$var$K = 0, $477696120c5741dc$var$R = null, $477696120c5741dc$var$Y = null, $477696120c5741dc$var$Z = 0, $477696120c5741dc$var$gj = 0, $477696120c5741dc$var$fj = $477696120c5741dc$var$Uf(0), $477696120c5741dc$var$T = 0, $477696120c5741dc$var$qk = null, $477696120c5741dc$var$hh = 0, $477696120c5741dc$var$rk = 0, $477696120c5741dc$var$sk = 0, $477696120c5741dc$var$tk = null, $477696120c5741dc$var$uk = null, $477696120c5741dc$var$gk = 0, $477696120c5741dc$var$Hj = Infinity, $477696120c5741dc$var$vk = null, $477696120c5741dc$var$Pi = !1, $477696120c5741dc$var$Qi = null, $477696120c5741dc$var$Si = null, $477696120c5741dc$var$wk = !1, $477696120c5741dc$var$xk = null, $477696120c5741dc$var$yk = 0, $477696120c5741dc$var$zk = 0, $477696120c5741dc$var$Ak = null, $477696120c5741dc$var$Bk = -1, $477696120c5741dc$var$Ck = 0;
function $477696120c5741dc$var$L() {
    return 0 !== ($477696120c5741dc$var$K & 6) ? $477696120c5741dc$var$B() : -1 !== $477696120c5741dc$var$Bk ? $477696120c5741dc$var$Bk : $477696120c5741dc$var$Bk = $477696120c5741dc$var$B();
}
function $477696120c5741dc$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($477696120c5741dc$var$K & 2) && 0 !== $477696120c5741dc$var$Z) return $477696120c5741dc$var$Z & -$477696120c5741dc$var$Z;
    if (null !== $477696120c5741dc$var$Kg.transition) return 0 === $477696120c5741dc$var$Ck && ($477696120c5741dc$var$Ck = $477696120c5741dc$var$yc()), $477696120c5741dc$var$Ck;
    a = $477696120c5741dc$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $477696120c5741dc$var$jd(a.type);
    return a;
}
function $477696120c5741dc$var$mh(a, b, c, d) {
    if (50 < $477696120c5741dc$var$zk) throw $477696120c5741dc$var$zk = 0, $477696120c5741dc$var$Ak = null, Error($477696120c5741dc$var$p(185));
    $477696120c5741dc$var$Ac(a, c, d);
    if (0 === ($477696120c5741dc$var$K & 2) || a !== $477696120c5741dc$var$R) a === $477696120c5741dc$var$R && (0 === ($477696120c5741dc$var$K & 2) && ($477696120c5741dc$var$rk |= c), 4 === $477696120c5741dc$var$T && $477696120c5741dc$var$Dk(a, $477696120c5741dc$var$Z)), $477696120c5741dc$var$Ek(a, d), 1 === c && 0 === $477696120c5741dc$var$K && 0 === (b.mode & 1) && ($477696120c5741dc$var$Hj = $477696120c5741dc$var$B() + 500, $477696120c5741dc$var$fg && $477696120c5741dc$var$jg());
}
function $477696120c5741dc$var$Ek(a, b) {
    var c = a.callbackNode;
    $477696120c5741dc$var$wc(a, b);
    var d = $477696120c5741dc$var$uc(a, a === $477696120c5741dc$var$R ? $477696120c5741dc$var$Z : 0);
    if (0 === d) null !== c && $477696120c5741dc$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $477696120c5741dc$var$bc(c);
        if (1 === b) 0 === a.tag ? $477696120c5741dc$var$ig($477696120c5741dc$var$Fk.bind(null, a)) : $477696120c5741dc$var$hg($477696120c5741dc$var$Fk.bind(null, a)), $477696120c5741dc$var$Jf(function() {
            0 === ($477696120c5741dc$var$K & 6) && $477696120c5741dc$var$jg();
        }), c = null;
        else {
            switch($477696120c5741dc$var$Dc(d)){
                case 1:
                    c = $477696120c5741dc$var$fc;
                    break;
                case 4:
                    c = $477696120c5741dc$var$gc;
                    break;
                case 16:
                    c = $477696120c5741dc$var$hc;
                    break;
                case 536870912:
                    c = $477696120c5741dc$var$jc;
                    break;
                default:
                    c = $477696120c5741dc$var$hc;
            }
            c = $477696120c5741dc$var$Gk(c, $477696120c5741dc$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $477696120c5741dc$var$Hk(a, b) {
    $477696120c5741dc$var$Bk = -1;
    $477696120c5741dc$var$Ck = 0;
    if (0 !== ($477696120c5741dc$var$K & 6)) throw Error($477696120c5741dc$var$p(327));
    var c = a.callbackNode;
    if ($477696120c5741dc$var$Ik() && a.callbackNode !== c) return null;
    var d = $477696120c5741dc$var$uc(a, a === $477696120c5741dc$var$R ? $477696120c5741dc$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $477696120c5741dc$var$Jk(a, d);
    else {
        b = d;
        var e = $477696120c5741dc$var$K;
        $477696120c5741dc$var$K |= 2;
        var f = $477696120c5741dc$var$Kk();
        if ($477696120c5741dc$var$R !== a || $477696120c5741dc$var$Z !== b) $477696120c5741dc$var$vk = null, $477696120c5741dc$var$Hj = $477696120c5741dc$var$B() + 500, $477696120c5741dc$var$Lk(a, b);
        for(;;)try {
            $477696120c5741dc$var$Mk();
            break;
        } catch (h) {
            $477696120c5741dc$var$Nk(a, h);
        }
        $477696120c5741dc$var$Qg();
        $477696120c5741dc$var$nk.current = f;
        $477696120c5741dc$var$K = e;
        null !== $477696120c5741dc$var$Y ? b = 0 : ($477696120c5741dc$var$R = null, $477696120c5741dc$var$Z = 0, b = $477696120c5741dc$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $477696120c5741dc$var$xc(a), 0 !== e && (d = e, b = $477696120c5741dc$var$Ok(a, e)));
        if (1 === b) throw c = $477696120c5741dc$var$qk, $477696120c5741dc$var$Lk(a, 0), $477696120c5741dc$var$Dk(a, d), $477696120c5741dc$var$Ek(a, $477696120c5741dc$var$B()), c;
        if (6 === b) $477696120c5741dc$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$477696120c5741dc$var$Pk(e) && (b = $477696120c5741dc$var$Jk(a, d), 2 === b && (f = $477696120c5741dc$var$xc(a), 0 !== f && (d = f, b = $477696120c5741dc$var$Ok(a, f))), 1 === b)) throw c = $477696120c5741dc$var$qk, $477696120c5741dc$var$Lk(a, 0), $477696120c5741dc$var$Dk(a, d), $477696120c5741dc$var$Ek(a, $477696120c5741dc$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($477696120c5741dc$var$p(345));
                case 2:
                    $477696120c5741dc$var$Qk(a, $477696120c5741dc$var$uk, $477696120c5741dc$var$vk);
                    break;
                case 3:
                    $477696120c5741dc$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $477696120c5741dc$var$gk + 500 - $477696120c5741dc$var$B(), 10 < b)) {
                        if (0 !== $477696120c5741dc$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $477696120c5741dc$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $477696120c5741dc$var$Ff($477696120c5741dc$var$Qk.bind(null, a, $477696120c5741dc$var$uk, $477696120c5741dc$var$vk), b);
                        break;
                    }
                    $477696120c5741dc$var$Qk(a, $477696120c5741dc$var$uk, $477696120c5741dc$var$vk);
                    break;
                case 4:
                    $477696120c5741dc$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $477696120c5741dc$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $477696120c5741dc$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $477696120c5741dc$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $477696120c5741dc$var$Ff($477696120c5741dc$var$Qk.bind(null, a, $477696120c5741dc$var$uk, $477696120c5741dc$var$vk), d);
                        break;
                    }
                    $477696120c5741dc$var$Qk(a, $477696120c5741dc$var$uk, $477696120c5741dc$var$vk);
                    break;
                case 5:
                    $477696120c5741dc$var$Qk(a, $477696120c5741dc$var$uk, $477696120c5741dc$var$vk);
                    break;
                default:
                    throw Error($477696120c5741dc$var$p(329));
            }
        }
    }
    $477696120c5741dc$var$Ek(a, $477696120c5741dc$var$B());
    return a.callbackNode === c ? $477696120c5741dc$var$Hk.bind(null, a) : null;
}
function $477696120c5741dc$var$Ok(a, b) {
    var c = $477696120c5741dc$var$tk;
    a.current.memoizedState.isDehydrated && ($477696120c5741dc$var$Lk(a, b).flags |= 256);
    a = $477696120c5741dc$var$Jk(a, b);
    2 !== a && (b = $477696120c5741dc$var$uk, $477696120c5741dc$var$uk = c, null !== b && $477696120c5741dc$var$Gj(b));
    return a;
}
function $477696120c5741dc$var$Gj(a) {
    null === $477696120c5741dc$var$uk ? $477696120c5741dc$var$uk = a : $477696120c5741dc$var$uk.push.apply($477696120c5741dc$var$uk, a);
}
function $477696120c5741dc$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$477696120c5741dc$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $477696120c5741dc$var$Dk(a, b) {
    b &= ~$477696120c5741dc$var$sk;
    b &= ~$477696120c5741dc$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $477696120c5741dc$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $477696120c5741dc$var$Fk(a) {
    if (0 !== ($477696120c5741dc$var$K & 6)) throw Error($477696120c5741dc$var$p(327));
    $477696120c5741dc$var$Ik();
    var b = $477696120c5741dc$var$uc(a, 0);
    if (0 === (b & 1)) return $477696120c5741dc$var$Ek(a, $477696120c5741dc$var$B()), null;
    var c = $477696120c5741dc$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $477696120c5741dc$var$xc(a);
        0 !== d && (b = d, c = $477696120c5741dc$var$Ok(a, d));
    }
    if (1 === c) throw c = $477696120c5741dc$var$qk, $477696120c5741dc$var$Lk(a, 0), $477696120c5741dc$var$Dk(a, b), $477696120c5741dc$var$Ek(a, $477696120c5741dc$var$B()), c;
    if (6 === c) throw Error($477696120c5741dc$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $477696120c5741dc$var$Qk(a, $477696120c5741dc$var$uk, $477696120c5741dc$var$vk);
    $477696120c5741dc$var$Ek(a, $477696120c5741dc$var$B());
    return null;
}
function $477696120c5741dc$var$Rk(a, b) {
    var c = $477696120c5741dc$var$K;
    $477696120c5741dc$var$K |= 1;
    try {
        return a(b);
    } finally{
        $477696120c5741dc$var$K = c, 0 === $477696120c5741dc$var$K && ($477696120c5741dc$var$Hj = $477696120c5741dc$var$B() + 500, $477696120c5741dc$var$fg && $477696120c5741dc$var$jg());
    }
}
function $477696120c5741dc$var$Sk(a) {
    null !== $477696120c5741dc$var$xk && 0 === $477696120c5741dc$var$xk.tag && 0 === ($477696120c5741dc$var$K & 6) && $477696120c5741dc$var$Ik();
    var b = $477696120c5741dc$var$K;
    $477696120c5741dc$var$K |= 1;
    var c = $477696120c5741dc$var$pk.transition, d = $477696120c5741dc$var$C;
    try {
        if ($477696120c5741dc$var$pk.transition = null, $477696120c5741dc$var$C = 1, a) return a();
    } finally{
        $477696120c5741dc$var$C = d, $477696120c5741dc$var$pk.transition = c, $477696120c5741dc$var$K = b, 0 === ($477696120c5741dc$var$K & 6) && $477696120c5741dc$var$jg();
    }
}
function $477696120c5741dc$var$Ij() {
    $477696120c5741dc$var$gj = $477696120c5741dc$var$fj.current;
    $477696120c5741dc$var$E($477696120c5741dc$var$fj);
}
function $477696120c5741dc$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $477696120c5741dc$var$Gf(c));
    if (null !== $477696120c5741dc$var$Y) for(c = $477696120c5741dc$var$Y.return; null !== c;){
        var d = c;
        $477696120c5741dc$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $477696120c5741dc$var$$f();
                break;
            case 3:
                $477696120c5741dc$var$Jh();
                $477696120c5741dc$var$E($477696120c5741dc$var$Wf);
                $477696120c5741dc$var$E($477696120c5741dc$var$H);
                $477696120c5741dc$var$Oh();
                break;
            case 5:
                $477696120c5741dc$var$Lh(d);
                break;
            case 4:
                $477696120c5741dc$var$Jh();
                break;
            case 13:
                $477696120c5741dc$var$E($477696120c5741dc$var$M);
                break;
            case 19:
                $477696120c5741dc$var$E($477696120c5741dc$var$M);
                break;
            case 10:
                $477696120c5741dc$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $477696120c5741dc$var$Ij();
        }
        c = c.return;
    }
    $477696120c5741dc$var$R = a;
    $477696120c5741dc$var$Y = a = $477696120c5741dc$var$wh(a.current, null);
    $477696120c5741dc$var$Z = $477696120c5741dc$var$gj = b;
    $477696120c5741dc$var$T = 0;
    $477696120c5741dc$var$qk = null;
    $477696120c5741dc$var$sk = $477696120c5741dc$var$rk = $477696120c5741dc$var$hh = 0;
    $477696120c5741dc$var$uk = $477696120c5741dc$var$tk = null;
    if (null !== $477696120c5741dc$var$Wg) {
        for(b = 0; b < $477696120c5741dc$var$Wg.length; b++)if (c = $477696120c5741dc$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $477696120c5741dc$var$Wg = null;
    }
    return a;
}
function $477696120c5741dc$var$Nk(a, b) {
    do {
        var c = $477696120c5741dc$var$Y;
        try {
            $477696120c5741dc$var$Qg();
            $477696120c5741dc$var$Ph.current = $477696120c5741dc$var$ai;
            if ($477696120c5741dc$var$Sh) {
                for(var d = $477696120c5741dc$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $477696120c5741dc$var$Sh = !1;
            }
            $477696120c5741dc$var$Rh = 0;
            $477696120c5741dc$var$P = $477696120c5741dc$var$O = $477696120c5741dc$var$N = null;
            $477696120c5741dc$var$Th = !1;
            $477696120c5741dc$var$Uh = 0;
            $477696120c5741dc$var$ok.current = null;
            if (null === c || null === c.return) {
                $477696120c5741dc$var$T = 1;
                $477696120c5741dc$var$qk = b;
                $477696120c5741dc$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $477696120c5741dc$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $477696120c5741dc$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $477696120c5741dc$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $477696120c5741dc$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $477696120c5741dc$var$Ti(f, l, b);
                            $477696120c5741dc$var$uj();
                            break a;
                        }
                        k = Error($477696120c5741dc$var$p(426));
                    }
                } else if ($477696120c5741dc$var$I && h.mode & 1) {
                    var J = $477696120c5741dc$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $477696120c5741dc$var$Wi(J, g, h, f, b);
                        $477696120c5741dc$var$Jg($477696120c5741dc$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $477696120c5741dc$var$Ki(k, h);
                4 !== $477696120c5741dc$var$T && ($477696120c5741dc$var$T = 2);
                null === $477696120c5741dc$var$tk ? $477696120c5741dc$var$tk = [
                    f
                ] : $477696120c5741dc$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $477696120c5741dc$var$Oi(f, k, b);
                            $477696120c5741dc$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $477696120c5741dc$var$Si || !$477696120c5741dc$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $477696120c5741dc$var$Ri(f, h, b);
                                $477696120c5741dc$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $477696120c5741dc$var$Tk(c);
        } catch (na) {
            b = na;
            $477696120c5741dc$var$Y === c && null !== c && ($477696120c5741dc$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $477696120c5741dc$var$Kk() {
    var a = $477696120c5741dc$var$nk.current;
    $477696120c5741dc$var$nk.current = $477696120c5741dc$var$ai;
    return null === a ? $477696120c5741dc$var$ai : a;
}
function $477696120c5741dc$var$uj() {
    if (0 === $477696120c5741dc$var$T || 3 === $477696120c5741dc$var$T || 2 === $477696120c5741dc$var$T) $477696120c5741dc$var$T = 4;
    null === $477696120c5741dc$var$R || 0 === ($477696120c5741dc$var$hh & 268435455) && 0 === ($477696120c5741dc$var$rk & 268435455) || $477696120c5741dc$var$Dk($477696120c5741dc$var$R, $477696120c5741dc$var$Z);
}
function $477696120c5741dc$var$Jk(a, b) {
    var c = $477696120c5741dc$var$K;
    $477696120c5741dc$var$K |= 2;
    var d = $477696120c5741dc$var$Kk();
    if ($477696120c5741dc$var$R !== a || $477696120c5741dc$var$Z !== b) $477696120c5741dc$var$vk = null, $477696120c5741dc$var$Lk(a, b);
    for(;;)try {
        $477696120c5741dc$var$Uk();
        break;
    } catch (e) {
        $477696120c5741dc$var$Nk(a, e);
    }
    $477696120c5741dc$var$Qg();
    $477696120c5741dc$var$K = c;
    $477696120c5741dc$var$nk.current = d;
    if (null !== $477696120c5741dc$var$Y) throw Error($477696120c5741dc$var$p(261));
    $477696120c5741dc$var$R = null;
    $477696120c5741dc$var$Z = 0;
    return $477696120c5741dc$var$T;
}
function $477696120c5741dc$var$Uk() {
    for(; null !== $477696120c5741dc$var$Y;)$477696120c5741dc$var$Vk($477696120c5741dc$var$Y);
}
function $477696120c5741dc$var$Mk() {
    for(; null !== $477696120c5741dc$var$Y && !$477696120c5741dc$var$cc();)$477696120c5741dc$var$Vk($477696120c5741dc$var$Y);
}
function $477696120c5741dc$var$Vk(a) {
    var b = $477696120c5741dc$var$Wk(a.alternate, a, $477696120c5741dc$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $477696120c5741dc$var$Tk(a) : $477696120c5741dc$var$Y = b;
    $477696120c5741dc$var$ok.current = null;
}
function $477696120c5741dc$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $477696120c5741dc$var$Fj(c, b, $477696120c5741dc$var$gj), null !== c) {
                $477696120c5741dc$var$Y = c;
                return;
            }
        } else {
            c = $477696120c5741dc$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $477696120c5741dc$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $477696120c5741dc$var$T = 6;
                $477696120c5741dc$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $477696120c5741dc$var$Y = b;
            return;
        }
        $477696120c5741dc$var$Y = b = a;
    }while (null !== b);
    0 === $477696120c5741dc$var$T && ($477696120c5741dc$var$T = 5);
}
function $477696120c5741dc$var$Qk(a, b, c) {
    var d = $477696120c5741dc$var$C, e = $477696120c5741dc$var$pk.transition;
    try {
        $477696120c5741dc$var$pk.transition = null, $477696120c5741dc$var$C = 1, $477696120c5741dc$var$Xk(a, b, c, d);
    } finally{
        $477696120c5741dc$var$pk.transition = e, $477696120c5741dc$var$C = d;
    }
    return null;
}
function $477696120c5741dc$var$Xk(a, b, c, d) {
    do $477696120c5741dc$var$Ik();
    while (null !== $477696120c5741dc$var$xk);
    if (0 !== ($477696120c5741dc$var$K & 6)) throw Error($477696120c5741dc$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($477696120c5741dc$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $477696120c5741dc$var$Bc(a, f);
    a === $477696120c5741dc$var$R && ($477696120c5741dc$var$Y = $477696120c5741dc$var$R = null, $477696120c5741dc$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $477696120c5741dc$var$wk || ($477696120c5741dc$var$wk = !0, $477696120c5741dc$var$Gk($477696120c5741dc$var$hc, function() {
        $477696120c5741dc$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $477696120c5741dc$var$pk.transition;
        $477696120c5741dc$var$pk.transition = null;
        var g = $477696120c5741dc$var$C;
        $477696120c5741dc$var$C = 1;
        var h = $477696120c5741dc$var$K;
        $477696120c5741dc$var$K |= 4;
        $477696120c5741dc$var$ok.current = null;
        $477696120c5741dc$var$Pj(a, c);
        $477696120c5741dc$var$ek(c, a);
        $477696120c5741dc$var$Oe($477696120c5741dc$var$Df);
        $477696120c5741dc$var$dd = !!$477696120c5741dc$var$Cf;
        $477696120c5741dc$var$Df = $477696120c5741dc$var$Cf = null;
        a.current = c;
        $477696120c5741dc$var$ik(c, a, e);
        $477696120c5741dc$var$dc();
        $477696120c5741dc$var$K = h;
        $477696120c5741dc$var$C = g;
        $477696120c5741dc$var$pk.transition = f;
    } else a.current = c;
    $477696120c5741dc$var$wk && ($477696120c5741dc$var$wk = !1, $477696120c5741dc$var$xk = a, $477696120c5741dc$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($477696120c5741dc$var$Si = null);
    $477696120c5741dc$var$mc(c.stateNode, d);
    $477696120c5741dc$var$Ek(a, $477696120c5741dc$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($477696120c5741dc$var$Pi) throw $477696120c5741dc$var$Pi = !1, a = $477696120c5741dc$var$Qi, $477696120c5741dc$var$Qi = null, a;
    0 !== ($477696120c5741dc$var$yk & 1) && 0 !== a.tag && $477696120c5741dc$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $477696120c5741dc$var$Ak ? $477696120c5741dc$var$zk++ : ($477696120c5741dc$var$zk = 0, $477696120c5741dc$var$Ak = a) : $477696120c5741dc$var$zk = 0;
    $477696120c5741dc$var$jg();
    return null;
}
function $477696120c5741dc$var$Ik() {
    if (null !== $477696120c5741dc$var$xk) {
        var a = $477696120c5741dc$var$Dc($477696120c5741dc$var$yk), b = $477696120c5741dc$var$pk.transition, c = $477696120c5741dc$var$C;
        try {
            $477696120c5741dc$var$pk.transition = null;
            $477696120c5741dc$var$C = 16 > a ? 16 : a;
            if (null === $477696120c5741dc$var$xk) var d = !1;
            else {
                a = $477696120c5741dc$var$xk;
                $477696120c5741dc$var$xk = null;
                $477696120c5741dc$var$yk = 0;
                if (0 !== ($477696120c5741dc$var$K & 6)) throw Error($477696120c5741dc$var$p(331));
                var e = $477696120c5741dc$var$K;
                $477696120c5741dc$var$K |= 4;
                for($477696120c5741dc$var$V = a.current; null !== $477696120c5741dc$var$V;){
                    var f = $477696120c5741dc$var$V, g = f.child;
                    if (0 !== ($477696120c5741dc$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($477696120c5741dc$var$V = l; null !== $477696120c5741dc$var$V;){
                                    var m = $477696120c5741dc$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $477696120c5741dc$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $477696120c5741dc$var$V = q;
                                    else for(; null !== $477696120c5741dc$var$V;){
                                        m = $477696120c5741dc$var$V;
                                        var r = m.sibling, y = m.return;
                                        $477696120c5741dc$var$Tj(m);
                                        if (m === l) {
                                            $477696120c5741dc$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $477696120c5741dc$var$V = r;
                                            break;
                                        }
                                        $477696120c5741dc$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $477696120c5741dc$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $477696120c5741dc$var$V = g;
                    else b: for(; null !== $477696120c5741dc$var$V;){
                        f = $477696120c5741dc$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $477696120c5741dc$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $477696120c5741dc$var$V = x;
                            break b;
                        }
                        $477696120c5741dc$var$V = f.return;
                    }
                }
                var w = a.current;
                for($477696120c5741dc$var$V = w; null !== $477696120c5741dc$var$V;){
                    g = $477696120c5741dc$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $477696120c5741dc$var$V = u;
                    else b: for(g = w; null !== $477696120c5741dc$var$V;){
                        h = $477696120c5741dc$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $477696120c5741dc$var$Rj(9, h);
                            }
                        } catch (na) {
                            $477696120c5741dc$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $477696120c5741dc$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $477696120c5741dc$var$V = F;
                            break b;
                        }
                        $477696120c5741dc$var$V = h.return;
                    }
                }
                $477696120c5741dc$var$K = e;
                $477696120c5741dc$var$jg();
                if ($477696120c5741dc$var$lc && "function" === typeof $477696120c5741dc$var$lc.onPostCommitFiberRoot) try {
                    $477696120c5741dc$var$lc.onPostCommitFiberRoot($477696120c5741dc$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $477696120c5741dc$var$C = c, $477696120c5741dc$var$pk.transition = b;
        }
    }
    return !1;
}
function $477696120c5741dc$var$Yk(a, b, c) {
    b = $477696120c5741dc$var$Ki(c, b);
    b = $477696120c5741dc$var$Oi(a, b, 1);
    a = $477696120c5741dc$var$dh(a, b, 1);
    b = $477696120c5741dc$var$L();
    null !== a && ($477696120c5741dc$var$Ac(a, 1, b), $477696120c5741dc$var$Ek(a, b));
}
function $477696120c5741dc$var$W(a, b, c) {
    if (3 === a.tag) $477696120c5741dc$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $477696120c5741dc$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $477696120c5741dc$var$Si || !$477696120c5741dc$var$Si.has(d))) {
                a = $477696120c5741dc$var$Ki(c, a);
                a = $477696120c5741dc$var$Ri(b, a, 1);
                b = $477696120c5741dc$var$dh(b, a, 1);
                a = $477696120c5741dc$var$L();
                null !== b && ($477696120c5741dc$var$Ac(b, 1, a), $477696120c5741dc$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $477696120c5741dc$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $477696120c5741dc$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $477696120c5741dc$var$R === a && ($477696120c5741dc$var$Z & c) === c && (4 === $477696120c5741dc$var$T || 3 === $477696120c5741dc$var$T && ($477696120c5741dc$var$Z & 130023424) === $477696120c5741dc$var$Z && 500 > $477696120c5741dc$var$B() - $477696120c5741dc$var$gk ? $477696120c5741dc$var$Lk(a, 0) : $477696120c5741dc$var$sk |= c);
    $477696120c5741dc$var$Ek(a, b);
}
function $477696120c5741dc$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $477696120c5741dc$var$sc, $477696120c5741dc$var$sc <<= 1, 0 === ($477696120c5741dc$var$sc & 130023424) && ($477696120c5741dc$var$sc = 4194304)));
    var c = $477696120c5741dc$var$L();
    a = $477696120c5741dc$var$Zg(a, b);
    null !== a && ($477696120c5741dc$var$Ac(a, b, c), $477696120c5741dc$var$Ek(a, c));
}
function $477696120c5741dc$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $477696120c5741dc$var$Zk(a, c);
}
function $477696120c5741dc$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($477696120c5741dc$var$p(314));
    }
    null !== d && d.delete(b);
    $477696120c5741dc$var$Zk(a, c);
}
var $477696120c5741dc$var$Wk;
$477696120c5741dc$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $477696120c5741dc$var$Wf.current) $477696120c5741dc$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $477696120c5741dc$var$Ug = !1, $477696120c5741dc$var$zj(a, b, c);
            $477696120c5741dc$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $477696120c5741dc$var$Ug = !1, $477696120c5741dc$var$I && 0 !== (b.flags & 1048576) && $477696120c5741dc$var$ug(b, $477696120c5741dc$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $477696120c5741dc$var$jj(a, b);
            a = b.pendingProps;
            var e = $477696120c5741dc$var$Yf(b, $477696120c5741dc$var$H.current);
            $477696120c5741dc$var$Tg(b, c);
            e = $477696120c5741dc$var$Xh(null, b, d, a, e, c);
            var f = $477696120c5741dc$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $477696120c5741dc$var$Zf(d) ? (f = !0, $477696120c5741dc$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $477696120c5741dc$var$ah(b), e.updater = $477696120c5741dc$var$nh, b.stateNode = e, e._reactInternals = b, $477696120c5741dc$var$rh(b, d, a, c), b = $477696120c5741dc$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $477696120c5741dc$var$I && f && $477696120c5741dc$var$vg(b), $477696120c5741dc$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $477696120c5741dc$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $477696120c5741dc$var$$k(d);
                a = $477696120c5741dc$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $477696120c5741dc$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $477696120c5741dc$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $477696120c5741dc$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $477696120c5741dc$var$aj(null, b, d, $477696120c5741dc$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($477696120c5741dc$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $477696120c5741dc$var$Lg(d, e), $477696120c5741dc$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $477696120c5741dc$var$Lg(d, e), $477696120c5741dc$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $477696120c5741dc$var$lj(b);
                if (null === a) throw Error($477696120c5741dc$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $477696120c5741dc$var$bh(a, b);
                $477696120c5741dc$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $477696120c5741dc$var$Ki(Error($477696120c5741dc$var$p(423)), b);
                        b = $477696120c5741dc$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $477696120c5741dc$var$Ki(Error($477696120c5741dc$var$p(424)), b);
                        b = $477696120c5741dc$var$mj(a, b, d, c, e);
                        break a;
                    } else for($477696120c5741dc$var$yg = $477696120c5741dc$var$Lf(b.stateNode.containerInfo.firstChild), $477696120c5741dc$var$xg = b, $477696120c5741dc$var$I = !0, $477696120c5741dc$var$zg = null, c = $477696120c5741dc$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $477696120c5741dc$var$Ig();
                    if (d === e) {
                        b = $477696120c5741dc$var$$i(a, b, c);
                        break a;
                    }
                    $477696120c5741dc$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $477696120c5741dc$var$Kh(b), null === a && $477696120c5741dc$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $477696120c5741dc$var$Ef(d, e) ? g = null : null !== f && $477696120c5741dc$var$Ef(d, f) && (b.flags |= 32), $477696120c5741dc$var$hj(a, b), $477696120c5741dc$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $477696120c5741dc$var$Eg(b), null;
        case 13:
            return $477696120c5741dc$var$pj(a, b, c);
        case 4:
            return $477696120c5741dc$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $477696120c5741dc$var$Bh(b, null, d, c) : $477696120c5741dc$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $477696120c5741dc$var$Lg(d, e), $477696120c5741dc$var$Zi(a, b, d, e, c);
        case 7:
            return $477696120c5741dc$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $477696120c5741dc$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $477696120c5741dc$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $477696120c5741dc$var$G($477696120c5741dc$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($477696120c5741dc$var$He(f.value, g)) {
                        if (f.children === e.children && !$477696120c5741dc$var$Wf.current) {
                            b = $477696120c5741dc$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $477696120c5741dc$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $477696120c5741dc$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($477696120c5741dc$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $477696120c5741dc$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $477696120c5741dc$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $477696120c5741dc$var$Tg(b, c), e = $477696120c5741dc$var$Vg(e), d = d(e), b.flags |= 1, $477696120c5741dc$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $477696120c5741dc$var$Lg(d, b.pendingProps), e = $477696120c5741dc$var$Lg(d.type, e), $477696120c5741dc$var$aj(a, b, d, e, c);
        case 15:
            return $477696120c5741dc$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $477696120c5741dc$var$Lg(d, e), $477696120c5741dc$var$jj(a, b), b.tag = 1, $477696120c5741dc$var$Zf(d) ? (a = !0, $477696120c5741dc$var$cg(b)) : a = !1, $477696120c5741dc$var$Tg(b, c), $477696120c5741dc$var$ph(b, d, e), $477696120c5741dc$var$rh(b, d, e, c), $477696120c5741dc$var$kj(null, b, d, !0, a, c);
        case 19:
            return $477696120c5741dc$var$yj(a, b, c);
        case 22:
            return $477696120c5741dc$var$ej(a, b, c);
    }
    throw Error($477696120c5741dc$var$p(156, b.tag));
};
function $477696120c5741dc$var$Gk(a, b) {
    return $477696120c5741dc$var$ac(a, b);
}
function $477696120c5741dc$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $477696120c5741dc$var$Bg(a, b, c, d) {
    return new $477696120c5741dc$var$al(a, b, c, d);
}
function $477696120c5741dc$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $477696120c5741dc$var$$k(a) {
    if ("function" === typeof a) return $477696120c5741dc$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $477696120c5741dc$var$Da) return 11;
        if (a === $477696120c5741dc$var$Ga) return 14;
    }
    return 2;
}
function $477696120c5741dc$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $477696120c5741dc$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $477696120c5741dc$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $477696120c5741dc$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $477696120c5741dc$var$ya:
            return $477696120c5741dc$var$Ah(c.children, e, f, b);
        case $477696120c5741dc$var$za:
            g = 8;
            e |= 8;
            break;
        case $477696120c5741dc$var$Aa:
            return a = $477696120c5741dc$var$Bg(12, c, b, e | 2), a.elementType = $477696120c5741dc$var$Aa, a.lanes = f, a;
        case $477696120c5741dc$var$Ea:
            return a = $477696120c5741dc$var$Bg(13, c, b, e), a.elementType = $477696120c5741dc$var$Ea, a.lanes = f, a;
        case $477696120c5741dc$var$Fa:
            return a = $477696120c5741dc$var$Bg(19, c, b, e), a.elementType = $477696120c5741dc$var$Fa, a.lanes = f, a;
        case $477696120c5741dc$var$Ia:
            return $477696120c5741dc$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $477696120c5741dc$var$Ba:
                    g = 10;
                    break a;
                case $477696120c5741dc$var$Ca:
                    g = 9;
                    break a;
                case $477696120c5741dc$var$Da:
                    g = 11;
                    break a;
                case $477696120c5741dc$var$Ga:
                    g = 14;
                    break a;
                case $477696120c5741dc$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($477696120c5741dc$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $477696120c5741dc$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $477696120c5741dc$var$Ah(a, b, c, d) {
    a = $477696120c5741dc$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $477696120c5741dc$var$qj(a, b, c, d) {
    a = $477696120c5741dc$var$Bg(22, a, d, b);
    a.elementType = $477696120c5741dc$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $477696120c5741dc$var$xh(a, b, c) {
    a = $477696120c5741dc$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $477696120c5741dc$var$zh(a, b, c) {
    b = $477696120c5741dc$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $477696120c5741dc$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $477696120c5741dc$var$zc(0);
    this.expirationTimes = $477696120c5741dc$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $477696120c5741dc$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $477696120c5741dc$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $477696120c5741dc$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $477696120c5741dc$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $477696120c5741dc$var$ah(f);
    return a;
}
function $477696120c5741dc$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $477696120c5741dc$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $477696120c5741dc$var$el(a) {
    if (!a) return $477696120c5741dc$var$Vf;
    a = a._reactInternals;
    a: {
        if ($477696120c5741dc$var$Vb(a) !== a || 1 !== a.tag) throw Error($477696120c5741dc$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($477696120c5741dc$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($477696120c5741dc$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($477696120c5741dc$var$Zf(c)) return $477696120c5741dc$var$bg(a, c, b);
    }
    return b;
}
function $477696120c5741dc$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $477696120c5741dc$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $477696120c5741dc$var$el(null);
    c = a.current;
    d = $477696120c5741dc$var$L();
    e = $477696120c5741dc$var$lh(c);
    f = $477696120c5741dc$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $477696120c5741dc$var$dh(c, f, e);
    a.current.lanes = e;
    $477696120c5741dc$var$Ac(a, e, d);
    $477696120c5741dc$var$Ek(a, d);
    return a;
}
function $477696120c5741dc$var$gl(a, b, c, d) {
    var e = b.current, f = $477696120c5741dc$var$L(), g = $477696120c5741dc$var$lh(e);
    c = $477696120c5741dc$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $477696120c5741dc$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $477696120c5741dc$var$dh(e, b, g);
    null !== a && ($477696120c5741dc$var$mh(a, e, g, f), $477696120c5741dc$var$eh(a, e, g));
    return g;
}
function $477696120c5741dc$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $477696120c5741dc$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $477696120c5741dc$var$jl(a, b) {
    $477696120c5741dc$var$il(a, b);
    (a = a.alternate) && $477696120c5741dc$var$il(a, b);
}
function $477696120c5741dc$var$kl() {
    return null;
}
var $477696120c5741dc$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $477696120c5741dc$var$ml(a) {
    this._internalRoot = a;
}
$477696120c5741dc$var$nl.prototype.render = $477696120c5741dc$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($477696120c5741dc$var$p(409));
    $477696120c5741dc$var$gl(a, b, null, null);
};
$477696120c5741dc$var$nl.prototype.unmount = $477696120c5741dc$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $477696120c5741dc$var$Sk(function() {
            $477696120c5741dc$var$gl(null, a, null, null);
        });
        b[$477696120c5741dc$var$uf] = null;
    }
};
function $477696120c5741dc$var$nl(a) {
    this._internalRoot = a;
}
$477696120c5741dc$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $477696120c5741dc$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $477696120c5741dc$var$Qc.length && 0 !== b && b < $477696120c5741dc$var$Qc[c].priority; c++);
        $477696120c5741dc$var$Qc.splice(c, 0, a);
        0 === c && $477696120c5741dc$var$Vc(a);
    }
};
function $477696120c5741dc$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $477696120c5741dc$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $477696120c5741dc$var$ql() {}
function $477696120c5741dc$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $477696120c5741dc$var$hl(g);
                f.call(a);
            };
        }
        var g = $477696120c5741dc$var$fl(b, d, a, 0, null, !1, !1, "", $477696120c5741dc$var$ql);
        a._reactRootContainer = g;
        a[$477696120c5741dc$var$uf] = g.current;
        $477696120c5741dc$var$sf(8 === a.nodeType ? a.parentNode : a);
        $477696120c5741dc$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $477696120c5741dc$var$hl(k);
            h.call(a);
        };
    }
    var k = $477696120c5741dc$var$cl(a, 0, !1, null, null, !1, !1, "", $477696120c5741dc$var$ql);
    a._reactRootContainer = k;
    a[$477696120c5741dc$var$uf] = k.current;
    $477696120c5741dc$var$sf(8 === a.nodeType ? a.parentNode : a);
    $477696120c5741dc$var$Sk(function() {
        $477696120c5741dc$var$gl(b, k, c, d);
    });
    return k;
}
function $477696120c5741dc$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $477696120c5741dc$var$hl(g);
                h.call(a);
            };
        }
        $477696120c5741dc$var$gl(b, g, a, e);
    } else g = $477696120c5741dc$var$rl(c, b, a, e, d);
    return $477696120c5741dc$var$hl(g);
}
$477696120c5741dc$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $477696120c5741dc$var$tc(b.pendingLanes);
                0 !== c && ($477696120c5741dc$var$Cc(b, c | 1), $477696120c5741dc$var$Ek(b, $477696120c5741dc$var$B()), 0 === ($477696120c5741dc$var$K & 6) && ($477696120c5741dc$var$Hj = $477696120c5741dc$var$B() + 500, $477696120c5741dc$var$jg()));
            }
            break;
        case 13:
            $477696120c5741dc$var$Sk(function() {
                var b = $477696120c5741dc$var$Zg(a, 1);
                if (null !== b) {
                    var c = $477696120c5741dc$var$L();
                    $477696120c5741dc$var$mh(b, a, 1, c);
                }
            }), $477696120c5741dc$var$jl(a, 1);
    }
};
$477696120c5741dc$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $477696120c5741dc$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $477696120c5741dc$var$L();
            $477696120c5741dc$var$mh(b, a, 134217728, c);
        }
        $477696120c5741dc$var$jl(a, 134217728);
    }
};
$477696120c5741dc$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $477696120c5741dc$var$lh(a), c = $477696120c5741dc$var$Zg(a, b);
        if (null !== c) {
            var d = $477696120c5741dc$var$L();
            $477696120c5741dc$var$mh(c, a, b, d);
        }
        $477696120c5741dc$var$jl(a, b);
    }
};
$477696120c5741dc$var$Hc = function() {
    return $477696120c5741dc$var$C;
};
$477696120c5741dc$var$Ic = function(a, b) {
    var c = $477696120c5741dc$var$C;
    try {
        return $477696120c5741dc$var$C = a, b();
    } finally{
        $477696120c5741dc$var$C = c;
    }
};
$477696120c5741dc$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $477696120c5741dc$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $477696120c5741dc$var$Db(d);
                        if (!e) throw Error($477696120c5741dc$var$p(90));
                        $477696120c5741dc$var$Wa(d);
                        $477696120c5741dc$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $477696120c5741dc$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $477696120c5741dc$var$fb(a, !!c.multiple, b, !1);
    }
};
$477696120c5741dc$var$Gb = $477696120c5741dc$var$Rk;
$477696120c5741dc$var$Hb = $477696120c5741dc$var$Sk;
var $477696120c5741dc$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $477696120c5741dc$var$Cb,
        $477696120c5741dc$var$ue,
        $477696120c5741dc$var$Db,
        $477696120c5741dc$var$Eb,
        $477696120c5741dc$var$Fb,
        $477696120c5741dc$var$Rk
    ]
}, $477696120c5741dc$var$ul = {
    findFiberByHostInstance: $477696120c5741dc$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $477696120c5741dc$var$vl = {
    bundleType: $477696120c5741dc$var$ul.bundleType,
    version: $477696120c5741dc$var$ul.version,
    rendererPackageName: $477696120c5741dc$var$ul.rendererPackageName,
    rendererConfig: $477696120c5741dc$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $477696120c5741dc$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $477696120c5741dc$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $477696120c5741dc$var$ul.findFiberByHostInstance || $477696120c5741dc$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $477696120c5741dc$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$477696120c5741dc$var$wl.isDisabled && $477696120c5741dc$var$wl.supportsFiber) try {
        $477696120c5741dc$var$kc = $477696120c5741dc$var$wl.inject($477696120c5741dc$var$vl), $477696120c5741dc$var$lc = $477696120c5741dc$var$wl;
    } catch (a) {}
}
$477696120c5741dc$export$ae55be85d98224ed = $477696120c5741dc$var$tl;
$477696120c5741dc$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$477696120c5741dc$var$ol(b)) throw Error($477696120c5741dc$var$p(200));
    return $477696120c5741dc$var$dl(a, b, null, c);
};
$477696120c5741dc$export$882461b6382ed46c = function(a, b) {
    if (!$477696120c5741dc$var$ol(a)) throw Error($477696120c5741dc$var$p(299));
    var c = !1, d = "", e = $477696120c5741dc$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $477696120c5741dc$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$477696120c5741dc$var$uf] = b.current;
    $477696120c5741dc$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $477696120c5741dc$var$ml(b);
};
$477696120c5741dc$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($477696120c5741dc$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($477696120c5741dc$var$p(268, a));
    }
    a = $477696120c5741dc$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$477696120c5741dc$export$cd75ccfd720a3cd4 = function(a) {
    return $477696120c5741dc$var$Sk(a);
};
$477696120c5741dc$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$477696120c5741dc$var$pl(b)) throw Error($477696120c5741dc$var$p(200));
    return $477696120c5741dc$var$sl(null, a, b, !0, c);
};
$477696120c5741dc$export$757ceba2d55c277e = function(a, b, c) {
    if (!$477696120c5741dc$var$ol(a)) throw Error($477696120c5741dc$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $477696120c5741dc$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $477696120c5741dc$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$477696120c5741dc$var$uf] = b.current;
    $477696120c5741dc$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $477696120c5741dc$var$nl(b);
};
$477696120c5741dc$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$477696120c5741dc$var$pl(b)) throw Error($477696120c5741dc$var$p(200));
    return $477696120c5741dc$var$sl(null, a, b, !1, c);
};
$477696120c5741dc$export$502457920280e6be = function(a) {
    if (!$477696120c5741dc$var$pl(a)) throw Error($477696120c5741dc$var$p(40));
    return a._reactRootContainer ? ($477696120c5741dc$var$Sk(function() {
        $477696120c5741dc$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$477696120c5741dc$var$uf] = null;
        });
    }), !0) : !1;
};
$477696120c5741dc$export$c78a37762a8d58e1 = $477696120c5741dc$var$Rk;
$477696120c5741dc$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$477696120c5741dc$var$pl(c)) throw Error($477696120c5741dc$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($477696120c5741dc$var$p(38));
    return $477696120c5741dc$var$sl(a, b, c, !1, d);
};
$477696120c5741dc$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("1c3ne", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ecVue"));

});
parcelRegister("ecVue", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $a57ec74d8a366a12$export$c4744153514ff05d; }, function (v) { return $a57ec74d8a366a12$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $a57ec74d8a366a12$export$3e506c1ccc9cc1a7; }, function (v) { return $a57ec74d8a366a12$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $a57ec74d8a366a12$export$e26fe2ed2fa76875; }, function (v) { return $a57ec74d8a366a12$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $a57ec74d8a366a12$export$502329bbf4b505b1; }, function (v) { return $a57ec74d8a366a12$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $a57ec74d8a366a12$export$6e3807111c4874c4; }, function (v) { return $a57ec74d8a366a12$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $a57ec74d8a366a12$export$c27134553091fb3a; }, function (v) { return $a57ec74d8a366a12$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $a57ec74d8a366a12$export$33ee1acdc04fd2a2; }, function (v) { return $a57ec74d8a366a12$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $a57ec74d8a366a12$export$b00a404bbd5edef2; }, function (v) { return $a57ec74d8a366a12$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $a57ec74d8a366a12$export$8352ce38b91d0c62; }, function (v) { return $a57ec74d8a366a12$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $a57ec74d8a366a12$export$d66a1c1c77bd778b; }, function (v) { return $a57ec74d8a366a12$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $a57ec74d8a366a12$export$d3dfb8e4810cb555; }, function (v) { return $a57ec74d8a366a12$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $a57ec74d8a366a12$export$839f9183b0465a69; }, function (v) { return $a57ec74d8a366a12$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $a57ec74d8a366a12$export$72fdf0e06517287b; }, function (v) { return $a57ec74d8a366a12$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $a57ec74d8a366a12$export$4b844e58a3e414b4; }, function (v) { return $a57ec74d8a366a12$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $a57ec74d8a366a12$export$816d2913ae6b83b1; }, function (v) { return $a57ec74d8a366a12$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $a57ec74d8a366a12$export$61bcfe829111a1d0; }, function (v) { return $a57ec74d8a366a12$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $a57ec74d8a366a12$export$7ee8c9beb337bc3f; }, function (v) { return $a57ec74d8a366a12$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $a57ec74d8a366a12$export$b5836b71941fa3ed; }, function (v) { return $a57ec74d8a366a12$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $a57ec74d8a366a12$export$cf845f2c119da08a; }, function (v) { return $a57ec74d8a366a12$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a57ec74d8a366a12$export$c4744153514ff05d;
var $a57ec74d8a366a12$export$3e506c1ccc9cc1a7;
var $a57ec74d8a366a12$export$e26fe2ed2fa76875;
var $a57ec74d8a366a12$export$502329bbf4b505b1;
var $a57ec74d8a366a12$export$6e3807111c4874c4;
var $a57ec74d8a366a12$export$c27134553091fb3a;
var $a57ec74d8a366a12$export$33ee1acdc04fd2a2;
var $a57ec74d8a366a12$export$b00a404bbd5edef2;
var $a57ec74d8a366a12$export$8352ce38b91d0c62;
var $a57ec74d8a366a12$export$d66a1c1c77bd778b;
var $a57ec74d8a366a12$export$d3dfb8e4810cb555;
var $a57ec74d8a366a12$export$839f9183b0465a69;
var $a57ec74d8a366a12$export$72fdf0e06517287b;
var $a57ec74d8a366a12$export$4b844e58a3e414b4;
var $a57ec74d8a366a12$export$816d2913ae6b83b1;
var $a57ec74d8a366a12$export$61bcfe829111a1d0;
var $a57ec74d8a366a12$export$7ee8c9beb337bc3f;
var $a57ec74d8a366a12$export$b5836b71941fa3ed;
var $a57ec74d8a366a12$export$cf845f2c119da08a;
"use strict";
function $a57ec74d8a366a12$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $a57ec74d8a366a12$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $a57ec74d8a366a12$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $a57ec74d8a366a12$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $a57ec74d8a366a12$var$g(C, c)) n < e && 0 > $a57ec74d8a366a12$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $a57ec74d8a366a12$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $a57ec74d8a366a12$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $a57ec74d8a366a12$var$l = performance;
    $a57ec74d8a366a12$export$c4744153514ff05d = function() {
        return $a57ec74d8a366a12$var$l.now();
    };
} else {
    var $a57ec74d8a366a12$var$p = Date, $a57ec74d8a366a12$var$q = $a57ec74d8a366a12$var$p.now();
    $a57ec74d8a366a12$export$c4744153514ff05d = function() {
        return $a57ec74d8a366a12$var$p.now() - $a57ec74d8a366a12$var$q;
    };
}
var $a57ec74d8a366a12$var$r = [], $a57ec74d8a366a12$var$t = [], $a57ec74d8a366a12$var$u = 1, $a57ec74d8a366a12$var$v = null, $a57ec74d8a366a12$var$y = 3, $a57ec74d8a366a12$var$z = !1, $a57ec74d8a366a12$var$A = !1, $a57ec74d8a366a12$var$B = !1, $a57ec74d8a366a12$var$D = "function" === typeof setTimeout ? setTimeout : null, $a57ec74d8a366a12$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $a57ec74d8a366a12$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $a57ec74d8a366a12$var$G(a) {
    for(var b = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$t); null !== b;){
        if (null === b.callback) $a57ec74d8a366a12$var$k($a57ec74d8a366a12$var$t);
        else if (b.startTime <= a) $a57ec74d8a366a12$var$k($a57ec74d8a366a12$var$t), b.sortIndex = b.expirationTime, $a57ec74d8a366a12$var$f($a57ec74d8a366a12$var$r, b);
        else break;
        b = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$t);
    }
}
function $a57ec74d8a366a12$var$H(a) {
    $a57ec74d8a366a12$var$B = !1;
    $a57ec74d8a366a12$var$G(a);
    if (!$a57ec74d8a366a12$var$A) {
        if (null !== $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r)) $a57ec74d8a366a12$var$A = !0, $a57ec74d8a366a12$var$I($a57ec74d8a366a12$var$J);
        else {
            var b = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$t);
            null !== b && $a57ec74d8a366a12$var$K($a57ec74d8a366a12$var$H, b.startTime - a);
        }
    }
}
function $a57ec74d8a366a12$var$J(a, b) {
    $a57ec74d8a366a12$var$A = !1;
    $a57ec74d8a366a12$var$B && ($a57ec74d8a366a12$var$B = !1, $a57ec74d8a366a12$var$E($a57ec74d8a366a12$var$L), $a57ec74d8a366a12$var$L = -1);
    $a57ec74d8a366a12$var$z = !0;
    var c = $a57ec74d8a366a12$var$y;
    try {
        $a57ec74d8a366a12$var$G(b);
        for($a57ec74d8a366a12$var$v = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r); null !== $a57ec74d8a366a12$var$v && (!($a57ec74d8a366a12$var$v.expirationTime > b) || a && !$a57ec74d8a366a12$var$M());){
            var d = $a57ec74d8a366a12$var$v.callback;
            if ("function" === typeof d) {
                $a57ec74d8a366a12$var$v.callback = null;
                $a57ec74d8a366a12$var$y = $a57ec74d8a366a12$var$v.priorityLevel;
                var e = d($a57ec74d8a366a12$var$v.expirationTime <= b);
                b = $a57ec74d8a366a12$export$c4744153514ff05d();
                "function" === typeof e ? $a57ec74d8a366a12$var$v.callback = e : $a57ec74d8a366a12$var$v === $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r) && $a57ec74d8a366a12$var$k($a57ec74d8a366a12$var$r);
                $a57ec74d8a366a12$var$G(b);
            } else $a57ec74d8a366a12$var$k($a57ec74d8a366a12$var$r);
            $a57ec74d8a366a12$var$v = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r);
        }
        if (null !== $a57ec74d8a366a12$var$v) var w = !0;
        else {
            var m = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$t);
            null !== m && $a57ec74d8a366a12$var$K($a57ec74d8a366a12$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $a57ec74d8a366a12$var$v = null, $a57ec74d8a366a12$var$y = c, $a57ec74d8a366a12$var$z = !1;
    }
}
var $a57ec74d8a366a12$var$N = !1, $a57ec74d8a366a12$var$O = null, $a57ec74d8a366a12$var$L = -1, $a57ec74d8a366a12$var$P = 5, $a57ec74d8a366a12$var$Q = -1;
function $a57ec74d8a366a12$var$M() {
    return $a57ec74d8a366a12$export$c4744153514ff05d() - $a57ec74d8a366a12$var$Q < $a57ec74d8a366a12$var$P ? !1 : !0;
}
function $a57ec74d8a366a12$var$R() {
    if (null !== $a57ec74d8a366a12$var$O) {
        var a = $a57ec74d8a366a12$export$c4744153514ff05d();
        $a57ec74d8a366a12$var$Q = a;
        var b = !0;
        try {
            b = $a57ec74d8a366a12$var$O(!0, a);
        } finally{
            b ? $a57ec74d8a366a12$var$S() : ($a57ec74d8a366a12$var$N = !1, $a57ec74d8a366a12$var$O = null);
        }
    } else $a57ec74d8a366a12$var$N = !1;
}
var $a57ec74d8a366a12$var$S;
if ("function" === typeof $a57ec74d8a366a12$var$F) $a57ec74d8a366a12$var$S = function() {
    $a57ec74d8a366a12$var$F($a57ec74d8a366a12$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $a57ec74d8a366a12$var$T = new MessageChannel, $a57ec74d8a366a12$var$U = $a57ec74d8a366a12$var$T.port2;
    $a57ec74d8a366a12$var$T.port1.onmessage = $a57ec74d8a366a12$var$R;
    $a57ec74d8a366a12$var$S = function() {
        $a57ec74d8a366a12$var$U.postMessage(null);
    };
} else $a57ec74d8a366a12$var$S = function() {
    $a57ec74d8a366a12$var$D($a57ec74d8a366a12$var$R, 0);
};
function $a57ec74d8a366a12$var$I(a) {
    $a57ec74d8a366a12$var$O = a;
    $a57ec74d8a366a12$var$N || ($a57ec74d8a366a12$var$N = !0, $a57ec74d8a366a12$var$S());
}
function $a57ec74d8a366a12$var$K(a, b) {
    $a57ec74d8a366a12$var$L = $a57ec74d8a366a12$var$D(function() {
        a($a57ec74d8a366a12$export$c4744153514ff05d());
    }, b);
}
$a57ec74d8a366a12$export$3e506c1ccc9cc1a7 = 5;
$a57ec74d8a366a12$export$e26fe2ed2fa76875 = 1;
$a57ec74d8a366a12$export$502329bbf4b505b1 = 4;
$a57ec74d8a366a12$export$6e3807111c4874c4 = 3;
$a57ec74d8a366a12$export$c27134553091fb3a = null;
$a57ec74d8a366a12$export$33ee1acdc04fd2a2 = 2;
$a57ec74d8a366a12$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$a57ec74d8a366a12$export$8352ce38b91d0c62 = function() {
    $a57ec74d8a366a12$var$A || $a57ec74d8a366a12$var$z || ($a57ec74d8a366a12$var$A = !0, $a57ec74d8a366a12$var$I($a57ec74d8a366a12$var$J));
};
$a57ec74d8a366a12$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $a57ec74d8a366a12$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$a57ec74d8a366a12$export$d3dfb8e4810cb555 = function() {
    return $a57ec74d8a366a12$var$y;
};
$a57ec74d8a366a12$export$839f9183b0465a69 = function() {
    return $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r);
};
$a57ec74d8a366a12$export$72fdf0e06517287b = function(a) {
    switch($a57ec74d8a366a12$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $a57ec74d8a366a12$var$y;
    }
    var c = $a57ec74d8a366a12$var$y;
    $a57ec74d8a366a12$var$y = b;
    try {
        return a();
    } finally{
        $a57ec74d8a366a12$var$y = c;
    }
};
$a57ec74d8a366a12$export$4b844e58a3e414b4 = function() {};
$a57ec74d8a366a12$export$816d2913ae6b83b1 = function() {};
$a57ec74d8a366a12$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $a57ec74d8a366a12$var$y;
    $a57ec74d8a366a12$var$y = a;
    try {
        return b();
    } finally{
        $a57ec74d8a366a12$var$y = c;
    }
};
$a57ec74d8a366a12$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $a57ec74d8a366a12$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $a57ec74d8a366a12$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $a57ec74d8a366a12$var$f($a57ec74d8a366a12$var$t, a), null === $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r) && a === $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$t) && ($a57ec74d8a366a12$var$B ? ($a57ec74d8a366a12$var$E($a57ec74d8a366a12$var$L), $a57ec74d8a366a12$var$L = -1) : $a57ec74d8a366a12$var$B = !0, $a57ec74d8a366a12$var$K($a57ec74d8a366a12$var$H, c - d))) : (a.sortIndex = e, $a57ec74d8a366a12$var$f($a57ec74d8a366a12$var$r, a), $a57ec74d8a366a12$var$A || $a57ec74d8a366a12$var$z || ($a57ec74d8a366a12$var$A = !0, $a57ec74d8a366a12$var$I($a57ec74d8a366a12$var$J)));
    return a;
};
$a57ec74d8a366a12$export$b5836b71941fa3ed = $a57ec74d8a366a12$var$M;
$a57ec74d8a366a12$export$cf845f2c119da08a = function(a) {
    var b = $a57ec74d8a366a12$var$y;
    return function() {
        var c = $a57ec74d8a366a12$var$y;
        $a57ec74d8a366a12$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $a57ec74d8a366a12$var$y = c;
        }
    };
};

});



parcelRegister("agd5q", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $77858cb85dfbcb17$export$bf730a2d8bf68b42; }, function (v) { return $77858cb85dfbcb17$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $77858cb85dfbcb17$export$bf730a2d8bf68b42;
"use strict";

var $4Iuzv = parcelRequire("4Iuzv");
function $77858cb85dfbcb17$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $77858cb85dfbcb17$var$p = "function" === typeof Object.is ? Object.is : $77858cb85dfbcb17$var$n, $77858cb85dfbcb17$var$q = $4Iuzv.useSyncExternalStore, $77858cb85dfbcb17$var$r = $4Iuzv.useRef, $77858cb85dfbcb17$var$t = $4Iuzv.useEffect, $77858cb85dfbcb17$var$u = $4Iuzv.useMemo, $77858cb85dfbcb17$var$v = $4Iuzv.useDebugValue;
$77858cb85dfbcb17$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $77858cb85dfbcb17$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $77858cb85dfbcb17$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var b = f.value;
                    if (h(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($77858cb85dfbcb17$var$p(d, a)) return b;
            var e = l(a);
            if (void 0 !== h && h(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $77858cb85dfbcb17$var$q(a, c[0], c[1]);
    $77858cb85dfbcb17$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $77858cb85dfbcb17$var$v(d);
    return d;
};

});

parcelRegister("cnbGx", function(module, exports) {

var $dIRJU = parcelRequire("dIRJU");
module.exports = $dIRJU("eaaPg").then(()=>parcelRequire("7kZKn"));

});
parcelRegister("dIRJU", function(module, exports) {
"use strict";

function $9fd911f5bde9abf3$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("giU2u")).resolve(id));
}
module.exports = $9fd911f5bde9abf3$var$load;

});



var $5aRSq = parcelRequire("5aRSq");

var $4Iuzv = parcelRequire("4Iuzv");
var $21fa618cfc67d6ae$exports = {};

$parcel$export($21fa618cfc67d6ae$exports, "createRoot", function () { return $21fa618cfc67d6ae$export$882461b6382ed46c; }, function (v) { return $21fa618cfc67d6ae$export$882461b6382ed46c = v; });
$parcel$export($21fa618cfc67d6ae$exports, "hydrateRoot", function () { return $21fa618cfc67d6ae$export$757ceba2d55c277e; }, function (v) { return $21fa618cfc67d6ae$export$757ceba2d55c277e = v; });
var $21fa618cfc67d6ae$export$882461b6382ed46c;
var $21fa618cfc67d6ae$export$757ceba2d55c277e;
"use strict";
var $d0525dc7624af49b$exports = {};
"use strict";
function $d0525dc7624af49b$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d0525dc7624af49b$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d0525dc7624af49b$var$checkDCE();

$d0525dc7624af49b$exports = (parcelRequire("68oCn"));


var $21fa618cfc67d6ae$var$i;
$21fa618cfc67d6ae$export$882461b6382ed46c = $d0525dc7624af49b$exports.createRoot;
$21fa618cfc67d6ae$export$757ceba2d55c277e = $d0525dc7624af49b$exports.hydrateRoot;




var $5aRSq = parcelRequire("5aRSq");

var $4Iuzv = parcelRequire("4Iuzv");
/**
 * React Router DOM v6.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4Iuzv = parcelRequire("4Iuzv");

/**
 * @remix-run/router v1.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $f29acb16f05b6a44$var$_extends() {
    $f29acb16f05b6a44$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f29acb16f05b6a44$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $f29acb16f05b6a44$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($f29acb16f05b6a44$export$e19cd5f9376f8cee || ($f29acb16f05b6a44$export$e19cd5f9376f8cee = {}));
const $f29acb16f05b6a44$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $f29acb16f05b6a44$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $f29acb16f05b6a44$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $f29acb16f05b6a44$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $f29acb16f05b6a44$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $f29acb16f05b6a44$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $f29acb16f05b6a44$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $f29acb16f05b6a44$export$fe53371bee54353d(to);
    }
    return $f29acb16f05b6a44$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $f29acb16f05b6a44$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $f29acb16f05b6a44$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $f29acb16f05b6a44$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $f29acb16f05b6a44$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $f29acb16f05b6a44$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $f29acb16f05b6a44$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $f29acb16f05b6a44$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $f29acb16f05b6a44$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $f29acb16f05b6a44$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $f29acb16f05b6a44$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $f29acb16f05b6a44$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $f29acb16f05b6a44$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $f29acb16f05b6a44$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $f29acb16f05b6a44$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $f29acb16f05b6a44$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $f29acb16f05b6a44$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($f29acb16f05b6a44$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push;
        let location = $f29acb16f05b6a44$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $f29acb16f05b6a44$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace;
        let location = $f29acb16f05b6a44$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $f29acb16f05b6a44$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $f29acb16f05b6a44$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $f29acb16f05b6a44$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($f29acb16f05b6a44$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($f29acb16f05b6a44$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $f29acb16f05b6a44$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($f29acb16f05b6a44$var$ResultType || ($f29acb16f05b6a44$var$ResultType = {}));
const $f29acb16f05b6a44$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $f29acb16f05b6a44$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $f29acb16f05b6a44$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $f29acb16f05b6a44$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $f29acb16f05b6a44$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($f29acb16f05b6a44$var$isIndexRoute(route)) {
            let indexRoute = $f29acb16f05b6a44$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $f29acb16f05b6a44$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $f29acb16f05b6a44$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $f29acb16f05b6a44$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $f29acb16f05b6a44$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $f29acb16f05b6a44$var$flattenRoutes(routes);
    $f29acb16f05b6a44$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $f29acb16f05b6a44$var$decodePath(pathname);
        matches = $f29acb16f05b6a44$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $f29acb16f05b6a44$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $f29acb16f05b6a44$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $f29acb16f05b6a44$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $f29acb16f05b6a44$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $f29acb16f05b6a44$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $f29acb16f05b6a44$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $f29acb16f05b6a44$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $f29acb16f05b6a44$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $f29acb16f05b6a44$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $f29acb16f05b6a44$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $f29acb16f05b6a44$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $f29acb16f05b6a44$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $f29acb16f05b6a44$var$paramRe = /^:[\w-]+$/;
const $f29acb16f05b6a44$var$dynamicSegmentValue = 3;
const $f29acb16f05b6a44$var$indexRouteValue = 2;
const $f29acb16f05b6a44$var$emptySegmentValue = 1;
const $f29acb16f05b6a44$var$staticSegmentValue = 10;
const $f29acb16f05b6a44$var$splatPenalty = -2;
const $f29acb16f05b6a44$var$isSplat = (s)=>s === "*";
function $f29acb16f05b6a44$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($f29acb16f05b6a44$var$isSplat)) initialScore += $f29acb16f05b6a44$var$splatPenalty;
    if (index) initialScore += $f29acb16f05b6a44$var$indexRouteValue;
    return segments.filter((s)=>!$f29acb16f05b6a44$var$isSplat(s)).reduce((score, segment)=>score + ($f29acb16f05b6a44$var$paramRe.test(segment) ? $f29acb16f05b6a44$var$dynamicSegmentValue : segment === "" ? $f29acb16f05b6a44$var$emptySegmentValue : $f29acb16f05b6a44$var$staticSegmentValue), initialScore);
}
function $f29acb16f05b6a44$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $f29acb16f05b6a44$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $f29acb16f05b6a44$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $f29acb16f05b6a44$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $f29acb16f05b6a44$export$a5c6d149b50c1d86($f29acb16f05b6a44$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $f29acb16f05b6a44$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $f29acb16f05b6a44$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $f29acb16f05b6a44$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $f29acb16f05b6a44$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $f29acb16f05b6a44$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $f29acb16f05b6a44$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $f29acb16f05b6a44$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $f29acb16f05b6a44$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $f29acb16f05b6a44$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $f29acb16f05b6a44$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $f29acb16f05b6a44$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $f29acb16f05b6a44$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $f29acb16f05b6a44$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $f29acb16f05b6a44$var$normalizeSearch(search),
        hash: $f29acb16f05b6a44$var$normalizeHash(hash)
    };
}
function $f29acb16f05b6a44$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $f29acb16f05b6a44$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $f29acb16f05b6a44$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $f29acb16f05b6a44$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $f29acb16f05b6a44$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $f29acb16f05b6a44$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $f29acb16f05b6a44$export$8ccf933b0513f8d0(toArg);
    else {
        to = $f29acb16f05b6a44$var$_extends({}, toArg);
        $f29acb16f05b6a44$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $f29acb16f05b6a44$var$getInvalidPathError("?", "pathname", "search", to));
        $f29acb16f05b6a44$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $f29acb16f05b6a44$var$getInvalidPathError("#", "pathname", "hash", to));
        $f29acb16f05b6a44$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $f29acb16f05b6a44$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $f29acb16f05b6a44$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $f29acb16f05b6a44$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $f29acb16f05b6a44$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $f29acb16f05b6a44$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $f29acb16f05b6a44$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $f29acb16f05b6a44$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $f29acb16f05b6a44$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $f29acb16f05b6a44$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $f29acb16f05b6a44$export$42a99a7a4bc0e76a extends Error {
}
class $f29acb16f05b6a44$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $f29acb16f05b6a44$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $f29acb16f05b6a44$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $f29acb16f05b6a44$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $f29acb16f05b6a44$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $f29acb16f05b6a44$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $f29acb16f05b6a44$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $f29acb16f05b6a44$var$unwrapTrackedPromise(value) {
    if (!$f29acb16f05b6a44$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $f29acb16f05b6a44$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $f29acb16f05b6a44$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $f29acb16f05b6a44$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $f29acb16f05b6a44$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $f29acb16f05b6a44$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $f29acb16f05b6a44$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $f29acb16f05b6a44$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $f29acb16f05b6a44$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $f29acb16f05b6a44$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $f29acb16f05b6a44$var$validMutationMethods = new Set($f29acb16f05b6a44$var$validMutationMethodsArr);
const $f29acb16f05b6a44$var$validRequestMethodsArr = [
    "get",
    ...$f29acb16f05b6a44$var$validMutationMethodsArr
];
const $f29acb16f05b6a44$var$validRequestMethods = new Set($f29acb16f05b6a44$var$validRequestMethodsArr);
const $f29acb16f05b6a44$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $f29acb16f05b6a44$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $f29acb16f05b6a44$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $f29acb16f05b6a44$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $f29acb16f05b6a44$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $f29acb16f05b6a44$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $f29acb16f05b6a44$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $f29acb16f05b6a44$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $f29acb16f05b6a44$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $f29acb16f05b6a44$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $f29acb16f05b6a44$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $f29acb16f05b6a44$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $f29acb16f05b6a44$var$defaultDataStrategy;
    // Config driven behavior flags
    let future = $f29acb16f05b6a44$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        unstable_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $f29acb16f05b6a44$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $f29acb16f05b6a44$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $f29acb16f05b6a44$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $f29acb16f05b6a44$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $f29acb16f05b6a44$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $f29acb16f05b6a44$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $f29acb16f05b6a44$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$f29acb16f05b6a44$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $f29acb16f05b6a44$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $f29acb16f05b6a44$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $f29acb16f05b6a44$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $f29acb16f05b6a44$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $f29acb16f05b6a44$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($f29acb16f05b6a44$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $f29acb16f05b6a44$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $f29acb16f05b6a44$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $f29acb16f05b6a44$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $f29acb16f05b6a44$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $f29acb16f05b6a44$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $f29acb16f05b6a44$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $f29acb16f05b6a44$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $f29acb16f05b6a44$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $f29acb16f05b6a44$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $f29acb16f05b6a44$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $f29acb16f05b6a44$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $f29acb16f05b6a44$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $f29acb16f05b6a44$var$findNearestBoundary(matches).route.id,
            {
                type: $f29acb16f05b6a44$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $f29acb16f05b6a44$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $f29acb16f05b6a44$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = $f29acb16f05b6a44$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $f29acb16f05b6a44$var$_extends({
            matches: matches
        }, $f29acb16f05b6a44$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $f29acb16f05b6a44$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $f29acb16f05b6a44$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $f29acb16f05b6a44$var$ResultType.error,
            error: $f29acb16f05b6a44$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($f29acb16f05b6a44$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $f29acb16f05b6a44$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($f29acb16f05b6a44$var$isDeferredResult(result)) throw $f29acb16f05b6a44$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($f29acb16f05b6a44$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $f29acb16f05b6a44$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push;
            return {
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $f29acb16f05b6a44$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $f29acb16f05b6a44$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $f29acb16f05b6a44$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $f29acb16f05b6a44$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $f29acb16f05b6a44$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $f29acb16f05b6a44$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $f29acb16f05b6a44$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData;
            if (pendingActionResult && !$f29acb16f05b6a44$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
            // would be a breaking change to use any.
            // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
            actionData = {
                [pendingActionResult[0]]: pendingActionResult[1].data
            };
            else if (state.actionData) {
                if (Object.keys(state.actionData).length === 0) actionData = null;
                else actionData = state.actionData;
            }
            updateState($f29acb16f05b6a44$var$_extends({
                navigation: loadingNavigation
            }, actionData !== undefined ? {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $f29acb16f05b6a44$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $f29acb16f05b6a44$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $f29acb16f05b6a44$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $f29acb16f05b6a44$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $f29acb16f05b6a44$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $f29acb16f05b6a44$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $f29acb16f05b6a44$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $f29acb16f05b6a44$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $f29acb16f05b6a44$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $f29acb16f05b6a44$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $f29acb16f05b6a44$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($f29acb16f05b6a44$var$isRedirectResult(actionResult) || $f29acb16f05b6a44$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $f29acb16f05b6a44$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($f29acb16f05b6a44$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $f29acb16f05b6a44$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $f29acb16f05b6a44$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($f29acb16f05b6a44$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($f29acb16f05b6a44$var$isDeferredResult(actionResult)) throw $f29acb16f05b6a44$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $f29acb16f05b6a44$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $f29acb16f05b6a44$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $f29acb16f05b6a44$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $f29acb16f05b6a44$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $f29acb16f05b6a44$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $f29acb16f05b6a44$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $f29acb16f05b6a44$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $f29acb16f05b6a44$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $f29acb16f05b6a44$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $f29acb16f05b6a44$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $f29acb16f05b6a44$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $f29acb16f05b6a44$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $f29acb16f05b6a44$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($f29acb16f05b6a44$var$isDeferredResult(result)) result = await $f29acb16f05b6a44$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $f29acb16f05b6a44$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($f29acb16f05b6a44$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $f29acb16f05b6a44$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($f29acb16f05b6a44$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $f29acb16f05b6a44$export$3e9cee6b33872309(!$f29acb16f05b6a44$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $f29acb16f05b6a44$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $f29acb16f05b6a44$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $f29acb16f05b6a44$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $f29acb16f05b6a44$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($f29acb16f05b6a44$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $f29acb16f05b6a44$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace : $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $f29acb16f05b6a44$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($f29acb16f05b6a44$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $f29acb16f05b6a44$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $f29acb16f05b6a44$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $f29acb16f05b6a44$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $f29acb16f05b6a44$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($f29acb16f05b6a44$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $f29acb16f05b6a44$var$ResultType.redirect,
                        response: $f29acb16f05b6a44$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $f29acb16f05b6a44$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $f29acb16f05b6a44$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $f29acb16f05b6a44$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $f29acb16f05b6a44$var$ResultType.error,
                    error: $f29acb16f05b6a44$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $f29acb16f05b6a44$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $f29acb16f05b6a44$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $f29acb16f05b6a44$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $f29acb16f05b6a44$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $f29acb16f05b6a44$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $f29acb16f05b6a44$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $f29acb16f05b6a44$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $f29acb16f05b6a44$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $f29acb16f05b6a44$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $f29acb16f05b6a44$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $f29acb16f05b6a44$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $f29acb16f05b6a44$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $f29acb16f05b6a44$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$f29acb16f05b6a44$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $f29acb16f05b6a44$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $f29acb16f05b6a44$export$4d0306f8f6a4585b = Symbol("deferred");
function $f29acb16f05b6a44$export$3336b097a6fbc59a(routes, opts) {
    $f29acb16f05b6a44$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $f29acb16f05b6a44$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $f29acb16f05b6a44$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $f29acb16f05b6a44$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $f29acb16f05b6a44$var$createLocation("", $f29acb16f05b6a44$export$fe53371bee54353d(url), null, "default");
        let matches = $f29acb16f05b6a44$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$f29acb16f05b6a44$var$isValidMethod(method) && method !== "HEAD") {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $f29acb16f05b6a44$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $f29acb16f05b6a44$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($f29acb16f05b6a44$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $f29acb16f05b6a44$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $f29acb16f05b6a44$var$createLocation("", $f29acb16f05b6a44$export$fe53371bee54353d(url), null, "default");
        let matches = $f29acb16f05b6a44$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$f29acb16f05b6a44$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $f29acb16f05b6a44$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $f29acb16f05b6a44$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $f29acb16f05b6a44$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $f29acb16f05b6a44$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $f29acb16f05b6a44$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, null, false, match);
        if ($f29acb16f05b6a44$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$f29acb16f05b6a44$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $f29acb16f05b6a44$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($f29acb16f05b6a44$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $f29acb16f05b6a44$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $f29acb16f05b6a44$var$isResponse(result) ? result : $f29acb16f05b6a44$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($f29acb16f05b6a44$var$isHandlerResult(e) && $f29acb16f05b6a44$var$isResponse(e.result)) {
                if (e.type === $f29acb16f05b6a44$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($f29acb16f05b6a44$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $f29acb16f05b6a44$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $f29acb16f05b6a44$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($f29acb16f05b6a44$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($f29acb16f05b6a44$var$isDeferredResult(result)) {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $f29acb16f05b6a44$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($f29acb16f05b6a44$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($f29acb16f05b6a44$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $f29acb16f05b6a44$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $f29acb16f05b6a44$var$_extends({}, context, {
                statusCode: $f29acb16f05b6a44$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $f29acb16f05b6a44$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $f29acb16f05b6a44$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $f29acb16f05b6a44$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $f29acb16f05b6a44$var$isErrorResult(pendingActionResult[1]) ? $f29acb16f05b6a44$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $f29acb16f05b6a44$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $f29acb16f05b6a44$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $f29acb16f05b6a44$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $f29acb16f05b6a44$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $f29acb16f05b6a44$var$callDataStrategyImpl(unstable_dataStrategy || $f29acb16f05b6a44$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($f29acb16f05b6a44$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $f29acb16f05b6a44$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($f29acb16f05b6a44$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $f29acb16f05b6a44$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $f29acb16f05b6a44$export$fec11da027c70692(routes, context, error) {
    let newContext = $f29acb16f05b6a44$var$_extends({}, context, {
        statusCode: $f29acb16f05b6a44$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $f29acb16f05b6a44$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $f29acb16f05b6a44$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $f29acb16f05b6a44$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $f29acb16f05b6a44$export$cae722b0cc860f13(to ? to : ".", $f29acb16f05b6a44$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $f29acb16f05b6a44$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$f29acb16f05b6a44$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $f29acb16f05b6a44$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $f29acb16f05b6a44$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $f29acb16f05b6a44$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$f29acb16f05b6a44$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$f29acb16f05b6a44$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $f29acb16f05b6a44$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $f29acb16f05b6a44$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $f29acb16f05b6a44$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$f29acb16f05b6a44$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$f29acb16f05b6a44$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $f29acb16f05b6a44$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $f29acb16f05b6a44$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $f29acb16f05b6a44$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $f29acb16f05b6a44$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $f29acb16f05b6a44$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($f29acb16f05b6a44$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $f29acb16f05b6a44$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $f29acb16f05b6a44$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $f29acb16f05b6a44$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $f29acb16f05b6a44$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $f29acb16f05b6a44$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $f29acb16f05b6a44$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $f29acb16f05b6a44$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $f29acb16f05b6a44$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($f29acb16f05b6a44$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $f29acb16f05b6a44$var$shouldRevalidateLoader(match, $f29acb16f05b6a44$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $f29acb16f05b6a44$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $f29acb16f05b6a44$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $f29acb16f05b6a44$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $f29acb16f05b6a44$var$shouldRevalidateLoader(fetcherMatch, $f29acb16f05b6a44$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $f29acb16f05b6a44$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $f29acb16f05b6a44$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $f29acb16f05b6a44$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $f29acb16f05b6a44$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $f29acb16f05b6a44$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $f29acb16f05b6a44$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$f29acb16f05b6a44$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $f29acb16f05b6a44$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $f29acb16f05b6a44$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $f29acb16f05b6a44$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $f29acb16f05b6a44$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $f29acb16f05b6a44$var$ResultType.data,
                    result: undefined
                });
            };
            return $f29acb16f05b6a44$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$f29acb16f05b6a44$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $f29acb16f05b6a44$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $f29acb16f05b6a44$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $f29acb16f05b6a44$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $f29acb16f05b6a44$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $f29acb16f05b6a44$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $f29acb16f05b6a44$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $f29acb16f05b6a44$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $f29acb16f05b6a44$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $f29acb16f05b6a44$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type, status: status } = handlerResult;
    if ($f29acb16f05b6a44$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $f29acb16f05b6a44$var$ResultType.error,
                error: e
            };
        }
        if (type === $f29acb16f05b6a44$var$ResultType.error) return {
            type: $f29acb16f05b6a44$var$ResultType.error,
            error: new $f29acb16f05b6a44$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $f29acb16f05b6a44$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $f29acb16f05b6a44$var$ResultType.error) return {
        type: $f29acb16f05b6a44$var$ResultType.error,
        error: result,
        statusCode: $f29acb16f05b6a44$export$972111febbeef05b(result) ? result.status : status
    };
    if ($f29acb16f05b6a44$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $f29acb16f05b6a44$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $f29acb16f05b6a44$var$ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function $f29acb16f05b6a44$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $f29acb16f05b6a44$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$f29acb16f05b6a44$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $f29acb16f05b6a44$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $f29acb16f05b6a44$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($f29acb16f05b6a44$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $f29acb16f05b6a44$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $f29acb16f05b6a44$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($f29acb16f05b6a44$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $f29acb16f05b6a44$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $f29acb16f05b6a44$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $f29acb16f05b6a44$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $f29acb16f05b6a44$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $f29acb16f05b6a44$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $f29acb16f05b6a44$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $f29acb16f05b6a44$export$3e9cee6b33872309(!$f29acb16f05b6a44$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($f29acb16f05b6a44$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $f29acb16f05b6a44$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $f29acb16f05b6a44$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($f29acb16f05b6a44$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $f29acb16f05b6a44$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $f29acb16f05b6a44$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $f29acb16f05b6a44$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($f29acb16f05b6a44$var$isErrorResult(result)) {
            let boundaryMatch = $f29acb16f05b6a44$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $f29acb16f05b6a44$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($f29acb16f05b6a44$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $f29acb16f05b6a44$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($f29acb16f05b6a44$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $f29acb16f05b6a44$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $f29acb16f05b6a44$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $f29acb16f05b6a44$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $f29acb16f05b6a44$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $f29acb16f05b6a44$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $f29acb16f05b6a44$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $f29acb16f05b6a44$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $f29acb16f05b6a44$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $f29acb16f05b6a44$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $f29acb16f05b6a44$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $f29acb16f05b6a44$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($f29acb16f05b6a44$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $f29acb16f05b6a44$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(path) : path;
    return $f29acb16f05b6a44$export$fe53371bee54353d($f29acb16f05b6a44$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $f29acb16f05b6a44$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $f29acb16f05b6a44$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $f29acb16f05b6a44$var$ResultType.data || result.type === $f29acb16f05b6a44$var$ResultType.error);
}
function $f29acb16f05b6a44$var$isRedirectHandlerResult(result) {
    return $f29acb16f05b6a44$var$isResponse(result.result) && $f29acb16f05b6a44$var$redirectStatusCodes.has(result.result.status);
}
function $f29acb16f05b6a44$var$isDeferredResult(result) {
    return result.type === $f29acb16f05b6a44$var$ResultType.deferred;
}
function $f29acb16f05b6a44$var$isErrorResult(result) {
    return result.type === $f29acb16f05b6a44$var$ResultType.error;
}
function $f29acb16f05b6a44$var$isRedirectResult(result) {
    return (result && result.type) === $f29acb16f05b6a44$var$ResultType.redirect;
}
function $f29acb16f05b6a44$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $f29acb16f05b6a44$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $f29acb16f05b6a44$var$isRedirectResponse(result) {
    if (!$f29acb16f05b6a44$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $f29acb16f05b6a44$var$isValidMethod(method) {
    return $f29acb16f05b6a44$var$validRequestMethods.has(method.toLowerCase());
}
function $f29acb16f05b6a44$var$isMutationMethod(method) {
    return $f29acb16f05b6a44$var$validMutationMethods.has(method.toLowerCase());
}
async function $f29acb16f05b6a44$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$f29acb16f05b6a44$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($f29acb16f05b6a44$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $f29acb16f05b6a44$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $f29acb16f05b6a44$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $f29acb16f05b6a44$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $f29acb16f05b6a44$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $f29acb16f05b6a44$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $f29acb16f05b6a44$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $f29acb16f05b6a44$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $f29acb16f05b6a44$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $f29acb16f05b6a44$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $f29acb16f05b6a44$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $f29acb16f05b6a44$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $f29acb16f05b6a44$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $f29acb16f05b6a44$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $f29acb16f05b6a44$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $f29acb16f05b6a44$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $f29acb16f05b6a44$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $f29acb16f05b6a44$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($f29acb16f05b6a44$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $f29acb16f05b6a44$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($f29acb16f05b6a44$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $f29acb16f05b6a44$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4Iuzv = parcelRequire("4Iuzv");

function $175a2504a1bf07a5$var$_extends() {
    $175a2504a1bf07a5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $175a2504a1bf07a5$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $175a2504a1bf07a5$export$3add0d5dce533e2e = /*#__PURE__*/ $4Iuzv.createContext(null);
const $175a2504a1bf07a5$export$145dfa71566a64dc = /*#__PURE__*/ $4Iuzv.createContext(null);
const $175a2504a1bf07a5$var$AwaitContext = /*#__PURE__*/ $4Iuzv.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $175a2504a1bf07a5$export$26749e8557646306 = /*#__PURE__*/ $4Iuzv.createContext(null);
const $175a2504a1bf07a5$export$c7914228fb69b0f5 = /*#__PURE__*/ $4Iuzv.createContext(null);
const $175a2504a1bf07a5$export$9072aa6dd1f93057 = /*#__PURE__*/ $4Iuzv.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $175a2504a1bf07a5$var$RouteErrorContext = /*#__PURE__*/ $4Iuzv.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $175a2504a1bf07a5$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $4Iuzv.useContext($175a2504a1bf07a5$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $175a2504a1bf07a5$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $f29acb16f05b6a44$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $175a2504a1bf07a5$export$9c954a9d03d32f4a() {
    return $4Iuzv.useContext($175a2504a1bf07a5$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $175a2504a1bf07a5$export$45d76561a5302f2b() {
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return $4Iuzv.useContext($175a2504a1bf07a5$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $175a2504a1bf07a5$export$1b3f31771c5d07c() {
    return $4Iuzv.useContext($175a2504a1bf07a5$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $175a2504a1bf07a5$export$6c330e8992e8a295(pattern) {
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $175a2504a1bf07a5$export$45d76561a5302f2b();
    return $4Iuzv.useMemo(()=>(0, $f29acb16f05b6a44$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $175a2504a1bf07a5$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $175a2504a1bf07a5$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $4Iuzv.useContext($175a2504a1bf07a5$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $4Iuzv.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $175a2504a1bf07a5$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $175a2504a1bf07a5$var$useNavigateStable() : $175a2504a1bf07a5$var$useNavigateUnstable();
}
function $175a2504a1bf07a5$var$useNavigateUnstable() {
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let dataRouterContext = $4Iuzv.useContext($175a2504a1bf07a5$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $4Iuzv.useContext($175a2504a1bf07a5$export$26749e8557646306);
    let { matches: matches } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $175a2504a1bf07a5$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $f29acb16f05b6a44$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $4Iuzv.useRef(false);
    $175a2504a1bf07a5$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4Iuzv.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $f29acb16f05b6a44$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $f29acb16f05b6a44$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $175a2504a1bf07a5$var$OutletContext = /*#__PURE__*/ $4Iuzv.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $175a2504a1bf07a5$export$4138103a3ae699cc() {
    return $4Iuzv.useContext($175a2504a1bf07a5$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $175a2504a1bf07a5$export$a3be3530d8e40d0b(context) {
    let outlet = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $175a2504a1bf07a5$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $175a2504a1bf07a5$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $4Iuzv.useContext($175a2504a1bf07a5$export$26749e8557646306);
    let { matches: matches } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $175a2504a1bf07a5$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $f29acb16f05b6a44$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $4Iuzv.useMemo(()=>(0, $f29acb16f05b6a44$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $175a2504a1bf07a5$export$5d3fca4a98652595(routes, locationArg) {
    return $175a2504a1bf07a5$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $175a2504a1bf07a5$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $4Iuzv.useContext($175a2504a1bf07a5$export$26749e8557646306);
    let { matches: parentMatches } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $175a2504a1bf07a5$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $f29acb16f05b6a44$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $f29acb16f05b6a44$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $175a2504a1bf07a5$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $f29acb16f05b6a44$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $f29acb16f05b6a44$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $175a2504a1bf07a5$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $f29acb16f05b6a44$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $175a2504a1bf07a5$var$DefaultErrorComponent() {
    let error = $175a2504a1bf07a5$export$ed527bf60f6e05f2();
    let message = (0, $f29acb16f05b6a44$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $4Iuzv.createElement($4Iuzv.Fragment, null, /*#__PURE__*/ $4Iuzv.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $4Iuzv.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $4Iuzv.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $175a2504a1bf07a5$var$defaultErrorElement = /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$DefaultErrorComponent, null);
class $175a2504a1bf07a5$var$RenderErrorBoundary extends $4Iuzv.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $175a2504a1bf07a5$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $4Iuzv.useContext($175a2504a1bf07a5$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $175a2504a1bf07a5$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $175a2504a1bf07a5$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $175a2504a1bf07a5$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $4Iuzv.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $175a2504a1bf07a5$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($175a2504a1bf07a5$var$DataRouterHook || {});
var $175a2504a1bf07a5$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($175a2504a1bf07a5$var$DataRouterStateHook || {});
function $175a2504a1bf07a5$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $175a2504a1bf07a5$var$useDataRouterContext(hookName) {
    let ctx = $4Iuzv.useContext($175a2504a1bf07a5$export$3add0d5dce533e2e);
    !ctx && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return ctx;
}
function $175a2504a1bf07a5$var$useDataRouterState(hookName) {
    let state = $4Iuzv.useContext($175a2504a1bf07a5$export$145dfa71566a64dc);
    !state && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return state;
}
function $175a2504a1bf07a5$var$useRouteContext(hookName) {
    let route = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    !route && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $175a2504a1bf07a5$var$useCurrentRouteId(hookName) {
    let route = $175a2504a1bf07a5$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $175a2504a1bf07a5$export$5fc8298006ad9e58() {
    return $175a2504a1bf07a5$var$useCurrentRouteId($175a2504a1bf07a5$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $175a2504a1bf07a5$export$d0fd4b7106de2769() {
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $175a2504a1bf07a5$export$600dc272ed516c15() {
    let dataRouterContext = $175a2504a1bf07a5$var$useDataRouterContext($175a2504a1bf07a5$var$DataRouterHook.UseRevalidator);
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseRevalidator);
    return $4Iuzv.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $175a2504a1bf07a5$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseMatches);
    return $4Iuzv.useMemo(()=>matches.map((m)=>(0, $f29acb16f05b6a44$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $175a2504a1bf07a5$export$1448a5050d252c4d() {
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseLoaderData);
    let routeId = $175a2504a1bf07a5$var$useCurrentRouteId($175a2504a1bf07a5$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $175a2504a1bf07a5$export$fd5d37484eab868d(routeId) {
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $175a2504a1bf07a5$export$fdc00f3f26066d5e() {
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseActionData);
    let routeId = $175a2504a1bf07a5$var$useCurrentRouteId($175a2504a1bf07a5$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $175a2504a1bf07a5$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $4Iuzv.useContext($175a2504a1bf07a5$var$RouteErrorContext);
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseRouteError);
    let routeId = $175a2504a1bf07a5$var$useCurrentRouteId($175a2504a1bf07a5$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $175a2504a1bf07a5$export$78a72ddb39bdd145() {
    let value = $4Iuzv.useContext($175a2504a1bf07a5$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $175a2504a1bf07a5$export$17f53340677d5831() {
    let value = $4Iuzv.useContext($175a2504a1bf07a5$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $175a2504a1bf07a5$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $175a2504a1bf07a5$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $175a2504a1bf07a5$var$useDataRouterContext($175a2504a1bf07a5$var$DataRouterHook.UseBlocker);
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $4Iuzv.useState("");
    let blockerFunction = $4Iuzv.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $175a2504a1bf07a5$var$_extends({}, currentLocation, {
                pathname: (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $175a2504a1bf07a5$var$_extends({}, nextLocation, {
                pathname: (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $4Iuzv.useEffect(()=>{
        let key = String(++$175a2504a1bf07a5$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $4Iuzv.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $f29acb16f05b6a44$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $175a2504a1bf07a5$var$useNavigateStable() {
    let { router: router } = $175a2504a1bf07a5$var$useDataRouterContext($175a2504a1bf07a5$var$DataRouterHook.UseNavigateStable);
    let id = $175a2504a1bf07a5$var$useCurrentRouteId($175a2504a1bf07a5$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $4Iuzv.useRef(false);
    $175a2504a1bf07a5$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4Iuzv.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $175a2504a1bf07a5$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $175a2504a1bf07a5$var$alreadyWarned = {};
function $175a2504a1bf07a5$var$warningOnce(key, cond, message) {
    if (!cond && !$175a2504a1bf07a5$var$alreadyWarned[key]) $175a2504a1bf07a5$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $175a2504a1bf07a5$var$START_TRANSITION = "startTransition";
const $175a2504a1bf07a5$var$startTransitionImpl = $4Iuzv[$175a2504a1bf07a5$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $175a2504a1bf07a5$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $4Iuzv.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4Iuzv.useCallback((newState)=>{
        if (v7_startTransition && $175a2504a1bf07a5$var$startTransitionImpl) $175a2504a1bf07a5$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $4Iuzv.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $4Iuzv.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $4Iuzv.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $4Iuzv.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $4Iuzv.createElement($4Iuzv.Fragment, null, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $175a2504a1bf07a5$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $175a2504a1bf07a5$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $175a2504a1bf07a5$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $4Iuzv.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f29acb16f05b6a44$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4Iuzv.useCallback((newState)=>{
        v7_startTransition && $175a2504a1bf07a5$var$startTransitionImpl ? $175a2504a1bf07a5$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $175a2504a1bf07a5$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $4Iuzv.useContext($175a2504a1bf07a5$export$26749e8557646306);
    let { matches: matches } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $175a2504a1bf07a5$export$45d76561a5302f2b();
    let navigate = $175a2504a1bf07a5$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $f29acb16f05b6a44$export$cae722b0cc860f13)(to, (0, $f29acb16f05b6a44$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $4Iuzv.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $175a2504a1bf07a5$export$910ae8079b2c2852(props) {
    return $175a2504a1bf07a5$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $175a2504a1bf07a5$export$e7b0ac011bb776c6(_props) {
    (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $175a2504a1bf07a5$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $f29acb16f05b6a44$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $4Iuzv.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $175a2504a1bf07a5$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $f29acb16f05b6a44$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $4Iuzv.useMemo(()=>{
        let trailingPathname = (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $175a2504a1bf07a5$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $175a2504a1bf07a5$export$5d3fca4a98652595($175a2504a1bf07a5$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $175a2504a1bf07a5$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$ResolveAwait, null, children));
}
var $175a2504a1bf07a5$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($175a2504a1bf07a5$var$AwaitRenderStatus || {});
const $175a2504a1bf07a5$var$neverSettledPromise = new Promise(()=>{});
class $175a2504a1bf07a5$var$AwaitErrorBoundary extends $4Iuzv.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $175a2504a1bf07a5$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $175a2504a1bf07a5$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $175a2504a1bf07a5$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $175a2504a1bf07a5$var$AwaitRenderStatus.error : promise._data !== undefined ? $175a2504a1bf07a5$var$AwaitRenderStatus.success : $175a2504a1bf07a5$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $175a2504a1bf07a5$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $175a2504a1bf07a5$var$AwaitRenderStatus.error && promise._error instanceof (0, $f29acb16f05b6a44$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $175a2504a1bf07a5$var$neverSettledPromise;
        if (status === $175a2504a1bf07a5$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $175a2504a1bf07a5$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $175a2504a1bf07a5$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $175a2504a1bf07a5$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $175a2504a1bf07a5$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $4Iuzv.createElement($4Iuzv.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $175a2504a1bf07a5$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $4Iuzv.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $4Iuzv.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $4Iuzv.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $175a2504a1bf07a5$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $175a2504a1bf07a5$export$e7b0ac011bb776c6) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $175a2504a1bf07a5$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $175a2504a1bf07a5$export$daf73786167a7f72(matches) {
    return $175a2504a1bf07a5$var$_renderMatches(matches);
}
function $175a2504a1bf07a5$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $4Iuzv.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $4Iuzv.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $4Iuzv.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $175a2504a1bf07a5$export$f30f7e456d254e83(routes, opts) {
    return (0, $f29acb16f05b6a44$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $175a2504a1bf07a5$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f29acb16f05b6a44$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $175a2504a1bf07a5$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy
    }).initialize();
}



function $c34e9f2261c19895$var$_extends() {
    $c34e9f2261c19895$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c34e9f2261c19895$var$_extends.apply(this, arguments);
}
function $c34e9f2261c19895$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $c34e9f2261c19895$var$defaultMethod = "get";
const $c34e9f2261c19895$var$defaultEncType = "application/x-www-form-urlencoded";
function $c34e9f2261c19895$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $c34e9f2261c19895$var$isButtonElement(object) {
    return $c34e9f2261c19895$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $c34e9f2261c19895$var$isFormElement(object) {
    return $c34e9f2261c19895$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $c34e9f2261c19895$var$isInputElement(object) {
    return $c34e9f2261c19895$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $c34e9f2261c19895$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $c34e9f2261c19895$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$c34e9f2261c19895$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $c34e9f2261c19895$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $c34e9f2261c19895$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $c34e9f2261c19895$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $c34e9f2261c19895$var$_formDataSupportsSubmitter = null;
function $c34e9f2261c19895$var$isFormDataSubmitterSupported() {
    if ($c34e9f2261c19895$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $c34e9f2261c19895$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $c34e9f2261c19895$var$_formDataSupportsSubmitter = true;
    }
    return $c34e9f2261c19895$var$_formDataSupportsSubmitter;
}
const $c34e9f2261c19895$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $c34e9f2261c19895$var$getFormEncType(encType) {
    if (encType != null && !$c34e9f2261c19895$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $c34e9f2261c19895$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($c34e9f2261c19895$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $c34e9f2261c19895$var$defaultMethod;
        encType = $c34e9f2261c19895$var$getFormEncType(target.getAttribute("enctype")) || $c34e9f2261c19895$var$defaultEncType;
        formData = new FormData(target);
    } else if ($c34e9f2261c19895$var$isButtonElement(target) || $c34e9f2261c19895$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $c34e9f2261c19895$var$defaultMethod;
        encType = $c34e9f2261c19895$var$getFormEncType(target.getAttribute("formenctype")) || $c34e9f2261c19895$var$getFormEncType(form.getAttribute("enctype")) || $c34e9f2261c19895$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$c34e9f2261c19895$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($c34e9f2261c19895$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $c34e9f2261c19895$var$defaultMethod;
        action = null;
        encType = $c34e9f2261c19895$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $c34e9f2261c19895$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $c34e9f2261c19895$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $c34e9f2261c19895$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $c34e9f2261c19895$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $c34e9f2261c19895$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $c34e9f2261c19895$export$1f3f55432a00e06d(routes, opts) {
    return (0, $f29acb16f05b6a44$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c34e9f2261c19895$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f29acb16f05b6a44$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c34e9f2261c19895$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $175a2504a1bf07a5$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $c34e9f2261c19895$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $f29acb16f05b6a44$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c34e9f2261c19895$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f29acb16f05b6a44$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c34e9f2261c19895$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $175a2504a1bf07a5$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $c34e9f2261c19895$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $c34e9f2261c19895$var$_extends({}, state, {
        errors: $c34e9f2261c19895$var$deserializeErrors(state.errors)
    });
    return state;
}
function $c34e9f2261c19895$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $f29acb16f05b6a44$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $c34e9f2261c19895$export$7ad602f0e94e62d1 = /*#__PURE__*/ $4Iuzv.createContext({
    isTransitioning: false
});
const $c34e9f2261c19895$export$148fd98d095596d4 = /*#__PURE__*/ $4Iuzv.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $c34e9f2261c19895$var$START_TRANSITION = "startTransition";
const $c34e9f2261c19895$var$startTransitionImpl = $4Iuzv[$c34e9f2261c19895$var$START_TRANSITION];
const $c34e9f2261c19895$var$FLUSH_SYNC = "flushSync";
const $c34e9f2261c19895$var$flushSyncImpl = $d0525dc7624af49b$exports[$c34e9f2261c19895$var$FLUSH_SYNC];
const $c34e9f2261c19895$var$USE_ID = "useId";
const $c34e9f2261c19895$var$useIdImpl = $4Iuzv[$c34e9f2261c19895$var$USE_ID];
function $c34e9f2261c19895$var$startTransitionSafe(cb) {
    if ($c34e9f2261c19895$var$startTransitionImpl) $c34e9f2261c19895$var$startTransitionImpl(cb);
    else cb();
}
function $c34e9f2261c19895$var$flushSyncSafe(cb) {
    if ($c34e9f2261c19895$var$flushSyncImpl) $c34e9f2261c19895$var$flushSyncImpl(cb);
    else cb();
}
class $c34e9f2261c19895$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $c34e9f2261c19895$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $4Iuzv.useState(router.state);
    let [pendingState, setPendingState] = $4Iuzv.useState();
    let [vtContext, setVtContext] = $4Iuzv.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $4Iuzv.useState();
    let [transition, setTransition] = $4Iuzv.useState();
    let [interruption, setInterruption] = $4Iuzv.useState();
    let fetcherData = $4Iuzv.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $4Iuzv.useCallback((cb)=>{
        if (v7_startTransition) $c34e9f2261c19895$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $4Iuzv.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $c34e9f2261c19895$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $c34e9f2261c19895$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $c34e9f2261c19895$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $c34e9f2261c19895$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $c34e9f2261c19895$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $4Iuzv.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $4Iuzv.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $c34e9f2261c19895$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $4Iuzv.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $4Iuzv.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $4Iuzv.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $4Iuzv.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $4Iuzv.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $4Iuzv.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $4Iuzv.createElement($4Iuzv.Fragment, null, /*#__PURE__*/ $4Iuzv.createElement((0, $175a2504a1bf07a5$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $4Iuzv.createElement((0, $175a2504a1bf07a5$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $4Iuzv.createElement($c34e9f2261c19895$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $4Iuzv.createElement($c34e9f2261c19895$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $4Iuzv.createElement((0, $175a2504a1bf07a5$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $4Iuzv.createElement($c34e9f2261c19895$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $c34e9f2261c19895$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $175a2504a1bf07a5$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $c34e9f2261c19895$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $4Iuzv.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f29acb16f05b6a44$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4Iuzv.useCallback((newState)=>{
        v7_startTransition && $c34e9f2261c19895$var$startTransitionImpl ? $c34e9f2261c19895$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4Iuzv.createElement((0, $175a2504a1bf07a5$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $c34e9f2261c19895$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $4Iuzv.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f29acb16f05b6a44$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4Iuzv.useCallback((newState)=>{
        v7_startTransition && $c34e9f2261c19895$var$startTransitionImpl ? $c34e9f2261c19895$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4Iuzv.createElement((0, $175a2504a1bf07a5$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $c34e9f2261c19895$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4Iuzv.useCallback((newState)=>{
        v7_startTransition && $c34e9f2261c19895$var$startTransitionImpl ? $c34e9f2261c19895$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4Iuzv.createElement((0, $175a2504a1bf07a5$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $c34e9f2261c19895$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $c34e9f2261c19895$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $c34e9f2261c19895$export$a6c7ac8248d6e38a = /*#__PURE__*/ $4Iuzv.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $c34e9f2261c19895$var$_objectWithoutPropertiesLoose(_ref7, $c34e9f2261c19895$var$_excluded);
    let { basename: basename } = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $c34e9f2261c19895$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($c34e9f2261c19895$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $175a2504a1bf07a5$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $c34e9f2261c19895$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $4Iuzv.createElement("a", $c34e9f2261c19895$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $c34e9f2261c19895$export$b0d92dbee9b5b60d = /*#__PURE__*/ $4Iuzv.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $c34e9f2261c19895$var$_objectWithoutPropertiesLoose(_ref8, $c34e9f2261c19895$var$_excluded2);
    let path = (0, $175a2504a1bf07a5$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $175a2504a1bf07a5$export$45d76561a5302f2b)();
    let routerState = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $c34e9f2261c19895$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $4Iuzv.createElement($c34e9f2261c19895$export$a6c7ac8248d6e38a, $c34e9f2261c19895$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $c34e9f2261c19895$export$a7fed597f4b8afd8 = /*#__PURE__*/ $4Iuzv.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $c34e9f2261c19895$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $c34e9f2261c19895$var$_objectWithoutPropertiesLoose(_ref9, $c34e9f2261c19895$var$_excluded3);
    let submit = $c34e9f2261c19895$export$47c85c6e3a081d3();
    let formAction = $c34e9f2261c19895$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $4Iuzv.createElement("form", $c34e9f2261c19895$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $c34e9f2261c19895$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $c34e9f2261c19895$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $c34e9f2261c19895$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($c34e9f2261c19895$var$DataRouterHook || ($c34e9f2261c19895$var$DataRouterHook = {}));
var $c34e9f2261c19895$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($c34e9f2261c19895$var$DataRouterStateHook || ($c34e9f2261c19895$var$DataRouterStateHook = {}));
// Internal hooks
function $c34e9f2261c19895$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $c34e9f2261c19895$var$useDataRouterContext(hookName) {
    let ctx = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$3add0d5dce533e2e));
    !ctx && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return ctx;
}
function $c34e9f2261c19895$var$useDataRouterState(hookName) {
    let state = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$145dfa71566a64dc));
    !state && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $c34e9f2261c19895$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $175a2504a1bf07a5$export$9770f232ac06a008)();
    let location = (0, $175a2504a1bf07a5$export$45d76561a5302f2b)();
    let path = (0, $175a2504a1bf07a5$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $4Iuzv.useCallback((event)=>{
        if ($c34e9f2261c19895$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $f29acb16f05b6a44$export$fe53371bee54353d)(location) === (0, $f29acb16f05b6a44$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $c34e9f2261c19895$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $4Iuzv.useRef($c34e9f2261c19895$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $4Iuzv.useRef(false);
    let location = (0, $175a2504a1bf07a5$export$45d76561a5302f2b)();
    let searchParams = $4Iuzv.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $c34e9f2261c19895$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $175a2504a1bf07a5$export$9770f232ac06a008)();
    let setSearchParams = $4Iuzv.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $c34e9f2261c19895$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $c34e9f2261c19895$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $c34e9f2261c19895$var$fetcherId = 0;
let $c34e9f2261c19895$var$getUniqueFetcherId = ()=>"__" + String(++$c34e9f2261c19895$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $c34e9f2261c19895$export$47c85c6e3a081d3() {
    let { router: router } = $c34e9f2261c19895$var$useDataRouterContext($c34e9f2261c19895$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$26749e8557646306));
    let currentRouteId = (0, $175a2504a1bf07a5$export$5fc8298006ad9e58)();
    return $4Iuzv.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $c34e9f2261c19895$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $c34e9f2261c19895$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $c34e9f2261c19895$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $c34e9f2261c19895$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$26749e8557646306));
    let routeContext = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$9072aa6dd1f93057));
    !routeContext && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $c34e9f2261c19895$var$_extends({}, (0, $175a2504a1bf07a5$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $175a2504a1bf07a5$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $f29acb16f05b6a44$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $f29acb16f05b6a44$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $c34e9f2261c19895$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $c34e9f2261c19895$var$useDataRouterContext($c34e9f2261c19895$var$DataRouterHook.UseFetcher);
    let state = $c34e9f2261c19895$var$useDataRouterState($c34e9f2261c19895$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $4Iuzv.useContext($c34e9f2261c19895$export$148fd98d095596d4);
    let route = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    !route && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $c34e9f2261c19895$var$useIdImpl ? $c34e9f2261c19895$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $4Iuzv.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($c34e9f2261c19895$var$getUniqueFetcherId());
    // Registration/cleanup
    $4Iuzv.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $4Iuzv.useCallback((href, opts)=>{
        !routeId && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $c34e9f2261c19895$export$47c85c6e3a081d3();
    let submit = $4Iuzv.useCallback((target, opts)=>{
        submitImpl(target, $c34e9f2261c19895$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $4Iuzv.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $4Iuzv.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $4Iuzv.createElement($c34e9f2261c19895$export$a7fed597f4b8afd8, $c34e9f2261c19895$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $f29acb16f05b6a44$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $4Iuzv.useMemo(()=>$c34e9f2261c19895$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $c34e9f2261c19895$export$fa996778a3a31087() {
    let state = $c34e9f2261c19895$var$useDataRouterState($c34e9f2261c19895$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $c34e9f2261c19895$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $c34e9f2261c19895$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $c34e9f2261c19895$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $c34e9f2261c19895$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $c34e9f2261c19895$var$useDataRouterContext($c34e9f2261c19895$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $c34e9f2261c19895$var$useDataRouterState($c34e9f2261c19895$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$26749e8557646306));
    let location = (0, $175a2504a1bf07a5$export$45d76561a5302f2b)();
    let matches = (0, $175a2504a1bf07a5$export$2378eb7f5ff86053)();
    let navigation = (0, $175a2504a1bf07a5$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $4Iuzv.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $c34e9f2261c19895$var$usePageHide($4Iuzv.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $c34e9f2261c19895$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $c34e9f2261c19895$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($c34e9f2261c19895$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4Iuzv.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $c34e9f2261c19895$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $c34e9f2261c19895$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4Iuzv.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($c34e9f2261c19895$var$_extends({}, location, {
                    pathname: (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($c34e9f2261c19895$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4Iuzv.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c34e9f2261c19895$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $4Iuzv.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c34e9f2261c19895$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $4Iuzv.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $c34e9f2261c19895$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $175a2504a1bf07a5$export$b273b3273281a049)(when);
    $4Iuzv.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $4Iuzv.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $c34e9f2261c19895$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $4Iuzv.useContext($c34e9f2261c19895$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let { basename: basename } = $c34e9f2261c19895$var$useDataRouterContext($c34e9f2261c19895$var$DataRouterHook.useViewTransitionState);
    let path = (0, $175a2504a1bf07a5$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $f29acb16f05b6a44$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $f29acb16f05b6a44$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $4Iuzv = parcelRequire("4Iuzv");
const $e3dee1ed6350a35d$var$useOnlineStatus = ()=>{
    const [onlineStatus, setOnlineStatus] = (0, $4Iuzv.useState)(true);
    (0, $4Iuzv.useEffect)(()=>{
        window.addEventListener("online", ()=>{
            setOnlineStatus(true);
        });
        window.addEventListener("offline", ()=>{
            setOnlineStatus(false);
        });
    });
    return onlineStatus;
};
var $e3dee1ed6350a35d$export$2e2bcd8739ae039 = $e3dee1ed6350a35d$var$useOnlineStatus;


var $68320d06c0af6c17$exports = {};
$68320d06c0af6c17$exports = new URL("brand_logo.9eab8eb5.png", import.meta.url).toString();



var $4Iuzv = parcelRequire("4Iuzv");
const $b302a4cdaf1c8188$var$UserContext = /*#__PURE__*/ (0, $4Iuzv.createContext)({
    loggedInUser: "Default User"
});
var $b302a4cdaf1c8188$export$2e2bcd8739ae039 = $b302a4cdaf1c8188$var$UserContext;



var $4Iuzv = parcelRequire("4Iuzv");
var $10715d3f0d22f08b$exports = {};
"use strict";

$10715d3f0d22f08b$exports = (parcelRequire("agd5q"));


var $25d342665550a083$var$__defProp = Object.defineProperty;
var $25d342665550a083$var$__defProps = Object.defineProperties;
var $25d342665550a083$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $25d342665550a083$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $25d342665550a083$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $25d342665550a083$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $25d342665550a083$var$__defNormalProp = (obj, key, value)=>key in obj ? $25d342665550a083$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $25d342665550a083$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($25d342665550a083$var$__hasOwnProp.call(b, prop)) $25d342665550a083$var$__defNormalProp(a, prop, b[prop]);
    if ($25d342665550a083$var$__getOwnPropSymbols) {
        for (var prop of $25d342665550a083$var$__getOwnPropSymbols(b))if ($25d342665550a083$var$__propIsEnum.call(b, prop)) $25d342665550a083$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $25d342665550a083$var$__spreadProps = (a, b)=>$25d342665550a083$var$__defProps(a, $25d342665550a083$var$__getOwnPropDescs(b));
var $25d342665550a083$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($25d342665550a083$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $25d342665550a083$var$__getOwnPropSymbols) {
        for (var prop of $25d342665550a083$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $25d342665550a083$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $25d342665550a083$var$React = // prettier-ignore
// @ts-ignore
"default" in $4Iuzv ? $4Iuzv["default"] : $4Iuzv;
// src/components/Context.ts
var $25d342665550a083$var$ContextKey = Symbol.for(`react-redux-context`);
var $25d342665550a083$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $25d342665550a083$var$getContext() {
    var _a;
    if (!$25d342665550a083$var$React.createContext) return {};
    const contextMap = (_a = $25d342665550a083$var$gT[$25d342665550a083$var$ContextKey]) != null ? _a : $25d342665550a083$var$gT[$25d342665550a083$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($25d342665550a083$var$React.createContext);
    if (!realContext) {
        realContext = $25d342665550a083$var$React.createContext(null);
        contextMap.set($25d342665550a083$var$React.createContext, realContext);
    }
    return realContext;
}
var $25d342665550a083$export$cc80c08dc91f1c00 = /* @__PURE__ */ $25d342665550a083$var$getContext();
// src/utils/useSyncExternalStore.ts
var $25d342665550a083$var$notInitialized = ()=>{
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $25d342665550a083$var$createReduxContextHook(context = $25d342665550a083$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $25d342665550a083$var$React.useContext(context);
        return contextValue;
    };
}
var $25d342665550a083$var$useReduxContext = /* @__PURE__ */ $25d342665550a083$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $25d342665550a083$var$useSyncExternalStoreWithSelector = $25d342665550a083$var$notInitialized;
var $25d342665550a083$var$initializeUseSelector = (fn)=>{
    $25d342665550a083$var$useSyncExternalStoreWithSelector = fn;
};
var $25d342665550a083$var$refEquality = (a, b)=>a === b;
function $25d342665550a083$export$2b53f90d2bd1cbfb(context = $25d342665550a083$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $25d342665550a083$export$cc80c08dc91f1c00 ? $25d342665550a083$var$useReduxContext : $25d342665550a083$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $25d342665550a083$var$refEquality, devModeChecks: devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: stabilityCheck, identityFunctionCheck: identityFunctionCheck } = useReduxContext2();
        const firstRun = $25d342665550a083$var$React.useRef(true);
        const wrappedSelector = $25d342665550a083$var$React.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        const selectedState = $25d342665550a083$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $25d342665550a083$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $25d342665550a083$export$2105062e25df4afe = /* @__PURE__ */ $25d342665550a083$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $25d342665550a083$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $25d342665550a083$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $25d342665550a083$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $25d342665550a083$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $25d342665550a083$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $25d342665550a083$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $25d342665550a083$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $25d342665550a083$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $25d342665550a083$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $25d342665550a083$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $25d342665550a083$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $25d342665550a083$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $25d342665550a083$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $25d342665550a083$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $25d342665550a083$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $25d342665550a083$var$ForwardRef = $25d342665550a083$var$REACT_FORWARD_REF_TYPE;
var $25d342665550a083$var$Memo = $25d342665550a083$var$REACT_MEMO_TYPE;
function $25d342665550a083$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $25d342665550a083$var$REACT_FRAGMENT_TYPE || type === $25d342665550a083$var$REACT_PROFILER_TYPE || type === $25d342665550a083$var$REACT_STRICT_MODE_TYPE || type === $25d342665550a083$var$REACT_SUSPENSE_TYPE || type === $25d342665550a083$var$REACT_SUSPENSE_LIST_TYPE || type === $25d342665550a083$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $25d342665550a083$var$REACT_LAZY_TYPE || type.$$typeof === $25d342665550a083$var$REACT_MEMO_TYPE || type.$$typeof === $25d342665550a083$var$REACT_PROVIDER_TYPE || type.$$typeof === $25d342665550a083$var$REACT_CONTEXT_TYPE || type.$$typeof === $25d342665550a083$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $25d342665550a083$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $25d342665550a083$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const $$typeof = object.$$typeof;
        switch($$typeof){
            case $25d342665550a083$var$REACT_ELEMENT_TYPE:
                {
                    const type = object.type;
                    switch(type){
                        case $25d342665550a083$var$REACT_FRAGMENT_TYPE:
                        case $25d342665550a083$var$REACT_PROFILER_TYPE:
                        case $25d342665550a083$var$REACT_STRICT_MODE_TYPE:
                        case $25d342665550a083$var$REACT_SUSPENSE_TYPE:
                        case $25d342665550a083$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                const $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $25d342665550a083$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $25d342665550a083$var$REACT_CONTEXT_TYPE:
                                    case $25d342665550a083$var$REACT_FORWARD_REF_TYPE:
                                    case $25d342665550a083$var$REACT_LAZY_TYPE:
                                    case $25d342665550a083$var$REACT_MEMO_TYPE:
                                    case $25d342665550a083$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $25d342665550a083$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $25d342665550a083$var$isContextConsumer(object) {
    return $25d342665550a083$var$typeOf(object) === $25d342665550a083$var$REACT_CONTEXT_TYPE;
}
function $25d342665550a083$var$isMemo(object) {
    return $25d342665550a083$var$typeOf(object) === $25d342665550a083$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $25d342665550a083$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $25d342665550a083$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $25d342665550a083$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $25d342665550a083$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $25d342665550a083$var$verify(mapStateToProps, "mapStateToProps");
    $25d342665550a083$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $25d342665550a083$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $25d342665550a083$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $25d342665550a083$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $25d342665550a083$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $25d342665550a083$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $25d342665550a083$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $25d342665550a083$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $25d342665550a083$var$verifyPlainObject(value, displayName, methodName) {
    if (!$25d342665550a083$var$isPlainObject(value)) $25d342665550a083$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $25d342665550a083$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $25d342665550a083$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $25d342665550a083$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $25d342665550a083$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $25d342665550a083$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $25d342665550a083$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $25d342665550a083$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $25d342665550a083$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $25d342665550a083$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $25d342665550a083$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $25d342665550a083$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $25d342665550a083$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $25d342665550a083$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $25d342665550a083$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $25d342665550a083$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $25d342665550a083$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $25d342665550a083$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $25d342665550a083$var$__spreadValues($25d342665550a083$var$__spreadValues($25d342665550a083$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $25d342665550a083$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $25d342665550a083$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$25d342665550a083$var$defaultMergeProps : typeof mergeProps === "function" ? $25d342665550a083$var$wrapMergePropsFunc(mergeProps) : $25d342665550a083$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $25d342665550a083$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $25d342665550a083$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $25d342665550a083$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $25d342665550a083$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $25d342665550a083$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $25d342665550a083$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $25d342665550a083$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $25d342665550a083$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $25d342665550a083$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $25d342665550a083$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $25d342665550a083$var$useIsomorphicLayoutEffect = $25d342665550a083$var$canUseDOM || $25d342665550a083$var$isReactNative ? $25d342665550a083$var$React.useLayoutEffect : $25d342665550a083$var$React.useEffect;
// src/utils/shallowEqual.ts
function $25d342665550a083$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $25d342665550a083$export$d36bdfa510afb180(objA, objB) {
    if ($25d342665550a083$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$25d342665550a083$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $25d342665550a083$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $25d342665550a083$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $25d342665550a083$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $25d342665550a083$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $25d342665550a083$var$TYPE_STATICS = {
    [$25d342665550a083$var$ForwardRef]: $25d342665550a083$var$FORWARD_REF_STATICS,
    [$25d342665550a083$var$Memo]: $25d342665550a083$var$MEMO_STATICS
};
function $25d342665550a083$var$getStatics(component) {
    if ($25d342665550a083$var$isMemo(component)) return $25d342665550a083$var$MEMO_STATICS;
    return $25d342665550a083$var$TYPE_STATICS[component["$$typeof"]] || $25d342665550a083$var$REACT_STATICS;
}
var $25d342665550a083$var$defineProperty = Object.defineProperty;
var $25d342665550a083$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $25d342665550a083$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $25d342665550a083$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $25d342665550a083$var$getPrototypeOf = Object.getPrototypeOf;
var $25d342665550a083$var$objectPrototype = Object.prototype;
function $25d342665550a083$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($25d342665550a083$var$objectPrototype) {
            const inheritedComponent = $25d342665550a083$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $25d342665550a083$var$objectPrototype) $25d342665550a083$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $25d342665550a083$var$getOwnPropertyNames(sourceComponent);
        if ($25d342665550a083$var$getOwnPropertySymbols) keys = keys.concat($25d342665550a083$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $25d342665550a083$var$getStatics(targetComponent);
        const sourceStatics = $25d342665550a083$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$25d342665550a083$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $25d342665550a083$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $25d342665550a083$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $25d342665550a083$var$useSyncExternalStore = $25d342665550a083$var$notInitialized;
var $25d342665550a083$var$initializeConnect = (fn)=>{
    $25d342665550a083$var$useSyncExternalStore = fn;
};
var $25d342665550a083$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $25d342665550a083$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $25d342665550a083$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $25d342665550a083$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $25d342665550a083$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $25d342665550a083$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $25d342665550a083$var$strictEqual(a, b) {
    return a === b;
}
var $25d342665550a083$var$hasWarnedAboutDeprecatedPureOption = false;
function $25d342665550a083$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $25d342665550a083$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $25d342665550a083$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $25d342665550a083$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $25d342665550a083$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $25d342665550a083$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $25d342665550a083$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $25d342665550a083$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $25d342665550a083$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $25d342665550a083$var$React.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $25d342665550a083$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $25d342665550a083$var$React.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $25d342665550a083$var$React.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $25d342665550a083$var$React.useMemo(()=>{
                return $25d342665550a083$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $25d342665550a083$var$React.useMemo(()=>{
                if (!shouldHandleStateChanges) return $25d342665550a083$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $25d342665550a083$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $25d342665550a083$var$React.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $25d342665550a083$var$__spreadProps($25d342665550a083$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $25d342665550a083$var$React.useRef(void 0);
            const lastWrapperProps = $25d342665550a083$var$React.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $25d342665550a083$var$React.useRef(void 0);
            const renderIsScheduled = $25d342665550a083$var$React.useRef(false);
            const isMounted = $25d342665550a083$var$React.useRef(false);
            const latestSubscriptionCallbackError = $25d342665550a083$var$React.useRef(void 0);
            $25d342665550a083$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $25d342665550a083$var$React.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $25d342665550a083$var$React.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $25d342665550a083$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $25d342665550a083$var$useIsomorphicLayoutEffectWithArgs($25d342665550a083$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $25d342665550a083$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $25d342665550a083$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $25d342665550a083$var$React.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $25d342665550a083$var$React.createElement(WrappedComponent, $25d342665550a083$var$__spreadProps($25d342665550a083$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $25d342665550a083$var$React.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $25d342665550a083$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $25d342665550a083$var$React.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $25d342665550a083$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $25d342665550a083$var$React.createElement(Connect, $25d342665550a083$var$__spreadProps($25d342665550a083$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $25d342665550a083$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $25d342665550a083$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $25d342665550a083$export$64605811ab45167f = $25d342665550a083$var$connect;
// src/components/Provider.tsx
function $25d342665550a083$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", identityFunctionCheck: identityFunctionCheck = "once" }) {
    const contextValue = $25d342665550a083$var$React.useMemo(()=>{
        const subscription = $25d342665550a083$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    const previousState = $25d342665550a083$var$React.useMemo(()=>store.getState(), [
        store
    ]);
    $25d342665550a083$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $25d342665550a083$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $25d342665550a083$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $25d342665550a083$export$2881499e37b75b9a = $25d342665550a083$var$Provider;
// src/hooks/useStore.ts
function $25d342665550a083$export$671dba69185d0304(context = $25d342665550a083$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $25d342665550a083$export$cc80c08dc91f1c00 ? $25d342665550a083$var$useReduxContext : // @ts-ignore
    $25d342665550a083$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $25d342665550a083$export$6ccbb43953eebf8 = /* @__PURE__ */ $25d342665550a083$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $25d342665550a083$export$bc9b55530897c558(context = $25d342665550a083$export$cc80c08dc91f1c00) {
    const useStore2 = context === $25d342665550a083$export$cc80c08dc91f1c00 ? $25d342665550a083$export$6ccbb43953eebf8 : $25d342665550a083$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $25d342665550a083$export$8ad76b76a4c905f8 = /* @__PURE__ */ $25d342665550a083$export$bc9b55530897c558();
// src/exports.ts
var $25d342665550a083$export$712ea50be43a7858 = $25d342665550a083$var$defaultNoopBatch;
// src/index.ts
$25d342665550a083$var$initializeUseSelector((0, $10715d3f0d22f08b$exports.useSyncExternalStoreWithSelector));
$25d342665550a083$var$initializeConnect($4Iuzv.useSyncExternalStore);


const $ca2c91bf6756c02e$var$Header = ()=>{
    const [btnName, setBtnName] = (0, $4Iuzv.useState)("Login");
    const onlineStatus = (0, $e3dee1ed6350a35d$export$2e2bcd8739ae039)();
    const { loggedInUser: loggedInUser } = (0, $4Iuzv.useContext)((0, $b302a4cdaf1c8188$export$2e2bcd8739ae039));
    // Subscribing to the store using a selector
    const cartItems = (0, $25d342665550a083$export$2105062e25df4afe)((store)=>store.cart.items);
    // console.log("CART Items ------>>>>",cartItems)
    return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
        className: "flex justify-center md:justify-between flex-wrap px-18 py-2 bg-yellow-400 text-black sticky top-0 z-10 font-normal",
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "pl-36",
                children: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                    to: "/",
                    children: /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                        className: "w-15 h-12 hidden",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($68320d06c0af6c17$exports)))
                    })
                })
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "flex pr-10",
                children: /*#__PURE__*/ (0, $5aRSq.jsxs)("ul", {
                    className: "flex justify-between flex-row p-2 items-center",
                    children: [
                        /*#__PURE__*/ (0, $5aRSq.jsx)("li", {
                            className: "px-4 font-bold",
                            children: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: "Home"
                            })
                        }),
                        /*#__PURE__*/ (0, $5aRSq.jsxs)("li", {
                            className: "px-4 hidden lg:block",
                            children: [
                                "OnlineStatus: ",
                                onlineStatus ? "\uD83D\uDFE2" : "\uD83D\uDD34"
                            ]
                        }),
                        /*#__PURE__*/ (0, $5aRSq.jsx)("li", {
                            className: "relative px-3 rounded-full",
                            children: /*#__PURE__*/ (0, $5aRSq.jsxs)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                                to: "/cart",
                                children: [
                                    "\uD83D\uDED2",
                                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                                        className: "absolute px-1 bg-white text-black right-2 bottom-3 rounded-full text-xs font-bold",
                                        children: cartItems.length
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $5aRSq.jsx)("li", {
                            className: "px-4",
                            onClick: ()=>btnName === "Login" ? setBtnName("Logout") : setBtnName("Login"),
                            children: btnName
                        }),
                        /*#__PURE__*/ (0, $5aRSq.jsx)("li", {
                            className: "px-4 font-bold",
                            children: loggedInUser
                        })
                    ]
                })
            })
        ]
    });
};
var $ca2c91bf6756c02e$export$2e2bcd8739ae039 = $ca2c91bf6756c02e$var$Header;



var $5aRSq = parcelRequire("5aRSq");

var $5aRSq = parcelRequire("5aRSq");
const $1449da937569f1f7$export$31adfacaf07ffe63 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
const $1449da937569f1f7$export$8878ead86ed0da0b = "https://cdn.dribbble.com/userupload/5966432/file/original-03c1fe57f7907074905632cbf187f058.png?resize=400x0";
const $1449da937569f1f7$export$4097a8af96486581 = "https://thingproxy.freeboard.io/fetch/https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.96340&lng=77.58550&restaurantId=";


const $80d248f504e512cb$var$RestaurantCard = (props)=>{
    const { resData: resData } = props;
    const { name: name, cloudinaryImageId: cloudinaryImageId, cuisines: cuisines, costForTwo: costForTwo, avgRating: avgRating, sla: { deliveryTime: deliveryTime }, id: id } = resData?.info;
    return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
        className: "flex flex-col w-[250px] m-3 p-1 bg-gray-100 rounded-lg hover:bg-gray-200",
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                className: "rounded-lg",
                alt: "res-logo",
                src: (0, $1449da937569f1f7$export$31adfacaf07ffe63) + cloudinaryImageId
            }),
            /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                className: "flex flex-col p-1",
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsx)("h3", {
                        className: "font-bold py-1",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("p", {
                        className: " overflow-x-hidden",
                        children: cuisines.join(",")
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                        className: " font-medium my-1",
                        children: costForTwo
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsxs)("h5", {
                        className: " bg-green-600 text-white px-2 w-[35%] rounded-md",
                        children: [
                            avgRating,
                            " stars"
                        ]
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsxs)("span", {
                        children: [
                            "Delivery in ",
                            deliveryTime,
                            " minutes"
                        ]
                    })
                ]
            })
        ]
    });
};
var // Higher Order Component Concept
// input-RestaurantCard, Output - RestaurantCardPromoted
// export const withPromotedLabel = (RestaurantCard) => {
//   return (props) => {
//     return(
//       <div>
//         <label className="absolute">Promoted</label>
//         <RestaurantCard {...props}/>
//       </div>
//     )
//   }
// }
$80d248f504e512cb$export$2e2bcd8739ae039 = $80d248f504e512cb$var$RestaurantCard;


// swiggy website real data from its api
// 20240621183949
// https://thingproxy.freeboard.io/fetch/https://www.swiggy.com/dapi/restaurants/list/v5?lat=12.96340&lng=77.58550&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING
const $7f2c384ac384527b$export$d9177f8a4a7a8b10 = {
    "statusCode": 0,
    "data": {
        "statusMessage": "done successfully",
        "pageOffset": {
            "nextOffset": "CJhlELQ4KICYm9qksqrbUzCnEzgD",
            "widgetOffset": {
                "NewListingView_category_bar_chicletranking_TwoRows": "",
                "NewListingView_category_bar_chicletranking_TwoRows_Rendition": "",
                "Restaurant_Group_WebView_PB_Theme": "",
                "Restaurant_Group_WebView_SEO_PB_Theme": "",
                "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo": "9",
                "inlineFacetFilter": "",
                "restaurantCountWidget": ""
            }
        },
        "cards": [
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
                        "header": {
                            "title": "What's on your mind?",
                            "headerStyling": {
                                "padding": {
                                    "left": 16,
                                    "top": 16,
                                    "bottom": 4
                                }
                            }
                        },
                        "layout": {
                            "rows": 1,
                            "columns": 10,
                            "horizontalScrollEnabled": true,
                            "itemSpacing": 24,
                            "widgetPadding": {},
                            "containerStyle": {
                                "containerPadding": {
                                    "left": 8,
                                    "top": 8,
                                    "right": 12,
                                    "bottom": 4
                                }
                            },
                            "scrollBar": {},
                            "widgetTheme": {
                                "defaultMode": {
                                    "backgroundColour": "#FFFFFF",
                                    "theme": "THEME_TYPE_LIGHT"
                                },
                                "darkMode": {
                                    "theme": "THEME_TYPE_DARK"
                                }
                            }
                        },
                        "imageGridCards": {
                            "info": [
                                {
                                    "id": "750579",
                                    "imageId": "v1674029856/PC_Creative%20refresh/3D_bau/banners_new/Pizza.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/83631?collection_id=83631&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
                                        "text": "Pizzas",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurants curated for pizza",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=83631&tags=layout_CCS_Pizza&search_context=pizza",
                                    "frequencyCapping": {}
                                },
                                {
                                    "id": "750222",
                                    "imageId": "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Rolls.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/83669?collection_id=83669&tags=layout_CCS_Rolls&type=rcv2",
                                        "text": "Rolls",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurants curated for roll",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=83669&tags=layout_CCS_Rolls",
                                    "frequencyCapping": {}
                                },
                                {
                                    "id": "750589",
                                    "imageId": "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Burger.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2",
                                        "text": "Burgers",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurants curated for burger",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=83637&tags=layout_CCS_Burger&search_context=burger",
                                    "frequencyCapping": {}
                                },
                                {
                                    "id": "750591",
                                    "imageId": "v1675667625/PC_Creative%20refresh/Biryani_2.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/83639?collection_id=83639&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
                                        "text": "Biryani",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurants curated for biryani",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=83639&tags=layout_CCS_Biryani&search_context=biryani",
                                    "frequencyCapping": {}
                                },
                                {
                                    "id": "750228",
                                    "imageId": "v1674029860/PC_Creative%20refresh/3D_bau/banners_new/Samosas.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80396?collection_id=80396&tags=layout_BAU_Contextual%2Csamosa&type=rcv2",
                                        "text": "Samosa",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurants curated for samosa",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "80396",
                                    "frequencyCapping": {}
                                },
                                {
                                    "id": "750587",
                                    "imageId": "v1674029848/PC_Creative%20refresh/3D_bau/banners_new/Chinese.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/83636?collection_id=83636&tags=layout_CCS_Chinese&type=rcv2",
                                        "text": "Chinese",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurant curated for chinese",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=83636&tags=layout_CCS_Chinese",
                                    "frequencyCapping": {}
                                },
                                {
                                    "id": "750248",
                                    "imageId": "v1674029859/PC_Creative%20refresh/3D_bau/banners_new/Shawarma.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80402?collection_id=80402&tags=layout_Shawarma_Contextual&type=rcv2",
                                        "text": "Shawarma",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurant curated for shawarma",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=80402&tags=layout_Shawarma_Contextual",
                                    "frequencyCapping": {}
                                },
                                {
                                    "id": "750206",
                                    "imageId": "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pasta.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80479?collection_id=80479&search_context=pasta&tags=layout_CCS_Pasta&type=rcv2",
                                        "text": "Pasta",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurant curated for pasta",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=80479&tags=layout_CCS_Pasta&search_context=pasta",
                                    "frequencyCapping": {}
                                },
                                {
                                    "id": "750225",
                                    "imageId": "v1674029859/PC_Creative%20refresh/3D_bau/banners_new/Salad.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80394?collection_id=80394&tags=layout_CCS_Salad&type=rcv2",
                                        "text": "Salad",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurant curated for salad",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=80394&tags=layout_CCS_Salad",
                                    "frequencyCapping": {}
                                },
                                {
                                    "id": "749768",
                                    "imageId": "v1674029852/PC_Creative%20refresh/3D_bau/banners_new/Momos.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80461?collection_id=80461&tags=layout_CCS_Momos&type=rcv2",
                                        "text": "Momos",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurant curated for momos",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=80461&tags=layout_CCS_Momos",
                                    "frequencyCapping": {}
                                },
                                {
                                    "id": "750131",
                                    "imageId": "v1674029850/PC_Creative%20refresh/3D_bau/banners_new/Dosa.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80424?collection_id=80424&tags=layout_CCS_Dosa&type=rcv2",
                                        "text": "Dosa",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurants curated for dosa",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=80424&tags=layout_CCS_Dosa",
                                    "frequencyCapping": {}
                                },
                                {
                                    "id": "749868",
                                    "imageId": "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Cakes.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/83655?collection_id=83655&tags=layout_CCS_Cake&type=rcv2",
                                        "text": "Cakes",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurant curated for cake",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=83655&tags=layout_CCS_Cake",
                                    "frequencyCapping": {}
                                },
                                {
                                    "id": "750216",
                                    "imageId": "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pav_Bhaji.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80362?collection_id=80362&tags=layout_PavBhaji_Contextual&type=rcv2",
                                        "text": "Pav Bhaji",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurant curated for pav bhaji",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=80362&tags=layout_PavBhaji_Contextual",
                                    "frequencyCapping": {}
                                },
                                {
                                    "id": "750571",
                                    "imageId": "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Pure_Veg.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80435?collection_id=80435&tags=layout_CCS_PureVeg&type=rcv2",
                                        "text": "Pure Veg",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurants curated for veg",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=80435&tags=layout_CCS_PureVeg",
                                    "frequencyCapping": {}
                                },
                                {
                                    "id": "750585",
                                    "imageId": "v1675667626/PC_Creative%20refresh/South_Indian_4.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/83634?collection_id=83634&search_context=southindian&tags=layout_CCS_SouthIndian&type=rcv2",
                                        "text": "South Indian",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurants curated for south indian",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=83634&tags=layout_CCS_SouthIndian&search_context=southindian",
                                    "frequencyCapping": {}
                                },
                                {
                                    "id": "750208",
                                    "imageId": "v1674029847/PC_Creative%20refresh/3D_bau/banners_new/Pastry.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80355?collection_id=80355&tags=layout_BAU_Contextual%2Cpastry&type=rcv2",
                                        "text": "Pastry",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurant curated for Pastry",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "80355",
                                    "frequencyCapping": {}
                                },
                                {
                                    "id": "749772",
                                    "imageId": "v1674029855/PC_Creative%20refresh/3D_bau/banners_new/Noodles.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80463?collection_id=80463&tags=layout_BAU_Contextual%2Cnoodles&type=rcv2",
                                        "text": "Noodles",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurant curated for noodles",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "80463",
                                    "frequencyCapping": {}
                                },
                                {
                                    "id": "750639",
                                    "imageId": "v1674029847/PC_Creative%20refresh/3D_bau/banners_new/Kachori.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80448?collection_id=80448&tags=layout_BAU_Contextual%2Ckachori&type=rcv2",
                                        "text": "Kachori",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurant curated for kachori",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "80448",
                                    "frequencyCapping": {}
                                },
                                {
                                    "id": "745861",
                                    "imageId": "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Shakes.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/83673?collection_id=83673&tags=layout_CCS_Shakes&type=rcv2",
                                        "text": "Shake",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurants curated for shakes",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=83673&tags=layout_CCS_Shakes",
                                    "frequencyCapping": {}
                                },
                                {
                                    "id": "750643",
                                    "imageId": "v1674029846/PC_Creative%20refresh/3D_bau/banners_new/Idli.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80440?collection_id=80440&tags=layout_CCS_Idli&type=rcv2",
                                        "text": "Idli",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurants curated for idly",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=80440&tags=layout_CCS_Idli",
                                    "frequencyCapping": {}
                                }
                            ],
                            "style": {
                                "width": {
                                    "type": "TYPE_RELATIVE",
                                    "value": 0.2941,
                                    "reference": "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"
                                },
                                "height": {
                                    "type": "TYPE_RELATIVE",
                                    "value": 1.2444,
                                    "reference": "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                                }
                            }
                        },
                        "id": "whats_on_your_mind",
                        "gridElements": {
                            "infoWithStyle": {
                                "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.ImageInfoLayoutCard",
                                "info": [
                                    {
                                        "id": "750579",
                                        "imageId": "v1674029856/PC_Creative%20refresh/3D_bau/banners_new/Pizza.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/83631?collection_id=83631&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
                                            "text": "Pizzas",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurants curated for pizza",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=83631&tags=layout_CCS_Pizza&search_context=pizza",
                                        "frequencyCapping": {}
                                    },
                                    {
                                        "id": "750222",
                                        "imageId": "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Rolls.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/83669?collection_id=83669&tags=layout_CCS_Rolls&type=rcv2",
                                            "text": "Rolls",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurants curated for roll",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=83669&tags=layout_CCS_Rolls",
                                        "frequencyCapping": {}
                                    },
                                    {
                                        "id": "750589",
                                        "imageId": "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Burger.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2",
                                            "text": "Burgers",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurants curated for burger",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=83637&tags=layout_CCS_Burger&search_context=burger",
                                        "frequencyCapping": {}
                                    },
                                    {
                                        "id": "750591",
                                        "imageId": "v1675667625/PC_Creative%20refresh/Biryani_2.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/83639?collection_id=83639&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
                                            "text": "Biryani",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurants curated for biryani",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=83639&tags=layout_CCS_Biryani&search_context=biryani",
                                        "frequencyCapping": {}
                                    },
                                    {
                                        "id": "750228",
                                        "imageId": "v1674029860/PC_Creative%20refresh/3D_bau/banners_new/Samosas.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80396?collection_id=80396&tags=layout_BAU_Contextual%2Csamosa&type=rcv2",
                                            "text": "Samosa",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurants curated for samosa",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "80396",
                                        "frequencyCapping": {}
                                    },
                                    {
                                        "id": "750587",
                                        "imageId": "v1674029848/PC_Creative%20refresh/3D_bau/banners_new/Chinese.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/83636?collection_id=83636&tags=layout_CCS_Chinese&type=rcv2",
                                            "text": "Chinese",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurant curated for chinese",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=83636&tags=layout_CCS_Chinese",
                                        "frequencyCapping": {}
                                    },
                                    {
                                        "id": "750248",
                                        "imageId": "v1674029859/PC_Creative%20refresh/3D_bau/banners_new/Shawarma.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80402?collection_id=80402&tags=layout_Shawarma_Contextual&type=rcv2",
                                            "text": "Shawarma",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurant curated for shawarma",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=80402&tags=layout_Shawarma_Contextual",
                                        "frequencyCapping": {}
                                    },
                                    {
                                        "id": "750206",
                                        "imageId": "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pasta.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80479?collection_id=80479&search_context=pasta&tags=layout_CCS_Pasta&type=rcv2",
                                            "text": "Pasta",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurant curated for pasta",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=80479&tags=layout_CCS_Pasta&search_context=pasta",
                                        "frequencyCapping": {}
                                    },
                                    {
                                        "id": "750225",
                                        "imageId": "v1674029859/PC_Creative%20refresh/3D_bau/banners_new/Salad.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80394?collection_id=80394&tags=layout_CCS_Salad&type=rcv2",
                                            "text": "Salad",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurant curated for salad",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=80394&tags=layout_CCS_Salad",
                                        "frequencyCapping": {}
                                    },
                                    {
                                        "id": "749768",
                                        "imageId": "v1674029852/PC_Creative%20refresh/3D_bau/banners_new/Momos.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80461?collection_id=80461&tags=layout_CCS_Momos&type=rcv2",
                                            "text": "Momos",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurant curated for momos",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=80461&tags=layout_CCS_Momos",
                                        "frequencyCapping": {}
                                    },
                                    {
                                        "id": "750131",
                                        "imageId": "v1674029850/PC_Creative%20refresh/3D_bau/banners_new/Dosa.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80424?collection_id=80424&tags=layout_CCS_Dosa&type=rcv2",
                                            "text": "Dosa",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurants curated for dosa",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=80424&tags=layout_CCS_Dosa",
                                        "frequencyCapping": {}
                                    },
                                    {
                                        "id": "749868",
                                        "imageId": "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Cakes.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/83655?collection_id=83655&tags=layout_CCS_Cake&type=rcv2",
                                            "text": "Cakes",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurant curated for cake",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=83655&tags=layout_CCS_Cake",
                                        "frequencyCapping": {}
                                    },
                                    {
                                        "id": "750216",
                                        "imageId": "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pav_Bhaji.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80362?collection_id=80362&tags=layout_PavBhaji_Contextual&type=rcv2",
                                            "text": "Pav Bhaji",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurant curated for pav bhaji",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=80362&tags=layout_PavBhaji_Contextual",
                                        "frequencyCapping": {}
                                    },
                                    {
                                        "id": "750571",
                                        "imageId": "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Pure_Veg.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80435?collection_id=80435&tags=layout_CCS_PureVeg&type=rcv2",
                                            "text": "Pure Veg",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurants curated for veg",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=80435&tags=layout_CCS_PureVeg",
                                        "frequencyCapping": {}
                                    },
                                    {
                                        "id": "750585",
                                        "imageId": "v1675667626/PC_Creative%20refresh/South_Indian_4.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/83634?collection_id=83634&search_context=southindian&tags=layout_CCS_SouthIndian&type=rcv2",
                                            "text": "South Indian",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurants curated for south indian",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=83634&tags=layout_CCS_SouthIndian&search_context=southindian",
                                        "frequencyCapping": {}
                                    },
                                    {
                                        "id": "750208",
                                        "imageId": "v1674029847/PC_Creative%20refresh/3D_bau/banners_new/Pastry.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80355?collection_id=80355&tags=layout_BAU_Contextual%2Cpastry&type=rcv2",
                                            "text": "Pastry",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurant curated for Pastry",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "80355",
                                        "frequencyCapping": {}
                                    },
                                    {
                                        "id": "749772",
                                        "imageId": "v1674029855/PC_Creative%20refresh/3D_bau/banners_new/Noodles.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80463?collection_id=80463&tags=layout_BAU_Contextual%2Cnoodles&type=rcv2",
                                            "text": "Noodles",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurant curated for noodles",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "80463",
                                        "frequencyCapping": {}
                                    },
                                    {
                                        "id": "750639",
                                        "imageId": "v1674029847/PC_Creative%20refresh/3D_bau/banners_new/Kachori.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80448?collection_id=80448&tags=layout_BAU_Contextual%2Ckachori&type=rcv2",
                                            "text": "Kachori",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurant curated for kachori",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "80448",
                                        "frequencyCapping": {}
                                    },
                                    {
                                        "id": "745861",
                                        "imageId": "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Shakes.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/83673?collection_id=83673&tags=layout_CCS_Shakes&type=rcv2",
                                            "text": "Shake",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurants curated for shakes",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=83673&tags=layout_CCS_Shakes",
                                        "frequencyCapping": {}
                                    },
                                    {
                                        "id": "750643",
                                        "imageId": "v1674029846/PC_Creative%20refresh/3D_bau/banners_new/Idli.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80440?collection_id=80440&tags=layout_CCS_Idli&type=rcv2",
                                            "text": "Idli",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurants curated for idly",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=80440&tags=layout_CCS_Idli",
                                        "frequencyCapping": {}
                                    }
                                ],
                                "style": {
                                    "width": {
                                        "type": "TYPE_RELATIVE",
                                        "value": 0.2941,
                                        "reference": "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"
                                    },
                                    "height": {
                                        "type": "TYPE_RELATIVE",
                                        "value": 1.2444,
                                        "reference": "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
                        "header": {
                            "title": "Top restaurant chains in Bangalore",
                            "action": {},
                            "headerStyling": {
                                "padding": {
                                    "left": 16,
                                    "top": 28,
                                    "bottom": 18
                                }
                            }
                        },
                        "layout": {
                            "rows": 1,
                            "columns": 20,
                            "horizontalScrollEnabled": true,
                            "itemSpacing": 32,
                            "widgetPadding": {},
                            "containerStyle": {
                                "containerPadding": {
                                    "left": 16,
                                    "right": 12,
                                    "bottom": 12
                                }
                            },
                            "scrollBar": {
                                "scrollThumbColor": "#E46D47",
                                "scrollTrackColor": "#02060C",
                                "width": 54,
                                "height": 4,
                                "scrollStyling": {
                                    "padding": {
                                        "top": 6,
                                        "bottom": 24
                                    }
                                }
                            },
                            "widgetTheme": {
                                "defaultMode": {
                                    "backgroundColour": "#1B3028",
                                    "theme": "THEME_TYPE_DARK"
                                },
                                "darkMode": {
                                    "backgroundColour": "#1B3028",
                                    "theme": "THEME_TYPE_DARK"
                                }
                            }
                        },
                        "id": "top_brands_for_you",
                        "gridElements": {
                            "infoWithStyle": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle",
                                "restaurants": [
                                    {
                                        "info": {
                                            "id": "10575",
                                            "name": "Pizza Hut",
                                            "cloudinaryImageId": "2b4f62d606d1b2bfba9ba9e5386fabb7",
                                            "locality": "Richmond Town",
                                            "areaName": "Shanti Nagar",
                                            "costForTwo": "\u20B9600 for two",
                                            "cuisines": [
                                                "Pizzas"
                                            ],
                                            "avgRating": 4.2,
                                            "parentId": "721",
                                            "avgRatingString": "4.2",
                                            "totalRatingsString": "5K+",
                                            "sla": {
                                                "deliveryTime": 29,
                                                "lastMileTravel": 1.6,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "25-30 mins",
                                                "lastMileTravelString": "1.6 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-22 01:00:00",
                                                "opened": true
                                            },
                                            "badges": {},
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "50% OFF",
                                                "subHeader": "UPTO \u20B9100"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {},
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/pizza-hut-richmond-town-shanti-nagar-bangalore-10575",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "66590",
                                            "name": "Havmor Havfunn Ice Cream",
                                            "cloudinaryImageId": "49845b494b1e637209b7bd1c7ca184ad",
                                            "locality": "Vanivilas road",
                                            "areaName": "Basavanagudi",
                                            "costForTwo": "\u20B9400 for two",
                                            "cuisines": [
                                                "Ice Cream",
                                                "Ice Cream Cakes",
                                                "Desserts",
                                                "Beverages"
                                            ],
                                            "avgRating": 4.5,
                                            "veg": true,
                                            "parentId": "94570",
                                            "avgRatingString": "4.5",
                                            "totalRatingsString": "500+",
                                            "sla": {
                                                "deliveryTime": 31,
                                                "lastMileTravel": 3,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "30-35 mins",
                                                "lastMileTravelString": "3.0 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-21 23:30:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "textExtendedBadges": [
                                                    {
                                                        "iconId": "v1705582451/Ratnesh_Badges/Perfect_cake.png",
                                                        "shortDescription": "Perfect cake delivery",
                                                        "fontColor": "#7E808C"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "aggregatedDiscountInfoV2": {},
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "",
                                                                    "fontColor": "#7E808C",
                                                                    "iconId": "v1705582451/Ratnesh_Badges/Perfect_cake.png",
                                                                    "shortDescription": "Perfect cake delivery"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {},
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/havmor-havfunn-ice-cream-vanivilas-road-basavanagudi-bangalore-66590",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "43836",
                                            "name": "McDonald's",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/4/1/fe11ced6-89a3-4080-8610-3c743a3bb3f0_43836.jpg",
                                            "locality": "MG Road",
                                            "areaName": "Ashok Nagar",
                                            "costForTwo": "\u20B9400 for two",
                                            "cuisines": [
                                                "Burgers",
                                                "Beverages",
                                                "Cafe",
                                                "Desserts"
                                            ],
                                            "avgRating": 4.3,
                                            "parentId": "630",
                                            "avgRatingString": "4.3",
                                            "totalRatingsString": "10K+",
                                            "sla": {
                                                "deliveryTime": 34,
                                                "lastMileTravel": 2.5,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "30-35 mins",
                                                "lastMileTravelString": "2.5 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-22 02:45:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Burger.png",
                                                        "description": "Delivery!"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Burger.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "\u20B9100 OFF",
                                                "subHeader": "ABOVE \u20B9199",
                                                "discountTag": "FLAT DEAL"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {},
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/mcdonalds-mg-road-ashok-nagar-bangalore-43836",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "77949",
                                            "name": "Burger King",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/6/11/4ee8bc77-ca9f-41bd-a0f3-511c70902b91_77949.JPG",
                                            "locality": "Gandhi Bazar",
                                            "areaName": "Basavanagudi",
                                            "costForTwo": "\u20B9350 for two",
                                            "cuisines": [
                                                "Burgers",
                                                "American"
                                            ],
                                            "avgRating": 4.2,
                                            "parentId": "166",
                                            "avgRatingString": "4.2",
                                            "totalRatingsString": "10K+",
                                            "sla": {
                                                "deliveryTime": 29,
                                                "lastMileTravel": 3,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "25-30 mins",
                                                "lastMileTravelString": "3.0 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-21 23:59:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Burger.png",
                                                        "description": "Delivery!"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Burger.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "50% OFF",
                                                "subHeader": "UPTO \u20B9100"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {},
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/burger-king-gandhi-bazar-basavanagudi-bangalore-77949",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "432976",
                                            "name": "KFC",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/4/17/9869efb0-ef0e-41eb-bffa-9d6e03eef55e_432976.JPG",
                                            "locality": "Double Road",
                                            "areaName": "Shanti Nagar",
                                            "costForTwo": "\u20B9400 for two",
                                            "cuisines": [
                                                "Burgers",
                                                "Fast Food",
                                                "Rolls & Wraps"
                                            ],
                                            "avgRating": 4.2,
                                            "parentId": "547",
                                            "avgRatingString": "4.2",
                                            "totalRatingsString": "1K+",
                                            "sla": {
                                                "deliveryTime": 31,
                                                "lastMileTravel": 1.5,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "30-35 mins",
                                                "lastMileTravelString": "1.5 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-21 23:00:00",
                                                "opened": true
                                            },
                                            "badges": {},
                                            "isOpen": true,
                                            "aggregatedDiscountInfoV2": {},
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {},
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/kfc-double-road-shanti-nagar-bangalore-432976",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "23846",
                                            "name": "Domino's Pizza",
                                            "cloudinaryImageId": "d0450ce1a6ba19ea60cd724471ed54a8",
                                            "locality": "Rehinus Street",
                                            "areaName": "Richmond Town",
                                            "costForTwo": "\u20B9400 for two",
                                            "cuisines": [
                                                "Pizzas",
                                                "Italian",
                                                "Pastas",
                                                "Desserts"
                                            ],
                                            "avgRating": 4.3,
                                            "parentId": "2456",
                                            "avgRatingString": "4.3",
                                            "totalRatingsString": "10K+",
                                            "sla": {
                                                "deliveryTime": 25,
                                                "lastMileTravel": 2,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "20-25 mins",
                                                "lastMileTravelString": "2.0 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-22 02:59:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Pizza.png",
                                                        "description": "Delivery!"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Pizza.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "\u20B9150 OFF",
                                                "subHeader": "ABOVE \u20B9299",
                                                "discountTag": "FLAT DEAL"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {},
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/dominos-pizza-rehinus-street-richmond-town-bangalore-23846",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "570511",
                                            "name": "Bakingo",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/6/20/3cef8d39-18af-420a-b2ab-2b1175e02370_570511.jpg",
                                            "locality": "Puhlong X-road",
                                            "areaName": "Vasanth Nagar",
                                            "costForTwo": "\u20B9299 for two",
                                            "cuisines": [
                                                "Bakery",
                                                "Desserts",
                                                "Beverages",
                                                "Snacks"
                                            ],
                                            "avgRating": 4.6,
                                            "parentId": "3818",
                                            "avgRatingString": "4.6",
                                            "totalRatingsString": "1K+",
                                            "sla": {
                                                "deliveryTime": 32,
                                                "lastMileTravel": 4.4,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "30-35 mins",
                                                "lastMileTravelString": "4.4 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-22 01:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "textExtendedBadges": [
                                                    {
                                                        "iconId": "v1705582451/Ratnesh_Badges/Perfect_cake.png",
                                                        "shortDescription": "Perfect cake delivery",
                                                        "fontColor": "#7E808C"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "",
                                                                    "fontColor": "#7E808C",
                                                                    "iconId": "v1705582451/Ratnesh_Badges/Perfect_cake.png",
                                                                    "shortDescription": "Perfect cake delivery"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "60% OFF",
                                                "subHeader": "UPTO \u20B9120"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {},
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/bakingo-puhlong-x-road-vasanth-nagar-bangalore-570511",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "822315",
                                            "name": "Subway",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/4/9/e0ab56c3-3d8e-4214-8705-240795d737c0_822315.jpg",
                                            "locality": "Langford Road",
                                            "areaName": "Richmond Town",
                                            "costForTwo": "\u20B9350 for two",
                                            "cuisines": [
                                                "Salads",
                                                "Snacks",
                                                "Desserts",
                                                "Beverages"
                                            ],
                                            "avgRating": 4.3,
                                            "parentId": "2",
                                            "avgRatingString": "4.3",
                                            "totalRatingsString": "100+",
                                            "sla": {
                                                "deliveryTime": 28,
                                                "lastMileTravel": 2.3,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "25-30 mins",
                                                "lastMileTravelString": "2.3 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-22 01:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Sandwiches.png",
                                                        "description": "Delivery!"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Sandwiches.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "ITEMS",
                                                "subHeader": "AT \u20B9149"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "isNewlyOnboarded": true,
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {},
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/subway-langford-road-richmond-town-bangalore-822315",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "41105",
                                            "name": "Nandhini Deluxe",
                                            "cloudinaryImageId": "zmp84ckarixkz73fzuws",
                                            "locality": "Kadubisanahalli",
                                            "areaName": "Basavanagudi",
                                            "costForTwo": "\u20B9550 for two",
                                            "cuisines": [
                                                "Andhra",
                                                "Chinese"
                                            ],
                                            "avgRating": 4.3,
                                            "parentId": "2451",
                                            "avgRatingString": "4.3",
                                            "totalRatingsString": "10K+",
                                            "sla": {
                                                "deliveryTime": 26,
                                                "lastMileTravel": 1.7,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "25-30 mins",
                                                "lastMileTravelString": "1.7 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-22 00:00:00",
                                                "opened": true
                                            },
                                            "badges": {},
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "\u20B9100 OFF",
                                                "subHeader": "ABOVE \u20B9299",
                                                "discountTag": "FLAT DEAL"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {},
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/nandhini-deluxe-kadubisanahalli-basavanagudi-bangalore-41105",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "426730",
                                            "name": "Theobroma",
                                            "cloudinaryImageId": "63dd75492c47fcec191132b8eb299ea5",
                                            "locality": "Vittal Malya Road",
                                            "areaName": "Ashok Nagar",
                                            "costForTwo": "\u20B9400 for two",
                                            "cuisines": [
                                                "Desserts",
                                                "Bakery",
                                                "Beverages"
                                            ],
                                            "avgRating": 4.7,
                                            "parentId": "1040",
                                            "avgRatingString": "4.7",
                                            "totalRatingsString": "1K+",
                                            "sla": {
                                                "deliveryTime": 32,
                                                "lastMileTravel": 2.2,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "30-35 mins",
                                                "lastMileTravelString": "2.2 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-21 23:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Desserts.png",
                                                        "description": "Delivery!"
                                                    }
                                                ],
                                                "textExtendedBadges": [
                                                    {
                                                        "iconId": "v1705582451/Ratnesh_Badges/Perfect_cake.png",
                                                        "shortDescription": "Perfect cake delivery",
                                                        "fontColor": "#7E808C"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Desserts.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "",
                                                                    "fontColor": "#7E808C",
                                                                    "iconId": "v1705582451/Ratnesh_Badges/Perfect_cake.png",
                                                                    "shortDescription": "Perfect cake delivery"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "15% OFF",
                                                "discountTag": "FLAT DEAL"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {},
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/theobroma-vittal-malya-road-ashok-nagar-bangalore-426730",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "160120",
                                            "name": "Asha Sweet Center - Since 1951",
                                            "cloudinaryImageId": "egm3aym4fa73hst2tv9b",
                                            "locality": "Gandhi Bazaar",
                                            "areaName": "Basavanagudi",
                                            "costForTwo": "\u20B9250 for two",
                                            "cuisines": [
                                                "Sweets",
                                                "Snacks",
                                                "Fast Food",
                                                "Bakery",
                                                "Beverages"
                                            ],
                                            "avgRating": 4.5,
                                            "veg": true,
                                            "parentId": "472555",
                                            "avgRatingString": "4.5",
                                            "totalRatingsString": "1K+",
                                            "sla": {
                                                "deliveryTime": 27,
                                                "lastMileTravel": 3,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "25-30 mins",
                                                "lastMileTravelString": "3.0 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-21 21:30:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "v1695133679/badges/Pure_Veg111.png",
                                                        "description": "pureveg"
                                                    }
                                                ],
                                                "textExtendedBadges": [
                                                    {
                                                        "iconId": "guiltfree/GF_Logo_android_3x",
                                                        "shortDescription": "options available",
                                                        "fontColor": "#7E808C"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "aggregatedDiscountInfoV2": {},
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "pureveg",
                                                                    "imageId": "v1695133679/badges/Pure_Veg111.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "",
                                                                    "fontColor": "#7E808C",
                                                                    "iconId": "guiltfree/GF_Logo_android_3x",
                                                                    "shortDescription": "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {},
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/asha-sweet-center-since-1951-gandhi-bazaar-basavanagudi-bangalore-160120",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "688434",
                                            "name": "Kwality Walls Frozen Dessert and Ice Cream Shop",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/6/13/dfea08dc-9227-4ce8-addb-72012b13f58d_688434.JPG",
                                            "locality": "WEST PORTION",
                                            "areaName": "Shanthinagar",
                                            "costForTwo": "\u20B9200 for two",
                                            "cuisines": [
                                                "Desserts",
                                                "Ice Cream",
                                                "Ice Cream Cakes"
                                            ],
                                            "avgRating": 4.5,
                                            "veg": true,
                                            "parentId": "582",
                                            "avgRatingString": "4.5",
                                            "totalRatingsString": "50+",
                                            "sla": {
                                                "deliveryTime": 27,
                                                "lastMileTravel": 1.1,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "25-30 mins",
                                                "lastMileTravelString": "1.1 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-21 23:59:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "v1695133679/badges/Pure_Veg111.png",
                                                        "description": "pureveg"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "pureveg",
                                                                    "imageId": "v1695133679/badges/Pure_Veg111.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "50% OFF",
                                                "subHeader": "UPTO \u20B9100"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {},
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/kwality-walls-frozen-dessert-and-ice-cream-shop-west-portion-shanthinagar-bangalore-688434",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "78511",
                                            "name": "NIC Ice Creams",
                                            "cloudinaryImageId": "18d8b8fb6bac8063a6fa886e20148110",
                                            "locality": "8th Block",
                                            "areaName": "Koramangala",
                                            "costForTwo": "\u20B9120 for two",
                                            "cuisines": [
                                                "Ice Cream",
                                                "Desserts"
                                            ],
                                            "avgRating": 4.7,
                                            "veg": true,
                                            "parentId": "6249",
                                            "avgRatingString": "4.7",
                                            "totalRatingsString": "5K+",
                                            "sla": {
                                                "deliveryTime": 36,
                                                "lastMileTravel": 5,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "35-40 mins",
                                                "lastMileTravelString": "5.0 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-21 23:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "v1695133679/badges/Pure_Veg111.png",
                                                        "description": "pureveg"
                                                    }
                                                ],
                                                "textExtendedBadges": [
                                                    {
                                                        "iconId": "Ratnesh_Badges/test2.png",
                                                        "shortDescription": "Perfect ice cream delivery",
                                                        "fontColor": "#7E808C"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "pureveg",
                                                                    "imageId": "v1695133679/badges/Pure_Veg111.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "",
                                                                    "fontColor": "#7E808C",
                                                                    "iconId": "Ratnesh_Badges/test2.png",
                                                                    "shortDescription": "Perfect ice cream delivery"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "\u20B9150 OFF",
                                                "subHeader": "ABOVE \u20B9499",
                                                "discountTag": "FLAT DEAL"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {},
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/nic-ice-creams-8th-block-koramangala-bangalore-78511",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "622202",
                                            "name": "MOJO Pizza - 2X Toppings",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/5/20/349e8d46-3138-4b19-96b2-df400a77e285_622202.JPG",
                                            "locality": "Langford Road",
                                            "areaName": "Shantinagar",
                                            "costForTwo": "\u20B9250 for two",
                                            "cuisines": [
                                                "Pizzas",
                                                "Italian",
                                                "Fast Food",
                                                "Desserts"
                                            ],
                                            "avgRating": 4.5,
                                            "parentId": "11329",
                                            "avgRatingString": "4.5",
                                            "totalRatingsString": "100+",
                                            "sla": {
                                                "deliveryTime": 30,
                                                "lastMileTravel": 1.6,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "20-30 mins",
                                                "lastMileTravelString": "1.6 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-22 02:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "textExtendedBadges": [
                                                    {
                                                        "iconId": "guiltfree/GF_Logo_android_3x",
                                                        "shortDescription": "options available",
                                                        "fontColor": "#7E808C"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "",
                                                                    "fontColor": "#7E808C",
                                                                    "iconId": "guiltfree/GF_Logo_android_3x",
                                                                    "shortDescription": "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "50% OFF",
                                                "subHeader": "UPTO \u20B9100"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {},
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/mojo-pizza-2x-toppings-langford-road-shantinagar-bangalore-622202",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "17376",
                                            "name": "Glen's Bakehouse",
                                            "cloudinaryImageId": "m6jahioyu7zrodei5pcq",
                                            "locality": "Lavelle Road",
                                            "areaName": "Ashok Nagar",
                                            "costForTwo": "\u20B9500 for two",
                                            "cuisines": [
                                                "Desserts",
                                                "Bakery",
                                                "Beverages",
                                                "Continental",
                                                "Italian"
                                            ],
                                            "avgRating": 4.6,
                                            "parentId": "3220",
                                            "avgRatingString": "4.6",
                                            "totalRatingsString": "10K+",
                                            "sla": {
                                                "deliveryTime": 35,
                                                "lastMileTravel": 2.4,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "30-35 mins",
                                                "lastMileTravelString": "2.4 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-21 23:59:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Gourmet.png",
                                                        "description": "Delivery!"
                                                    }
                                                ],
                                                "textExtendedBadges": [
                                                    {
                                                        "iconId": "v1705582451/Ratnesh_Badges/Perfect_cake.png",
                                                        "shortDescription": "Perfect cake delivery",
                                                        "fontColor": "#7E808C"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "aggregatedDiscountInfoV2": {},
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Gourmet.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "",
                                                                    "fontColor": "#7E808C",
                                                                    "iconId": "v1705582451/Ratnesh_Badges/Perfect_cake.png",
                                                                    "shortDescription": "Perfect cake delivery"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {},
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/glens-bakehouse-lavelle-road-ashok-nagar-bangalore-17376",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "58527",
                                            "name": "Cookie Man",
                                            "cloudinaryImageId": "9859734c76da085e6fa82ab6ff6f9324",
                                            "locality": "Ashok Nagar",
                                            "areaName": "Ashok Nagar",
                                            "costForTwo": "\u20B9140 for two",
                                            "cuisines": [
                                                "Desserts",
                                                "Ice Cream",
                                                "Bakery"
                                            ],
                                            "avgRating": 4.5,
                                            "parentId": "2420",
                                            "avgRatingString": "4.5",
                                            "totalRatingsString": "500+",
                                            "sla": {
                                                "deliveryTime": 34,
                                                "lastMileTravel": 3.8,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "30-35 mins",
                                                "lastMileTravelString": "3.8 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-21 22:00:00",
                                                "opened": true
                                            },
                                            "badges": {},
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "40% OFF",
                                                "subHeader": "UPTO \u20B980"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {},
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/cookie-man-ashok-nagar-bangalore-58527",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "643832",
                                            "name": "WeFit - Protein Bowls, Salads & Sandwiches",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/5/23/d32dda02-869b-46d5-b16c-47c4c14314e2_643832.JPG",
                                            "locality": "Langford Road",
                                            "areaName": "Santhinagar",
                                            "costForTwo": "\u20B9250 for two",
                                            "cuisines": [
                                                "Healthy Food",
                                                "Salads",
                                                "Keto",
                                                "Snacks"
                                            ],
                                            "avgRating": 4.6,
                                            "parentId": "355285",
                                            "avgRatingString": "4.6",
                                            "totalRatingsString": "100+",
                                            "sla": {
                                                "deliveryTime": 30,
                                                "lastMileTravel": 1.6,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "20-30 mins",
                                                "lastMileTravelString": "1.6 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-22 02:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "textExtendedBadges": [
                                                    {
                                                        "iconId": "guiltfree/GF_Logo_android_3x",
                                                        "shortDescription": "brand",
                                                        "fontColor": "#7E808C"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "",
                                                                    "fontColor": "#7E808C",
                                                                    "iconId": "guiltfree/GF_Logo_android_3x",
                                                                    "shortDescription": "brand"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "50% OFF",
                                                "subHeader": "UPTO \u20B9100"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {},
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/wefit-protein-bowls-salads-and-sandwiches-langford-road-santhinagar-bangalore-643832",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "692226",
                                            "name": "BOOM Sandwich - Sub of India",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/5/19/1392089b-bfd1-4ac2-90f5-cdb914aa163a_692226.JPG",
                                            "locality": "Lakshmi Road",
                                            "areaName": "Shanti Nagar",
                                            "costForTwo": "\u20B9250 for two",
                                            "cuisines": [
                                                "Snacks",
                                                "Indian",
                                                "Desserts"
                                            ],
                                            "avgRating": 4.4,
                                            "parentId": "401169",
                                            "avgRatingString": "4.4",
                                            "totalRatingsString": "50+",
                                            "sla": {
                                                "deliveryTime": 30,
                                                "lastMileTravel": 1.6,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "20-30 mins",
                                                "lastMileTravelString": "1.6 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-22 02:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "textExtendedBadges": [
                                                    {
                                                        "iconId": "guiltfree/GF_Logo_android_3x",
                                                        "shortDescription": "options available",
                                                        "fontColor": "#7E808C"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "",
                                                                    "fontColor": "#7E808C",
                                                                    "iconId": "guiltfree/GF_Logo_android_3x",
                                                                    "shortDescription": "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "50% OFF",
                                                "subHeader": "UPTO \u20B9100"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {},
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/boom-sandwich-sub-of-india-lakshmi-road-shanti-nagar-bangalore-692226",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "750396",
                                            "name": "Daily Kitchen - Homely Meals",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/5/19/741d7d41-1341-4358-b6e0-cc22b8e82f9a_750396.JPG",
                                            "locality": "Lakshmi Road",
                                            "areaName": "Langford Road",
                                            "costForTwo": "\u20B9400 for two",
                                            "cuisines": [
                                                "Home Food",
                                                "Indian",
                                                "North Indian",
                                                "Thalis"
                                            ],
                                            "avgRating": 4.4,
                                            "parentId": "444382",
                                            "avgRatingString": "4.4",
                                            "totalRatingsString": "100+",
                                            "sla": {
                                                "deliveryTime": 25,
                                                "lastMileTravel": 1.6,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "15-25 mins",
                                                "lastMileTravelString": "1.6 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-22 02:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "textExtendedBadges": [
                                                    {
                                                        "iconId": "guiltfree/GF_Logo_android_3x",
                                                        "shortDescription": "options available",
                                                        "fontColor": "#7E808C"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "",
                                                                    "fontColor": "#7E808C",
                                                                    "iconId": "guiltfree/GF_Logo_android_3x",
                                                                    "shortDescription": "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "50% OFF",
                                                "subHeader": "UPTO \u20B9100"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {},
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/daily-kitchen-homely-meals-lakshmi-road-langford-road-bangalore-750396",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "503001",
                                            "name": "Mealful Rolls - India's Biggest Rolls",
                                            "cloudinaryImageId": "0d959f87516479195952893fa26b11c9",
                                            "locality": "SHANTHINAGAR",
                                            "areaName": "Lakshmi Road",
                                            "costForTwo": "\u20B9250 for two",
                                            "cuisines": [
                                                "Fast Food",
                                                "Snacks",
                                                "North Indian",
                                                "Desserts"
                                            ],
                                            "avgRating": 4.4,
                                            "parentId": "10390",
                                            "avgRatingString": "4.4",
                                            "totalRatingsString": "100+",
                                            "sla": {
                                                "deliveryTime": 35,
                                                "lastMileTravel": 1.6,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "25-35 mins",
                                                "lastMileTravelString": "1.6 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-22 02:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "textExtendedBadges": [
                                                    {
                                                        "iconId": "guiltfree/GF_Logo_android_3x",
                                                        "shortDescription": "options available",
                                                        "fontColor": "#7E808C"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "",
                                                                    "fontColor": "#7E808C",
                                                                    "iconId": "guiltfree/GF_Logo_android_3x",
                                                                    "shortDescription": "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "50% OFF",
                                                "subHeader": "UPTO \u20B9100"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {},
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/mealful-rolls-indias-biggest-rolls-shanthinagar-lakshmi-road-bangalore-503001",
                                            "type": "WEBLINK"
                                        }
                                    }
                                ],
                                "theme": "Restaurant_Group_WebView_SEO_PB_Theme",
                                "widgetType": "WIDGET_TYPE_POPULAR_BRANDS",
                                "style": {
                                    "width": {
                                        "type": "TYPE_RELATIVE",
                                        "value": 0.41111112,
                                        "reference": "RELATIVE_DIMENSION_REFERENCE_DEVICE_WIDTH"
                                    },
                                    "height": {
                                        "type": "TYPE_RELATIVE",
                                        "value": 0.7027027,
                                        "reference": "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                                    },
                                    "layoutAlignment": "LAYOUT_ALIGNMENT_LEFT"
                                },
                                "collectionId": "84124"
                            }
                        }
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BasicContent",
                        "title": "Restaurants with online food delivery in Bangalore",
                        "id": "popular_restaurants_title"
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.InlineViewFilterSortWidget",
                        "sortConfigs": [
                            {
                                "key": "relevance",
                                "title": "Relevance(Default)",
                                "selected": true,
                                "defaultSelection": true
                            },
                            {
                                "key": "deliveryTimeAsc",
                                "title": "DeliveryTime"
                            },
                            {
                                "key": "modelBasedRatingDesc",
                                "title": "Rating"
                            },
                            {
                                "key": "costForTwoAsc",
                                "title": "Cost:LowtoHigh"
                            },
                            {
                                "key": "costForTwoDesc",
                                "title": "Cost:HightoLow"
                            }
                        ],
                        "restaurantCount": 1878,
                        "facetList": [
                            {
                                "label": "Delivery Time",
                                "id": "deliveryTime",
                                "selection": "SELECT_TYPE_MULTISELECT",
                                "facetInfo": [
                                    {
                                        "label": "Fast Delivery",
                                        "id": "deliveryTimefacetquery1",
                                        "analytics": {},
                                        "openFilter": true
                                    }
                                ],
                                "viewType": "VIEW_TYPE_HALF_CARD",
                                "subLabel": "Filter by"
                            },
                            {
                                "label": "Cuisines",
                                "id": "catalog_cuisines",
                                "selection": "SELECT_TYPE_MULTISELECT",
                                "facetInfo": [
                                    {
                                        "label": "Afghani",
                                        "id": "query_afghani",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "American",
                                        "id": "query_american",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Andhra",
                                        "id": "query_andhra",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Arabian",
                                        "id": "query_arabian",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Asian",
                                        "id": "query_asian",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Assamese",
                                        "id": "query_assamese",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Awadhi",
                                        "id": "query_awadhi",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Bakery",
                                        "id": "query_bakery",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Barbecue",
                                        "id": "query_barbecue",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Bengali",
                                        "id": "query_bengali",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Beverages",
                                        "id": "query_beverages",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Bihari",
                                        "id": "query_bihari",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Biryani",
                                        "id": "query_biryani",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "British",
                                        "id": "query_british",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Bubble Tea",
                                        "id": "query_bubble_tea",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Buffalo meat",
                                        "id": "query_buffalo_meat",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Burger",
                                        "id": "query_burger",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Burgers",
                                        "id": "query_burgers",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Burmese",
                                        "id": "query_burmese",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Cafe",
                                        "id": "query_cafe",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Cakes & Pastries",
                                        "id": "query_cakes_&_pastries",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Cakes and Pastries",
                                        "id": "query_cakes_and_pastries",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Chaat",
                                        "id": "query_chaat",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Chettinad",
                                        "id": "query_chettinad",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Chinese",
                                        "id": "query_chinese",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Coastal",
                                        "id": "query_coastal",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Coffee",
                                        "id": "query_coffee",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Combo",
                                        "id": "query_combo",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Confectionery",
                                        "id": "query_confectionery",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Continental",
                                        "id": "query_continental",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Desserts",
                                        "id": "query_desserts",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "European",
                                        "id": "query_european",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Fast Food",
                                        "id": "query_fast_food",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "French",
                                        "id": "query_french",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Goan",
                                        "id": "query_goan",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Greek",
                                        "id": "query_greek",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Grill",
                                        "id": "query_grill",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Gujarati",
                                        "id": "query_gujarati",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Haleem",
                                        "id": "query_haleem",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Healthy Food",
                                        "id": "query_healthy_food",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Home Food",
                                        "id": "query_home_food",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Hyderabadi",
                                        "id": "query_hyderabadi",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Ice Cream",
                                        "id": "query_ice_cream",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Ice Cream Cakes",
                                        "id": "query_ice_cream_cakes",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Indian",
                                        "id": "query_indian",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Indonesian",
                                        "id": "query_indonesian",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Italian",
                                        "id": "query_italian",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Italian-American",
                                        "id": "query_italian-american",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Jain",
                                        "id": "query_jain",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Japanese",
                                        "id": "query_japanese",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Juices",
                                        "id": "query_juices",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Kashmiri",
                                        "id": "query_kashmiri",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Kebabs",
                                        "id": "query_kebabs",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Kerala",
                                        "id": "query_kerala",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Keto",
                                        "id": "query_keto",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Korean",
                                        "id": "query_korean",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Lebanese",
                                        "id": "query_lebanese",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Lucknowi",
                                        "id": "query_lucknowi",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Maharashtrian",
                                        "id": "query_maharashtrian",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Malaysian",
                                        "id": "query_malaysian",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Mangalorean",
                                        "id": "query_mangalorean",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Meat",
                                        "id": "query_meat",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Mediterranean",
                                        "id": "query_mediterranean",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Mexican",
                                        "id": "query_mexican",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Middle Eastern",
                                        "id": "query_middle_eastern",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Momos",
                                        "id": "query_momos",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Mughlai",
                                        "id": "query_mughlai",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Naga",
                                        "id": "query_naga",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Nepalese",
                                        "id": "query_nepalese",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "North Eastern",
                                        "id": "query_north_eastern",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "North Indian",
                                        "id": "query_north_indian",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Offer Valid only for New Customers",
                                        "id": "query_offer_valid_only_for_new_customers",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Oriental",
                                        "id": "query_oriental",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Paan",
                                        "id": "query_paan",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Pan-Asian",
                                        "id": "query_pan-asian",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Parsi",
                                        "id": "query_parsi",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Pastas",
                                        "id": "query_pastas",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Pizzas",
                                        "id": "query_pizzas",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Portuguese",
                                        "id": "query_portuguese",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Punjabi",
                                        "id": "query_punjabi",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Raja",
                                        "id": "query_raja",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Rajasthani",
                                        "id": "query_rajasthani",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Rayalaseema",
                                        "id": "query_rayalaseema",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Rolls",
                                        "id": "query_rolls",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Rolls & Wraps",
                                        "id": "query_rolls_&_wraps",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Salads",
                                        "id": "query_salads",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Seafood",
                                        "id": "query_seafood",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Sindhi",
                                        "id": "query_sindhi",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Singaporean",
                                        "id": "query_singaporean",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Snacks",
                                        "id": "query_snacks",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "South American",
                                        "id": "query_south_american",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "South Indian",
                                        "id": "query_south_indian",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Sri Lankan",
                                        "id": "query_sri_lankan",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Steakhouse",
                                        "id": "query_steakhouse",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Street Food",
                                        "id": "query_street_food",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Sushi",
                                        "id": "query_sushi",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Sweets",
                                        "id": "query_sweets",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Tandoor",
                                        "id": "query_tandoor",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Tea",
                                        "id": "query_tea",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Telangana",
                                        "id": "query_telangana",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Tex-Mex",
                                        "id": "query_tex-mex",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Thai",
                                        "id": "query_thai",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Thalis",
                                        "id": "query_thalis",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Tibetan",
                                        "id": "query_tibetan",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Tribal",
                                        "id": "query_tribal",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Turkish",
                                        "id": "query_turkish",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Vietnamese",
                                        "id": "query_vietnamese",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Waffle",
                                        "id": "query_waffle",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "briyani",
                                        "id": "query_briyani",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "fastfood",
                                        "id": "query_fastfood",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "paratha",
                                        "id": "query_paratha",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "pav bhaji",
                                        "id": "query_pav_bhaji",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "pizza",
                                        "id": "query_pizza",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "rolls",
                                        "id": "query_rolls",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "sandwich",
                                        "id": "query_sandwich",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "shawarma",
                                        "id": "query_shawarma",
                                        "analytics": {},
                                        "openFilter": true
                                    }
                                ],
                                "viewType": "VIEW_TYPE_HALF_CARD",
                                "canSearch": true,
                                "subLabel": "Filter by cuisine",
                                "openFilter": true
                            },
                            {
                                "label": "Explore",
                                "id": "explore",
                                "selection": "SELECT_TYPE_MULTISELECT",
                                "facetInfo": [
                                    {
                                        "label": "New on Swiggy",
                                        "id": "newfacetquery1",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Swiggy Exclusives",
                                        "id": "isExclusivefacetquery1",
                                        "analytics": {}
                                    }
                                ],
                                "viewType": "VIEW_TYPE_HALF_CARD"
                            },
                            {
                                "label": "Ratings",
                                "id": "rating",
                                "selection": "SELECT_TYPE_MULTISELECT",
                                "facetInfo": [
                                    {
                                        "label": "Ratings 4.5+",
                                        "id": "ratingfacetquery3",
                                        "analytics": {}
                                    },
                                    {
                                        "label": "Ratings 4.0+",
                                        "id": "ratingfacetquery4",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Ratings 3.5+",
                                        "id": "ratingfacetquery5",
                                        "analytics": {}
                                    }
                                ],
                                "viewType": "VIEW_TYPE_HALF_CARD",
                                "subLabel": "Filter by"
                            },
                            {
                                "label": "Veg/Non-Veg",
                                "id": "isVeg",
                                "selection": "SELECT_TYPE_SINGLESELECT",
                                "facetInfo": [
                                    {
                                        "label": "Pure Veg",
                                        "id": "isVegfacetquery2",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Non Veg",
                                        "id": "isVegfacetquery3",
                                        "analytics": {}
                                    }
                                ],
                                "viewType": "VIEW_TYPE_FLATTENED",
                                "subLabel": "Filter by"
                            },
                            {
                                "label": "Offers",
                                "id": "restaurantOfferMultiTd",
                                "selection": "SELECT_TYPE_SINGLESELECT",
                                "facetInfo": [
                                    {
                                        "label": "Offers",
                                        "id": "restaurantOfferMultiTdfacetquery3",
                                        "analytics": {},
                                        "openFilter": true
                                    }
                                ],
                                "viewType": "VIEW_TYPE_FLATTENED",
                                "subLabel": "Restaurants with"
                            },
                            {
                                "label": "Cost for two",
                                "id": "costForTwo",
                                "selection": "SELECT_TYPE_MULTISELECT",
                                "facetInfo": [
                                    {
                                        "label": "Rs. 300-Rs. 600",
                                        "id": "costForTwofacetquery3",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Greater than Rs. 600",
                                        "id": "costForTwofacetquery4",
                                        "analytics": {}
                                    },
                                    {
                                        "label": "Less than Rs. 300",
                                        "id": "costForTwofacetquery5",
                                        "analytics": {},
                                        "openFilter": true
                                    }
                                ],
                                "viewType": "VIEW_TYPE_HALF_CARD",
                                "subLabel": "Filter by"
                            }
                        ]
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
                        "layout": {
                            "columns": 4
                        },
                        "id": "restaurant_grid_listing",
                        "gridElements": {
                            "infoWithStyle": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle",
                                "restaurants": [
                                    {
                                        "info": {
                                            "id": "10575",
                                            "name": "Pizza Hut",
                                            "cloudinaryImageId": "2b4f62d606d1b2bfba9ba9e5386fabb7",
                                            "locality": "Richmond Town",
                                            "areaName": "Shanti Nagar",
                                            "costForTwo": "\u20B9600 for two",
                                            "cuisines": [
                                                "Pizzas"
                                            ],
                                            "avgRating": 4.2,
                                            "parentId": "721",
                                            "avgRatingString": "4.2",
                                            "totalRatingsString": "5K+",
                                            "sla": {
                                                "deliveryTime": 29,
                                                "lastMileTravel": 1.6,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "25-30 mins",
                                                "lastMileTravelString": "1.6 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-22 01:00:00",
                                                "opened": true
                                            },
                                            "badges": {},
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "50% OFF",
                                                "subHeader": "UPTO \u20B9100"
                                            },
                                            "orderabilityCommunication": {
                                                "title": {},
                                                "subTitle": {},
                                                "message": {},
                                                "customIcon": {}
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {
                                            "context": "seo-data-efe5a914-ae14-47c9-9a01-08a78a64d0a7"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/pizza-hut-richmond-town-shanti-nagar-bangalore-10575",
                                            "text": "RESTAURANT_MENU",
                                            "type": "WEBLINK"
                                        },
                                        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        "info": {
                                            "id": "405798",
                                            "name": "Chinese Wok",
                                            "cloudinaryImageId": "e0839ff574213e6f35b3899ebf1fc597",
                                            "locality": "Malleshwaram",
                                            "areaName": "Malleshwaram",
                                            "costForTwo": "\u20B9250 for two",
                                            "cuisines": [
                                                "Chinese",
                                                "Asian",
                                                "Tibetan",
                                                "Desserts"
                                            ],
                                            "avgRating": 4.3,
                                            "parentId": "61955",
                                            "avgRatingString": "4.3",
                                            "totalRatingsString": "500+",
                                            "sla": {
                                                "deliveryTime": 46,
                                                "lastMileTravel": 5,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "45-50 mins",
                                                "lastMileTravelString": "5.0 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-21 22:00:00",
                                                "opened": true
                                            },
                                            "badges": {},
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "ITEMS",
                                                "subHeader": "AT \u20B9169"
                                            },
                                            "orderabilityCommunication": {
                                                "title": {},
                                                "subTitle": {},
                                                "message": {},
                                                "customIcon": {}
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {
                                            "context": "seo-data-efe5a914-ae14-47c9-9a01-08a78a64d0a7"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/chinese-wok-malleshwaram-bangalore-405798",
                                            "text": "RESTAURANT_MENU",
                                            "type": "WEBLINK"
                                        },
                                        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        "info": {
                                            "id": "82504",
                                            "name": "UBQ by Barbeque Nation",
                                            "cloudinaryImageId": "mpxqoksbeig38xs1wkgm",
                                            "locality": "Dr Rajkumar Road",
                                            "areaName": "Rajajinagar",
                                            "costForTwo": "\u20B9300 for two",
                                            "cuisines": [
                                                "North Indian",
                                                "Barbecue",
                                                "Biryani",
                                                "Kebabs",
                                                "Mughlai",
                                                "Desserts"
                                            ],
                                            "avgRating": 3.9,
                                            "parentId": "10804",
                                            "avgRatingString": "3.9",
                                            "totalRatingsString": "5K+",
                                            "sla": {
                                                "deliveryTime": 46,
                                                "lastMileTravel": 5,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "45-50 mins",
                                                "lastMileTravelString": "5.0 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-21 23:30:00",
                                                "opened": true
                                            },
                                            "badges": {},
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "60% OFF",
                                                "subHeader": "UPTO \u20B9120"
                                            },
                                            "orderabilityCommunication": {
                                                "title": {},
                                                "subTitle": {},
                                                "message": {},
                                                "customIcon": {}
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {
                                            "context": "seo-data-efe5a914-ae14-47c9-9a01-08a78a64d0a7"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/ubq-by-barbeque-nation-dr-rajkumar-road-rajajinagar-bangalore-82504",
                                            "text": "RESTAURANT_MENU",
                                            "type": "WEBLINK"
                                        },
                                        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        "info": {
                                            "id": "66590",
                                            "name": "Havmor Havfunn Ice Cream",
                                            "cloudinaryImageId": "49845b494b1e637209b7bd1c7ca184ad",
                                            "locality": "Vanivilas road",
                                            "areaName": "Basavanagudi",
                                            "costForTwo": "\u20B9400 for two",
                                            "cuisines": [
                                                "Ice Cream",
                                                "Ice Cream Cakes",
                                                "Desserts",
                                                "Beverages"
                                            ],
                                            "avgRating": 4.5,
                                            "veg": true,
                                            "parentId": "94570",
                                            "avgRatingString": "4.5",
                                            "totalRatingsString": "500+",
                                            "sla": {
                                                "deliveryTime": 31,
                                                "lastMileTravel": 3,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "30-35 mins",
                                                "lastMileTravelString": "3.0 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-21 23:30:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "textExtendedBadges": [
                                                    {
                                                        "iconId": "v1705582451/Ratnesh_Badges/Perfect_cake.png",
                                                        "shortDescription": "Perfect cake delivery",
                                                        "fontColor": "#7E808C"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "aggregatedDiscountInfoV2": {},
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "",
                                                                    "fontColor": "#7E808C",
                                                                    "iconId": "v1705582451/Ratnesh_Badges/Perfect_cake.png",
                                                                    "shortDescription": "Perfect cake delivery"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            "orderabilityCommunication": {
                                                "title": {},
                                                "subTitle": {},
                                                "message": {},
                                                "customIcon": {}
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {
                                            "context": "seo-data-efe5a914-ae14-47c9-9a01-08a78a64d0a7"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/havmor-havfunn-ice-cream-vanivilas-road-basavanagudi-bangalore-66590",
                                            "text": "RESTAURANT_MENU",
                                            "type": "WEBLINK"
                                        },
                                        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        "info": {
                                            "id": "43836",
                                            "name": "McDonald's",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/4/1/fe11ced6-89a3-4080-8610-3c743a3bb3f0_43836.jpg",
                                            "locality": "MG Road",
                                            "areaName": "Ashok Nagar",
                                            "costForTwo": "\u20B9400 for two",
                                            "cuisines": [
                                                "Burgers",
                                                "Beverages",
                                                "Cafe",
                                                "Desserts"
                                            ],
                                            "avgRating": 4.3,
                                            "parentId": "630",
                                            "avgRatingString": "4.3",
                                            "totalRatingsString": "10K+",
                                            "sla": {
                                                "deliveryTime": 34,
                                                "lastMileTravel": 2.5,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "30-35 mins",
                                                "lastMileTravelString": "2.5 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-22 02:45:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Burger.png",
                                                        "description": "Delivery!"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Burger.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "\u20B9100 OFF",
                                                "subHeader": "ABOVE \u20B9199",
                                                "discountTag": "FLAT DEAL"
                                            },
                                            "orderabilityCommunication": {
                                                "title": {},
                                                "subTitle": {},
                                                "message": {},
                                                "customIcon": {}
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {
                                            "context": "seo-data-efe5a914-ae14-47c9-9a01-08a78a64d0a7"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/mcdonalds-mg-road-ashok-nagar-bangalore-43836",
                                            "text": "RESTAURANT_MENU",
                                            "type": "WEBLINK"
                                        },
                                        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        "info": {
                                            "id": "432976",
                                            "name": "KFC",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/4/17/9869efb0-ef0e-41eb-bffa-9d6e03eef55e_432976.JPG",
                                            "locality": "Double Road",
                                            "areaName": "Shanti Nagar",
                                            "costForTwo": "\u20B9400 for two",
                                            "cuisines": [
                                                "Burgers",
                                                "Fast Food",
                                                "Rolls & Wraps"
                                            ],
                                            "avgRating": 4.2,
                                            "parentId": "547",
                                            "avgRatingString": "4.2",
                                            "totalRatingsString": "1K+",
                                            "sla": {
                                                "deliveryTime": 31,
                                                "lastMileTravel": 1.5,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "30-35 mins",
                                                "lastMileTravelString": "1.5 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-21 23:00:00",
                                                "opened": true
                                            },
                                            "badges": {},
                                            "isOpen": true,
                                            "aggregatedDiscountInfoV2": {},
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "orderabilityCommunication": {
                                                "title": {},
                                                "subTitle": {},
                                                "message": {},
                                                "customIcon": {}
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {
                                            "context": "seo-data-efe5a914-ae14-47c9-9a01-08a78a64d0a7"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/kfc-double-road-shanti-nagar-bangalore-432976",
                                            "text": "RESTAURANT_MENU",
                                            "type": "WEBLINK"
                                        },
                                        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        "info": {
                                            "id": "77949",
                                            "name": "Burger King",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/6/11/4ee8bc77-ca9f-41bd-a0f3-511c70902b91_77949.JPG",
                                            "locality": "Gandhi Bazar",
                                            "areaName": "Basavanagudi",
                                            "costForTwo": "\u20B9350 for two",
                                            "cuisines": [
                                                "Burgers",
                                                "American"
                                            ],
                                            "avgRating": 4.2,
                                            "parentId": "166",
                                            "avgRatingString": "4.2",
                                            "totalRatingsString": "10K+",
                                            "sla": {
                                                "deliveryTime": 29,
                                                "lastMileTravel": 3,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "25-30 mins",
                                                "lastMileTravelString": "3.0 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-21 23:59:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Burger.png",
                                                        "description": "Delivery!"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Burger.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "50% OFF",
                                                "subHeader": "UPTO \u20B9100"
                                            },
                                            "orderabilityCommunication": {
                                                "title": {},
                                                "subTitle": {},
                                                "message": {},
                                                "customIcon": {}
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {
                                            "context": "seo-data-efe5a914-ae14-47c9-9a01-08a78a64d0a7"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/burger-king-gandhi-bazar-basavanagudi-bangalore-77949",
                                            "text": "RESTAURANT_MENU",
                                            "type": "WEBLINK"
                                        },
                                        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        "info": {
                                            "id": "23846",
                                            "name": "Domino's Pizza",
                                            "cloudinaryImageId": "d0450ce1a6ba19ea60cd724471ed54a8",
                                            "locality": "Rehinus Street",
                                            "areaName": "Richmond Town",
                                            "costForTwo": "\u20B9400 for two",
                                            "cuisines": [
                                                "Pizzas",
                                                "Italian",
                                                "Pastas",
                                                "Desserts"
                                            ],
                                            "avgRating": 4.3,
                                            "parentId": "2456",
                                            "avgRatingString": "4.3",
                                            "totalRatingsString": "10K+",
                                            "sla": {
                                                "deliveryTime": 25,
                                                "lastMileTravel": 2,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "20-25 mins",
                                                "lastMileTravelString": "2.0 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2024-06-22 02:59:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Pizza.png",
                                                        "description": "Delivery!"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Pizza.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "\u20B9150 OFF",
                                                "subHeader": "ABOVE \u20B9299",
                                                "discountTag": "FLAT DEAL"
                                            },
                                            "orderabilityCommunication": {
                                                "title": {},
                                                "subTitle": {},
                                                "message": {},
                                                "customIcon": {}
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {}
                                        },
                                        "analytics": {
                                            "context": "seo-data-efe5a914-ae14-47c9-9a01-08a78a64d0a7"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/restaurants/dominos-pizza-rehinus-street-richmond-town-bangalore-23846",
                                            "text": "RESTAURANT_MENU",
                                            "type": "WEBLINK"
                                        },
                                        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    }
                                ],
                                "theme": "SeoRestaurantListingGridWidget"
                            }
                        }
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.ShowMoreButton",
                        "message": "Show More",
                        "id": "show_more_button"
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
                        "title": "Best Places to Eat Across Cities",
                        "brands": [
                            {
                                "text": "Best Restaurants in Bangalore",
                                "link": "https://www.swiggy.com/city/bangalore/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Pune",
                                "link": "https://www.swiggy.com/city/pune/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Mumbai",
                                "link": "https://www.swiggy.com/city/mumbai/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Delhi",
                                "link": "https://www.swiggy.com/city/delhi/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Hyderabad",
                                "link": "https://www.swiggy.com/city/hyderabad/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Kolkata",
                                "link": "https://www.swiggy.com/city/kolkata/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Chennai",
                                "link": "https://www.swiggy.com/city/chennai/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Chandigarh",
                                "link": "https://www.swiggy.com/city/chandigarh/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Ahmedabad",
                                "link": "https://www.swiggy.com/city/ahmedabad/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Jaipur",
                                "link": "https://www.swiggy.com/city/jaipur/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Nagpur",
                                "link": "https://www.swiggy.com/city/nagpur/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Bhubaneswar",
                                "link": "https://www.swiggy.com/city/bhubaneswar/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Kochi",
                                "link": "https://www.swiggy.com/city/kochi/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Surat",
                                "link": "https://www.swiggy.com/city/surat/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Dehradun",
                                "link": "https://www.swiggy.com/city/dehradun/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Ludhiana",
                                "link": "https://www.swiggy.com/city/ludhiana/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Patna",
                                "link": "https://www.swiggy.com/city/patna/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Mangaluru",
                                "link": "https://www.swiggy.com/city/mangaluru/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Bhopal",
                                "link": "https://www.swiggy.com/city/bhopal/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Gurgaon",
                                "link": "https://www.swiggy.com/city/gurgaon/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Coimbatore",
                                "link": "https://www.swiggy.com/city/coimbatore/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Agra",
                                "link": "https://www.swiggy.com/city/agra/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Noida",
                                "link": "https://www.swiggy.com/city/noida/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Vijayawada",
                                "link": "https://www.swiggy.com/city/vijayawada/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Guwahati",
                                "link": "https://www.swiggy.com/city/guwahati/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Mysore",
                                "link": "https://www.swiggy.com/city/mysore/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Pondicherry",
                                "link": "https://www.swiggy.com/city/pondicherry/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Thiruvananthapuram",
                                "link": "https://www.swiggy.com/city/thiruvananthapuram/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Ranchi",
                                "link": "https://www.swiggy.com/city/ranchi/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Vizag",
                                "link": "https://www.swiggy.com/city/vizag/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Udaipur",
                                "link": "https://www.swiggy.com/city/udaipur/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Vadodara",
                                "link": "https://www.swiggy.com/city/vadodara/best-restaurants"
                            }
                        ],
                        "id": "restaurant_near_me_links"
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
                        "title": "Best Cuisines Near Me",
                        "brands": [
                            {
                                "text": "Chinese Restaurant Near Me",
                                "link": "https://www.swiggy.com/chinese-restaurants-near-me"
                            },
                            {
                                "text": "South Indian Restaurant Near Me",
                                "link": "https://www.swiggy.com/south-indian-restaurants-near-me"
                            },
                            {
                                "text": "Indian Restaurant Near Me",
                                "link": "https://www.swiggy.com/indian-restaurants-near-me"
                            },
                            {
                                "text": "Kerala Restaurant Near Me",
                                "link": "https://www.swiggy.com/kerala-restaurants-near-me"
                            },
                            {
                                "text": "Korean Restaurant Near Me",
                                "link": "https://www.swiggy.com/korean-restaurants-near-me"
                            },
                            {
                                "text": "North Indian Restaurant Near Me",
                                "link": "https://www.swiggy.com/north-indian-restaurants-near-me"
                            },
                            {
                                "text": "Seafood Restaurant Near Me",
                                "link": "https://www.swiggy.com/seafood-restaurants-near-me"
                            },
                            {
                                "text": "Bengali Restaurant Near Me",
                                "link": "https://www.swiggy.com/bengali-restaurants-near-me"
                            },
                            {
                                "text": "Punjabi Restaurant Near Me",
                                "link": "https://www.swiggy.com/punjabi-restaurants-near-me"
                            },
                            {
                                "text": "Italian Restaurant Near Me",
                                "link": "https://www.swiggy.com/italian-restaurants-near-me"
                            },
                            {
                                "text": "Andhra Restaurant Near Me",
                                "link": "https://www.swiggy.com/andhra-restaurants-near-me"
                            },
                            {
                                "text": "Biryani Restaurant Near Me",
                                "link": "https://www.swiggy.com/biryani-restaurants-near-me"
                            },
                            {
                                "text": "Japanese Restaurant Near Me",
                                "link": "https://www.swiggy.com/japanese-restaurants-near-me"
                            },
                            {
                                "text": "Arabian Restaurant Near Me",
                                "link": "https://www.swiggy.com/arabian-restaurants-near-me"
                            },
                            {
                                "text": "Fast Food Restaurant Near Me",
                                "link": "https://www.swiggy.com/fast-food-restaurants-near-me"
                            },
                            {
                                "text": "Jain Restaurant Near Me",
                                "link": "https://www.swiggy.com/jain-restaurants-near-me"
                            },
                            {
                                "text": "Gujarati Restaurant Near Me",
                                "link": "https://www.swiggy.com/gujarati-restaurants-near-me"
                            },
                            {
                                "text": "Thai Restaurant Near Me",
                                "link": "https://www.swiggy.com/thai-restaurants-near-me"
                            },
                            {
                                "text": "Pizzas Restaurant Near Me",
                                "link": "https://www.swiggy.com/pizzas-restaurants-near-me"
                            },
                            {
                                "text": "Asian Restaurant Near Me",
                                "link": "https://www.swiggy.com/asian-restaurants-near-me"
                            },
                            {
                                "text": "Cafe Restaurant Near Me",
                                "link": "https://www.swiggy.com/cafe-restaurants-near-me"
                            },
                            {
                                "text": "Continental Restaurant Near Me",
                                "link": "https://www.swiggy.com/continental-restaurants-near-me"
                            },
                            {
                                "text": "Mexican Restaurant Near Me",
                                "link": "https://www.swiggy.com/mexican-restaurants-near-me"
                            },
                            {
                                "text": "Mughlai Restaurant Near Me",
                                "link": "https://www.swiggy.com/mughlai-restaurants-near-me"
                            },
                            {
                                "text": "Sushi Restaurant Near Me",
                                "link": "https://www.swiggy.com/sushi-restaurants-near-me"
                            },
                            {
                                "text": "Mangalorean Restaurant Near Me",
                                "link": "https://www.swiggy.com/mangalorean-restaurants-near-me"
                            },
                            {
                                "text": "Tibetan Restaurant Near Me",
                                "link": "https://www.swiggy.com/tibetan-restaurants-near-me"
                            },
                            {
                                "text": "Barbecue Restaurant Near Me",
                                "link": "https://www.swiggy.com/barbecue-restaurants-near-me"
                            },
                            {
                                "text": "Maharashtrian Restaurant Near Me",
                                "link": "https://www.swiggy.com/maharashtrian-restaurants-near-me"
                            },
                            {
                                "text": "Nepalese Restaurant Near Me",
                                "link": "https://www.swiggy.com/nepalese-restaurants-near-me"
                            },
                            {
                                "text": "Rajasthani Restaurant Near Me",
                                "link": "https://www.swiggy.com/rajasthani-restaurants-near-me"
                            },
                            {
                                "text": "Turkish Restaurant Near Me",
                                "link": "https://www.swiggy.com/turkish-restaurants-near-me"
                            }
                        ],
                        "id": "restaurant_near_me_links"
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
                        "title": "Explore Every Restaurants Near Me",
                        "brands": [
                            {
                                "text": "Explore Restaurants Near Me",
                                "link": "https://www.swiggy.com/restaurants-near-me"
                            },
                            {
                                "text": "Explore Top Rated Restaurants Near Me",
                                "link": "https://www.swiggy.com/best-restaurants-near-me"
                            }
                        ],
                        "id": "restaurant_near_me_links"
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.AppInstallLinks",
                        "title": "For better experience,download the Swiggy app now",
                        "androidAppImage": "portal/m/play_store.png",
                        "androidAppLink": "https://play.google.com/store/apps/details?id=in.swiggy.android&referrer=utm_source%3Dswiggy%26utm_medium%3Dheader",
                        "iosAppImage": "portal/m/app_store.png",
                        "iosAppLink": "https://itunes.apple.com/in/app/id989540920?referrer=utm_source%3Dswiggy%26utm_medium%3Dhomepage",
                        "id": "app_install_links"
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.FooterContent",
                        "cities": [
                            {
                                "text": "Bangalore",
                                "link": "https://www.swiggy.com/city/bangalore"
                            },
                            {
                                "text": "Gurgaon",
                                "link": "https://www.swiggy.com/city/gurgaon"
                            },
                            {
                                "text": "Hyderabad",
                                "link": "https://www.swiggy.com/city/hyderabad"
                            },
                            {
                                "text": "Delhi",
                                "link": "https://www.swiggy.com/city/delhi"
                            },
                            {
                                "text": "Mumbai",
                                "link": "https://www.swiggy.com/city/mumbai"
                            },
                            {
                                "text": "Pune",
                                "link": "https://www.swiggy.com/city/pune"
                            },
                            {
                                "text": "Kolkata",
                                "link": "https://www.swiggy.com/city/kolkata"
                            },
                            {
                                "text": "Chennai",
                                "link": "https://www.swiggy.com/city/chennai"
                            },
                            {
                                "text": "Ahmedabad",
                                "link": "https://www.swiggy.com/city/ahmedabad"
                            },
                            {
                                "text": "Chandigarh",
                                "link": "https://www.swiggy.com/city/chandigarh"
                            },
                            {
                                "text": "Jaipur",
                                "link": "https://www.swiggy.com/city/jaipur"
                            },
                            {
                                "text": "Kochi",
                                "link": "https://www.swiggy.com/city/kochi"
                            },
                            {
                                "text": "Coimbatore",
                                "link": "https://www.swiggy.com/city/coimbatore"
                            },
                            {
                                "text": "Lucknow",
                                "link": "https://www.swiggy.com/city/lucknow"
                            },
                            {
                                "text": "Nagpur",
                                "link": "https://www.swiggy.com/city/nagpur"
                            },
                            {
                                "text": "Vadodara",
                                "link": "https://www.swiggy.com/city/vadodara"
                            },
                            {
                                "text": "Indore",
                                "link": "https://www.swiggy.com/city/indore"
                            },
                            {
                                "text": "Guwahati",
                                "link": "https://www.swiggy.com/city/guwahati"
                            },
                            {
                                "text": "Vizag",
                                "link": "https://www.swiggy.com/city/vizag"
                            },
                            {
                                "text": "Surat",
                                "link": "https://www.swiggy.com/city/surat"
                            },
                            {
                                "text": "Dehradun",
                                "link": "https://www.swiggy.com/city/dehradun"
                            },
                            {
                                "text": "Noida",
                                "link": "https://www.swiggy.com/city/noida"
                            },
                            {
                                "text": "Ludhiana",
                                "link": "https://www.swiggy.com/city/ludhiana"
                            },
                            {
                                "text": "Trichy",
                                "link": "https://www.swiggy.com/city/trichy"
                            },
                            {
                                "text": "Vijayawada",
                                "link": "https://www.swiggy.com/city/vijayawada"
                            },
                            {
                                "text": "Kanpur",
                                "link": "https://www.swiggy.com/city/kanpur"
                            },
                            {
                                "text": "Mysore",
                                "link": "https://www.swiggy.com/city/mysore"
                            },
                            {
                                "text": "Nashik",
                                "link": "https://www.swiggy.com/city/nashik"
                            },
                            {
                                "text": "Udaipur",
                                "link": "https://www.swiggy.com/city/udaipur"
                            },
                            {
                                "text": "Pondicherry",
                                "link": "https://www.swiggy.com/city/pondicherry"
                            },
                            {
                                "text": "Agra",
                                "link": "https://www.swiggy.com/city/agra"
                            },
                            {
                                "text": "Aurangabad",
                                "link": "https://www.swiggy.com/city/aurangabad"
                            },
                            {
                                "text": "Jalandhar",
                                "link": "https://www.swiggy.com/city/jalandhar"
                            },
                            {
                                "text": "Kota",
                                "link": "https://www.swiggy.com/city/kota"
                            },
                            {
                                "text": "Madurai",
                                "link": "https://www.swiggy.com/city/madurai"
                            },
                            {
                                "text": "Allahabad",
                                "link": "https://www.swiggy.com/city/allahabad"
                            },
                            {
                                "text": "Manipal",
                                "link": "https://www.swiggy.com/city/manipal"
                            },
                            {
                                "text": "Amritsar",
                                "link": "https://www.swiggy.com/city/amritsar"
                            },
                            {
                                "text": "Bareilly",
                                "link": "https://www.swiggy.com/city/bareilly"
                            },
                            {
                                "text": "Meerut",
                                "link": "https://www.swiggy.com/city/meerut"
                            },
                            {
                                "text": "Bhopal",
                                "link": "https://www.swiggy.com/city/bhopal"
                            },
                            {
                                "text": "Ooty",
                                "link": "https://www.swiggy.com/city/ooty"
                            },
                            {
                                "text": "Bhubaneswar",
                                "link": "https://www.swiggy.com/city/bhubaneswar"
                            },
                            {
                                "text": "Raipur",
                                "link": "https://www.swiggy.com/city/raipur"
                            },
                            {
                                "text": "Bikaner",
                                "link": "https://www.swiggy.com/city/bikaner"
                            },
                            {
                                "text": "Rajkot",
                                "link": "https://www.swiggy.com/city/rajkot"
                            },
                            {
                                "text": "Kozhikode",
                                "link": "https://www.swiggy.com/city/kozhikode"
                            },
                            {
                                "text": "Central Goa",
                                "link": "https://www.swiggy.com/city/central-goa"
                            },
                            {
                                "text": "Sirsa",
                                "link": "https://www.swiggy.com/city/sirsa"
                            },
                            {
                                "text": "Gwalior",
                                "link": "https://www.swiggy.com/city/gwalior"
                            },
                            {
                                "text": "Thrissur",
                                "link": "https://www.swiggy.com/city/thrissur"
                            },
                            {
                                "text": "Kharagpur",
                                "link": "https://www.swiggy.com/city/kharagpur"
                            },
                            {
                                "text": "Tirupati",
                                "link": "https://www.swiggy.com/city/tirupati"
                            },
                            {
                                "text": "Tirupur",
                                "link": "https://www.swiggy.com/city/tirupur"
                            },
                            {
                                "text": "Vellore",
                                "link": "https://www.swiggy.com/city/vellore"
                            },
                            {
                                "text": "Thiruvananthapuram",
                                "link": "https://www.swiggy.com/city/thiruvananthapuram"
                            },
                            {
                                "text": "Warangal",
                                "link": "https://www.swiggy.com/city/warangal"
                            },
                            {
                                "text": "Varanasi",
                                "link": "https://www.swiggy.com/city/varanasi"
                            },
                            {
                                "text": "Mangaluru",
                                "link": "https://www.swiggy.com/city/mangaluru"
                            },
                            {
                                "text": "Patna",
                                "link": "https://www.swiggy.com/city/patna"
                            },
                            {
                                "text": "Ranchi",
                                "link": "https://www.swiggy.com/city/ranchi"
                            },
                            {
                                "text": "Faridabad",
                                "link": "https://www.swiggy.com/city/faridabad"
                            },
                            {
                                "text": "Guntur",
                                "link": "https://www.swiggy.com/city/guntur"
                            },
                            {
                                "text": "Ujjain",
                                "link": "https://www.swiggy.com/city/ujjain"
                            },
                            {
                                "text": "Patiala",
                                "link": "https://www.swiggy.com/city/patiala"
                            },
                            {
                                "text": "Karnal",
                                "link": "https://www.swiggy.com/city/karnal"
                            },
                            {
                                "text": "Kakinada",
                                "link": "https://www.swiggy.com/city/kakinada"
                            },
                            {
                                "text": "Rajahmundry",
                                "link": "https://www.swiggy.com/city/rajahmundry"
                            },
                            {
                                "text": "Bilaspur",
                                "link": "https://www.swiggy.com/city/bilaspur"
                            },
                            {
                                "text": "Bhilai",
                                "link": "https://www.swiggy.com/city/bhilai"
                            },
                            {
                                "text": "Anand",
                                "link": "https://www.swiggy.com/city/anand"
                            },
                            {
                                "text": "Bhavnagar",
                                "link": "https://www.swiggy.com/city/bhavnagar"
                            },
                            {
                                "text": "Jammu",
                                "link": "https://www.swiggy.com/city/jammu"
                            },
                            {
                                "text": "Muktsar",
                                "link": "https://www.swiggy.com/city/muktsar"
                            },
                            {
                                "text": "Panipat",
                                "link": "https://www.swiggy.com/city/panipat"
                            },
                            {
                                "text": "Dhanbad",
                                "link": "https://www.swiggy.com/city/dhanbad"
                            },
                            {
                                "text": "Hubli",
                                "link": "https://www.swiggy.com/city/hubli"
                            },
                            {
                                "text": "Belgaum",
                                "link": "https://www.swiggy.com/city/belgaum"
                            },
                            {
                                "text": "Jabalpur",
                                "link": "https://www.swiggy.com/city/jabalpur"
                            },
                            {
                                "text": "Kolhapur",
                                "link": "https://www.swiggy.com/city/kolhapur"
                            },
                            {
                                "text": "Solapur",
                                "link": "https://www.swiggy.com/city/solapur"
                            },
                            {
                                "text": "Shillong",
                                "link": "https://www.swiggy.com/city/shillong"
                            },
                            {
                                "text": "Cuttack",
                                "link": "https://www.swiggy.com/city/cuttack"
                            },
                            {
                                "text": "Aligarh",
                                "link": "https://www.swiggy.com/city/aligarh"
                            },
                            {
                                "text": "Salem",
                                "link": "https://www.swiggy.com/city/salem"
                            },
                            {
                                "text": "Jodhpur",
                                "link": "https://www.swiggy.com/city/jodhpur"
                            },
                            {
                                "text": "Ajmer",
                                "link": "https://www.swiggy.com/city/ajmer"
                            },
                            {
                                "text": "Jhansi",
                                "link": "https://www.swiggy.com/city/jhansi"
                            },
                            {
                                "text": "Gorakhpur",
                                "link": "https://www.swiggy.com/city/gorakhpur"
                            },
                            {
                                "text": "Thanjavur",
                                "link": "https://www.swiggy.com/city/thanjavur"
                            },
                            {
                                "text": "Erode",
                                "link": "https://www.swiggy.com/city/erode"
                            },
                            {
                                "text": "Nellore",
                                "link": "https://www.swiggy.com/city/nellore"
                            },
                            {
                                "text": "Rourkela",
                                "link": "https://www.swiggy.com/city/rourkela"
                            },
                            {
                                "text": "Anantapur",
                                "link": "https://www.swiggy.com/city/anantapur"
                            },
                            {
                                "text": "Kurnool",
                                "link": "https://www.swiggy.com/city/kurnool"
                            },
                            {
                                "text": "Ahmednagar",
                                "link": "https://www.swiggy.com/city/ahmednagar"
                            },
                            {
                                "text": "Phagwara",
                                "link": "https://www.swiggy.com/city/phagwara"
                            },
                            {
                                "text": "Ambala",
                                "link": "https://www.swiggy.com/city/ambala"
                            },
                            {
                                "text": "Ballari",
                                "link": "https://www.swiggy.com/city/ballari"
                            },
                            {
                                "text": "Saharanpur",
                                "link": "https://www.swiggy.com/city/saharanpur"
                            },
                            {
                                "text": "Tirunelveli",
                                "link": "https://www.swiggy.com/city/tirunelveli"
                            },
                            {
                                "text": "Bathinda",
                                "link": "https://www.swiggy.com/city/bathinda"
                            },
                            {
                                "text": "Mathura",
                                "link": "https://www.swiggy.com/city/mathura"
                            },
                            {
                                "text": "Haridwar",
                                "link": "https://www.swiggy.com/city/haridwar"
                            },
                            {
                                "text": "Ratnagiri",
                                "link": "https://www.swiggy.com/city/ratnagiri"
                            },
                            {
                                "text": "Sangli",
                                "link": "https://www.swiggy.com/city/sangli"
                            },
                            {
                                "text": "Amravati",
                                "link": "https://www.swiggy.com/city/amravati"
                            },
                            {
                                "text": "Rishikesh",
                                "link": "https://www.swiggy.com/city/rishikesh"
                            },
                            {
                                "text": "Nagercoil",
                                "link": "https://www.swiggy.com/city/nagercoil"
                            },
                            {
                                "text": "KanyaKumari",
                                "link": "https://www.swiggy.com/city/kanyakumari"
                            },
                            {
                                "text": "Kadapa",
                                "link": "https://www.swiggy.com/city/kadapa"
                            },
                            {
                                "text": "Nizamabad",
                                "link": "https://www.swiggy.com/city/nizamabad"
                            },
                            {
                                "text": "Shivamogga",
                                "link": "https://www.swiggy.com/city/shivamogga"
                            },
                            {
                                "text": "Davanagere",
                                "link": "https://www.swiggy.com/city/davanagere"
                            },
                            {
                                "text": "Roorkee",
                                "link": "https://www.swiggy.com/city/roorkee"
                            },
                            {
                                "text": "Nanded",
                                "link": "https://www.swiggy.com/city/nanded"
                            },
                            {
                                "text": "Rewa",
                                "link": "https://www.swiggy.com/city/rewa"
                            },
                            {
                                "text": "Satna",
                                "link": "https://www.swiggy.com/city/satna"
                            },
                            {
                                "text": "Muzaffarpur",
                                "link": "https://www.swiggy.com/city/muzaffarpur"
                            },
                            {
                                "text": "Valsad",
                                "link": "https://www.swiggy.com/city/valsad"
                            },
                            {
                                "text": "Vapi",
                                "link": "https://www.swiggy.com/city/vapi"
                            },
                            {
                                "text": "Chhapra",
                                "link": "https://www.swiggy.com/city/chhapra"
                            },
                            {
                                "text": "Dharamshala",
                                "link": "https://www.swiggy.com/city/dharamshala"
                            },
                            {
                                "text": "Kollam",
                                "link": "https://www.swiggy.com/city/kollam"
                            },
                            {
                                "text": "Silchar",
                                "link": "https://www.swiggy.com/city/silchar"
                            },
                            {
                                "text": "Alappuzha",
                                "link": "https://www.swiggy.com/city/alappuzha"
                            },
                            {
                                "text": "Sonipat",
                                "link": "https://www.swiggy.com/city/sonipat"
                            },
                            {
                                "text": "Rohtak",
                                "link": "https://www.swiggy.com/city/rohtak"
                            },
                            {
                                "text": "Mehsana",
                                "link": "https://www.swiggy.com/city/mehsana"
                            },
                            {
                                "text": "Kullu",
                                "link": "https://www.swiggy.com/city/kullu"
                            },
                            {
                                "text": "Dhule",
                                "link": "https://www.swiggy.com/city/dhule"
                            },
                            {
                                "text": "Dharwad",
                                "link": "https://www.swiggy.com/city/dharwad"
                            },
                            {
                                "text": "Latur",
                                "link": "https://www.swiggy.com/city/latur"
                            },
                            {
                                "text": "Vizianagaram",
                                "link": "https://www.swiggy.com/city/vizianagaram"
                            },
                            {
                                "text": "Khammam",
                                "link": "https://www.swiggy.com/city/khammam"
                            },
                            {
                                "text": "Hampi",
                                "link": "https://www.swiggy.com/city/hampi"
                            },
                            {
                                "text": "Nainital",
                                "link": "https://www.swiggy.com/city/nainital"
                            },
                            {
                                "text": "Akola",
                                "link": "https://www.swiggy.com/city/akola"
                            },
                            {
                                "text": "Kalaburagi",
                                "link": "https://www.swiggy.com/city/kalaburagi"
                            },
                            {
                                "text": "Gaya",
                                "link": "https://www.swiggy.com/city/gaya"
                            },
                            {
                                "text": "Muzaffarnagar",
                                "link": "https://www.swiggy.com/city/muzaffarnagar"
                            },
                            {
                                "text": "Dewas",
                                "link": "https://www.swiggy.com/city/dewas"
                            },
                            {
                                "text": "Korba",
                                "link": "https://www.swiggy.com/city/korba"
                            },
                            {
                                "text": "Mussoorie",
                                "link": "https://www.swiggy.com/city/mussoorie"
                            },
                            {
                                "text": "Jalgaon",
                                "link": "https://www.swiggy.com/city/jalgaon"
                            },
                            {
                                "text": "Yamuna Nagar",
                                "link": "https://www.swiggy.com/city/yamuna-nagar"
                            },
                            {
                                "text": "Bhagalpur",
                                "link": "https://www.swiggy.com/city/bhagalpur"
                            },
                            {
                                "text": "Hapur",
                                "link": "https://www.swiggy.com/city/hapur"
                            },
                            {
                                "text": "Morena",
                                "link": "https://www.swiggy.com/city/morena"
                            },
                            {
                                "text": "Hassan",
                                "link": "https://www.swiggy.com/city/hassan"
                            },
                            {
                                "text": "Hisar",
                                "link": "https://www.swiggy.com/city/hisar"
                            },
                            {
                                "text": "Godhra",
                                "link": "https://www.swiggy.com/city/godhra"
                            },
                            {
                                "text": "Kolar ",
                                "link": "https://www.swiggy.com/city/kolar"
                            },
                            {
                                "text": "Rampur",
                                "link": "https://www.swiggy.com/city/rampur"
                            },
                            {
                                "text": "Sitapur",
                                "link": "https://www.swiggy.com/city/sitapur"
                            },
                            {
                                "text": "Etawah",
                                "link": "https://www.swiggy.com/city/etawah"
                            },
                            {
                                "text": "Porbandar",
                                "link": "https://www.swiggy.com/city/porbandar"
                            },
                            {
                                "text": "Nadiad",
                                "link": "https://www.swiggy.com/city/nadiad"
                            },
                            {
                                "text": "Sagar",
                                "link": "https://www.swiggy.com/city/sagar"
                            },
                            {
                                "text": "Morbi",
                                "link": "https://www.swiggy.com/city/morbi"
                            },
                            {
                                "text": "Chhindwara",
                                "link": "https://www.swiggy.com/city/chhindwara"
                            },
                            {
                                "text": "Tumakuru",
                                "link": "https://www.swiggy.com/city/tumakuru"
                            },
                            {
                                "text": "Singrauli",
                                "link": "https://www.swiggy.com/city/singrauli"
                            },
                            {
                                "text": "Thoothukudi",
                                "link": "https://www.swiggy.com/city/thoothukudi"
                            },
                            {
                                "text": "Katni",
                                "link": "https://www.swiggy.com/city/katni"
                            },
                            {
                                "text": "Khandwa",
                                "link": "https://www.swiggy.com/city/khandwa"
                            },
                            {
                                "text": "Eluru",
                                "link": "https://www.swiggy.com/city/eluru"
                            },
                            {
                                "text": "Malappuram",
                                "link": "https://www.swiggy.com/city/malappuram"
                            },
                            {
                                "text": "Dibrugarh",
                                "link": "https://www.swiggy.com/city/dibrugarh"
                            },
                            {
                                "text": "Deoghar",
                                "link": "https://www.swiggy.com/city/deoghar"
                            },
                            {
                                "text": "Khanna",
                                "link": "https://www.swiggy.com/city/khanna"
                            },
                            {
                                "text": "Bidar",
                                "link": "https://www.swiggy.com/city/bidar"
                            },
                            {
                                "text": "Madikeri",
                                "link": "https://www.swiggy.com/city/madikeri"
                            },
                            {
                                "text": "Haldwani",
                                "link": "https://www.swiggy.com/city/haldwani"
                            },
                            {
                                "text": "Farrukhabad",
                                "link": "https://www.swiggy.com/city/farrukhabad"
                            },
                            {
                                "text": "Malegaon",
                                "link": "https://www.swiggy.com/city/malegaon"
                            },
                            {
                                "text": "Dindigul",
                                "link": "https://www.swiggy.com/city/dindigul"
                            },
                            {
                                "text": "Shahjahanpur",
                                "link": "https://www.swiggy.com/city/shahjahanpur"
                            },
                            {
                                "text": "Beed",
                                "link": "https://www.swiggy.com/city/beed"
                            },
                            {
                                "text": "Junagadh",
                                "link": "https://www.swiggy.com/city/junagadh"
                            },
                            {
                                "text": "Asansol",
                                "link": "https://www.swiggy.com/city/asansol"
                            },
                            {
                                "text": "Beawar",
                                "link": "https://www.swiggy.com/city/beawar"
                            },
                            {
                                "text": "Kishangarh",
                                "link": "https://www.swiggy.com/city/kishangarh"
                            },
                            {
                                "text": "Parbhani",
                                "link": "https://www.swiggy.com/city/parbhani"
                            },
                            {
                                "text": "Gondia",
                                "link": "https://www.swiggy.com/city/gondia"
                            },
                            {
                                "text": "Ichalkaranji",
                                "link": "https://www.swiggy.com/city/ichalkaranji"
                            },
                            {
                                "text": "Jalna",
                                "link": "https://www.swiggy.com/city/jalna"
                            },
                            {
                                "text": "Yavatmal",
                                "link": "https://www.swiggy.com/city/yavatmal"
                            },
                            {
                                "text": "Shivpuri",
                                "link": "https://www.swiggy.com/city/shivpuri"
                            },
                            {
                                "text": "Moga",
                                "link": "https://www.swiggy.com/city/moga"
                            },
                            {
                                "text": "Abohar",
                                "link": "https://www.swiggy.com/city/abohar"
                            },
                            {
                                "text": "Adoni",
                                "link": "https://www.swiggy.com/city/adoni"
                            },
                            {
                                "text": "Madanapalle",
                                "link": "https://www.swiggy.com/city/madanapalle"
                            },
                            {
                                "text": "Tiruvannamalai",
                                "link": "https://www.swiggy.com/city/tiruvannamalai"
                            },
                            {
                                "text": "Satara",
                                "link": "https://www.swiggy.com/city/satara"
                            },
                            {
                                "text": "Ambur",
                                "link": "https://www.swiggy.com/city/ambur"
                            },
                            {
                                "text": "Karimnagar",
                                "link": "https://www.swiggy.com/city/karimnagar"
                            },
                            {
                                "text": "Ratlam",
                                "link": "https://www.swiggy.com/city/ratlam"
                            },
                            {
                                "text": "Moradabad",
                                "link": "https://www.swiggy.com/city/moradabad"
                            },
                            {
                                "text": "Machilipatnam",
                                "link": "https://www.swiggy.com/city/machilipatnam"
                            },
                            {
                                "text": "Ongole",
                                "link": "https://www.swiggy.com/city/ongole"
                            },
                            {
                                "text": "Kottayam",
                                "link": "https://www.swiggy.com/city/kottayam"
                            },
                            {
                                "text": "Darbhanga",
                                "link": "https://www.swiggy.com/city/darbhanga"
                            },
                            {
                                "text": "Kurukshetra",
                                "link": "https://www.swiggy.com/city/kurukshetra"
                            },
                            {
                                "text": "Unnao",
                                "link": "https://www.swiggy.com/city/unnao"
                            },
                            {
                                "text": "Bulandshahr",
                                "link": "https://www.swiggy.com/city/bulandshahr"
                            },
                            {
                                "text": "Durgapur",
                                "link": "https://www.swiggy.com/city/durgapur"
                            },
                            {
                                "text": "Siliguri",
                                "link": "https://www.swiggy.com/city/siliguri"
                            },
                            {
                                "text": "Pali",
                                "link": "https://www.swiggy.com/city/pali"
                            },
                            {
                                "text": "Tadepalligudem",
                                "link": "https://www.swiggy.com/city/tadepalligudem"
                            },
                            {
                                "text": "Ramagundam",
                                "link": "https://www.swiggy.com/city/ramagundam"
                            },
                            {
                                "text": "Mahbubnagar",
                                "link": "https://www.swiggy.com/city/mahbubnagar"
                            },
                            {
                                "text": "Bhiwani",
                                "link": "https://www.swiggy.com/city/bhiwani"
                            },
                            {
                                "text": "Cuddalore",
                                "link": "https://www.swiggy.com/city/cuddalore"
                            },
                            {
                                "text": "Kaithal",
                                "link": "https://www.swiggy.com/city/kaithal"
                            },
                            {
                                "text": "Jagtial",
                                "link": "https://www.swiggy.com/city/jagtial"
                            },
                            {
                                "text": "Palakkad",
                                "link": "https://www.swiggy.com/city/palakkad"
                            },
                            {
                                "text": "Guna",
                                "link": "https://www.swiggy.com/city/guna"
                            },
                            {
                                "text": "Kumbakonam",
                                "link": "https://www.swiggy.com/city/kumbakonam"
                            },
                            {
                                "text": "Maunath Bhanjan",
                                "link": "https://www.swiggy.com/city/maunath-bhanjan"
                            },
                            {
                                "text": "Baripada",
                                "link": "https://www.swiggy.com/city/baripada"
                            },
                            {
                                "text": "Orai",
                                "link": "https://www.swiggy.com/city/orai"
                            },
                            {
                                "text": "Bhadrak",
                                "link": "https://www.swiggy.com/city/bhadrak"
                            },
                            {
                                "text": "Batala",
                                "link": "https://www.swiggy.com/city/batala"
                            },
                            {
                                "text": "Firozpur",
                                "link": "https://www.swiggy.com/city/firozpur"
                            },
                            {
                                "text": "Barnala",
                                "link": "https://www.swiggy.com/city/barnala"
                            },
                            {
                                "text": "Raigarh",
                                "link": "https://www.swiggy.com/city/raigarh"
                            },
                            {
                                "text": "Nagaon",
                                "link": "https://www.swiggy.com/city/nagaon"
                            },
                            {
                                "text": "Mainpuri",
                                "link": "https://www.swiggy.com/city/mainpuri"
                            },
                            {
                                "text": "Balurghat",
                                "link": "https://www.swiggy.com/city/balurghat"
                            },
                            {
                                "text": "Giridih",
                                "link": "https://www.swiggy.com/city/giridih"
                            },
                            {
                                "text": "Ghazipur",
                                "link": "https://www.swiggy.com/city/ghazipur"
                            },
                            {
                                "text": "Jagdalpur",
                                "link": "https://www.swiggy.com/city/jagdalpur"
                            },
                            {
                                "text": "Vidisha",
                                "link": "https://www.swiggy.com/city/vidisha"
                            },
                            {
                                "text": "Dimapur",
                                "link": "https://www.swiggy.com/city/dimapur"
                            },
                            {
                                "text": "Shikohabad",
                                "link": "https://www.swiggy.com/city/shikohabad"
                            },
                            {
                                "text": "Imphal",
                                "link": "https://www.swiggy.com/city/imphal"
                            },
                            {
                                "text": "Lakhimpur",
                                "link": "https://www.swiggy.com/city/lakhimpur"
                            },
                            {
                                "text": "Rudrapur",
                                "link": "https://www.swiggy.com/city/rudrapur"
                            },
                            {
                                "text": "Ambikapur",
                                "link": "https://www.swiggy.com/city/ambikapur"
                            },
                            {
                                "text": "Rae Bareli",
                                "link": "https://www.swiggy.com/city/rae-bareli"
                            },
                            {
                                "text": "Tinsukia",
                                "link": "https://www.swiggy.com/city/tinsukia"
                            },
                            {
                                "text": "Rajapalayam",
                                "link": "https://www.swiggy.com/city/rajapalayam"
                            },
                            {
                                "text": "Rajnandgaon",
                                "link": "https://www.swiggy.com/city/rajnandgaon"
                            },
                            {
                                "text": "Kashipur",
                                "link": "https://www.swiggy.com/city/kashipur"
                            },
                            {
                                "text": "Ranibennur",
                                "link": "https://www.swiggy.com/city/ranibennur"
                            },
                            {
                                "text": "Burhanpur",
                                "link": "https://www.swiggy.com/city/burhanpur"
                            },
                            {
                                "text": "Bhadravati",
                                "link": "https://www.swiggy.com/city/bhadravati"
                            },
                            {
                                "text": "Chittoor",
                                "link": "https://www.swiggy.com/city/chittoor"
                            },
                            {
                                "text": "Pudukkottai",
                                "link": "https://www.swiggy.com/city/pudukkottai"
                            },
                            {
                                "text": "Hardoi",
                                "link": "https://www.swiggy.com/city/hardoi"
                            },
                            {
                                "text": "Basti",
                                "link": "https://www.swiggy.com/city/basti"
                            },
                            {
                                "text": "Karaikkudi",
                                "link": "https://www.swiggy.com/city/karaikkudi"
                            },
                            {
                                "text": "Lalitpur",
                                "link": "https://www.swiggy.com/city/lalitpur"
                            },
                            {
                                "text": "Hospet",
                                "link": "https://www.swiggy.com/city/hospet"
                            },
                            {
                                "text": "Budaun",
                                "link": "https://www.swiggy.com/city/budaun"
                            },
                            {
                                "text": "Neemuch",
                                "link": "https://www.swiggy.com/city/neemuch"
                            },
                            {
                                "text": "Pilibhit",
                                "link": "https://www.swiggy.com/city/pilibhit"
                            },
                            {
                                "text": "Barshi",
                                "link": "https://www.swiggy.com/city/barshi"
                            },
                            {
                                "text": "Sri Ganganagar",
                                "link": "https://www.swiggy.com/city/sri-ganganagar"
                            },
                            {
                                "text": "Wardha",
                                "link": "https://www.swiggy.com/city/wardha"
                            },
                            {
                                "text": "Sehore",
                                "link": "https://www.swiggy.com/city/sehore"
                            },
                            {
                                "text": "Bhimavaram",
                                "link": "https://www.swiggy.com/city/bhimavaram"
                            },
                            {
                                "text": "Hanumangarh",
                                "link": "https://www.swiggy.com/city/hanumangarh"
                            },
                            {
                                "text": "Pathankot",
                                "link": "https://www.swiggy.com/city/pathankot"
                            },
                            {
                                "text": "Puri",
                                "link": "https://www.swiggy.com/city/puri"
                            },
                            {
                                "text": "Fatehpur",
                                "link": "https://www.swiggy.com/city/fatehpur"
                            },
                            {
                                "text": "Surendranagar Dudhrej",
                                "link": "https://www.swiggy.com/city/surendranagar-dudhrej"
                            },
                            {
                                "text": "Jamnagar",
                                "link": "https://www.swiggy.com/city/jamnagar"
                            },
                            {
                                "text": "Bhuj",
                                "link": "https://www.swiggy.com/city/bhuj"
                            },
                            {
                                "text": "Gandhidham",
                                "link": "https://www.swiggy.com/city/gandhidham"
                            },
                            {
                                "text": "Bharuch",
                                "link": "https://www.swiggy.com/city/bharuch"
                            },
                            {
                                "text": "Navsari",
                                "link": "https://www.swiggy.com/city/navsari"
                            },
                            {
                                "text": "Amreli",
                                "link": "https://www.swiggy.com/city/amreli"
                            },
                            {
                                "text": "Palanpur",
                                "link": "https://www.swiggy.com/city/palanpur"
                            },
                            {
                                "text": "Bhilwara",
                                "link": "https://www.swiggy.com/city/bhilwara"
                            },
                            {
                                "text": "Suratgarh",
                                "link": "https://www.swiggy.com/city/suratgarh"
                            },
                            {
                                "text": "Sikar",
                                "link": "https://www.swiggy.com/city/sikar"
                            },
                            {
                                "text": "Churu",
                                "link": "https://www.swiggy.com/city/churu"
                            },
                            {
                                "text": "Alwar",
                                "link": "https://www.swiggy.com/city/alwar"
                            },
                            {
                                "text": "Bhiwadi",
                                "link": "https://www.swiggy.com/city/bhiwadi"
                            },
                            {
                                "text": "Bharatpur",
                                "link": "https://www.swiggy.com/city/bharatpur"
                            },
                            {
                                "text": "Mount Abu",
                                "link": "https://www.swiggy.com/city/mount-abu"
                            },
                            {
                                "text": "Bundi",
                                "link": "https://www.swiggy.com/city/bundi"
                            },
                            {
                                "text": "Sawai Madhopur",
                                "link": "https://www.swiggy.com/city/sawai-madhopur"
                            },
                            {
                                "text": "Purulia",
                                "link": "https://www.swiggy.com/city/purulia"
                            },
                            {
                                "text": "Bardhaman",
                                "link": "https://www.swiggy.com/city/bardhaman"
                            },
                            {
                                "text": "Raniganj",
                                "link": "https://www.swiggy.com/city/raniganj"
                            },
                            {
                                "text": "Darjeeling",
                                "link": "https://www.swiggy.com/city/darjeeling"
                            },
                            {
                                "text": "Jalpaiguri",
                                "link": "https://www.swiggy.com/city/jalpaiguri"
                            },
                            {
                                "text": "Chittorgarh",
                                "link": "https://www.swiggy.com/city/chittorgarh"
                            },
                            {
                                "text": "Dholpur",
                                "link": "https://www.swiggy.com/city/dholpur"
                            },
                            {
                                "text": "Uluberia",
                                "link": "https://www.swiggy.com/city/uluberia"
                            },
                            {
                                "text": "Nabadwip",
                                "link": "https://www.swiggy.com/city/nabadwip"
                            },
                            {
                                "text": "Bongaon",
                                "link": "https://www.swiggy.com/city/bongaon"
                            },
                            {
                                "text": "Kanchrapara",
                                "link": "https://www.swiggy.com/city/kanchrapara"
                            },
                            {
                                "text": "Habra",
                                "link": "https://www.swiggy.com/city/habra"
                            },
                            {
                                "text": "Firozabad",
                                "link": "https://www.swiggy.com/city/firozabad"
                            },
                            {
                                "text": "Nalgonda",
                                "link": "https://www.swiggy.com/city/nalgonda"
                            },
                            {
                                "text": "Chandrapur",
                                "link": "https://www.swiggy.com/city/chandrapur"
                            },
                            {
                                "text": "Bijapur",
                                "link": "https://www.swiggy.com/city/bijapur"
                            },
                            {
                                "text": "Bhusawal",
                                "link": "https://www.swiggy.com/city/bhusawal"
                            },
                            {
                                "text": "Raichur",
                                "link": "https://www.swiggy.com/city/raichur"
                            },
                            {
                                "text": "Bahraich",
                                "link": "https://www.swiggy.com/city/bahraich"
                            },
                            {
                                "text": "Azamgarh",
                                "link": "https://www.swiggy.com/city/azamgarh"
                            },
                            {
                                "text": "Bahadurgarh",
                                "link": "https://www.swiggy.com/city/bahadurgarh"
                            },
                            {
                                "text": "Jind",
                                "link": "https://www.swiggy.com/city/jind"
                            },
                            {
                                "text": "Rewari",
                                "link": "https://www.swiggy.com/city/rewari"
                            },
                            {
                                "text": "Palwal",
                                "link": "https://www.swiggy.com/city/palwal"
                            },
                            {
                                "text": "Hathras",
                                "link": "https://www.swiggy.com/city/hathras"
                            },
                            {
                                "text": "Sambalpur",
                                "link": "https://www.swiggy.com/city/sambalpur"
                            },
                            {
                                "text": "Banda",
                                "link": "https://www.swiggy.com/city/banda"
                            },
                            {
                                "text": "Hoshiarpur",
                                "link": "https://www.swiggy.com/city/hoshiarpur"
                            },
                            {
                                "text": "Faridkot",
                                "link": "https://www.swiggy.com/city/faridkot"
                            },
                            {
                                "text": "Mandsaur",
                                "link": "https://www.swiggy.com/city/mandsaur"
                            },
                            {
                                "text": "Suryapet",
                                "link": "https://www.swiggy.com/city/suryapet"
                            },
                            {
                                "text": "Adilabad",
                                "link": "https://www.swiggy.com/city/adilabad"
                            },
                            {
                                "text": "Narasaraopet",
                                "link": "https://www.swiggy.com/city/narasaraopet"
                            },
                            {
                                "text": "Faizabad",
                                "link": "https://www.swiggy.com/city/faizabad"
                            },
                            {
                                "text": "Tadpatri",
                                "link": "https://www.swiggy.com/city/tadpatri"
                            },
                            {
                                "text": "Gonda",
                                "link": "https://www.swiggy.com/city/gonda"
                            },
                            {
                                "text": "Mughalsarai",
                                "link": "https://www.swiggy.com/city/mughalsarai"
                            },
                            {
                                "text": "Medinipur",
                                "link": "https://www.swiggy.com/city/medinipur"
                            },
                            {
                                "text": "Nagda",
                                "link": "https://www.swiggy.com/city/nagda"
                            },
                            {
                                "text": "Raiganj",
                                "link": "https://www.swiggy.com/city/raiganj"
                            },
                            {
                                "text": "Deoria City",
                                "link": "https://www.swiggy.com/city/deoria-city"
                            },
                            {
                                "text": "Sultanpur",
                                "link": "https://www.swiggy.com/city/sultanpur"
                            },
                            {
                                "text": "Shamli",
                                "link": "https://www.swiggy.com/city/shamli"
                            },
                            {
                                "text": "Krishnanagar",
                                "link": "https://www.swiggy.com/city/krishnanagar"
                            },
                            {
                                "text": "Ballia",
                                "link": "https://www.swiggy.com/city/ballia"
                            },
                            {
                                "text": "Guntakal",
                                "link": "https://www.swiggy.com/city/guntakal"
                            },
                            {
                                "text": "Miryalaguda",
                                "link": "https://www.swiggy.com/city/miryalaguda"
                            },
                            {
                                "text": "Etah",
                                "link": "https://www.swiggy.com/city/etah"
                            },
                            {
                                "text": "Berhampore",
                                "link": "https://www.swiggy.com/city/berhampore"
                            },
                            {
                                "text": "Gudivada",
                                "link": "https://www.swiggy.com/city/gudivada"
                            },
                            {
                                "text": "Haldia",
                                "link": "https://www.swiggy.com/city/haldia"
                            },
                            {
                                "text": "Santipur",
                                "link": "https://www.swiggy.com/city/santipur"
                            },
                            {
                                "text": "Basirhat",
                                "link": "https://www.swiggy.com/city/basirhat"
                            },
                            {
                                "text": "Udgir",
                                "link": "https://www.swiggy.com/city/udgir"
                            },
                            {
                                "text": "Proddatur",
                                "link": "https://www.swiggy.com/city/proddatur"
                            },
                            {
                                "text": "Nagapattinam",
                                "link": "https://www.swiggy.com/city/nagapattinam"
                            },
                            {
                                "text": "Chikmagalur",
                                "link": "https://www.swiggy.com/city/chikmagalur"
                            },
                            {
                                "text": "Chandausi",
                                "link": "https://www.swiggy.com/city/chandausi"
                            },
                            {
                                "text": "Bhind",
                                "link": "https://www.swiggy.com/city/bhind"
                            },
                            {
                                "text": "Mandya",
                                "link": "https://www.swiggy.com/city/mandya"
                            },
                            {
                                "text": "Bagalkot",
                                "link": "https://www.swiggy.com/city/bagalkot"
                            },
                            {
                                "text": "Nandurbar",
                                "link": "https://www.swiggy.com/city/nandurbar"
                            },
                            {
                                "text": "Chitradurga",
                                "link": "https://www.swiggy.com/city/chitradurga"
                            },
                            {
                                "text": "Osmanabad",
                                "link": "https://www.swiggy.com/city/osmanabad"
                            },
                            {
                                "text": "Modinagar",
                                "link": "https://www.swiggy.com/city/modinagar"
                            },
                            {
                                "text": "Gadag-Betigeri",
                                "link": "https://www.swiggy.com/city/gadag-betigeri"
                            },
                            {
                                "text": "Hoshangabad",
                                "link": "https://www.swiggy.com/city/hoshangabad"
                            },
                            {
                                "text": "Jaunpur",
                                "link": "https://www.swiggy.com/city/jaunpur"
                            },
                            {
                                "text": "Port Blair",
                                "link": "https://www.swiggy.com/city/port-blair"
                            },
                            {
                                "text": "Jorhat",
                                "link": "https://www.swiggy.com/city/jorhat"
                            },
                            {
                                "text": "Nandyal",
                                "link": "https://www.swiggy.com/city/nandyal"
                            },
                            {
                                "text": "Biharsharif",
                                "link": "https://www.swiggy.com/city/biharsharif"
                            },
                            {
                                "text": "Buxar",
                                "link": "https://www.swiggy.com/city/buxar"
                            },
                            {
                                "text": "Siwan",
                                "link": "https://www.swiggy.com/city/siwan"
                            },
                            {
                                "text": "Dehri",
                                "link": "https://www.swiggy.com/city/dehri"
                            },
                            {
                                "text": "Bettiah",
                                "link": "https://www.swiggy.com/city/bettiah"
                            },
                            {
                                "text": "Kishanganj",
                                "link": "https://www.swiggy.com/city/kishanganj"
                            },
                            {
                                "text": "Saharsa",
                                "link": "https://www.swiggy.com/city/saharsa"
                            },
                            {
                                "text": "Hajipur",
                                "link": "https://www.swiggy.com/city/hajipur"
                            },
                            {
                                "text": "Motihari",
                                "link": "https://www.swiggy.com/city/motihari"
                            },
                            {
                                "text": "Sasaram",
                                "link": "https://www.swiggy.com/city/sasaram"
                            },
                            {
                                "text": "Munger",
                                "link": "https://www.swiggy.com/city/munger"
                            },
                            {
                                "text": "Katihar",
                                "link": "https://www.swiggy.com/city/katihar"
                            },
                            {
                                "text": "Arrah",
                                "link": "https://www.swiggy.com/city/arrah"
                            },
                            {
                                "text": "Srikakulam",
                                "link": "https://www.swiggy.com/city/srikakulam"
                            },
                            {
                                "text": "Begusarai",
                                "link": "https://www.swiggy.com/city/begusarai"
                            },
                            {
                                "text": "Neyveli",
                                "link": "https://www.swiggy.com/city/neyveli"
                            },
                            {
                                "text": "Waidhan",
                                "link": "https://www.swiggy.com/city/waidhan"
                            },
                            {
                                "text": "Markapur",
                                "link": "https://www.swiggy.com/city/markapur"
                            },
                            {
                                "text": "Chikkaballapur",
                                "link": "https://www.swiggy.com/city/chikkaballapur"
                            },
                            {
                                "text": "Bhatkal",
                                "link": "https://www.swiggy.com/city/bhatkal"
                            },
                            {
                                "text": "Gokak",
                                "link": "https://www.swiggy.com/city/gokak"
                            },
                            {
                                "text": "Itarsi",
                                "link": "https://www.swiggy.com/city/itarsi"
                            },
                            {
                                "text": "Dhar",
                                "link": "https://www.swiggy.com/city/dhar"
                            },
                            {
                                "text": "Chalisgaon",
                                "link": "https://www.swiggy.com/city/chalisgaon"
                            },
                            {
                                "text": "Thiruvallur",
                                "link": "https://www.swiggy.com/city/thiruvallur"
                            },
                            {
                                "text": "Namakkal",
                                "link": "https://www.swiggy.com/city/namakkal"
                            },
                            {
                                "text": "Dharmapuri",
                                "link": "https://www.swiggy.com/city/dharmapuri"
                            },
                            {
                                "text": "Bhandara",
                                "link": "https://www.swiggy.com/city/bhandara"
                            },
                            {
                                "text": "Virudhunagar",
                                "link": "https://www.swiggy.com/city/virudhunagar"
                            },
                            {
                                "text": "Siddipet",
                                "link": "https://www.swiggy.com/city/siddipet"
                            },
                            {
                                "text": "Gadwal",
                                "link": "https://www.swiggy.com/city/gadwal"
                            },
                            {
                                "text": "Bodhan-Rural",
                                "link": "https://www.swiggy.com/city/bodhan-rural"
                            },
                            {
                                "text": "Kamareddy",
                                "link": "https://www.swiggy.com/city/kamareddy"
                            },
                            {
                                "text": "Jhunjhunu",
                                "link": "https://www.swiggy.com/city/jhunjhunu"
                            },
                            {
                                "text": "Kapurthala",
                                "link": "https://www.swiggy.com/city/kapurthala"
                            },
                            {
                                "text": "Sangrur",
                                "link": "https://www.swiggy.com/city/sangrur"
                            },
                            {
                                "text": "Gurdaspur",
                                "link": "https://www.swiggy.com/city/gurdaspur"
                            },
                            {
                                "text": "Ramgarh",
                                "link": "https://www.swiggy.com/city/ramgarh"
                            },
                            {
                                "text": "Bantwal",
                                "link": "https://www.swiggy.com/city/bantwal"
                            },
                            {
                                "text": "Doddaballapura",
                                "link": "https://www.swiggy.com/city/doddaballapura"
                            },
                            {
                                "text": "Buldana",
                                "link": "https://www.swiggy.com/city/buldana"
                            },
                            {
                                "text": "Karad",
                                "link": "https://www.swiggy.com/city/karad"
                            },
                            {
                                "text": "Krishnagiri",
                                "link": "https://www.swiggy.com/city/krishnagiri"
                            },
                            {
                                "text": "Tiptur",
                                "link": "https://www.swiggy.com/city/tiptur"
                            },
                            {
                                "text": "Bhadrachalam",
                                "link": "https://www.swiggy.com/city/bhadrachalam"
                            },
                            {
                                "text": "Mancherial",
                                "link": "https://www.swiggy.com/city/mancherial"
                            },
                            {
                                "text": "Balrampur",
                                "link": "https://www.swiggy.com/city/balrampur"
                            },
                            {
                                "text": "Bharabanki",
                                "link": "https://www.swiggy.com/city/bharabanki"
                            },
                            {
                                "text": "Malout",
                                "link": "https://www.swiggy.com/city/malout"
                            },
                            {
                                "text": "Fatehgarh Sahib",
                                "link": "https://www.swiggy.com/city/fatehgarh-sahib"
                            },
                            {
                                "text": "Ropar",
                                "link": "https://www.swiggy.com/city/ropar"
                            },
                            {
                                "text": "Nangal",
                                "link": "https://www.swiggy.com/city/nangal"
                            },
                            {
                                "text": "Narnaul",
                                "link": "https://www.swiggy.com/city/narnaul"
                            },
                            {
                                "text": "Naraingarh",
                                "link": "https://www.swiggy.com/city/naraingarh"
                            },
                            {
                                "text": "Himmatnagar",
                                "link": "https://www.swiggy.com/city/himmatnagar"
                            },
                            {
                                "text": "Dausa",
                                "link": "https://www.swiggy.com/city/dausa"
                            },
                            {
                                "text": "Jahanabad",
                                "link": "https://www.swiggy.com/city/jahanabad"
                            },
                            {
                                "text": "Samastipur",
                                "link": "https://www.swiggy.com/city/samastipur"
                            },
                            {
                                "text": "Purnea",
                                "link": "https://www.swiggy.com/city/purnea"
                            },
                            {
                                "text": "Berhampur",
                                "link": "https://www.swiggy.com/city/berhampur"
                            },
                            {
                                "text": "Malda",
                                "link": "https://www.swiggy.com/city/malda"
                            },
                            {
                                "text": "Tuni",
                                "link": "https://www.swiggy.com/city/tuni"
                            },
                            {
                                "text": "Puttur",
                                "link": "https://www.swiggy.com/city/puttur"
                            },
                            {
                                "text": "Rayachoty",
                                "link": "https://www.swiggy.com/city/rayachoty"
                            },
                            {
                                "text": "Nirmal",
                                "link": "https://www.swiggy.com/city/nirmal"
                            },
                            {
                                "text": "Mirzapur",
                                "link": "https://www.swiggy.com/city/mirzapur"
                            },
                            {
                                "text": "Tanuku",
                                "link": "https://www.swiggy.com/city/tanuku"
                            },
                            {
                                "text": "Dahod",
                                "link": "https://www.swiggy.com/city/dahod"
                            },
                            {
                                "text": "Barmer",
                                "link": "https://www.swiggy.com/city/barmer"
                            },
                            {
                                "text": "Gangapur City",
                                "link": "https://www.swiggy.com/city/gangapur-city"
                            },
                            {
                                "text": "Mandi Gobindgarh",
                                "link": "https://www.swiggy.com/city/mandi-gobindgarh"
                            },
                            {
                                "text": "Tarn Taran Sahib",
                                "link": "https://www.swiggy.com/city/tarn-taran-sahib"
                            },
                            {
                                "text": "Nakodar",
                                "link": "https://www.swiggy.com/city/nakodar"
                            },
                            {
                                "text": "Ankleshwar",
                                "link": "https://www.swiggy.com/city/ankleshwar"
                            },
                            {
                                "text": "Vyara",
                                "link": "https://www.swiggy.com/city/vyara"
                            },
                            {
                                "text": "Bardoli",
                                "link": "https://www.swiggy.com/city/bardoli"
                            },
                            {
                                "text": "Halol",
                                "link": "https://www.swiggy.com/city/halol"
                            },
                            {
                                "text": "Bijnor",
                                "link": "https://www.swiggy.com/city/bijnor"
                            },
                            {
                                "text": "Sangamner",
                                "link": "https://www.swiggy.com/city/sangamner"
                            },
                            {
                                "text": "Baramati",
                                "link": "https://www.swiggy.com/city/baramati"
                            },
                            {
                                "text": "Betul",
                                "link": "https://www.swiggy.com/city/betul"
                            },
                            {
                                "text": "Chhatarpur",
                                "link": "https://www.swiggy.com/city/chhatarpur"
                            },
                            {
                                "text": "Balaghat",
                                "link": "https://www.swiggy.com/city/balaghat"
                            },
                            {
                                "text": "Sivakasi",
                                "link": "https://www.swiggy.com/city/sivakasi"
                            },
                            {
                                "text": "Viluppuram",
                                "link": "https://www.swiggy.com/city/viluppuram"
                            },
                            {
                                "text": "Ramanathapuram",
                                "link": "https://www.swiggy.com/city/ramanathapuram"
                            },
                            {
                                "text": "Sirsi",
                                "link": "https://www.swiggy.com/city/sirsi"
                            },
                            {
                                "text": "Theni",
                                "link": "https://www.swiggy.com/city/theni"
                            },
                            {
                                "text": "Karur",
                                "link": "https://www.swiggy.com/city/karur"
                            },
                            {
                                "text": "Karwar",
                                "link": "https://www.swiggy.com/city/karwar"
                            },
                            {
                                "text": "Sindhanur",
                                "link": "https://www.swiggy.com/city/sindhanur"
                            },
                            {
                                "text": "Kannur",
                                "link": "https://www.swiggy.com/city/kannur"
                            },
                            {
                                "text": "Noida 1",
                                "link": "https://www.swiggy.com/city/noida-1"
                            },
                            {
                                "text": "Thiruvalla",
                                "link": "https://www.swiggy.com/city/thiruvalla"
                            },
                            {
                                "text": "Thodupuzha",
                                "link": "https://www.swiggy.com/city/thodupuzha"
                            },
                            {
                                "text": "Kadiri",
                                "link": "https://www.swiggy.com/city/kadiri"
                            },
                            {
                                "text": "Kavali",
                                "link": "https://www.swiggy.com/city/kavali"
                            },
                            {
                                "text": "Tezpur",
                                "link": "https://www.swiggy.com/city/tezpur"
                            },
                            {
                                "text": "Kayamkulam",
                                "link": "https://www.swiggy.com/city/kayamkulam"
                            },
                            {
                                "text": "Kottarakkara",
                                "link": "https://www.swiggy.com/city/kottarakkara"
                            },
                            {
                                "text": "Mandi Dabwali",
                                "link": "https://www.swiggy.com/city/mandi-dabwali"
                            },
                            {
                                "text": "Fatehabad",
                                "link": "https://www.swiggy.com/city/fatehabad"
                            },
                            {
                                "text": "Jagraon",
                                "link": "https://www.swiggy.com/city/jagraon"
                            },
                            {
                                "text": "Mansa",
                                "link": "https://www.swiggy.com/city/mansa"
                            },
                            {
                                "text": "Pinjore City",
                                "link": "https://www.swiggy.com/city/pinjore-city"
                            },
                            {
                                "text": "Fazilka",
                                "link": "https://www.swiggy.com/city/fazilka"
                            },
                            {
                                "text": "Baddi",
                                "link": "https://www.swiggy.com/city/baddi"
                            },
                            {
                                "text": "Solan",
                                "link": "https://www.swiggy.com/city/solan"
                            },
                            {
                                "text": "Daltonganj",
                                "link": "https://www.swiggy.com/city/daltonganj"
                            },
                            {
                                "text": "Balangir",
                                "link": "https://www.swiggy.com/city/balangir"
                            },
                            {
                                "text": "Kothagudem",
                                "link": "https://www.swiggy.com/city/kothagudem"
                            },
                            {
                                "text": "Hansi",
                                "link": "https://www.swiggy.com/city/hansi"
                            },
                            {
                                "text": "Aurangabad_Bihar",
                                "link": "https://www.swiggy.com/city/aurangabadbihar"
                            },
                            {
                                "text": "Gopalganj",
                                "link": "https://www.swiggy.com/city/gopalganj"
                            },
                            {
                                "text": "Jharsuguda",
                                "link": "https://www.swiggy.com/city/jharsuguda"
                            },
                            {
                                "text": "Tohana",
                                "link": "https://www.swiggy.com/city/tohana"
                            },
                            {
                                "text": "Jhalawar",
                                "link": "https://www.swiggy.com/city/jhalawar"
                            },
                            {
                                "text": "Sivasagar",
                                "link": "https://www.swiggy.com/city/sivasagar"
                            },
                            {
                                "text": "Bagdogra",
                                "link": "https://www.swiggy.com/city/bagdogra"
                            },
                            {
                                "text": "Kendrapada",
                                "link": "https://www.swiggy.com/city/kendrapada"
                            },
                            {
                                "text": "Mallapuram (Do not Use)",
                                "link": "https://www.swiggy.com/city/mallapuram-do-not-use"
                            },
                            {
                                "text": "Veraval",
                                "link": "https://www.swiggy.com/city/veraval"
                            },
                            {
                                "text": "Daman",
                                "link": "https://www.swiggy.com/city/daman"
                            },
                            {
                                "text": "Chiplun",
                                "link": "https://www.swiggy.com/city/chiplun"
                            },
                            {
                                "text": "Silvassa",
                                "link": "https://www.swiggy.com/city/silvassa"
                            },
                            {
                                "text": "Lonavla",
                                "link": "https://www.swiggy.com/city/lonavla"
                            },
                            {
                                "text": "Bongaigaon",
                                "link": "https://www.swiggy.com/city/bongaigaon"
                            },
                            {
                                "text": "Golaghat",
                                "link": "https://www.swiggy.com/city/golaghat"
                            },
                            {
                                "text": "Duliajan",
                                "link": "https://www.swiggy.com/city/duliajan"
                            },
                            {
                                "text": "Bolpur",
                                "link": "https://www.swiggy.com/city/bolpur"
                            },
                            {
                                "text": "Madhubani",
                                "link": "https://www.swiggy.com/city/madhubani"
                            },
                            {
                                "text": "Balasore",
                                "link": "https://www.swiggy.com/city/balasore"
                            },
                            {
                                "text": "Palampur",
                                "link": "https://www.swiggy.com/city/palampur"
                            },
                            {
                                "text": "Kotdwar",
                                "link": "https://www.swiggy.com/city/kotdwar"
                            },
                            {
                                "text": "Koppal",
                                "link": "https://www.swiggy.com/city/koppal"
                            },
                            {
                                "text": "Chikhli",
                                "link": "https://www.swiggy.com/city/chikhli"
                            },
                            {
                                "text": "Dahanu",
                                "link": "https://www.swiggy.com/city/dahanu"
                            },
                            {
                                "text": "Itanagar",
                                "link": "https://www.swiggy.com/city/itanagar"
                            },
                            {
                                "text": "Rangpo",
                                "link": "https://www.swiggy.com/city/rangpo"
                            },
                            {
                                "text": "Aizawl",
                                "link": "https://www.swiggy.com/city/aizawl"
                            },
                            {
                                "text": "Gangtok",
                                "link": "https://www.swiggy.com/city/gangtok"
                            },
                            {
                                "text": "Mayiladuthurai",
                                "link": "https://www.swiggy.com/city/mayiladuthurai"
                            },
                            {
                                "text": "Kannauj",
                                "link": "https://www.swiggy.com/city/kannauj"
                            },
                            {
                                "text": "Cooch Behar",
                                "link": "https://www.swiggy.com/city/cooch-behar"
                            },
                            {
                                "text": "Palani",
                                "link": "https://www.swiggy.com/city/palani"
                            },
                            {
                                "text": "Bilimora",
                                "link": "https://www.swiggy.com/city/bilimora"
                            },
                            {
                                "text": "Boisar",
                                "link": "https://www.swiggy.com/city/boisar"
                            },
                            {
                                "text": "Kohima",
                                "link": "https://www.swiggy.com/city/kohima"
                            },
                            {
                                "text": "Naharlagun",
                                "link": "https://www.swiggy.com/city/naharlagun"
                            },
                            {
                                "text": "Dumka",
                                "link": "https://www.swiggy.com/city/dumka"
                            },
                            {
                                "text": "Rajsamand",
                                "link": "https://www.swiggy.com/city/rajsamand"
                            },
                            {
                                "text": "Gauriganj",
                                "link": "https://www.swiggy.com/city/gauriganj"
                            },
                            {
                                "text": "Bodinayakanur",
                                "link": "https://www.swiggy.com/city/bodinayakanur"
                            },
                            {
                                "text": "Bhawanipatna",
                                "link": "https://www.swiggy.com/city/bhawanipatna"
                            },
                            {
                                "text": "Baran",
                                "link": "https://www.swiggy.com/city/baran"
                            },
                            {
                                "text": "Narsinghpur",
                                "link": "https://www.swiggy.com/city/narsinghpur"
                            },
                            {
                                "text": "Kovilpatti",
                                "link": "https://www.swiggy.com/city/kovilpatti"
                            },
                            {
                                "text": "Pusad",
                                "link": "https://www.swiggy.com/city/pusad"
                            },
                            {
                                "text": "Kendujhar",
                                "link": "https://www.swiggy.com/city/kendujhar"
                            },
                            {
                                "text": "Manali",
                                "link": "https://www.swiggy.com/city/manali"
                            },
                            {
                                "text": "Diu",
                                "link": "https://www.swiggy.com/city/diu"
                            },
                            {
                                "text": "Khamgaon",
                                "link": "https://www.swiggy.com/city/khamgaon"
                            },
                            {
                                "text": "Ramanagara",
                                "link": "https://www.swiggy.com/city/ramanagara"
                            },
                            {
                                "text": "Alipurduar",
                                "link": "https://www.swiggy.com/city/alipurduar"
                            },
                            {
                                "text": "Almora",
                                "link": "https://www.swiggy.com/city/almora"
                            },
                            {
                                "text": "Jhargram",
                                "link": "https://www.swiggy.com/city/jhargram"
                            },
                            {
                                "text": "Arambagh",
                                "link": "https://www.swiggy.com/city/arambagh"
                            },
                            {
                                "text": "Bhadohi",
                                "link": "https://www.swiggy.com/city/bhadohi"
                            },
                            {
                                "text": "Tenkasi",
                                "link": "https://www.swiggy.com/city/tenkasi"
                            },
                            {
                                "text": "Srivilliputhur",
                                "link": "https://www.swiggy.com/city/srivilliputhur"
                            },
                            {
                                "text": "Chidambaram",
                                "link": "https://www.swiggy.com/city/chidambaram"
                            },
                            {
                                "text": "Rajgarh",
                                "link": "https://www.swiggy.com/city/rajgarh"
                            },
                            {
                                "text": "Pratapgarh",
                                "link": "https://www.swiggy.com/city/pratapgarh"
                            },
                            {
                                "text": "Washim",
                                "link": "https://www.swiggy.com/city/washim"
                            },
                            {
                                "text": "Raghunathpur",
                                "link": "https://www.swiggy.com/city/raghunathpur"
                            },
                            {
                                "text": "Suri",
                                "link": "https://www.swiggy.com/city/suri"
                            },
                            {
                                "text": "Kadayanallur",
                                "link": "https://www.swiggy.com/city/kadayanallur"
                            },
                            {
                                "text": "Thiruvarur",
                                "link": "https://www.swiggy.com/city/thiruvarur"
                            },
                            {
                                "text": "Ranaghat-WB",
                                "link": "https://www.swiggy.com/city/ranaghat-wb"
                            },
                            {
                                "text": "Wayanad",
                                "link": "https://www.swiggy.com/city/wayanad"
                            },
                            {
                                "text": "Perambalur",
                                "link": "https://www.swiggy.com/city/perambalur"
                            },
                            {
                                "text": "Paramakudi",
                                "link": "https://www.swiggy.com/city/paramakudi"
                            },
                            {
                                "text": "Bela Pratapgarh",
                                "link": "https://www.swiggy.com/city/bela-pratapgarh"
                            },
                            {
                                "text": "Mahoba",
                                "link": "https://www.swiggy.com/city/mahoba"
                            },
                            {
                                "text": "Sitamarhi",
                                "link": "https://www.swiggy.com/city/sitamarhi"
                            },
                            {
                                "text": "Chakdaha",
                                "link": "https://www.swiggy.com/city/chakdaha"
                            },
                            {
                                "text": "Khalilabad",
                                "link": "https://www.swiggy.com/city/khalilabad"
                            },
                            {
                                "text": "Pattukkottai",
                                "link": "https://www.swiggy.com/city/pattukkottai"
                            },
                            {
                                "text": "Tindivanam",
                                "link": "https://www.swiggy.com/city/tindivanam"
                            },
                            {
                                "text": "Tiruttani",
                                "link": "https://www.swiggy.com/city/tiruttani"
                            },
                            {
                                "text": "Gangarampur",
                                "link": "https://www.swiggy.com/city/gangarampur"
                            },
                            {
                                "text": "Dharapuram",
                                "link": "https://www.swiggy.com/city/dharapuram"
                            },
                            {
                                "text": "Arakkonam",
                                "link": "https://www.swiggy.com/city/arakkonam"
                            },
                            {
                                "text": "Sirkali",
                                "link": "https://www.swiggy.com/city/sirkali"
                            },
                            {
                                "text": "Mettupalayam",
                                "link": "https://www.swiggy.com/city/mettupalayam"
                            },
                            {
                                "text": "Digboi",
                                "link": "https://www.swiggy.com/city/digboi"
                            },
                            {
                                "text": "Biswanath Chariali",
                                "link": "https://www.swiggy.com/city/biswanath-chariali"
                            },
                            {
                                "text": "Nalbari",
                                "link": "https://www.swiggy.com/city/nalbari"
                            },
                            {
                                "text": "Shirdi city",
                                "link": "https://www.swiggy.com/city/shirdi-city"
                            },
                            {
                                "text": "Mukerian",
                                "link": "https://www.swiggy.com/city/mukerian"
                            },
                            {
                                "text": "Hosur",
                                "link": "https://www.swiggy.com/city/hosur"
                            },
                            {
                                "text": "Palakollu",
                                "link": "https://www.swiggy.com/city/palakollu"
                            },
                            {
                                "text": "Ravulapalem",
                                "link": "https://www.swiggy.com/city/ravulapalem"
                            },
                            {
                                "text": "Barh",
                                "link": "https://www.swiggy.com/city/barh"
                            },
                            {
                                "text": "Palghar",
                                "link": "https://www.swiggy.com/city/palghar"
                            },
                            {
                                "text": "Kushalnagar",
                                "link": "https://www.swiggy.com/city/kushalnagar"
                            },
                            {
                                "text": "Dungarpur",
                                "link": "https://www.swiggy.com/city/dungarpur"
                            },
                            {
                                "text": "Chaibasa",
                                "link": "https://www.swiggy.com/city/chaibasa"
                            },
                            {
                                "text": "Haveri",
                                "link": "https://www.swiggy.com/city/haveri"
                            },
                            {
                                "text": "Karaikal",
                                "link": "https://www.swiggy.com/city/karaikal"
                            },
                            {
                                "text": "Jjajjar",
                                "link": "https://www.swiggy.com/city/jjajjar"
                            },
                            {
                                "text": "Kokrajhar",
                                "link": "https://www.swiggy.com/city/kokrajhar"
                            },
                            {
                                "text": "Rangia",
                                "link": "https://www.swiggy.com/city/rangia"
                            },
                            {
                                "text": "Hamirpur",
                                "link": "https://www.swiggy.com/city/hamirpur"
                            },
                            {
                                "text": "Una",
                                "link": "https://www.swiggy.com/city/una"
                            },
                            {
                                "text": "Sulthan Bathery",
                                "link": "https://www.swiggy.com/city/sulthan-bathery"
                            },
                            {
                                "text": "Rayagada",
                                "link": "https://www.swiggy.com/city/rayagada"
                            },
                            {
                                "text": "Paradeep",
                                "link": "https://www.swiggy.com/city/paradeep"
                            },
                            {
                                "text": "Mandapeta",
                                "link": "https://www.swiggy.com/city/mandapeta"
                            },
                            {
                                "text": "Jamui",
                                "link": "https://www.swiggy.com/city/jamui"
                            },
                            {
                                "text": "Pilkhuwa",
                                "link": "https://www.swiggy.com/city/pilkhuwa"
                            },
                            {
                                "text": "Parvathipuram",
                                "link": "https://www.swiggy.com/city/parvathipuram"
                            },
                            {
                                "text": "Ambajogai",
                                "link": "https://www.swiggy.com/city/ambajogai"
                            },
                            {
                                "text": "Araria",
                                "link": "https://www.swiggy.com/city/araria"
                            },
                            {
                                "text": "North Lakhimpur",
                                "link": "https://www.swiggy.com/city/north-lakhimpur"
                            },
                            {
                                "text": "Rajampet",
                                "link": "https://www.swiggy.com/city/rajampet"
                            },
                            {
                                "text": "Udumalaipettai",
                                "link": "https://www.swiggy.com/city/udumalaipettai"
                            },
                            {
                                "text": "Tirupattur",
                                "link": "https://www.swiggy.com/city/tirupattur"
                            },
                            {
                                "text": "Hojai",
                                "link": "https://www.swiggy.com/city/hojai"
                            },
                            {
                                "text": "Khagaria",
                                "link": "https://www.swiggy.com/city/khagaria"
                            },
                            {
                                "text": "Dasuya",
                                "link": "https://www.swiggy.com/city/dasuya"
                            },
                            {
                                "text": "Gudur",
                                "link": "https://www.swiggy.com/city/gudur"
                            },
                            {
                                "text": "Sullurpeta",
                                "link": "https://www.swiggy.com/city/sullurpeta"
                            },
                            {
                                "text": "Piler",
                                "link": "https://www.swiggy.com/city/piler"
                            },
                            {
                                "text": "SankaranKoil",
                                "link": "https://www.swiggy.com/city/sankarankoil"
                            },
                            {
                                "text": "Nabha",
                                "link": "https://www.swiggy.com/city/nabha"
                            },
                            {
                                "text": "LPU - Phagwara",
                                "link": "https://www.swiggy.com/city/lpu-phagwara"
                            },
                            {
                                "text": "Jangipur",
                                "link": "https://www.swiggy.com/city/jangipur"
                            },
                            {
                                "text": "Roha",
                                "link": "https://www.swiggy.com/city/roha"
                            }
                        ],
                        "id": "footer_content"
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.MetaContext",
                        "citySlug": "bangalore",
                        "lat": "12.96340",
                        "lng": "77.58550",
                        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/125.0.0.0 Safari/537.36",
                        "gandalfRequest": '{"sortAttribute":"relevance","isFiltered":false,"queryId":"seo-data-efe5a914-ae14-47c9-9a01-08a78a64d0a7","seoParams":{"apiName":"FoodHomePage","brandId":"","seoUrl":"www.swiggy.com","pageType":"FOOD_HOME_PAGE"}}',
                        "id": "meta_data",
                        "metaInfo": {
                            "pageType": "FOOD_HOME_PAGE",
                            "pageTitle": "Order Food Online from India's Best Food Delivery Service | Swiggy",
                            "pageMetaDescription": "Order food online from restaurants and get it delivered. Serving in Bangalore, Hyderabad, Delhi and more. Order Pizzas, Biryanis, from Swiggy.",
                            "pageKeywords": "Food delivery, Online food order, Online food dleivery"
                        },
                        "screenType": "filteredCollection",
                        "seoParams": {
                            "apiName": "FoodHomePage",
                            "seoUrl": "www.swiggy.com",
                            "pageType": "FOOD_HOME_PAGE"
                        }
                    }
                }
            }
        ],
        "firstOffsetRequest": true,
        "cacheExpiryTime": 240,
        "nextFetch": 1
    },
    "tid": "d8ac568f-ac2f-49b0-aefc-d53ef8871aea",
    "sid": "ej6b94e3-0870-42e0-a3b1-d434d6edb7d6",
    "deviceId": "cd4ba80f-02fd-6134-dc25-bb96b0379c3c",
    "csrfToken": "RvUdsKIk61Ad-E7s8Zoy0V4adRYNECnb5IVdptDY"
};
const $7f2c384ac384527b$export$befc3081f5a05f32 = {
    "statusCode": 0,
    "data": {
        "statusMessage": "done successfully",
        "cards": [
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
                        "text": "McDonald's",
                        "headerStyling": {
                            "textColor": "text_Highest_Emphasis",
                            "textVariant": "header_H3_Black"
                        }
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
                        "tabs": [
                            {
                                "id": "Order Online",
                                "title": "Order Online"
                            }
                        ]
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                        "info": {
                            "id": "43836",
                            "name": "McDonald's",
                            "city": "Bangalore",
                            "slugs": {
                                "restaurant": "mcdonalds-kasturba-road-central-bangalore",
                                "city": "bangalore"
                            },
                            "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/4/1/fe11ced6-89a3-4080-8610-3c743a3bb3f0_43836.jpg",
                            "locality": "MG Road",
                            "areaName": "Ashok Nagar",
                            "costForTwo": "40000",
                            "costForTwoMessage": "\u20B9400 for two",
                            "cuisines": [
                                "Burgers",
                                "Beverages"
                            ],
                            "avgRating": 4.3,
                            "feeDetails": {
                                "restaurantId": "43836",
                                "fees": [
                                    {
                                        "name": "TYPE_DISTANCE",
                                        "fee": 4300
                                    },
                                    {
                                        "name": "TYPE_TIME"
                                    }
                                ],
                                "totalFee": 4300,
                                "title": "Delivery Charge",
                                "amount": "4300",
                                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                                "message": "<b>2.5 kms</b> | \u20B943 Delivery fee will apply"
                            },
                            "parentId": "630",
                            "avgRatingString": "4.3",
                            "totalRatingsString": "10K+ ratings",
                            "sla": {
                                "restaurantId": "43836",
                                "deliveryTime": 36,
                                "minDeliveryTime": 35,
                                "maxDeliveryTime": 40,
                                "lastMileTravel": 2.5,
                                "serviceability": "SERVICEABLE",
                                "stressFactor": 1,
                                "rainMode": "RAIN_MODE_LIGHT",
                                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                                "zoneId": 68,
                                "slaString": "35-40 MINS",
                                "lastMileTravelString": "2.5 km",
                                "iconType": "ICON_TYPE_EMPTY"
                            },
                            "availability": {
                                "nextCloseTime": "2024-06-22 02:45:00",
                                "visibility": true,
                                "opened": true,
                                "restaurantClosedMeta": {}
                            },
                            "aggregatedDiscountInfo": {
                                "shortDescriptionList": [
                                    {
                                        "discountType": "Flat",
                                        "operationType": "RESTAURANT"
                                    },
                                    {
                                        "discountType": "Percentage",
                                        "operationType": "RESTAURANT"
                                    }
                                ],
                                "descriptionList": [
                                    {
                                        "meta": "Flat \u20B950 off | Above \u20B9600",
                                        "discountType": "Flat",
                                        "operationType": "RESTAURANT"
                                    },
                                    {
                                        "meta": "15% off upto \u20B9150 |  Use HSBCFEST Above \u20B9499",
                                        "discountType": "Percentage",
                                        "operationType": "RESTAURANT"
                                    }
                                ],
                                "visible": true
                            },
                            "badges": {},
                            "slugString": "mcdonalds-kasturba-road-central-bangalore",
                            "multiOutlet": true,
                            "isOpen": true,
                            "labels": [
                                {
                                    "title": "Timings",
                                    "message": "null"
                                },
                                {
                                    "title": "Address",
                                    "message": "Hardcastle Restaurants Pvt Ltd, No. 10, India Garage, Opp. Cubbon Park police Station, Near BPCL Petrol pump, Kasturba Road, Bengaluru - 560001"
                                },
                                {
                                    "title": "Cuisines",
                                    "message": "Burgers,Beverages"
                                }
                            ],
                            "logo": "ygzpacvdpquemhj77imr",
                            "totalRatings": 10000,
                            "aggregatedDiscountInfoV2": {
                                "shortDescriptionList": [
                                    {
                                        "discountType": "Flat",
                                        "operationType": "RESTAURANT"
                                    },
                                    {
                                        "discountType": "Percentage",
                                        "operationType": "RESTAURANT"
                                    }
                                ],
                                "descriptionList": [
                                    {
                                        "meta": "Flat \u20B950 off | Above \u20B9600",
                                        "discountType": "Flat",
                                        "operationType": "RESTAURANT"
                                    },
                                    {
                                        "meta": "15% off upto \u20B9150 |  Use HSBCFEST Above \u20B9499",
                                        "discountType": "Percentage",
                                        "operationType": "RESTAURANT"
                                    }
                                ],
                                "couponDetailsCta": "View coupon details"
                            },
                            "type": "F",
                            "headerBanner": {
                                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/43836"
                            },
                            "expectationNotifiers": [
                                {
                                    "text": "<b>2.5 kms</b> | \u20B943 Delivery fee will apply",
                                    "icon": {
                                        "imageId": "v1648635511/Delivery_fee_new_cjxumu"
                                    },
                                    "popup": {
                                        "cta": {}
                                    },
                                    "type": "DISTANCE_FEE_NON_FOOD_LM",
                                    "enrichedText": "<b>2.5 kms</b> | \u20B943 Delivery fee will apply",
                                    "halfCardPopup": {
                                        "halfCardPopupHeader": {}
                                    },
                                    "trailingIcon": {}
                                }
                            ],
                            "generalPurposeInfoListV2": [
                                {
                                    "cta": {
                                        "info": {
                                            "recordings": {}
                                        },
                                        "linkCta": {}
                                    }
                                }
                            ],
                            "ratingSlab": "RATING_SLAB_5",
                            "orderabilityCommunication": {
                                "title": {},
                                "subTitle": {},
                                "message": {},
                                "customIcon": {}
                            },
                            "hasBestsellerItems": true,
                            "hasGuiltfreeItems": true,
                            "cartOrderabilityNudgeBanner": {
                                "parameters": {},
                                "presentation": {}
                            },
                            "latLong": "12.97565719,77.59843376",
                            "backgroundImageOverlayInfo": {}
                        },
                        "analytics": {}
                    },
                    "relevance": {
                        "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
                        "sectionId": "POP_UP_CROUTON_MENU"
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
                        "layout": {
                            "rows": 1,
                            "columns": 2,
                            "horizontalScrollEnabled": true,
                            "itemSpacing": 12,
                            "lineSpacing": 10,
                            "widgetPadding": {},
                            "containerStyle": {
                                "containerPadding": {
                                    "left": 10,
                                    "right": 10,
                                    "bottom": 16
                                }
                            },
                            "scrollBar": {}
                        },
                        "id": "offerCollectionWidget_UX4",
                        "gridElements": {
                            "infoWithStyle": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                                "offers": [
                                    {
                                        "info": {
                                            "header": "FLAT \u20B950 OFF",
                                            "offerTagColor": "#E46D47",
                                            "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/5/31/f71f1df1-bfba-4f4c-88a4-82cccf73fe9e_ici.jpg",
                                            "offerIds": [
                                                "55c218f5-5adb-4051-8bcb-96410b716ba6"
                                            ],
                                            "expiryTime": "1970-01-01T00:00:00Z",
                                            "couponCode": "NO CODE REQUIRED",
                                            "description": "ABOVE \u20B9600",
                                            "offerType": "offers",
                                            "restId": "43836",
                                            "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/5/31/f71f1df1-bfba-4f4c-88a4-82cccf73fe9e_ici.jpg",
                                            "descriptionTextColor": "#7302060C"
                                        },
                                        "cta": {
                                            "type": "OFFER_HALF_CARD"
                                        }
                                    },
                                    {
                                        "info": {
                                            "header": "15% OFF UPTO \u20B9150",
                                            "offerTagColor": "#E46D47",
                                            "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/5/31/88c34f98-1ddc-4d74-86d8-7efd9a120d00_HSBC.png",
                                            "offerIds": [
                                                "aacf3a01-2485-4df3-a453-c18e2f6544e5"
                                            ],
                                            "expiryTime": "1970-01-01T00:00:00Z",
                                            "couponCode": "USE HSBCFEST",
                                            "description": "ABOVE \u20B9499",
                                            "offerType": "offers",
                                            "restId": "43836",
                                            "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/5/31/88c34f98-1ddc-4d74-86d8-7efd9a120d00_HSBC.png",
                                            "descriptionTextColor": "#7302060C"
                                        },
                                        "cta": {
                                            "type": "OFFER_HALF_CARD"
                                        }
                                    }
                                ],
                                "habitMilestoneInfo": {
                                    "callout": {}
                                },
                                "loyaltyDiscoverPresentationInfo": {
                                    "logoCtx": {}
                                }
                            }
                        }
                    }
                }
            },
            {
                "groupedCard": {
                    "cardGroupMap": {
                        "REGULAR": {
                            "cards": [
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                                            "badges": {},
                                            "vegOnlyDetails": {
                                                "imageId": "AutoVegOnly_qkjowj",
                                                "title": "Showing only vegetarian options.",
                                                "description": "Tap on the VEG ONLY button to turn off the setting"
                                            },
                                            "topRatedFilter": {
                                                "attributes": {
                                                    "displayText": "Ratings 4.0+"
                                                }
                                            },
                                            "kidsCategoryFilter": {
                                                "attributes": {
                                                    "displayText": "Kids Favourites",
                                                    "tooltip": {
                                                        "enabled": true,
                                                        "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                                                    }
                                                }
                                            },
                                            "vegFilter": {
                                                "attributes": {
                                                    "displayText": "VEG"
                                                }
                                            },
                                            "nonvegFilter": {
                                                "attributes": {
                                                    "displayText": "NONVEG"
                                                }
                                            }
                                        },
                                        "relevance": {
                                            "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                                            "sectionId": "MENU_FILTER_TOGGLE"
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                                            "title": "Top Picks",
                                            "carousel": [
                                                {
                                                    "type": "TopCarousel",
                                                    "subtype": "image",
                                                    "bannerId": "2057973",
                                                    "creativeId": "TopPicks/McSpcyChkBCb",
                                                    "title": " McSpicy Deluxe Chicken Burger Combo",
                                                    "description": " ",
                                                    "fontColor": "#FFFFFF",
                                                    "dish": {
                                                        "info": {
                                                            "id": "132405957",
                                                            "name": " McSpicy Deluxe Chicken Burger Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "McSpicy Deluxe Chicken Burger + Fries (M) + Drink of your choice.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/15/925ee002-5dad-42b2-bfb3-7ae0dfa291d3_42d881c9-ebea-45f5-a91d-ce0eb4b25d2a.png",
                                                            "inStock": 1,
                                                            "price": 37048,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "132025562",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "132025563",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "132025564",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "itemBadge": {},
                                                            "badgesV2": {}
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "type": "TopCarousel",
                                                    "subtype": "image",
                                                    "bannerId": "2058314",
                                                    "creativeId": "TopPicks/McSpcyPanBCb",
                                                    "title": "McSpicy Deluxe Paneer Burger Combo",
                                                    "description": " ",
                                                    "fontColor": "#FFFFFF",
                                                    "dish": {
                                                        "info": {
                                                            "id": "132405958",
                                                            "name": "McSpicy Deluxe Paneer Burger Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "McSpicy Deluxe paneer Burger + Fries (M) + Drink of your choice.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/15/72abe84e-7e1d-4bbe-aa2d-a6de6753df3d_60e7e353-1fb1-4365-a6c4-aa4834198570.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 36095,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "132025565",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "132025566",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "132025567",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "itemBadge": {},
                                                            "badgesV2": {}
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "type": "TopCarousel",
                                                    "subtype": "image",
                                                    "bannerId": "2058654",
                                                    "creativeId": "TopPicks/5McSpcyFdCkB",
                                                    "title": "5 pcs McSpicy Fried Chicken Bucket",
                                                    "description": " ",
                                                    "fontColor": "#FFFFFF",
                                                    "dish": {
                                                        "info": {
                                                            "id": "119984440",
                                                            "name": "5 pcs McSpicy Fried Chicken Bucket",
                                                            "category": "Fried Chicken & Wings",
                                                            "description": "Enjoy 5 pcs of juicy, spicy and crunchy McSpicy Fried Chicken in a Bucket that's perfect for sharing. Serves 3-4",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/5/342dd4fb-54d0-4261-9b0a-b4e33d8e8447_54e45770-76f6-4ec2-aabf-08b286a498f7.png",
                                                            "inStock": 1,
                                                            "price": 45857,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "itemBadge": {},
                                                            "badgesV2": {}
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "McSaver Combos (2pc Combos)",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "63149158",
                                                            "name": "McChicken Burger + Fries (M)",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Tender and juicy chicken patty cooked to perfection, with creamy mayonnaise and crunchy lettuce adding flavour to each bite. Served with Medium Fries.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/5/3da4014b-ad94-432f-94de-952be5c238da_1fd6a2a5-c71f-4de7-9c36-8e81eff20d06.png",
                                                            "inStock": 1,
                                                            "price": 22381,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.9",
                                                                    "ratingCount": "400 ratings",
                                                                    "ratingCountV2": "400"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "63149159",
                                                            "name": "McVeggie Burger + Fries (M)",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "A delectable patty filled with potatoes, peas, carrots and tasty Indian spices. Topped with crispy lettuce, mayonnaise, and packed into toasted sesame buns. Served with Medium Fries.",
                                                            "imageId": "d14cc495747a172686ebe43e675bc941",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 18952,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.0",
                                                                    "ratingCount": "233 ratings",
                                                                    "ratingCountV2": "233"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "66834988",
                                                            "name": "McChicken Burger + Fries (L)",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Tender and juicy chicken patty cooked to perfection, with creamy mayonnaise and crunchy lettuce adding flavour to each bite. Served with Large Fries.",
                                                            "imageId": "a4148348225f693c23b73eda06934fac",
                                                            "inStock": 1,
                                                            "price": 22762,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.7",
                                                                    "ratingCount": "23 ratings",
                                                                    "ratingCountV2": "23"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "50287486",
                                                            "name": "McChicken Burger + McSpicy Chicken Burger",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "The ultimate chicken combo made just for you. Get the top selling McChicken with the McSpicy Chicken Burger.",
                                                            "imageId": "006d51070b0ab9c839a293b87412541c",
                                                            "inStock": 1,
                                                            "price": 29143,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "12 ratings",
                                                                    "ratingCountV2": "12"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "123193892",
                                                            "name": "McSpicy Chicken Burger + Fries (M) + Piri Piri Spice Mix",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Tender and juicy chicken patty coated in spicy, crispy batter topped with a creamy sauce and crispy shredded lettuce will have you craving for more. Served with the spicy piri piri mix and medium fries.",
                                                            "imageId": "e10982204687e18ee6541684365039b8",
                                                            "inStock": 1,
                                                            "price": 26476,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "23 ratings",
                                                                    "ratingCountV2": "23"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "102107205",
                                                            "name": "McVeggie Burger + Veg Pizza McPuff + Fries (L)",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Flat 15% Off on McVeggie Burger + Veg Pizza McPuff + Fries (L)",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/29/0e4d8ee8-ee6b-4e12-9386-658dbcdc6be4_6810365e-3735-4b21-860b-923a416403be.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 26667,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.2",
                                                                    "ratingCount": "19 ratings",
                                                                    "ratingCountV2": "19"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713329",
                                                            "name": "2 McFlurry Oreo (S)",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Delicious soft serve meets crumbled oreo cookies, a match made in dessert heaven. Make it double with this combo!",
                                                            "imageId": "65f3574f53112e9d263dfa924b1f8fed",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 15524,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "5 ratings",
                                                                    "ratingCountV2": "5"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "66834991",
                                                            "name": "McVeggie Burger + Fries (L)",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "A delectable patty filled with potatoes, peas, carrots and tasty Indian spices. Topped with crispy lettuce, mayonnaise, and packed into toasted sesame buns. Served with Large fries.",
                                                            "imageId": "f16eeec3e5d19f8627971620ed2da6f8",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 22286,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "13 ratings",
                                                                    "ratingCountV2": "13"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "65343175",
                                                            "name": "McChicken Burger + Veg Pizza McPuff",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Tender and juicy chicken patty cooked to perfection, with creamy mayonnaise and crunchy lettuce adding flavour to each bite. Served with Veg Pizza McPuff.",
                                                            "imageId": "9a66b8ef66d780b9f83a0fc7cd434ded",
                                                            "inStock": 1,
                                                            "price": 17048,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "5 ratings",
                                                                    "ratingCountV2": "5"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "66834979",
                                                            "name": "Mexican McAloo Tikki Burger + Fries (L)",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "A fusion of international taste combined with your favourite aloo tikki patty, layered with shredded onion, and delicious Chipotle sauce. Served with Large Fries.",
                                                            "imageId": "f4be6e877d2567a0b585d4b16e53871e",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 17524,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.6",
                                                                    "ratingCount": "6 ratings",
                                                                    "ratingCountV2": "6"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "87366535",
                                                            "name": "2 Fries (R)",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "World Famous Fries, crispy, golden, lightly salted and fried to perfection! Double your happiness with this fries combo",
                                                            "imageId": "4a170da5ecae92e11410a8fbb44c8476",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 11238,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.6",
                                                                    "ratingCount": "42 ratings",
                                                                    "ratingCountV2": "42"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "65343167",
                                                            "name": "McAloo Tikki + Fries (R)",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Aloo Tikki+ Fries (R)",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/5/ee4cf174-0bb3-46ba-8244-4d92e5fb2223_3a206de2-f183-4bb2-bdb6-232ba0db0538.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 10762,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.5",
                                                                    "ratingCount": "23 ratings",
                                                                    "ratingCountV2": "23"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "108334826",
                                                            "name": "6 Pc Chicken Nuggets + Fries (M) + Piri Piri Spice Mix",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "The best Non veg sides combo curated for you! Get 6 pc Chicken McNuggets + Fries M. Top it up with Piri Piri mix.",
                                                            "imageId": "8cba0938b4401e5c8cb2ccf3741b93c4",
                                                            "inStock": 1,
                                                            "price": 24762,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "106302965",
                                                                    "groupName": "Choose an option for Mustard Sauce",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94834150",
                                                                            "name": "Barbeque Sauce",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.8",
                                                                    "ratingCount": "5 ratings",
                                                                    "ratingCountV2": "5"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "50287497",
                                                            "name": "McVeggie Burger + McAloo Tikki Burger",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "A delectable patty filled with potatoes, peas, carrots and tasty Indian spices. Topped with crispy lettuce, mayonnaise, makes our iconic McVeggie and combo with our top selling McAloo Tikki Burger.",
                                                            "imageId": "1f4d583548597d41086df0c723560da7",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 18952,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "65343179",
                                                            "name": "McVeggie Burger + Veg Pizza McPuff",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "A delectable patty filled with potatoes, peas, carrots and tasty Indian spices. Topped with crispy lettuce, mayonnaise, and packed into toasted sesame buns. Served with Veg Pizza McPuff.",
                                                            "imageId": "8cb2f75ca6a51061c69280daf1b63bec",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 17048,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "9 ratings",
                                                                    "ratingCountV2": "9"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "33933608",
                                                            "name": "Veg Pizza McPuff + McSpicy Chicken Burger",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Tender and juicy chicken patty coated in spicy, crispy batter topped with a creamy sauce and crispy shredded lettuce will have you craving for more. Served with Veg Pizza McPuff",
                                                            "imageId": "fb4b9d4775505e82d05d6734ef3e2491",
                                                            "inStock": 1,
                                                            "price": 23905,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.6",
                                                                    "ratingCount": "26 ratings",
                                                                    "ratingCountV2": "26"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "123193910",
                                                            "name": "McSpicy Paneer Burger + Fries (M) + Piri Piri Spice Mix",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Rich and filling cottage cheese patty coated in spicy, crispy batter topped with a creamy sauce and crispy shredded lettuce will have you craving for more. Served with the spicy piri piri mix and medium fries.",
                                                            "imageId": "87ce9779f986dcb21ab1fcfe794938d1",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 25048,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "5.0",
                                                                    "ratingCount": "4 ratings",
                                                                    "ratingCountV2": "4"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "65343174",
                                                            "name": "Mexican McAloo Tikki Burger + Fries (R)",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "A fusion of international taste combined with your favourite aloo tikki patty, layered with shredded onion, and delicious Chipotle sauce. Served with Regular Fries.",
                                                            "imageId": "7274d82212a758e597550e8c246fb2f7",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 11619,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "13 ratings",
                                                                    "ratingCountV2": "13"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "121923944",
                                                            "name": "Corn & Cheese Burger + Coke + Fries (M) + Veg Pizza McPuff",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Enjoy Corn and Cheese Burger + Coke + Fries (M) + Veg Pizza McPuff",
                                                            "imageId": "8d4a82d50f6e79d95fcc324b161374f8",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 35333,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "102107201",
                                                            "name": "McAloo Tikki Burger + Veg Pizza McPuff + Fries (R)",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Flat 15% Off on McAloo Tikki + Veg Pizza McPuff + Fries (R)",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/5/f31c4e82-6b25-4d97-99a7-c68c43c053da_01305763-5101-4310-b03c-e5a28c8f0742.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 20095,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.0",
                                                                    "ratingCount": "89 ratings",
                                                                    "ratingCountV2": "89"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "123193893",
                                                            "name": "McSpicy Chicken Burger + Mexican Cheese Fries",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Tender and juicy chicken patty coated in spicy, crispy batter topped with a creamy sauce and crispy shredded lettuce will have you craving for more. Served with Mexican Cheese Fries.",
                                                            "imageId": "40259e78ad0e89966755805a7c1ad800",
                                                            "inStock": 1,
                                                            "price": 26476,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "5.0",
                                                                    "ratingCount": "3 ratings",
                                                                    "ratingCountV2": "3"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "102107204",
                                                            "name": "McVeggie Burger + Fries (M) + Piri Piri Mix",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Flat 15% Off on McVeggie Burger + Fries (M) + Piri Piri Mix",
                                                            "imageId": "0205cbd8b77f841e19e25ce727993d51",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 23238,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "102107198",
                                                            "name": "Grilled Chicken & Cheese Burger + Coke",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Flat 15% Off on Grilled Chicken & Cheese Burger + Coke",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/29/18f3ce07-00b5-487b-8608-56440efff007_2b241e0a-fad5-4be4-a848-81c124c95b8b.png",
                                                            "inStock": 1,
                                                            "price": 21619,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "144944121",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.5",
                                                                    "ratingCount": "5 ratings",
                                                                    "ratingCountV2": "5"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "65343180",
                                                            "name": "McVeggie Burger + Fries (R)",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "A delectable patty filled with potatoes, peas, carrots and tasty Indian spices. Topped with crispy lettuce, mayonnaise, and packed into toasted sesame buns. Served with Regular fries.",
                                                            "imageId": "52a347eab543d461b1a15b609779b8c2",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 17524,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "2.4",
                                                                    "ratingCount": "9 ratings",
                                                                    "ratingCountV2": "9"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "123193912",
                                                            "name": "McSpicy Paneer + Classic Cheese Fries",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Rich and filling cottage cheese patty coated in spicy, crispy batter topped with a creamy sauce and crispy shredded lettuce will have you craving for more. Served with Mexican Cheese Fries.",
                                                            "imageId": "fcc2fb1635f8e14c69b57126014f0bd5",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 25048,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.0",
                                                                    "ratingCount": "3 ratings",
                                                                    "ratingCountV2": "3"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "109039801",
                                                            "name": "Corn & Cheese Burger + Fries (R)",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "A delicious Corn & Cheese Burger + a side of crispy, golden, world famous fries ??",
                                                            "imageId": "495bcb831b35c29883707b9458fd55b0",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 18667,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.0",
                                                                    "ratingCount": "12 ratings",
                                                                    "ratingCountV2": "12"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "109039800",
                                                            "name": "Corn & Cheese Burger + Veg Pizza McPuff",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "A delicious Corn & Cheese Burger + a crispy brown, delicious Pizza McPuff",
                                                            "imageId": "f847f39d3b81367ecd2aa14bd2dca94d",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 17619,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.4",
                                                                    "ratingCount": "9 ratings",
                                                                    "ratingCountV2": "9"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "109039799",
                                                            "name": "Grilled Chicken & Cheese Burger + Veg Pizza McPuff",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "A delicious Grilled Chicken & Cheese Burger + a crispy brown, delicious Pizza McPuff",
                                                            "imageId": "b9f02abd64c74307339cbd3421e7f853",
                                                            "inStock": 1,
                                                            "price": 19524,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "63149162",
                                                            "name": "McAloo Tikki Burger + Veg Pizza McPuff + Coke",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "The ultimate veg combo made just for you. Get the top selling McAloo Tikki served with Veg Pizza McPuff and Coke.",
                                                            "imageId": "9f0269a2d28f4918a3b07f63a487f26d",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 16096,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278634",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.0",
                                                                    "ratingCount": "148 ratings",
                                                                    "ratingCountV2": "148"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713620",
                                                            "name": "Strawberry Shake + Fries (M)",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Can't decide what to eat? We've got you covered. Get this snacking combo with Medium Fries and Strawberry Shake.",
                                                            "imageId": "74603316fc90ea3cd2b193ab491fbf53",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 19524,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "5.0",
                                                                    "ratingCount": "4 ratings",
                                                                    "ratingCountV2": "4"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "136748451",
                                                            "name": "Classic Cheese Fries + Sprite",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Relish Classic Cheese Fries + Sprite",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/8884ec57-9e66-4c27-81a9-d02cbe1c6592_e530e5b6-f2ad-4b4e-ba89-7eb4850f6d4a.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 24682,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150727157",
                                                                    "groupName": "Choose an option for Sprite",
                                                                    "choices": [
                                                                        {
                                                                            "id": "115680626",
                                                                            "name": "Coke",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680638",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680649",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680651",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680650",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680648",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680646",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680647",
                                                                            "name": "McCafe-Ice Coffee",
                                                                            "price": 9700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680643",
                                                                            "name": "Chocolate Frappe",
                                                                            "price": 17800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680645",
                                                                            "name": "Mocha Frappe",
                                                                            "price": 17800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680639",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680641",
                                                                            "name": "Hot Chocolate (R)",
                                                                            "price": 11500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680627",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "136748453",
                                                            "name": "Fries (M) + Piri Piri Mix + Sprite",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Enjoy your favourite Fries (M) + Piri Piri Mix + Sprite",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/6ec0d891-1355-4d2e-b9fb-f243a96ae534_cebd2d4b-f605-4085-a183-bac1d7067fc2.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 22093,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150726768",
                                                                    "groupName": "Choose an option for Sprite",
                                                                    "choices": [
                                                                        {
                                                                            "id": "115680626",
                                                                            "name": "Coke",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680638",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680649",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680651",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680650",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680648",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680646",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680647",
                                                                            "name": "McCafe-Ice Coffee",
                                                                            "price": 9700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680643",
                                                                            "name": "Chocolate Frappe",
                                                                            "price": 17800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680645",
                                                                            "name": "Mocha Frappe",
                                                                            "price": 17800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680639",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680641",
                                                                            "name": "Hot Chocolate (R)",
                                                                            "price": 11500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680627",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "65035612",
                                                            "name": "2 Coke",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "The perfect companion to your burger, fries and everything nice. Double it up with this combo.",
                                                            "imageId": "2d7540e92ac04c0c0823e9f4f029e2dd",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 16476,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.7",
                                                                    "ratingCount": "8 ratings",
                                                                    "ratingCountV2": "8"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713348",
                                                            "name": "Chocolate Flavoured Shake+ Fries (M)",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Can't decide what to eat? We've got you covered. Get this snacking combo with Medium Fries and Chocolate Flavoured Shake.",
                                                            "imageId": "46781c13d587e5f951ac1bbb39e57154",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 19524,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "2.1",
                                                                    "ratingCount": "4 ratings",
                                                                    "ratingCountV2": "4"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "108334831",
                                                            "name": "McAloo Tikki Burger + Veg Pizza McPuff + Piri Piri Spice Mix",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Get India's favourite burger - McAloo Tikki along with Veg Pizza McPuff and spice it up with a Piri Piri Mix",
                                                            "imageId": "46bcb1e486cbe6dcdb0487b063af58a6",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 12762,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.6",
                                                                    "ratingCount": "4 ratings",
                                                                    "ratingCountV2": "4"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713331",
                                                            "name": "2 Soft Serve Hot Fudge (M)",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "A sinful delight, soft serve topped with delicious, gooey hot chocolate fudge. So good you won't be able to stop at one!",
                                                            "imageId": "f1238db9da73d8ec7a999792f35865d9",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 15524,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "5.0",
                                                                    "ratingCount": "3 ratings",
                                                                    "ratingCountV2": "3"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "125972286",
                                                            "name": "Black Forest Mcflurry (M) BOGO",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Get 2 Black Forest McFlurry for the price of one!",
                                                            "imageId": "972a2b3aca8059ba25a04875ec091885",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 11524,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.0",
                                                                    "ratingCount": "30 ratings",
                                                                    "ratingCountV2": "30"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "136748484",
                                                            "name": "McVeggie Double Patty Burger + Sprite",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Enjoy the classic combo of McVeggie Double Patty Burger + Sprite",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/88e03107-2e0b-404d-8510-00cca538b03c_663b0c06-1bc1-4f92-9db3-f338ba5aa964.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 29002,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150726731",
                                                                    "groupName": "Choose an option for Sprite",
                                                                    "choices": [
                                                                        {
                                                                            "id": "115680626",
                                                                            "name": "Coke",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680638",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680649",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680651",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680650",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680648",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680646",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680647",
                                                                            "name": "McCafe-Ice Coffee",
                                                                            "price": 9700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680643",
                                                                            "name": "Chocolate Frappe",
                                                                            "price": 17800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680645",
                                                                            "name": "Mocha Frappe",
                                                                            "price": 17800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680639",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680641",
                                                                            "name": "Hot Chocolate (R)",
                                                                            "price": 11500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680627",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "143868552",
                                                            "name": "McSaver Chicken Surprise Burger + Coke",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Enjoy a delicious combo of the new Chicken Surprise Burger with a beverage, now in a delivery friendly reusable bottle.",
                                                            "imageId": "043eae9480bd4c80333c7d99cb0cd96b",
                                                            "inStock": 1,
                                                            "price": 7524,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "161398356",
                                                                    "groupName": "Choose an option for Coke ",
                                                                    "choices": [
                                                                        {
                                                                            "id": "119686831",
                                                                            "name": "Cold Coffee ",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686829",
                                                                            "name": "Chocolate Shake ",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686830",
                                                                            "name": "Strawberry Shake ",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686836",
                                                                            "name": "Berry Cooler ",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686834",
                                                                            "name": "Iced Coffee ",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686835",
                                                                            "name": "Small Cappuccino",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686832",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686833",
                                                                            "name": "Sprite ",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "143868557",
                                                            "name": "New McSaver Chicken Nuggets (4 Pc)",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Enjoy New McSaver Chicken Nuggets (4 Pc)",
                                                            "imageId": "7bf83367ed61708817caefbc79a3c9eb",
                                                            "inStock": 1,
                                                            "price": 10381,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "161398361",
                                                                    "groupName": "Choose an option for Coke ",
                                                                    "choices": [
                                                                        {
                                                                            "id": "119686831",
                                                                            "name": "Cold Coffee ",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686829",
                                                                            "name": "Chocolate Shake ",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686830",
                                                                            "name": "Strawberry Shake ",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686836",
                                                                            "name": "Berry Cooler ",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686834",
                                                                            "name": "Iced Coffee ",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686835",
                                                                            "name": "Small Cappuccino",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686832",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686833",
                                                                            "name": "Sprite ",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "143868561",
                                                            "name": "New McSaver Masala McEgg",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Enjoy New McSaver Masala McEgg",
                                                            "imageId": "8f0cbf7d50d3f8dad87b971fb11f8d6c",
                                                            "inStock": 1,
                                                            "price": 7524,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "161398365",
                                                                    "groupName": "Choose an option for Coke ",
                                                                    "choices": [
                                                                        {
                                                                            "id": "119686831",
                                                                            "name": "Cold Coffee ",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686829",
                                                                            "name": "Chocolate Shake ",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686830",
                                                                            "name": "Strawberry Shake ",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686836",
                                                                            "name": "Berry Cooler ",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686834",
                                                                            "name": "Iced Coffee ",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686835",
                                                                            "name": "Small Cappuccino",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686832",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686833",
                                                                            "name": "Sprite ",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "143868562",
                                                            "name": "New McSaver McAloo Tikki",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Enjoy New McSaver McAloo Tikki",
                                                            "imageId": "ab4c47366f0e51ac0071f705b0f2d93e",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 10381,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "161398367",
                                                                    "groupName": "Choose an option for Coke ",
                                                                    "choices": [
                                                                        {
                                                                            "id": "119686831",
                                                                            "name": "Cold Coffee ",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686829",
                                                                            "name": "Chocolate Shake ",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686830",
                                                                            "name": "Strawberry Shake ",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686836",
                                                                            "name": "Berry Cooler ",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686834",
                                                                            "name": "Iced Coffee ",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686835",
                                                                            "name": "Small Cappuccino",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686832",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686833",
                                                                            "name": "Sprite ",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "143868570",
                                                            "name": "New McSaver Mexican McAloo Tikki",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Enjoy New McSaver Mexican McAloo Tikki",
                                                            "imageId": "5897849bed9b0298559968c3e5f4af81",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 10381,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "161398374",
                                                                    "groupName": "Choose an option for Coke ",
                                                                    "choices": [
                                                                        {
                                                                            "id": "119686831",
                                                                            "name": "Cold Coffee ",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686829",
                                                                            "name": "Chocolate Shake ",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686830",
                                                                            "name": "Strawberry Shake ",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686836",
                                                                            "name": "Berry Cooler ",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686834",
                                                                            "name": "Iced Coffee ",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686835",
                                                                            "name": "Small Cappuccino",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686832",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686833",
                                                                            "name": "Sprite ",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "143868571",
                                                            "name": "New McSaver Pizza McPuff",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Enjoy New McSaver Pizza McPuff",
                                                            "imageId": "45fa406e76418771de26c37e8863fbb3",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 10381,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "161398375",
                                                                    "groupName": "Choose an option for Coke ",
                                                                    "choices": [
                                                                        {
                                                                            "id": "119686831",
                                                                            "name": "Cold Coffee ",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686829",
                                                                            "name": "Chocolate Shake ",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686830",
                                                                            "name": "Strawberry Shake ",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686836",
                                                                            "name": "Berry Cooler ",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686834",
                                                                            "name": "Iced Coffee ",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686835",
                                                                            "name": "Small Cappuccino",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686832",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686833",
                                                                            "name": "Sprite ",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "143868572",
                                                            "name": "New McSaver Small Fries",
                                                            "category": "McSaver Combos (2pc Combos)",
                                                            "description": "Enjoy New McSaver Small Fries",
                                                            "imageId": "70771ada9c14923d9535e84d1d2fc2e0",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 10381,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "161398376",
                                                                    "groupName": "Choose an option for Coke ",
                                                                    "choices": [
                                                                        {
                                                                            "id": "119686831",
                                                                            "name": "Cold Coffee ",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686829",
                                                                            "name": "Chocolate Shake ",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686830",
                                                                            "name": "Strawberry Shake ",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686836",
                                                                            "name": "Berry Cooler ",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686834",
                                                                            "name": "Iced Coffee ",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686835",
                                                                            "name": "Small Cappuccino",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686832",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119686833",
                                                                            "name": "Sprite ",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Burger Combos ( Meals )",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "58150212",
                                                            "name": "McSpicy Chicken Burger Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Your favorite McSpicy Chicken Burger + Fries (M) + Drink of your choice.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/15/214189a0-fd53-4f83-9d18-c3e53f2c017a_70748bf8-e587-47d6-886c-9b7ac57e84b3.png",
                                                            "inStock": 1,
                                                            "price": 35143,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278639",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278640",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129301789",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "236 ratings",
                                                                    "ratingCountV2": "236"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "58150236",
                                                            "name": "Chicken Maharaja Mac Burger Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Enjoy a double decker Chicken Maharaja Mac + Fries (M) + Drink of your Choice . Order now to experience a customizable, delicious meal.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/ead090f2-5f80-4159-a335-d32658bcfc7c_8bcc5cd9-b22a-4f5d-8cde-0a2372c985c8.png",
                                                            "inStock": 1,
                                                            "price": 38476,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278664",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278665",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129301491",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.8",
                                                                    "ratingCount": "74 ratings",
                                                                    "ratingCountV2": "74"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "58150241",
                                                            "name": "McSpicy Paneer Burger Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Enjoy your favourite McSpicy Paneer Burger + Fries (M) + Drink of your Choice . Order now to experience a customizable, delicious combo",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/15/70fc7aa0-7f3b-418e-8ccd-5947b5f1aacd_055bbe77-fbe7-4200-84d3-4349475eb298.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 34191,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278709",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278711",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129301458",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.8",
                                                                    "ratingCount": "71 ratings",
                                                                    "ratingCountV2": "71"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "100815471",
                                                            "name": "McCheese Burger Chicken Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Enjoy a deliciously filling meal of McCheese Chicken Burger + Fries (M) + Beverage of your Choice in a delivery friendly, reusable bottle.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/b32eb9b3-7873-4f00-b601-0c92dd5a71ef_ec318a73-0e41-4277-8606-dc5c33b04533.png",
                                                            "inStock": 1,
                                                            "price": 38476,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278672",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278674",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129301700",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.0",
                                                                    "ratingCount": "31 ratings",
                                                                    "ratingCountV2": "31"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "58150229",
                                                            "name": "Veg Maharaja Mac Burger Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Enjoy a double decker Veg Maharaja Mac+ Fries (M) + Drink of your Choice . Order now to experience a customizable, delicious meal.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/d064fb5e-fb2e-4e1d-9515-18f26489f5b1_f6f49dba-2ae7-4ebf-8777-548c5ad4d799.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 38476,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278646",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278647",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129301427",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.5",
                                                                    "ratingCount": "111 ratings",
                                                                    "ratingCountV2": "111"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "132405957",
                                                            "name": " McSpicy Deluxe Chicken Burger Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "McSpicy Deluxe Chicken Burger + Fries (M) + Drink of your choice.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/15/925ee002-5dad-42b2-bfb3-7ae0dfa291d3_42d881c9-ebea-45f5-a91d-ce0eb4b25d2a.png",
                                                            "inStock": 1,
                                                            "price": 37048,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "132025562",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "132025563",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "132025564",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.8",
                                                                    "ratingCount": "8 ratings",
                                                                    "ratingCountV2": "8"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "58150233",
                                                            "name": "Big Spicy Chicken Wrap Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Your favorite Big Spicy Chicken Wrap + Fries (M) + Drink of your choice.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/f631f834-aec2-410d-ab9d-7636cd53d7a0_8801a3c7-ad83-4f7c-bcb0-76101fadde91.png",
                                                            "inStock": 1,
                                                            "price": 37048,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278658",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278659",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129301836",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.9",
                                                                    "ratingCount": "47 ratings",
                                                                    "ratingCountV2": "47"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "53956802",
                                                            "name": "McChicken Double Patty Burger Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Your favorite McChicken Burger double pattu burger + Fries (M) + Drink of your choice in a new, delivery friendly, resuable bottle.",
                                                            "imageId": "e8a8f43ee29a3b97d2fac37e89648eac",
                                                            "inStock": 1,
                                                            "price": 34286,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "137967250",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "137967251",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "137967252",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "1.0",
                                                                    "ratingCount": "3 ratings",
                                                                    "ratingCountV2": "3"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "60385945",
                                                            "name": "9 Pc Chicken Nuggets Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Enjoy your favorite Chicken McNuggets + Fries (M) + Drink of your choice.",
                                                            "imageId": "4c56f086e500afe6b2025f9c46846e12",
                                                            "inStock": 1,
                                                            "price": 38882,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278650",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278651",
                                                                    "groupName": "Choose an option for Mustard Sauce",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94834150",
                                                                            "name": "Barbeque Sauce",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.7",
                                                                    "ratingCount": "25 ratings",
                                                                    "ratingCountV2": "25"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713511",
                                                            "name": "McCheese Burger Veg Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Enjoy a deliciously filling meal of McCheese Veg Burger + Fries (M) + Beverage of your Choice in a delivery friendly, reusable bottle.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/22b25dd0-80ed-426b-a323-82c6b947612d_df827568-54f9-4329-af60-1fff38d105e9.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 38476,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278752",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278755",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129301484",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "11 ratings",
                                                                    "ratingCountV2": "11"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "134350421",
                                                            "name": "McSpicy Deluxe Chicken Double Patty Burger Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "McSpicy Deluxe Chicken double patty Burger + Fries (M) + Drink of your choice.",
                                                            "imageId": "6581baefa0ab6c6a7f4b99e67e1c38c0",
                                                            "inStock": 1,
                                                            "price": 42762,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "137967269",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "137967272",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "137967274",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "80576224",
                                                            "name": "McSpicy Premium Burger Chicken Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "A deliciously filling meal of McSpicy Premium Chicken Burger + Fries (M) + Drink of your choice",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/827df5ce-3efe-48bd-ae39-bfe0dec0f615_f81da671-aed0-4c84-a331-12548d700e25.png",
                                                            "inStock": 1,
                                                            "price": 38476,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278670",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278671",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129301521",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.6",
                                                                    "ratingCount": "25 ratings",
                                                                    "ratingCountV2": "25"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "53956692",
                                                            "name": "McSpicy Chicken Double Patty Burger combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Your favorite McSpicy Chicken double patty Burger + Fries (M) + Drink of your choice.",
                                                            "imageId": "91ed96b67df6e630a6830fc2e857b5b1",
                                                            "inStock": 1,
                                                            "price": 40857,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "137967259",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "137967260",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "137967261",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "58150136",
                                                            "name": "McChicken Burger Happy Meal",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Enjoy a combo of McChicken Burger + Sweet Corn + B Natural Mixed Fruit Beverage + Book",
                                                            "imageId": "2b7356d14d1c9dc38d20ab8a30247834",
                                                            "inStock": 1,
                                                            "price": 32953,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278666",
                                                                    "groupName": "Choose an option for Happy Meal Book",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044249",
                                                                            "name": "Happy Meal Book",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278667",
                                                                    "groupName": "Choose an option for Mixed Fruit Beverage",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044264",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044263",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044258",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044259",
                                                                            "name": "Fanta (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044260",
                                                                            "name": "Coke (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044261",
                                                                            "name": "Mixed Berry Smoothie",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044262",
                                                                            "name": "Indie Mango Smoothie",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044253",
                                                                            "name": "Ice Coffee (S)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044254",
                                                                            "name": "American Mud Pie Shake",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044255",
                                                                            "name": "Classic Coffee (R)",
                                                                            "price": 14500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044256",
                                                                            "name": "Chocolate Frappe  (S)",
                                                                            "price": 19500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044257",
                                                                            "name": "Berry Lemonade Regular",
                                                                            "price": 5400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044252",
                                                                            "name": "Sprite (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.9",
                                                                    "ratingCount": "19 ratings",
                                                                    "ratingCountV2": "19"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "132405958",
                                                            "name": "McSpicy Deluxe Paneer Burger Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "McSpicy Deluxe paneer Burger + Fries (M) + Drink of your choice.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/15/72abe84e-7e1d-4bbe-aa2d-a6de6753df3d_60e7e353-1fb1-4365-a6c4-aa4834198570.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 36095,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "132025565",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "132025566",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "132025567",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "117965854",
                                                            "name": "Jain Meal - McCheese Burger Veg Combo ",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Enjoy a combo of the Jain friendly, McCheese Burger Veg, Classic corn, Cheese Dip, McFlurry Oreo (Small) with a beverage of your choice in a delivery friendly, resuable bottle.",
                                                            "imageId": "49e13df87ab3602afa703792ee63fcd3",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 41584,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278662",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.9",
                                                                    "ratingCount": "4 ratings",
                                                                    "ratingCountV2": "4"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "58150237",
                                                            "name": "Big Spicy Paneer Wrap Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Your favorite Big Spicy Paneer Wrap + Fries (M) + Drink of your choice.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/116148a2-7f56-44af-bdd0-6bbb46f48baa_355bbd20-86d4-49b8-b3a9-d290772a9676.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 36095,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278642",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278643",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129301797",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.9",
                                                                    "ratingCount": "35 ratings",
                                                                    "ratingCountV2": "35"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "60386057",
                                                            "name": "Chicken McNuggets 6 Pcs Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Enjoy your favorite Chicken McNuggets + Fries (M) + Drink of your choice.",
                                                            "imageId": "6e7f9411ed67fe8d8873734af1e8d4e9",
                                                            "inStock": 1,
                                                            "price": 34858,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278698",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278699",
                                                                    "groupName": "Choose an option for Mustard Sauce",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94834150",
                                                                            "name": "Barbeque Sauce",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "13 ratings",
                                                                    "ratingCountV2": "13"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "53956807",
                                                            "name": "McVeggie Double Patty Burger Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Enjoy a combo of McVeggie double patty burer + Fries (M) + Drink of your Choice in a new, delivery friendly, resuable bottle.",
                                                            "imageId": "b13dfa207df1045eae030442555fb69c",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 33810,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "137967289",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "137967293",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "137967294",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "115128753",
                                                            "name": "Corn & cheese Burger Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Enjoy a combo of Corn & Cheese Burger + Fries (M) + Coke . Order now to experience a customizable, delicious meal.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/c8839f22-e525-44bb-8a50-8ee7cffecd26_cf4c0bcf-c1b9-4c0e-9109-03eb86abf4dd.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 28857,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "144944213",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "144944214",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "144944216",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.8",
                                                                    "ratingCount": "10 ratings",
                                                                    "ratingCountV2": "10"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "115128756",
                                                            "name": "Grilled Cheese and Chicken Burger Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Enjoy a combo of Grilled Chicken & Cheese Burger + Fries (M) + Coke . Order now to experience a customizable, delicious meal.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/f6813404-54a4-492b-a03a-cf32d00ee1ae_c98c4761-69eb-4503-bde3-dffaafd43b15.png",
                                                            "inStock": 1,
                                                            "price": 30381,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278648",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278649",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129301720",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.4",
                                                                    "ratingCount": "4 ratings",
                                                                    "ratingCountV2": "4"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "80576228",
                                                            "name": "McSpicy Premium Burger Veg Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "A deliciously filling meal of McSpicy Premium Veg Burger + Fries (M) + Drink of your choice",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/0469bd9c-863b-4fd8-b1c6-ddb9955f7ff1_5b922e42-8308-48d1-820f-bdf4ff8a7a68.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 38476,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278678",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278681",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129301825",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "5.0",
                                                                    "ratingCount": "8 ratings",
                                                                    "ratingCountV2": "8"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "58150137",
                                                            "name": "McVeggie Burger Happy Meal",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Enjoy a combo of McVeggie Burger + Sweet Corn + B Natural Mixed Fruit Beverage + Book",
                                                            "imageId": "ca05cb0597101eb8357cda385b92b584",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 30667,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278701",
                                                                    "groupName": "Choose an option for Happy Meal Book",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044249",
                                                                            "name": "Happy Meal Book",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278702",
                                                                    "groupName": "Choose an option for Mixed Fruit Beverage",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044264",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044263",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044258",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044259",
                                                                            "name": "Fanta (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044260",
                                                                            "name": "Coke (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044261",
                                                                            "name": "Mixed Berry Smoothie",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044262",
                                                                            "name": "Indie Mango Smoothie",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044253",
                                                                            "name": "Ice Coffee (S)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044254",
                                                                            "name": "American Mud Pie Shake",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044255",
                                                                            "name": "Classic Coffee (R)",
                                                                            "price": 14500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044256",
                                                                            "name": "Chocolate Frappe  (S)",
                                                                            "price": 19500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044257",
                                                                            "name": "Berry Lemonade Regular",
                                                                            "price": 5400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044252",
                                                                            "name": "Sprite (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "2.1",
                                                                    "ratingCount": "5 ratings",
                                                                    "ratingCountV2": "5"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "126294829",
                                                            "name": "4 Pc Chicken Nuggets Happy Meal",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Enjoy a combo of  4 Pc Chicken Nuggets + Sweet Corn+ B Natural Mixed Fruit Beverage + Book",
                                                            "imageId": "d85f06a7806ccad6994a3a4badf90135",
                                                            "inStock": 1,
                                                            "price": 26762,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278660",
                                                                    "groupName": "Choose an option for Happy Meal Book",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044249",
                                                                            "name": "Happy Meal Book",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278661",
                                                                    "groupName": "Choose an option for Mixed Fruit Beverage",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044264",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044263",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044258",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044259",
                                                                            "name": "Fanta (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044260",
                                                                            "name": "Coke (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044261",
                                                                            "name": "Mixed Berry Smoothie",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044262",
                                                                            "name": "Indie Mango Smoothie",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044253",
                                                                            "name": "Ice Coffee (S)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044254",
                                                                            "name": "American Mud Pie Shake",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044255",
                                                                            "name": "Classic Coffee (R)",
                                                                            "price": 14500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044256",
                                                                            "name": "Chocolate Frappe  (S)",
                                                                            "price": 19500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044257",
                                                                            "name": "Berry Lemonade Regular",
                                                                            "price": 5400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044252",
                                                                            "name": "Sprite (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "53956835",
                                                            "name": "McAloo Tikki Double Patty Burger Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Enjoy a delicious combo of McAloo Tikki Burger double patty burger + Fries (M) + Beverage of your choice in a new, delivery friendly, reusable bottle.",
                                                            "imageId": "1bcd9724fca70871a0e1fdc298c1f0e0",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 22381,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "137967244",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "137967245",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "137967246",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "67553370",
                                                            "name": "Masala McEgg Burger Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Enjoy a combo of Masala McEgg + Fries (M) + Drink of your Choice . Order now to experience a customizable, delicious meal.",
                                                            "imageId": "4f474c833930fa31d08ad2feed3414d8",
                                                            "inStock": 1,
                                                            "price": 22667,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278735",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278737",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129301612",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "123193894",
                                                            "name": "Mcspicy Fried Chicken Combo.",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Enjoy the new McSpicy Fried chicken + Fries (M) + Drink of your choice",
                                                            "imageId": "2bc1f7542c53c75ee548e5bdd5061742",
                                                            "inStock": 1,
                                                            "price": 22000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "106302970",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "126294828",
                                                            "name": "2 Pc Chicken Nuggets Happy Meal",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Enjoy a combo of  2 Pc Chicken Nuggets + Sweet Corn+ B Natural Mixed Fruit Beverage + Book",
                                                            "imageId": "78924991d845b01f4413bafd169fb8bc",
                                                            "inStock": 1,
                                                            "price": 22000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278746",
                                                                    "groupName": "Choose an option for Happy Meal Book",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044249",
                                                                            "name": "Happy Meal Book",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278747",
                                                                    "groupName": "Choose an option for Mixed Fruit Beverage",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044264",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044263",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044258",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044259",
                                                                            "name": "Fanta (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044260",
                                                                            "name": "Coke (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044261",
                                                                            "name": "Mixed Berry Smoothie",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044262",
                                                                            "name": "Indie Mango Smoothie",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044253",
                                                                            "name": "Ice Coffee (S)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044254",
                                                                            "name": "American Mud Pie Shake",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044255",
                                                                            "name": "Classic Coffee (R)",
                                                                            "price": 14500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044256",
                                                                            "name": "Chocolate Frappe  (S)",
                                                                            "price": 19500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044257",
                                                                            "name": "Berry Lemonade Regular",
                                                                            "price": 5400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044252",
                                                                            "name": "Sprite (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "58150141",
                                                            "name": "McAloo Tikki Burger Happy Meal",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Enjoy a combo of McAloo Tikki Burger + Sweet Corn + B Natural Mixed Fruit Beverage + Book",
                                                            "imageId": "98b4674a979d6faf528f05e65e6799f2",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 21334,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278740",
                                                                    "groupName": "Choose an option for Happy Meal Book",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044249",
                                                                            "name": "Happy Meal Book",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278742",
                                                                    "groupName": "Choose an option for Mixed Fruit Beverage",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044264",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044263",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044258",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044259",
                                                                            "name": "Fanta (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044260",
                                                                            "name": "Coke (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044261",
                                                                            "name": "Mixed Berry Smoothie",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044262",
                                                                            "name": "Indie Mango Smoothie",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044253",
                                                                            "name": "Ice Coffee (S)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044254",
                                                                            "name": "American Mud Pie Shake",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044255",
                                                                            "name": "Classic Coffee (R)",
                                                                            "price": 14500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044256",
                                                                            "name": "Chocolate Frappe  (S)",
                                                                            "price": 19500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044257",
                                                                            "name": "Berry Lemonade Regular",
                                                                            "price": 5400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044252",
                                                                            "name": "Sprite (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.8",
                                                                    "ratingCount": "11 ratings",
                                                                    "ratingCountV2": "11"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "54781517",
                                                            "name": "Mexican McAloo Tikki Double Patty Burger Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Enjoy the Mexican McAloo Tikki burger with double patty + Fries (M) + Coke (M)",
                                                            "imageId": "6bfe589298fbd3dc6d5fcebf35cad1c2",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 24286,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "141162366",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "141162367",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "141162368",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "78479522",
                                                            "name": "Birthday Party Package - McChicken",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "5 McChicken Burger + 5 Sweet Corn + 5 B Natural Mixed Fruit Beverage + 5 Soft Serve (M) + Book",
                                                            "imageId": "31da1776bf9e74beea809aadc61cf1da",
                                                            "inStock": 1,
                                                            "price": 221144,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278717",
                                                                    "groupName": "Choose an option for Happy Meal Book",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044249",
                                                                            "name": "Happy Meal Book",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278719",
                                                                    "groupName": "Choose an option for Mixed Fruit Beverage",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044264",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044263",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044258",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044259",
                                                                            "name": "Fanta (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044260",
                                                                            "name": "Coke (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044261",
                                                                            "name": "Mixed Berry Smoothie",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044262",
                                                                            "name": "Indie Mango Smoothie",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044253",
                                                                            "name": "Ice Coffee (S)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044254",
                                                                            "name": "American Mud Pie Shake",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044255",
                                                                            "name": "Classic Coffee (R)",
                                                                            "price": 14500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044256",
                                                                            "name": "Chocolate Frappe  (S)",
                                                                            "price": 19500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044257",
                                                                            "name": "Berry Lemonade Regular",
                                                                            "price": 5400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044252",
                                                                            "name": "Sprite (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "78479523",
                                                            "name": "Birthday Party Package - McVeggie",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "5 McVeggie Burger + 5 Sweet Corn + 5 B Natural Mixed Fruit Beverage + 5 Soft Serve (M) + Book",
                                                            "imageId": "567411605ac9c72680aa742e17fb83d5",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 221144,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278724",
                                                                    "groupName": "Choose an option for Happy Meal Book",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044249",
                                                                            "name": "Happy Meal Book",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278726",
                                                                    "groupName": "Choose an option for Mixed Fruit Beverage",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044264",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044263",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044258",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044259",
                                                                            "name": "Fanta (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044260",
                                                                            "name": "Coke (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044261",
                                                                            "name": "Mixed Berry Smoothie",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044262",
                                                                            "name": "Indie Mango Smoothie",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044253",
                                                                            "name": "Ice Coffee (S)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044254",
                                                                            "name": "American Mud Pie Shake",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044255",
                                                                            "name": "Classic Coffee (R)",
                                                                            "price": 14500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044256",
                                                                            "name": "Chocolate Frappe  (S)",
                                                                            "price": 19500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044257",
                                                                            "name": "Berry Lemonade Regular",
                                                                            "price": 5400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044252",
                                                                            "name": "Sprite (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "78479524",
                                                            "name": "McEgg Burger Happy Meal",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Enjoy a combo of McEgg Burger  + Sweet Corn + B Natural Mixed Fruit Beverage + Book",
                                                            "imageId": "7a328a58de3b5e209116682223e5d94d",
                                                            "inStock": 1,
                                                            "price": 23905,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129278696",
                                                                    "groupName": "Choose an option for Happy Meal Book",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044249",
                                                                            "name": "Happy Meal Book",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "129278697",
                                                                    "groupName": "Choose an option for Mixed Fruit Beverage",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044264",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044263",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044258",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 7500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044259",
                                                                            "name": "Fanta (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044260",
                                                                            "name": "Coke (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044261",
                                                                            "name": "Mixed Berry Smoothie",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044262",
                                                                            "name": "Indie Mango Smoothie",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044253",
                                                                            "name": "Ice Coffee (S)",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044254",
                                                                            "name": "American Mud Pie Shake",
                                                                            "price": 13100,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044255",
                                                                            "name": "Classic Coffee (R)",
                                                                            "price": 14500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044256",
                                                                            "name": "Chocolate Frappe  (S)",
                                                                            "price": 19500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044257",
                                                                            "name": "Berry Lemonade Regular",
                                                                            "price": 5400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110044252",
                                                                            "name": "Sprite (R)",
                                                                            "price": 800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "143868524",
                                                            "name": " Chicken Surprise Burger Combo",
                                                            "category": "Burger Combos ( Meals )",
                                                            "description": "Chicken Surprise Burger Combo + Fries (M) + Drink of your choice.",
                                                            "imageId": "68ebd939ee4f17d0d5346a7b5fba5ef7",
                                                            "inStock": 1,
                                                            "price": 23714,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "161398340",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "161398341",
                                                                    "groupName": "Choose an option for Nothing for Today",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110044250",
                                                                            "name": "Mcflurry Oreo ( S )",
                                                                            "price": 9400,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293558",
                                                                            "name": "Vanilla Chocolate Muffin",
                                                                            "price": 12900,
                                                                            "inStock": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293556",
                                                                            "name": "Chocochip Muffin",
                                                                            "price": 14200,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "161398342",
                                                                    "groupName": "Choose an option for Fries (Medium)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "110047291",
                                                                            "name": "Fries (Large)",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "110047289",
                                                                            "name": "Mexican Cheese Fries",
                                                                            "price": 3800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Fries & Sides",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "65329669",
                                                            "name": "Fries (Medium)",
                                                            "category": "Fries & Sides",
                                                            "description": "World Famous Fries, crispy, golden, lightly salted and fried to perfection! Also known as happiness.",
                                                            "imageId": "8a61e7fd97c454ea14d0750859fcebb8",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 11905,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.0",
                                                                    "ratingCount": "340 ratings",
                                                                    "ratingCountV2": "340"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "58150151",
                                                            "name": "Piri Piri Spice Mix",
                                                            "category": "Fries & Sides",
                                                            "description": "The perfect, taste bud tingling partner for our World Famous Fries. Shake Shake, and dive in!",
                                                            "imageId": "df3edfc74f610edff535324cc53a362a",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 2381,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "1707 ratings",
                                                                    "ratingCountV2": "1707"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "58150175",
                                                            "name": "Veg Pizza McPuff",
                                                            "category": "Fries & Sides",
                                                            "description": "Crispy brown crust with a generous filling of rich tomato sauce, mixed with carrots, bell peppers, beans, onions and mozzarella. Served HOT.",
                                                            "imageId": "abe4b8cdf0f1bbfd1b9a7a05be3413e8",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 5905,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.0",
                                                                    "ratingCount": "757 ratings",
                                                                    "ratingCountV2": "757"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "65329670",
                                                            "name": "Fries (Large)",
                                                            "category": "Fries & Sides",
                                                            "description": "World Famous Fries, crispy, golden, lightly salted and fried to perfection! Also known as happiness.",
                                                            "imageId": "a4b3002d0ea35bde5e5983f40e4ebfb4",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 13905,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "503 ratings",
                                                                    "ratingCountV2": "503"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "68261451",
                                                            "name": "9 Pc Chicken Nuggets",
                                                            "category": "Fries & Sides",
                                                            "description": "9 pieces of our iconic crispy, golden fried Chicken McNuggets!",
                                                            "imageId": "1ca7abb262e8880f5cb545d0d2f9bb9b",
                                                            "inStock": 1,
                                                            "price": 20858,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150727115",
                                                                    "groupName": "Choose an option for Mustard Sauce",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94834150",
                                                                            "name": "Barbeque Sauce",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "97 ratings",
                                                                    "ratingCountV2": "97"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "68261457",
                                                            "name": "6 Pc Chicken Nuggets",
                                                            "category": "Fries & Sides",
                                                            "description": "6 pieces of our iconic crispy, golden fried Chicken McNuggets!",
                                                            "imageId": "44dc10c1099d7c366db9f5ce776878bd",
                                                            "inStock": 1,
                                                            "price": 17715,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150726717",
                                                                    "groupName": "Choose an option for Mustard Sauce",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94834150",
                                                                            "name": "Barbeque Sauce",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "79 ratings",
                                                                    "ratingCountV2": "79"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "116486555",
                                                            "name": "20 Pc Chicken Nuggets",
                                                            "category": "Fries & Sides",
                                                            "description": "20 pieces of our iconic crispy, golden fried Chicken McNuggets!",
                                                            "imageId": "1ca7abb262e8880f5cb545d0d2f9bb9b",
                                                            "inStock": 1,
                                                            "price": 42383,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150726906",
                                                                    "groupName": "Choose an option for Mustard Sauce",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94834150",
                                                                            "name": "Barbeque Sauce",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "4 ratings",
                                                                    "ratingCountV2": "4"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "67458864",
                                                            "name": "Tomato Ketchup Sachet",
                                                            "category": "Fries & Sides",
                                                            "description": "Looking for a sauce to complement your meal? Look no further.",
                                                            "imageId": "7db5533db29a4e9d2cc033f35c5572bc",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 95,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "77 ratings",
                                                                    "ratingCountV2": "77"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "65329668",
                                                            "name": "Fries (Regular)",
                                                            "category": "Fries & Sides",
                                                            "description": "World Famous Fries, crispy, golden, lightly salted and fried to perfection! Also known as happiness.",
                                                            "imageId": "5a18fbbff67076c9a4457a6b220a55d9",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 8571,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.5",
                                                                    "ratingCount": "264 ratings",
                                                                    "ratingCountV2": "264"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112620564",
                                                            "name": "Classic Cheese Fries",
                                                            "category": "Fries & Sides",
                                                            "description": "The world famous, crispy golden Fries, served with delicious cheese sauce with a hint of spice. Contains cheese & mayonnaise",
                                                            "imageId": "f13f7c1db7b7fda89c86e84e98dc1d29",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 15714,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.5",
                                                                    "ratingCount": "30 ratings",
                                                                    "ratingCountV2": "30"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112620498",
                                                            "name": "Fries (M) + Piri Piri Mix",
                                                            "category": "Fries & Sides",
                                                            "description": "Flat 15% Off on Fries (M) + Piri Piri Mix",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/7f31c10d-b2a7-4611-8b0e-ac9324460fd0_4ec1b62d-543f-4e35-8e9d-8c156d470ef4.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 12095,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.9",
                                                                    "ratingCount": "36 ratings",
                                                                    "ratingCountV2": "36"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "126294856",
                                                            "name": "Salsa Cheese Fries",
                                                            "category": "Fries & Sides",
                                                            "description": "The world famous, crispy, golden Fries, served with rich cheese sauce and a tangy twist of salsa",
                                                            "imageId": "319bffa6b4a2045961e09585cd5988a0",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 13524,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.9",
                                                                    "ratingCount": "3 ratings",
                                                                    "ratingCountV2": "3"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "123193882",
                                                            "name": "4 Pcs Chicken Nuggets",
                                                            "category": "Fries & Sides",
                                                            "description": "4 pieces of our iconic crispy, golden fried Chicken McNuggets!",
                                                            "imageId": "44dc10c1099d7c366db9f5ce776878bd",
                                                            "inStock": 1,
                                                            "price": 11048,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.6",
                                                                    "ratingCount": "12 ratings",
                                                                    "ratingCountV2": "12"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "123193915",
                                                            "name": "Mustard Sauce",
                                                            "category": "Fries & Sides",
                                                            "description": "Looking for a sauce to complement your meal? Look no further.",
                                                            "imageId": "6c3aeffdbd544ea3ceae1e4b8ce3fc43",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 1905,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.5",
                                                                    "ratingCount": "10 ratings",
                                                                    "ratingCountV2": "10"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112620491",
                                                            "name": "Classic Corn Cup",
                                                            "category": "Fries & Sides",
                                                            "description": "A delicious side of golden sweet kernels of corn in a cup",
                                                            "imageId": "9d67eae020425c4413acaf5af2a29dce",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 9048,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "5.0",
                                                                    "ratingCount": "4 ratings",
                                                                    "ratingCountV2": "4"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "69669709",
                                                            "name": "Chilli Sauce Sachet",
                                                            "category": "Fries & Sides",
                                                            "description": "Looking for a sauce to complement your meal? Look no further.",
                                                            "imageId": "f708dfc29c9624d8aef6e6ec30bde1c9",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 190,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.5",
                                                                    "ratingCount": "40 ratings",
                                                                    "ratingCountV2": "40"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "123193873",
                                                            "name": "Barbeque Sauce",
                                                            "category": "Fries & Sides",
                                                            "description": "Looking for a sauce to complement your meal? Look no further.",
                                                            "imageId": "ba0a188d45aecc3d4d187f340ea9df54",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 1905,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.7",
                                                                    "ratingCount": "23 ratings",
                                                                    "ratingCountV2": "23"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Match Time Sharing Combos",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "102107203",
                                                            "name": "McSpicy Chicken Burger + McChicken Burger + Fries (M)",
                                                            "category": "Match Time Sharing Combos",
                                                            "description": "Flat 15% Off on McSpicy Chicken Burger + McChicken Burger + Fries (M)",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/5/8c87d83a-310b-44b3-84ce-79cbb310bc16_96c8bb84-bce1-4948-a5f0-e74f5e9a94f8.png",
                                                            "inStock": 1,
                                                            "price": 43714,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "22 ratings",
                                                                    "ratingCountV2": "22"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "123193870",
                                                            "name": "2 Chicken Maharaja Mac Burger + 2 Coke + Fries (L) + McFlurry Oreo (M)",
                                                            "category": "Match Time Sharing Combos",
                                                            "description": "Enjoy 2 of the tallest burgers innovated by us. Created with chunky juicy grilled chicken patty paired along with fresh ingredients like jalapeno, onion, slice of cheese, tomatoes & crunchy lettuce dressed with the classical Habanero sauce. Served with Coke, Large Fries and a medium McFlurry Oreo",
                                                            "imageId": "65c9c9b82c4d1f77a05dc4d89c9ead1d",
                                                            "inStock": 1,
                                                            "price": 59334,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150726702",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "118027865",
                                                            "name": "Burger Combo for 2: McSpicy Chicken Burger ",
                                                            "category": "Match Time Sharing Combos",
                                                            "description": "Save big on your favourite sharing combo - 2 McSpicy Chicken Burger + Fries (L) + 2 Coke",
                                                            "imageId": "98afaf26d81b15bec74cc356fe60cc13",
                                                            "inStock": 1,
                                                            "price": 48953,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150727153",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "63149161",
                                                            "name": "6 Pc Chicken Nuggets + McChicken Burger + Coke",
                                                            "category": "Match Time Sharing Combos",
                                                            "description": "Tender and juicy chicken patty cooked to perfection, with creamy mayonnaise and crunchy lettuce adding flavour to each bite. Served with 6 Pc Nuggets and Coke.",
                                                            "imageId": "934194567f9c231dc46dccf2d4e6d415",
                                                            "inStock": 1,
                                                            "price": 35810,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150727017",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "150727019",
                                                                    "groupName": "Choose an option for Mustard Sauce",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94834150",
                                                                            "name": "Barbeque Sauce",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.4",
                                                                    "ratingCount": "147 ratings",
                                                                    "ratingCountV2": "147"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713361",
                                                            "name": "Corn & Cheese Burger +McVeggie Burger+Fries (M)",
                                                            "category": "Match Time Sharing Combos",
                                                            "description": "Flat 15% Off on Corn & Cheese Burger +McVeggie Burger+Fries (M)",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/15/08e9bc73-6774-41cf-96bb-ca817c4e23d3_e00ec89e-86f8-4531-956a-646082dc294c.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 39143,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "13 ratings",
                                                                    "ratingCountV2": "13"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "117965859",
                                                            "name": "McVeggie Burger + 2 Fries (M) + McAloo Tikki+ Veg Pizza McPuff",
                                                            "category": "Match Time Sharing Combos",
                                                            "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - McVeggie Burger + 2 Fries (M) + McAloo Tikki Burger + Veg Pizza McPuff",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/5/d26c6bc2-7a4f-4ff3-a3e1-c0033302cdd4_d67286a3-7da9-402f-a921-269fc38fdccb.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 39143,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "18 ratings",
                                                                    "ratingCountV2": "18"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "136748449",
                                                            "name": "Burger Combo for 2: McSpicy Deluxe Chicken Burger",
                                                            "category": "Match Time Sharing Combos",
                                                            "description": "Save upto 24% off on your favorite sharing combo of 2 McSpicy Deluxe Chicken Burger + Fries (L) + 2 Coke (Serves 2)",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/a7aa30c4-da8c-4155-9152-78dda1f86d78_1c8693d2-38fb-4699-b1b6-6b1ccb555a4f.png",
                                                            "inStock": 1,
                                                            "price": 49901,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "144255839",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "118027863",
                                                            "name": "Burger Combo for 2: McChicken Burger ",
                                                            "category": "Match Time Sharing Combos",
                                                            "description": "Save big on your favourite sharing combo - 2 McChicken Burger + Fries (L) + 2 Coke",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/ecb1cc16-8f97-4322-8359-0acad29ede85_a03665c2-bbcc-43af-bc1f-4de7ce55ee4d.png",
                                                            "inStock": 1,
                                                            "price": 42667,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150726820",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.6",
                                                                    "ratingCount": "8 ratings",
                                                                    "ratingCountV2": "8"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "117965852",
                                                            "name": "Burger Combo for 2: McSpicy Chicken Burger with Pizza McPuff",
                                                            "category": "Match Time Sharing Combos",
                                                            "description": "Save big on your favourite sharing combo- 2 McSpicy Chicken Burger + 2 Fries (M) + Veg Pizza McPuff",
                                                            "imageId": "e62aea3ba1cd5585a76004f59cd991e5",
                                                            "inStock": 1,
                                                            "price": 49048,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "125284324",
                                                            "name": "Burger Combo for 2: Grilled Chicken & Cheese",
                                                            "category": "Match Time Sharing Combos",
                                                            "description": "Save big on your favourite sharing combo - 2 Grilled Chicken and Cheese Burger + Fries (L) + 2 Coke",
                                                            "imageId": "1166a8baa3066342affb829ef0c428dd",
                                                            "inStock": 1,
                                                            "price": 46953,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "130979725",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "3 ratings",
                                                                    "ratingCountV2": "3"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "117965857",
                                                            "name": "McSpicy Fried Chicken - 2 Pc + 2 Fries (M)	 	+ McSpicy Chicken Burger",
                                                            "category": "Match Time Sharing Combos",
                                                            "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - McSpicy Fried Chicken - 2 Pc + 2 Fries (M) + McSpicy Chicken Burger",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/5/90a0df80-6932-43dc-a057-ba98e3b7c4c5_58a2d7bc-d24c-4cb8-ab96-7dac38e5f64c.png",
                                                            "inStock": 1,
                                                            "price": 43905,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "136748450",
                                                            "name": "Burger Combo for 2: McSpicy Deluxe Paneer Burger",
                                                            "category": "Match Time Sharing Combos",
                                                            "description": "Save upto 24% off on your favorite sharing combo of 2 McSpicy Deluxe Paneer Burger + Fries (L) + 2 Coke (Serves 2)",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/67f01168-b4a0-4f99-aa13-4da0b492b913_67d42161-a5ad-4249-ade7-6169a184f534.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 54953,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "144255843",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "117965851",
                                                            "name": "Burger Combo for 2: McChicken Burger with Pizza McPuff",
                                                            "category": "Match Time Sharing Combos",
                                                            "description": "Save big on your favourite sharing combo - 2 McChicken Burger + 2 Fries (M) + Veg Pizza McPuff",
                                                            "imageId": "b57153898abed2127d7217c2ee3e9e4b",
                                                            "inStock": 1,
                                                            "price": 38762,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.2",
                                                                    "ratingCount": "22 ratings",
                                                                    "ratingCountV2": "22"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "52431077",
                                                            "name": "2 McAloo Tikki Burger + 2 Fries (L)",
                                                            "category": "Match Time Sharing Combos",
                                                            "description": "Stay home, stay safe and share a combo- 2 McAloo Tikki Burgers + 2 Fries (L)",
                                                            "imageId": "ea7ba594c7d77cb752de9a730fbcb3bf",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 32984,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.4",
                                                                    "ratingCount": "92 ratings",
                                                                    "ratingCountV2": "92"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "117965858",
                                                            "name": "McSpicy Paneer Burger + 2 Fries M + McAloo Tikki + Veg Pizza McPuff",
                                                            "category": "Match Time Sharing Combos",
                                                            "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - McSpicy Paneer Burger  + 2 Fries (M) + McAloo Tikki Burger + Veg Pizza McPuff",
                                                            "imageId": "0ea8a2fddbbc17bc6239a9104963a3e8",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 38762,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.5",
                                                                    "ratingCount": "4 ratings",
                                                                    "ratingCountV2": "4"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "125284323",
                                                            "name": "Burger Combo for 2: Corn & Cheese Burger",
                                                            "category": "Match Time Sharing Combos",
                                                            "description": "Save big on your favourite sharing combo - 2 Corn and Cheese Burger + Fries (L) + 2 Coke",
                                                            "imageId": "847b562672e71c2352d92b797c0b0a4e",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 41905,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150726842",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "118027868",
                                                            "name": "Burger Combo for 2: McVeggie Burger ",
                                                            "category": "Match Time Sharing Combos",
                                                            "description": "Save big on your favourite sharing combo - 2 McVeggie Burger + Fries (L) + 2 Coke",
                                                            "imageId": "09b3cb6130cfae15d486223c313fb6c6",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 38762,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150727092",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.0",
                                                                    "ratingCount": "6 ratings",
                                                                    "ratingCountV2": "6"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "117965853",
                                                            "name": "Burger Combo for 2: McVeggie Burger with Pizza McPuff",
                                                            "category": "Match Time Sharing Combos",
                                                            "description": "Save big on your favourite sharing combo - 2 McVeggie Burger + 2 Fries (M) + Veg Pizza McPuff",
                                                            "imageId": "1ff73fc5aa656a10da5801469da3327a",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 45905,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.6",
                                                                    "ratingCount": "7 ratings",
                                                                    "ratingCountV2": "7"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "118027870",
                                                            "name": "McSpicy Paneer Burger + McAloo Tikki Burger + Fries (L) + 2 Coke",
                                                            "category": "Match Time Sharing Combos",
                                                            "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - McSpicy Paneer Burger + Fries (L) + 2 Coke + McAloo Tikki Burger",
                                                            "imageId": "642ae100416c13ce1c4c2d61c44026a1",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 38858,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150726643",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "118027875",
                                                            "name": "McVeggie Burger + McAloo Tikki Burger + Fries (L) + 2 Coke",
                                                            "category": "Match Time Sharing Combos",
                                                            "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - McVeggie Burger + Fries (L) + 2 Coke + McAloo Tikki Burger",
                                                            "imageId": "d2381b84780fb273c2e7b868410a22cc",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 33715,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "130979718",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.5",
                                                                    "ratingCount": "3 ratings",
                                                                    "ratingCountV2": "3"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Burgers & Wraps",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "58150150",
                                                            "name": "McVeggie Burger",
                                                            "category": "Burgers & Wraps",
                                                            "description": "Savour your favorite spiced veggie patty, lettuce, mayo, between toasted sesame buns in every bite",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/2cf63c01-fef1-49b6-af70-d028bc79be7b_bfe88b73-33a9-489c-97f3-fb24631de1fc.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 14914,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.0",
                                                                    "ratingCount": "835 ratings",
                                                                    "ratingCountV2": "835"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "58150206",
                                                            "name": "McChicken Burger",
                                                            "category": "Burgers & Wraps",
                                                            "description": "Enjoy the classic, tender chicken patty with creamy mayonnaise and lettuce in every bite",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/c093ba63-c4fe-403e-811a-dc5da0fa6661_f2ad8e1e-5162-4cf8-8dab-5cc5208cdb85.png",
                                                            "inStock": 1,
                                                            "price": 14165,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.8",
                                                                    "ratingCount": "962 ratings",
                                                                    "ratingCountV2": "962"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "58150140",
                                                            "name": "McAloo Tikki Burger",
                                                            "category": "Burgers & Wraps",
                                                            "description": "The World's favourite Indian burger! A crispy Aloo patty, tomato mayo sauce & onions",
                                                            "imageId": "b13811eeee71e578bc6ca89eca0ec87f",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 6952,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "777 ratings",
                                                                    "ratingCountV2": "777"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "58150213",
                                                            "name": "Grilled Chicken & Cheese Burger",
                                                            "category": "Burgers & Wraps",
                                                            "description": "A grilled chicken patty, topped with sliced cheese, spicy Habanero sauce, with some heat from jalapenos & crunch from onions",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/55a77d9e-cc28-4853-89c8-1ba3861f38c4_a378aafc-62b3-4328-a255-0f35f810966e.png",
                                                            "inStock": 1,
                                                            "price": 16857,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isGuiltfree": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.8",
                                                                    "ratingCount": "169 ratings",
                                                                    "ratingCountV2": "169"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713347",
                                                            "name": "Chicken Maharaja Mac Burger",
                                                            "category": "Burgers & Wraps",
                                                            "description": "Savor our filling 11 layer burger! Double the indulgence with 2 juicy grilled chicken patties, along with jalape\xf1os, onion, cheese, tomatoes, lettuce, and zesty Habanero sauce. ",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/65a88cf4-7bcd-40f6-a09d-ec38c307c5d9_8993ea5b-f8e0-4d6c-9691-7f85adee2000.png",
                                                            "inStock": 1,
                                                            "price": 25429,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "24 ratings",
                                                                    "ratingCountV2": "24"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "58150234",
                                                            "name": "Mexican McAloo Tikki Burger",
                                                            "category": "Burgers & Wraps",
                                                            "description": "Your favourite McAloo Tikki with a fusion spin with a Chipotle sauce & onions",
                                                            "imageId": "167aeccf27bab14940fa646c8328b1b4",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 7238,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.8",
                                                                    "ratingCount": "495 ratings",
                                                                    "ratingCountV2": "495"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "117965855",
                                                            "name": "McCheese Burger Veg",
                                                            "category": "Burgers & Wraps",
                                                            "description": "Find pure indulgence in our Veg McCheese Burger, featuring a sinfully oozing cheesy veg patty, roasted chipotle sauce, jalapenos & lettuce.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/de84d4cc-6169-4235-942e-e4883a81c2e0_d90762c6-283f-46e5-a6ed-14ee3262bae0.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 26190,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.1",
                                                                    "ratingCount": "27 ratings",
                                                                    "ratingCountV2": "27"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "57683215",
                                                            "name": "Veg Maharaja Mac Burger",
                                                            "category": "Burgers & Wraps",
                                                            "description": "Savor our filling 11 layer burger! Double the indulgence with 2 corn & cheese patties, along with jalape\xf1os, onion, cheese, tomatoes, lettuce, and spicy Cocktail sauce. ",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/06354d09-be1b-406c-86b5-49dc9b5062d1_2f80f39e-c951-4ca6-8fca-a243a18c3448.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 23562,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.6",
                                                                    "ratingCount": "113 ratings",
                                                                    "ratingCountV2": "113"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "58150227",
                                                            "name": "Corn & Cheese Burger",
                                                            "category": "Burgers & Wraps",
                                                            "description": "A juicy corn and cheese patty, topped with extra cheese, Cocktail sauce, with some heat from jalapenos & crunch from onions",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/cb4d60c0-72c0-4694-8d41-3c745e253ea6_8262ec8c-e2ac-4c4f-8e52-36144a372851.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 16327,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.0",
                                                                    "ratingCount": "164 ratings",
                                                                    "ratingCountV2": "164"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "53520883",
                                                            "name": "McSpicy Chicken Double Patty Burger",
                                                            "category": "Burgers & Wraps",
                                                            "description": "Indulge in our signature tender double chicken patty, coated in spicy, crispy batter, topped with creamy sauce, and crispy lettuce.",
                                                            "imageId": "314b5b5786f73746de4880602723a913",
                                                            "inStock": 1,
                                                            "price": 27143,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "5.0",
                                                                    "ratingCount": "74 ratings",
                                                                    "ratingCountV2": "74"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "53520888",
                                                            "name": "McChicken Double Patty Burger",
                                                            "category": "Burgers & Wraps",
                                                            "description": "Enjoy the classic, tender double chicken patty with creamy mayonnaise and lettuce in every bite",
                                                            "imageId": "af88f46a82ef5e6a0feece86c349bb00",
                                                            "inStock": 1,
                                                            "price": 17238,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.4",
                                                                    "ratingCount": "33 ratings",
                                                                    "ratingCountV2": "33"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "67553380",
                                                            "name": "Masala McEgg Burger",
                                                            "category": "Burgers & Wraps",
                                                            "description": "A steamed egg, spicy Habanero sauce, & onions on toasted buns, a protein packed delight!",
                                                            "imageId": "265c57f68b1a52f1cc4b63acf082d611",
                                                            "inStock": 1,
                                                            "price": 6952,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isGuiltfree": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.5",
                                                                    "ratingCount": "54 ratings",
                                                                    "ratingCountV2": "54"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "134350420",
                                                            "name": "McSpicy Deluxe Chicken Double Patty Burger",
                                                            "category": "Burgers & Wraps",
                                                            "description": "Indulge in a burger made with two spicy and crispy Chicken Patty, Chipotle Sauce, Tomatos, Lettuce & Jalapenos.",
                                                            "imageId": "8540bab49c99e3b9f0d625c7b17a1347",
                                                            "inStock": 1,
                                                            "price": 29048,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "53520891",
                                                            "name": "McVeggie Double Patty Burger",
                                                            "category": "Burgers & Wraps",
                                                            "description": "Savour your favorite spiced double veggie patty, lettuce, mayo, between toasted sesame buns in every bite",
                                                            "imageId": "2d5062832f4d36c90e7dfe61ef48e85a",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 18762,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.9",
                                                                    "ratingCount": "35 ratings",
                                                                    "ratingCountV2": "35"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "53520909",
                                                            "name": "McAloo Tikki Double Patty Burger",
                                                            "category": "Burgers & Wraps",
                                                            "description": "The World's favourite Indian burger! A crispy double Aloo patty, tomato mayo sauce & onions",
                                                            "imageId": "ef569f74786e6344883a1decdd193229",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 8857,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "1.6",
                                                                    "ratingCount": "38 ratings",
                                                                    "ratingCountV2": "38"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "58150221",
                                                            "name": "Mexican McAloo Tikki Double Patty Burger",
                                                            "category": "Burgers & Wraps",
                                                            "description": "A fusion of International taste combined with your favourite aloo tikki now with two patties",
                                                            "imageId": "cda0e2d51420a95fad28ad728914b6de",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 9333,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.5",
                                                                    "ratingCount": "19 ratings",
                                                                    "ratingCountV2": "19"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "115610651",
                                                            "name": "Chicken Surprise Burger",
                                                            "category": "Burgers & Wraps",
                                                            "description": "Introducing the new Chicken Surprise Burger which has the perfect balance of a crispy fried chicken patty, the crunch of onions and the richness of creamy sauce.",
                                                            "imageId": "860fe1dcbd0fe5f4650003253a46f280",
                                                            "inStock": 1,
                                                            "price": 7524,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Coffee & Beverages (Hot and Cold)",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "68962005",
                                                            "name": "Coke zero can",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "The perfect diet companion to your burger, fries and everything nice. Regular serving size, 300 Ml.",
                                                            "imageId": "8d6a37c4fc69bceb66b6a66690097190",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 6667,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.4",
                                                                    "ratingCount": "62 ratings",
                                                                    "ratingCountV2": "62"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "68302584",
                                                            "name": "Coke",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "The perfect companion to your burger, fries and everything nice.",
                                                            "imageId": "a1afed29afd8a2433b25cc47b83d01da",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 10286,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.8",
                                                                    "ratingCount": "87 ratings",
                                                                    "ratingCountV2": "87"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "125972291",
                                                            "name": "Mocha Frappe",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "The perfect mix of indulgence and bold flavours. Enjoy a delicious blend of coffee, chocolate sauce, and soft serve",
                                                            "imageId": "063e9cd747c621978ab4fddbb6d0a5ee",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 28095,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112620515",
                                                            "name": "Chocolate Frappe",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "An induglent treat of chocolate sauce & Oreo cookies blended with soft serve, ice & topped with whipped cream",
                                                            "imageId": "58e19527263a4bf3bbbac4befb924120",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 28095,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "125972290",
                                                            "name": "McCafe-Classic Coffee",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "An irrestible blend of our signature espresso and soft serve with whipped cream on top, a timeless combination! Now in a new, convenient and delivery friendly packaging.",
                                                            "imageId": "5f9bdb36689a11cadb601a27b6fdef2d",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 21619,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.5",
                                                                    "ratingCount": "8 ratings",
                                                                    "ratingCountV2": "8"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713427",
                                                            "name": "McCafe-Ice Coffee",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "Classic coffee poured over ice with soft servefor a refreshing pick-me-up",
                                                            "imageId": "06cb5429b883a108cc5be508fb2780b0",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 20000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "4 ratings",
                                                                    "ratingCountV2": "4"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "136748455",
                                                            "name": "Lotus Biscoff Frappe",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "A tall glass of creamy indulgence with the unique taste and texture of Lotus Biscoff",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/5a41c2de-81e7-4176-9d19-91f483118d60_849dfa65-d162-4158-9f08-bec159fb0a47.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 29143,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112620458",
                                                            "name": "American Mud Pie Shake",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "Creamy and rich with chocolate and blended with nutty brownie bits for that extra thick goodness",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/5ad3343d-a520-498d-a933-52104c624304_9f6cb499-0229-40dc-8b17-4c386f0cc287.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 20190,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.9",
                                                                    "ratingCount": "3 ratings",
                                                                    "ratingCountV2": "3"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713603",
                                                            "name": "Mocha Coffee (R)",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "A delight of ground Arabica espresso, chocolate syrup and steamed milk",
                                                            "imageId": "04a137420bf3febf861c4beed86d5702",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 23810,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "125972288",
                                                            "name": "Chocolate Flavoured Shake",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "The classic sinful Chocolate Flavoured Shake, a treat for anytime you need one. Now in new, convenient and delivery friendly packaging",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/463331b6-aa39-4d37-a8b2-c175aa20f723_14e888b6-2ebf-4d84-93a7-7b0576147bda.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 18190,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "5.0",
                                                                    "ratingCount": "5 ratings",
                                                                    "ratingCountV2": "5"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "125972293",
                                                            "name": "Strawberry Shake",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "An all time favourite treat bringing together the perfect blend of creamy vanilla soft serve and strawberry flavor.Now in new, convenient and delivery friendly packaging",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/b7d85483-4328-40a7-8cba-c408771d2482_99cab512-28fc-4b2c-b07f-87850002e79c.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 18190,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "5.0",
                                                                    "ratingCount": "5 ratings",
                                                                    "ratingCountV2": "5"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713404",
                                                            "name": "Latte Coffee (R)",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "A classic combination of the signature McCafe espresso, smooth milk, steamed and frothed",
                                                            "imageId": "cee1ec0e10e25018572adcaf3a3c9e8c",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 20190,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713395",
                                                            "name": "Hot Chocolate (S)",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "Sinfully creamy chocolate whisked with silky streamed milk",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/15/1948679f-65df-4f93-a9cc-2ec796ca0818_6ad8b55d-e3cc-48ed-867d-511100b5735d.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 18571,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "121923948",
                                                            "name": "Cappuccino Coffee (R)",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "A refreshing espresso shot of 100% Arabica beans, topped with steamed milk froth. 473ml",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/4f45f0d8-111a-4d9c-a993-06d6858fdb06_cb5d79e9-c112-45e5-9e6a-e17d75acd8ac.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 20190,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713429",
                                                            "name": "Ice Americano Coffee ",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "Signature Arabica espresso shot mixed with ice for an energizing experience",
                                                            "imageId": "7d89db9d67c537d666d838ddc1e0c44f",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 18190,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713407",
                                                            "name": "Latte Coffee (S)",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "A classic combination of the signature McCafe espresso, smooth milk, steamed and froth",
                                                            "imageId": "cee1ec0e10e25018572adcaf3a3c9e8c",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 17143,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "121923947",
                                                            "name": "Cappuccino Coffee (S)",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "A refreshing espresso shot of 100% Arabica beans, topped with steamed milk froth. 236ml",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/4f45f0d8-111a-4d9c-a993-06d6858fdb06_cb5d79e9-c112-45e5-9e6a-e17d75acd8ac.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 17143,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713379",
                                                            "name": "Flat White Coffee",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "Our signature McCafe espresso made with 100% Arabica beans, blended with steamed milk",
                                                            "imageId": "562cb96c1de1c6f650daab676cf8dc8a",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 17524,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isGuiltfree": true,
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "69017952",
                                                            "name": "Vedica Zen Water Bottle",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "Quench your thirst with the Vedica Zen Water Bottle",
                                                            "imageId": "6da8fa6b64c806e89058c87c0a85e759",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 4762,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "83840289",
                                                            "name": "Sprite",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "The perfect companion to your burger, fries and everything nice.",
                                                            "imageId": "46e03daf797857bfbce9f9fbb539a6aa",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 10286,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.8",
                                                                    "ratingCount": "12 ratings",
                                                                    "ratingCountV2": "12"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "69678412",
                                                            "name": "Fanta",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "Add a zest of refreshing orange to your meal.",
                                                            "imageId": "7d662c96bc13c4ac33cea70c691f7f28",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 10286,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.1",
                                                                    "ratingCount": "15 ratings",
                                                                    "ratingCountV2": "15"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "142788032",
                                                            "name": "Strawberry Fizz",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "Enjoy Sprite with a twist of strawberry flavour. Refreshing and perfectly sweet! Contains no fruit. Contains added flavour.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/11/d9e2ac29-3bc0-4bb8-8e3f-c7c763e6afb4_ff7561da-6674-4598-9a98-09db39c786e7.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 10286,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "78479525",
                                                            "name": "Mixed Fruit Beverage",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "Made with puree, pulp & juice from 6 delicious fruits",
                                                            "imageId": "8e455d39bbbd8e4107b2099da51f3933",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 7524,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "2.7",
                                                                    "ratingCount": "4 ratings",
                                                                    "ratingCountV2": "4"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713377",
                                                            "name": "English Breakfast Tea",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "For when you want your time to enjoy long, slow sips of the wholesome English Breakfast tea",
                                                            "imageId": "6333ac2ebe823a20cad586c0cd397b16",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 16095,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713421",
                                                            "name": "Americano Coffee (R)",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "Refreshing cup of bold and robust espresso made with our signature 100% Arabica beans, combined with hot water",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/6a300499-efad-4a89-8fe4-ef6f6d3c1e2d_db248587-e3ea-4034-bbd7-33f9e483d6cb.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 19143,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713424",
                                                            "name": "Americano Coffee (S)",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "Refreshing cup of bold and robust espresso made with our signature 100% Arabica beans, combined with hot water",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/6a300499-efad-4a89-8fe4-ef6f6d3c1e2d_db248587-e3ea-4034-bbd7-33f9e483d6cb.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 17143,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713605",
                                                            "name": "Moroccan Mint Green Tea (R )",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "Freshly-brewed refreshing tea with hint of Moroccon Mint flavour",
                                                            "imageId": "2699c7c2130b4f50a09af3e294966b2e",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 19143,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713618",
                                                            "name": "Strawberry Green Tea (S)",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "Freshly-brewed refreshing tea with fruity Strawbery flavour",
                                                            "imageId": "167dc0134bc1f4e8d7cb8e5c2a9dde5d",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 15429,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "142788031",
                                                            "name": "Green Apple Lemon Fizz",
                                                            "category": "Coffee & Beverages (Hot and Cold)",
                                                            "description": "Try Sprite with green apple and lemon flavour. It\u2019s zesty, and refreshingly bold! Contains no fruit. Contains added flavour.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/11/770ab1e4-3f09-4aa8-916c-a810422f20cb_baeba47c-5f90-46c0-859d-8cf7644d57f1.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 10286,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Fried Chicken & Wings",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "125972273",
                                                            "name": "10 pcs McSpicy Fried Chicken Bucket + 2 Fries (L) + 4 Coke",
                                                            "category": "Fried Chicken & Wings",
                                                            "description": "Enjoy McSpicy Fried Chicken 10 Pc + 2 Fries (L) + 4 Coke - the perfect sharing combo! Serves 4-10",
                                                            "imageId": "225d73dc44b15869fe737798a154fba7",
                                                            "inStock": 1,
                                                            "price": 123906,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129301578",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "119984440",
                                                            "name": "5 pcs McSpicy Fried Chicken Bucket",
                                                            "category": "Fried Chicken & Wings",
                                                            "description": "Enjoy 5 pcs of juicy, spicy and crunchy McSpicy Fried Chicken in a Bucket that's perfect for sharing. Serves 3-4",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/5/342dd4fb-54d0-4261-9b0a-b4e33d8e8447_54e45770-76f6-4ec2-aabf-08b286a498f7.png",
                                                            "inStock": 1,
                                                            "price": 45857,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.7",
                                                                    "ratingCount": "5 ratings",
                                                                    "ratingCountV2": "5"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713380",
                                                            "name": "5 pcs McSpicy Fried chicken Bucket + 2 Coke",
                                                            "category": "Fried Chicken & Wings",
                                                            "description": "Enjoy 5 pc of McSpicy Fried chicken + 2 Coke - perfect sharing meal for a party!",
                                                            "imageId": "54bafa953686424e5af0f9a0a20ef1c9",
                                                            "inStock": 1,
                                                            "price": 53334,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "130979773",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "125972272",
                                                            "name": "4 pcs McSpicy Fried chicken Bucket + 1 Coke",
                                                            "category": "Fried Chicken & Wings",
                                                            "description": "Enjoy 4 pcs of juicy, spicy and crunchy McSpicy Fried Chicken in a Bucket that's perfect for sharing + 1 Coke. Serves 1-2",
                                                            "imageId": "77ce9851cf897e3d82779977a4848c08",
                                                            "inStock": 1,
                                                            "price": 47619,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "129301477",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713376",
                                                            "name": "2 PC Mcspicy Fried chicken",
                                                            "category": "Fried Chicken & Wings",
                                                            "description": "Enjoy 2 pcs of juicy, spicy and crunchy McSpicy Fried Chicken",
                                                            "imageId": "fcbc9e5bc45ebf0fde9ac2da44032035",
                                                            "inStock": 1,
                                                            "price": 22762,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "16 ratings",
                                                                    "ratingCountV2": "16"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "125972274",
                                                            "name": "3 pcs McSpicy Fried Chicken Bucket + 2 Coke",
                                                            "category": "Fried Chicken & Wings",
                                                            "description": "Enjoy 3 pcs of juicy, spicy and crunchy McSpicy Fried Chicken in a Bucket that's perfect for sharing + 2 Coke. Serves 2-3",
                                                            "imageId": "e8523cbe88496b99f299c8eb7b137059",
                                                            "inStock": 1,
                                                            "price": 38001,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "130979852",
                                                                    "groupName": "Choose an option for Coke",
                                                                    "choices": [
                                                                        {
                                                                            "id": "94487429",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541775",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541774",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541773",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614790",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541776",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "94487426",
                                                                            "name": "Sprite",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "95614788",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293557",
                                                                            "name": "Upgrade to Mocha Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176121",
                                                                            "name": "Strawberry Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "119176122",
                                                                            "name": "Green Apple Lemon Fizz",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293559",
                                                                            "name": "Upgrade to Mixed Berry Smoothie",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293553",
                                                                            "name": "Upgrade to Chocolate Frappe",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293554",
                                                                            "name": "Upgrade to Iced Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293551",
                                                                            "name": "Upgrade to Hot Chocolate",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293552",
                                                                            "name": "Mango Smoothie",
                                                                            "price": 11000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "117293550",
                                                                            "name": "Coke Zero Can",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115421138",
                                                                            "name": "Upgrade to Berry Cooler",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "100541778",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "52364329",
                                                            "name": "McSpicy Fried Chicken - 1 PC",
                                                            "category": "Fried Chicken & Wings",
                                                            "description": "Enjoy juicy, spicy and crunchy McSpicy Fried Chicken ",
                                                            "imageId": "18cdeabc815b748622911259c3b7df1d",
                                                            "inStock": 1,
                                                            "price": 12000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.3",
                                                                    "ratingCount": "24 ratings",
                                                                    "ratingCountV2": "24"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Desserts",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713467",
                                                            "name": "McFlurry Oreo ( M )",
                                                            "category": "Desserts",
                                                            "description": "Delicious soft serve meets crumbled oreo cookies, a match made in dessert heaven. Share it, if you can.",
                                                            "imageId": "f966500ed8b913a16cfdb25aab9244e4",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 12857,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.3",
                                                                    "ratingCount": "9 ratings",
                                                                    "ratingCountV2": "9"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "68302588",
                                                            "name": "Mcflurry Oreo ( S )",
                                                            "category": "Desserts",
                                                            "description": "Delicious soft serve meets crumbled oreo cookies, a match made in dessert heaven. Perfect for one.",
                                                            "imageId": "a28369e386195be4071d9cf5078a438d",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 9429,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.7",
                                                                    "ratingCount": "56 ratings",
                                                                    "ratingCountV2": "56"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713610",
                                                            "name": "Soft Serve Hot Fudge (M)",
                                                            "category": "Desserts",
                                                            "description": "A sinful delight, soft serve topped with delicious, gooey hot chocolate fudge. Always grab an extra spoon.",
                                                            "imageId": "9c8958145495e8f2cf70470195f7834a",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 6476,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "137 ratings",
                                                                    "ratingCountV2": "137"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "123193878",
                                                            "name": "Brownie Hot Fudge (M)",
                                                            "category": "Desserts",
                                                            "description": "Luscious chocolate brownie and hot-chocolate fudge to sweeten your day",
                                                            "imageId": "6e00a57c6d8ceff6812a765c80e9ce74",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 13810,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "136748456",
                                                            "name": "Lotus Biscoff Medium McFlurry",
                                                            "category": "Desserts",
                                                            "description": "Try the trending indulgent Lotus Biscoff for a unique sweet end to your meal. Hurry before it's gone!",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/a0144afb-5c88-45be-b7e9-64b0ad29e614_34ef1aa5-ba94-4a13-8859-73297d3980cf.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 13333,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "121923952",
                                                            "name": "Oreo Sundae ( M )",
                                                            "category": "Desserts",
                                                            "description": "Enjoy the classic McFlurry Oreo goodness with a drizzle of hot fudge sauce with the Oreo Sundae!",
                                                            "imageId": "3696da86802f534ba9ca68bd8be717ab",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 7143,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "2.6",
                                                                    "ratingCount": "3 ratings",
                                                                    "ratingCountV2": "3"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "123193874",
                                                            "name": "Black Forest McFlurry Medium",
                                                            "category": "Desserts",
                                                            "description": "A sweet treat to suit your every mood",
                                                            "imageId": "f513cc8c35cadd098835fb5b23c03561",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 11524,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.6",
                                                                    "ratingCount": "46 ratings",
                                                                    "ratingCountV2": "46"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "136748457",
                                                            "name": "Lotus Biscoff Regular McFlurry",
                                                            "category": "Desserts",
                                                            "description": "Try the trending indulgent Lotus Biscoff for a unique sweet end to your meal. Hurry before it's gone!",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/a1d158fd-7cd0-4e3d-b776-bf4d5306b141_297d3942-cae8-4a10-8636-830f7d68618a.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 10381,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "112713616",
                                                            "name": "Soft Serve Strawberry (M)",
                                                            "category": "Desserts",
                                                            "description": "The cool vanilla soft serve ice cream with twirls of strawberry syrup.",
                                                            "imageId": "d7bd22aa47cffdcdde2d5b6223fde06e",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 6476,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "1.2",
                                                                    "ratingCount": "39 ratings",
                                                                    "ratingCountV2": "39"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "143868537",
                                                            "name": "Mango McFlurry with Lotus Biscoff Medium",
                                                            "category": "Desserts",
                                                            "description": "Level up your Lotus Biscoff McFlurry with a Mango flavoured twist!\r\nDoes not contain fruit. Contains natural colour.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/91785dbf-6814-480b-a5a6-f5690bb87ad9_76a315d3-3cc0-412f-b9d4-e47e1dbf61b9.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 15524,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "143868540",
                                                            "name": "Mango McFlurry with Lotus Biscoff Small",
                                                            "category": "Desserts",
                                                            "description": "Level up your Lotus Biscoff McFlurry with a Mango flavoured twist!\r\nDoes not contain fruit. Contains natural colour.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/511dc029-aaa2-4a1a-9b5c-fbfc8838d82d_92611a04-cc17-41d2-b54a-1b65e8ddac61.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 12000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "143868545",
                                                            "name": "Mango McFlurry with Oreo Medium",
                                                            "category": "Desserts",
                                                            "description": "Level up your Oreo McFlurry with a Mango flavoured twist!\r\nDoes not contain fruit. Contains natural colour.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/4f8a1005-178c-4e6d-b25b-c6cb728181f1_c3d8e06d-c610-4e2a-b57d-312ae59569c7.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 14000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "143868550",
                                                            "name": "Mango McFlurry with Oreo Small",
                                                            "category": "Desserts",
                                                            "description": "Level up your Oreo McFlurry with a Mango flavoured twist!\r\nDoes not contain fruit. Contains natural colour.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/4f8a1005-178c-4e6d-b25b-c6cb728181f1_c3d8e06d-c610-4e2a-b57d-312ae59569c7.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 11048,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "143871458",
                                                            "name": "Mango Sundae Medium",
                                                            "category": "Desserts",
                                                            "description": "Enjoy the refreshing combination of Mango Flavoured Soft Serve, for a creamy and indulgent dessert. Does not contain fruit. Contains natural colour.",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/8e66d8d7-d095-45a1-8fe8-4ccc7bf6b520_8fd9c489-773d-48b8-8895-6196b2f6e2b6.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 7905,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "McSpicy Combos with Sprite",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "136748445",
                                                            "name": "Big Spicy Chicken Wrap + Sprite + Fries (R)",
                                                            "category": "McSpicy Combos with Sprite",
                                                            "description": "Enjoy a deliciously filling combo of Big Spicy Paneer Wrap + Sprite + Fries (R)",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/dd775029-7f4d-4dbe-bc91-e4df292899b7_47e8257e-d890-407b-a6cd-185d10c39050.png",
                                                            "inStock": 1,
                                                            "price": 31904,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "144255831",
                                                                    "groupName": "Choose an option for Sprite",
                                                                    "choices": [
                                                                        {
                                                                            "id": "115680626",
                                                                            "name": "Coke",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680638",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680649",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680651",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680650",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680648",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680646",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680647",
                                                                            "name": "McCafe-Ice Coffee",
                                                                            "price": 9700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680643",
                                                                            "name": "Chocolate Frappe",
                                                                            "price": 17800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680645",
                                                                            "name": "Mocha Frappe",
                                                                            "price": 17800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680639",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680641",
                                                                            "name": "Hot Chocolate (R)",
                                                                            "price": 11500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680627",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "136748469",
                                                            "name": "McSpicy Deluxe Chicken Burger + Sprite + Fries (R)",
                                                            "category": "McSpicy Combos with Sprite",
                                                            "description": "Enjoy a deliciously indulgent combo of McSpicy Deluxe Chicken Burger + Sprite + Fries (R)",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/4168ca8a-9dcc-44d3-99e5-edcf51050e09_34f8853d-255b-49f3-b60b-73b1e4456868.png",
                                                            "inStock": 1,
                                                            "price": 29933,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "144255878",
                                                                    "groupName": "Choose an option for Sprite",
                                                                    "choices": [
                                                                        {
                                                                            "id": "115680626",
                                                                            "name": "Coke",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680638",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680649",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680651",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680650",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680648",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680646",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680647",
                                                                            "name": "McCafe-Ice Coffee",
                                                                            "price": 9700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680643",
                                                                            "name": "Chocolate Frappe",
                                                                            "price": 17800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680645",
                                                                            "name": "Mocha Frappe",
                                                                            "price": 17800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680639",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680641",
                                                                            "name": "Hot Chocolate (R)",
                                                                            "price": 11500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680627",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "136748447",
                                                            "name": "Big Spicy Paneer Wrap + Sprite + Fries (R)",
                                                            "category": "McSpicy Combos with Sprite",
                                                            "description": "Enjoy a deliciously filling combo of Big Spicy Paneer Wrap + Sprite + Fries (R)",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/37dea52e-22f5-40b4-ace3-c733ed1b6b23_ce5455fd-1b9a-4834-97b8-35bc7b004378.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 31933,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "144255834",
                                                                    "groupName": "Choose an option for Sprite",
                                                                    "choices": [
                                                                        {
                                                                            "id": "115680626",
                                                                            "name": "Coke",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680638",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680649",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680651",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680650",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680648",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680646",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680647",
                                                                            "name": "McCafe-Ice Coffee",
                                                                            "price": 9700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680643",
                                                                            "name": "Chocolate Frappe",
                                                                            "price": 17800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680645",
                                                                            "name": "Mocha Frappe",
                                                                            "price": 17800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680639",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680641",
                                                                            "name": "Hot Chocolate (R)",
                                                                            "price": 11500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680627",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "136748471",
                                                            "name": "McSpicy Deluxe Paneer Burger + Sprite + Fries (R)",
                                                            "category": "McSpicy Combos with Sprite",
                                                            "description": "Enjoy a deliciously indulgent combo of McSpicy Deluxe Paneer Burger + Sprite + Fries (R)",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/bc5437f7-ec45-425f-b29e-4b9cbef69879_20b8cd0e-e83d-415a-9da1-73832c156a41.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 29884,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "144255883",
                                                                    "groupName": "Choose an option for Sprite",
                                                                    "choices": [
                                                                        {
                                                                            "id": "115680626",
                                                                            "name": "Coke",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680638",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680649",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680651",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680650",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680648",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680646",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680647",
                                                                            "name": "McCafe-Ice Coffee",
                                                                            "price": 9700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680643",
                                                                            "name": "Chocolate Frappe",
                                                                            "price": 17800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680645",
                                                                            "name": "Mocha Frappe",
                                                                            "price": 17800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680639",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680641",
                                                                            "name": "Hot Chocolate (R)",
                                                                            "price": 11500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680627",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "136748463",
                                                            "name": "McSpicy Chicken + Sprite + Fries (R)",
                                                            "category": "McSpicy Combos with Sprite",
                                                            "description": "Enjoy a deliciously indulgent combo of McSpicy Chicken Burger + Sprite + Fries (R)",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/08a2c6f5-c36e-4987-8e6f-255664617faa_6ce226c4-363b-4542-b16f-a790741fc357.png",
                                                            "inStock": 1,
                                                            "price": 29895,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "144255866",
                                                                    "groupName": "Choose an option for Sprite",
                                                                    "choices": [
                                                                        {
                                                                            "id": "115680626",
                                                                            "name": "Coke",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680638",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680649",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680651",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680650",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680648",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680646",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680647",
                                                                            "name": "McCafe-Ice Coffee",
                                                                            "price": 9700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680643",
                                                                            "name": "Chocolate Frappe",
                                                                            "price": 17800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680645",
                                                                            "name": "Mocha Frappe",
                                                                            "price": 17800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680639",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680641",
                                                                            "name": "Hot Chocolate (R)",
                                                                            "price": 11500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680627",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "136748478",
                                                            "name": "McSpicy Paneer + Sprite + Fries (R)",
                                                            "category": "McSpicy Combos with Sprite",
                                                            "description": "Enjoy a deliciously indulgent combo of McSpicy Paneer Burger + Sprite + Fries (R)",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/5e9c5574-2d99-43ac-8bca-8f41d98a1da9_de8aa300-d905-4518-ae9e-aebd1b5d1c95.png",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 29898,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "144255889",
                                                                    "groupName": "Choose an option for Sprite",
                                                                    "choices": [
                                                                        {
                                                                            "id": "115680626",
                                                                            "name": "Coke",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680638",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680649",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680651",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680650",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680648",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680646",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680647",
                                                                            "name": "McCafe-Ice Coffee",
                                                                            "price": 9700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680643",
                                                                            "name": "Chocolate Frappe",
                                                                            "price": 17800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680645",
                                                                            "name": "Mocha Frappe",
                                                                            "price": 17800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680639",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680641",
                                                                            "name": "Hot Chocolate (R)",
                                                                            "price": 11500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680627",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "136748474",
                                                            "name": "McSpicy Fried Chicken - 1 pc + Sprite + Fries (R)",
                                                            "category": "McSpicy Combos with Sprite",
                                                            "description": "Relish on Juicy McSpicy Fried Chicken + Sprite + Fries (R)",
                                                            "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/3e6d0620-635e-462f-803d-3c43f4993d79_c55fdaa4-c311-4bfe-a38f-9cdb506853c7.png",
                                                            "inStock": 1,
                                                            "price": 26861,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "144255886",
                                                                    "groupName": "Choose an option for Sprite",
                                                                    "choices": [
                                                                        {
                                                                            "id": "115680626",
                                                                            "name": "Coke",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680638",
                                                                            "name": "Fanta",
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680649",
                                                                            "name": "Upgrade to McCafe-Classic Coffee",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680651",
                                                                            "name": "Upgrade to American Mud Pie Shake",
                                                                            "price": 7600,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680650",
                                                                            "name": "Upgrade to Strawberry Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680648",
                                                                            "name": "Upgrade to  Chocolate Flavoured Shake",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680646",
                                                                            "name": "Upgrade to Cappuccino Coffee (S)",
                                                                            "price": 4800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680647",
                                                                            "name": "McCafe-Ice Coffee",
                                                                            "price": 9700,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680643",
                                                                            "name": "Chocolate Frappe",
                                                                            "price": 17800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680645",
                                                                            "name": "Mocha Frappe",
                                                                            "price": 17800,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680639",
                                                                            "name": "Mocha Coffee (R)",
                                                                            "price": 13500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680641",
                                                                            "name": "Hot Chocolate (R)",
                                                                            "price": 11500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "115680627",
                                                                            "name": "Latte Coffee (R)",
                                                                            "price": 9900,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "Cakes Brownies and Cookies",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "123193885",
                                                            "name": "Chocolate Express Cake.",
                                                            "category": "Cakes Brownies and Cookies",
                                                            "description": "This rich chocolate cake is topped with chocolate shavings, perfect for all chocolate lovers",
                                                            "imageId": "b424bcb7466a0a04ff8d7fe3270641b6",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 17048,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.4",
                                                                    "ratingCount": "4 ratings",
                                                                    "ratingCountV2": "4"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "125972294",
                                                            "name": "Vanilla Chocolate Muffin.",
                                                            "category": "Cakes Brownies and Cookies",
                                                            "description": "Sweet, soft, and fluffy vanilla flavoured chocolate chip muffins are perfect accompaniment with hot coffee!",
                                                            "imageId": "56ecb9e43f657ee8f239cc22f7831b83",
                                                            "inStock": 1,
                                                            "price": 12857,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.7",
                                                                    "ratingCount": "7 ratings",
                                                                    "ratingCountV2": "7"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "125972287",
                                                            "name": "Chocochip Muffin.",
                                                            "category": "Cakes Brownies and Cookies",
                                                            "description": "Enjoy a dense chocochip muffin, with melty chocolate chips for a choco-lover's delight",
                                                            "imageId": "6c748c0b21f4a99593d1040021500430",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 14190,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "139079851",
                                                            "name": "Choco Crunch Cookie",
                                                            "category": "Cakes Brownies and Cookies",
                                                            "description": "Grab the choco crunch cookies packed with chocolate chips for the perfect crunch",
                                                            "imageId": "32ff88484a8607b6d740c1635b9ce09f",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 9429,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "139079852",
                                                            "name": "Cinnamon Raisin Cookie",
                                                            "category": "Cakes Brownies and Cookies",
                                                            "description": "Enjoy the wholesome flavours of this chewy and satisfying cookie",
                                                            "imageId": "fa5526832dfc6e236e6de7c322beae94",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 9429,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            "title": "McBreakfast",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "115693032",
                                                            "name": "Sausage with Egg McMuffin 3 Pc Meal",
                                                            "category": "McBreakfast",
                                                            "description": "Sizzling aromatic sausage accompanied by the freshly steamed egg between two slices of fresh English muffins. Served with Hashbrown and a coffee of your choice.",
                                                            "imageId": "853df93396ec14836751239af41c0f84",
                                                            "price": 29619,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150726736",
                                                                    "groupName": "Choose an option for Cappuccino Coffee (S)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "117293555",
                                                                            "name": "Cappuccino Coffee (R)",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "5.0",
                                                                    "ratingCount": "4 ratings",
                                                                    "ratingCountV2": "4"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "115693031",
                                                            "name": "Sausage McMuffin- sandwich combo",
                                                            "category": "McBreakfast",
                                                            "description": "Sizzling aromatic sausage patty between two slices of fresh English muffins. Served with Hashbrown and a coffee of your choice.",
                                                            "imageId": "acee1d07c362312c3bc4332013450e88",
                                                            "price": 27429,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150726855",
                                                                    "groupName": "Choose an option for Cappuccino Coffee (S)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "117293555",
                                                                            "name": "Cappuccino Coffee (R)",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "115693037",
                                                            "name": "Veg McMuffin 3 Pc Meal",
                                                            "category": "McBreakfast",
                                                            "description": "Grilled Spinach & Corn patty and slice of processed cheddar cheese nestled between a toasty English Muffin served with Hashbrowns and a Coffee of your choice",
                                                            "imageId": "76aeecdcdea1eea92c575db5b1111223",
                                                            "isVeg": 1,
                                                            "price": 26476,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150726695",
                                                                    "groupName": "Choose an option for Cappuccino Coffee (S)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "117293555",
                                                                            "name": "Cappuccino Coffee (R)",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "115693034",
                                                            "name": "Spicy Egg McMuffin 3 Pc Meal",
                                                            "category": "McBreakfast",
                                                            "description": "Try the delcious combo of Spicy Egg McMuffin, Crispy Hashbrown and a beverage of your choice (S) to brighten up your day.",
                                                            "imageId": "38d8784662196a231858925936c84847",
                                                            "price": 25333,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150726685",
                                                                    "groupName": "Choose an option for Cappuccino Coffee (S)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "117293555",
                                                                            "name": "Cappuccino Coffee (R)",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "33428076",
                                                            "name": "Sausage McMuffin 2 pc Meal",
                                                            "category": "McBreakfast",
                                                            "description": "Sizzling aromatic sausage patty between the two slices of fresh English muffins + Coffee (R)",
                                                            "imageId": "c57b5327ffeb8d44f90982ef13811c78",
                                                            "price": 25333,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150726835",
                                                                    "groupName": "Choose an option for Cappuccino Coffee (S)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "117293555",
                                                                            "name": "Cappuccino Coffee (R)",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.0",
                                                                    "ratingCount": "22 ratings",
                                                                    "ratingCountV2": "22"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "115693023",
                                                            "name": "Double Cheese McMuffin - sandwich Combo",
                                                            "category": "McBreakfast",
                                                            "description": "Try the delcious combo of Double Cheese McMuffin, Crispy Hashbrown and a beverage of your choice (S) to brighten up your day.",
                                                            "imageId": "3a91832849055b8770ec4ef2bd27fd03",
                                                            "isVeg": 1,
                                                            "price": 24286,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150726739",
                                                                    "groupName": "Choose an option for Cappuccino Coffee (S)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "117293555",
                                                                            "name": "Cappuccino Coffee (R)",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "115693029",
                                                            "name": "Sausage & Egg McMuffin - Sandwich",
                                                            "category": "McBreakfast",
                                                            "description": "Sizzling aromatic sausage accompanied by the freshly steamed egg between two slices of fresh English muffins. A wholesome breakfast!",
                                                            "imageId": "63f426865644cf79af5163230a901d80",
                                                            "price": 15429,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isGuiltfree": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "16 ratings",
                                                                    "ratingCountV2": "16"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "115693030",
                                                            "name": "Sausage McMuffin - Sandwich",
                                                            "category": "McBreakfast",
                                                            "description": "Sizzling aromatic sausage patty between two slices of fresh English muffins. A wholesome breakfast!",
                                                            "imageId": "83bcbf3a3eab08d09e332aa2d7acca69",
                                                            "price": 13238,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isGuiltfree": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "5.0",
                                                                    "ratingCount": "8 ratings",
                                                                    "ratingCountV2": "8"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "115693028",
                                                            "name": "Spicy Egg McMuffin - sandwich combo",
                                                            "category": "McBreakfast",
                                                            "description": "Spice up your mornings with the new Spicy Egg McMuffin, Freshly cracked and steamed egg patty topped with spicy masala seasoning, shredded onions, topped with habanero sauce, layered between toasted and buttered Muffin buns. Served with a coffee of your choice.",
                                                            "imageId": "ae7bc83b4549021a4579323516bab7ad",
                                                            "price": 14190,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "115693035",
                                                            "name": "Veg McMuffin - Sandwich",
                                                            "category": "McBreakfast",
                                                            "description": "Grilled Spinach & Corn patty and slice of processed Cheddar cheese nestled between a toasty English Muffin.",
                                                            "imageId": "36d8d4789793db20bcfe3359ec814b8e",
                                                            "isVeg": 1,
                                                            "price": 11810,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isGuiltfree": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "2.2",
                                                                    "ratingCount": "4 ratings",
                                                                    "ratingCountV2": "4"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "115693024",
                                                            "name": "Egg & Cheese McMuffin - Sandwich",
                                                            "category": "McBreakfast",
                                                            "description": "Fluffy soft egg topped with Cheese served between English muffins",
                                                            "imageId": "39bb3c273b440ee352b738fa1f00c842",
                                                            "price": 10095,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isGuiltfree": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.2",
                                                                    "ratingCount": "5 ratings",
                                                                    "ratingCountV2": "5"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "115693033",
                                                            "name": "Spicy Egg McMuffin - Sandwich",
                                                            "category": "McBreakfast",
                                                            "description": "Spice up your mornings with the new Spicy Egg McMuffin, Freshly cracked and steamed egg patty topped with spicy masala seasoning, shredded onions, topped with habanero sauce, layered between toasted and buttered Muffin buns.",
                                                            "imageId": "798e2b493a04283cea3f7c388d6ef6ea",
                                                            "price": 10762,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isGuiltfree": true,
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "115693022",
                                                            "name": "Double Cheese McMuffin- Sandwich",
                                                            "category": "McBreakfast",
                                                            "description": "Make your mornings Cheese with the new Double Cheese McMuffin. Shredded onion, Jalapenos topped with Cheese (and more cheese) layered between toasted and buttered Muffin buns",
                                                            "imageId": "8bcca26adae8fa3e5593e1c8405dcac9",
                                                            "isVeg": 1,
                                                            "price": 10095,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "58150161",
                                                            "name": "Hashbrown",
                                                            "category": "McBreakfast",
                                                            "description": "Freshly fried golden brown potatoes that melt in your mouth.",
                                                            "imageId": "534f18e69e28bb060a85d30e03a102e4",
                                                            "isVeg": 1,
                                                            "price": 5333,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "232 ratings",
                                                                    "ratingCountV2": "232"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "33428071",
                                                            "name": "Sausage & Egg McMuffin 2 pc Meal",
                                                            "category": "McBreakfast",
                                                            "description": "Sizzling aromatic sausage accompanied by the freshly steamed egg between the two slices of fresh English muffins + Coffee (R)",
                                                            "imageId": "55f41cd2962cd5162adf657a949fab80",
                                                            "price": 26953,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150726837",
                                                                    "groupName": "Choose an option for Cappuccino Coffee (S)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "117293555",
                                                                            "name": "Cappuccino Coffee (R)",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "39 ratings",
                                                                    "ratingCountV2": "39"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "115693025",
                                                            "name": "Egg & Cheese McMuffin 3 Pc Meal",
                                                            "category": "McBreakfast",
                                                            "description": "Fluffy soft egg topped with cheese served between English muffins. Served with Hashbrown and a coffee of your choice.",
                                                            "imageId": "6e3ebff1d0678c7678e4fd2401f799ae",
                                                            "price": 24286,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150726676",
                                                                    "groupName": "Choose an option for Cappuccino Coffee (S)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "117293555",
                                                                            "name": "Cappuccino Coffee (R)",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "115693026",
                                                            "name": "Double Cheese McMuffin- 2 Pc Meal",
                                                            "category": "McBreakfast",
                                                            "description": "Make your mornings Cheese with the new Double Cheese McMuffin. Shredded onion, Jalapenos topped with Cheese (and more cheese) layered between toasted and buttered Muffin buns. Served with a coffee of your choice.",
                                                            "imageId": "4a32aa8cabd4caa4f6dc361b1fe0331c",
                                                            "isVeg": 1,
                                                            "price": 14190,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "115693036",
                                                            "name": "Veg McMuffin 2 Pc Meal",
                                                            "category": "McBreakfast",
                                                            "description": "Start your day with a combo of Veg McMuffin and a Coffee (S)",
                                                            "imageId": "0d64bf0e5a9308ab143f28e49e190902",
                                                            "isVeg": 1,
                                                            "price": 24286,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "150727046",
                                                                    "groupName": "Choose an option for Cappuccino Coffee (S)",
                                                                    "choices": [
                                                                        {
                                                                            "id": "117293555",
                                                                            "name": "Cappuccino Coffee (R)",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "136249688",
                                                            "name": "Egg & Cheese McMuffin - sandwich Combo",
                                                            "category": "McBreakfast",
                                                            "description": "Start your day with a combo of Egg & Cheese McMuffin and a Cappuccino (S)",
                                                            "imageId": "a00928a1fbaa5a3a49a58953295987db",
                                                            "price": 14190,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                                                            "itemAttribute": {
                                                                "vegClassifier": "NONVEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                                            "type": "FSSAI",
                                            "imageId": "fssai_final_edss9i",
                                            "text": [
                                                "License No. 11214333001617"
                                            ]
                                        }
                                    }
                                },
                                {
                                    "card": {
                                        "card": {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                                            "name": "McDonald's",
                                            "area": "Ashok Nagar",
                                            "completeAddress": "Hardcastle Restaurants Pvt Ltd, No. 10, India Garage, Opp. Cubbon Park police Station, Near BPCL Petrol pump, Kasturba Road, Bengaluru - 560001"
                                        }
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "firstOffsetRequest": true,
        "isQCLink": false
    },
    "tid": "64867903-cdf5-4962-8e11-0d082f65406d",
    "sid": "ej9c98ac-2fea-4e5c-a03a-4fd44aa85da5",
    "deviceId": "11a3191f-d62c-58e6-7035-6789a374b3f6",
    "csrfToken": "xk1nik56mXY4-DHiXL-4DwmfXCqZ5r0dftrCrUnk"
};



var $4Iuzv = parcelRequire("4Iuzv");

var $5aRSq = parcelRequire("5aRSq");
const $eb3dc97cbfcc19b2$var$Shimmer = ()=>{
    return /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
        className: "flex flex-wrap justify-center",
        children: Array(12).fill(0).map((ele, index)=>/*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "rounded-lg  h-[480px] w-[250px] m-3 p-1 bg-gray-200"
            }, index))
    });
};
var $eb3dc97cbfcc19b2$export$2e2bcd8739ae039 = $eb3dc97cbfcc19b2$var$Shimmer;





const $58044eda1763adcb$var$Body = ()=>{
    const [listOfRestaurants, setListOfRestaurants] = (0, $4Iuzv.useState)([]);
    const [filteredListOfRestaurants, setFilteredListOfRestaurants] = (0, $4Iuzv.useState)([]);
    const [searchText, setSearchText] = (0, $4Iuzv.useState)("");
    const [debounceTimer, setDebounceTimer] = (0, $4Iuzv.useState)(null);
    const { loggedInUser: loggedInUser, setUserName: setUserName } = (0, $4Iuzv.useContext)((0, $b302a4cdaf1c8188$export$2e2bcd8739ae039));
    //HOC concept
    // const RestaurantWithPromotedLabel = withPromotedLabel(RestaurantCard);
    (0, $4Iuzv.useEffect)(()=>{
        fetchData();
    }, []);
    // Facing CORS error while fetching live swiggy api[Plan was to load UI with api data]
    const fetchData = async ()=>{
        //Here, to avoid CORS error, we've have used corsproxy urls
        // const data = await fetch(
        //   "https://thingproxy.freeboard.io/fetch/https://www.swiggy.com/dapi/restaurants/list/v5?lat=12.96340&lng=77.58550&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING"
        // );
        // const json = await data.json();
        // console.log(
        //   swiggyApiData?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants
        // );
        setListOfRestaurants(// json?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants
        (0, $7f2c384ac384527b$export$d9177f8a4a7a8b10)?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
        setFilteredListOfRestaurants((0, $7f2c384ac384527b$export$d9177f8a4a7a8b10)?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
    };
    // console.log("RESTAURANT----->>>>",listOfRestaurants)
    const onlineStatus = (0, $e3dee1ed6350a35d$export$2e2bcd8739ae039)();
    if (onlineStatus === false) return /*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
        children: "Looks like you're Offline. Please check your internet connection."
    });
    const searchHandler = ()=>{
        console.log("SearchHandler fn called");
        //Filter the restaurant cards and update the UI
        const searchFilteredListOfRestaurants = listOfRestaurants.filter((res)=>res.info.name.toLowerCase().includes(searchText.toLowerCase()));
        setFilteredListOfRestaurants(searchFilteredListOfRestaurants);
    //   console.log(searchFilteredListOfRestaurants)
    };
    //Debouncing logic
    const debounceHandler = ()=>{
        if (debounceTimer) clearTimeout(debounceTimer);
        const newTimer = setTimeout(()=>{
            searchHandler();
        }, 1000);
        setDebounceTimer(newTimer);
    };
    const filterRestaurantHandler = ()=>{
        //filter logic here
        const filteredListOfRestaurants = listOfRestaurants.filter((restaurant)=>restaurant.info.avgRating > 4);
        setListOfRestaurants(filteredListOfRestaurants);
    };
    return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
        className: "px-200 py-100 mx-10 my-2",
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "flex justify-center mx-8",
                children: /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                    className: "flex flex-col sm:flex-row m-2",
                    children: [
                        /*#__PURE__*/ (0, $5aRSq.jsx)("input", {
                            type: "text",
                            placeholder: "Search for restaurants",
                            className: "border border-orange-500 sm:mx-2 mr-2 p-1 rounded-md",
                            value: searchText,
                            //NOTE: On every onChange event, <Body/> component re-renders but react updates only the input text value on every render
                            // onChange={(e) => {
                            //   setSearchText(e.target.value);
                            // }} // entered input value should update the 'searchText'
                            // onChange={(e) => {
                            //   searchHandler(e.target.value);
                            // }}
                            onChange: (e)=>{
                                setSearchText(e.target.value);
                                debounceHandler();
                            }
                        }),
                        /*#__PURE__*/ (0, $5aRSq.jsx)("button", {
                            className: "px-2 py-1 mr-2 my-2 bg-green-600 text-white rounded-md font-normal",
                            onClick: ()=>filterRestaurantHandler(),
                            children: "Filter Top Restaurants"
                        }),
                        /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                            className: "flex justify-center m-2 hidden lg:block",
                            children: [
                                /*#__PURE__*/ (0, $5aRSq.jsx)("label", {
                                    className: "mx-2",
                                    children: "User Name:"
                                }),
                                /*#__PURE__*/ (0, $5aRSq.jsx)("input", {
                                    className: "px-2 border border-black rounded-lg",
                                    value: loggedInUser,
                                    onChange: (e)=>setUserName(e.target.value)
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "flex flex-wrap justify-center",
                children: filteredListOfRestaurants.length === 0 ? /*#__PURE__*/ (0, $5aRSq.jsx)((0, $eb3dc97cbfcc19b2$export$2e2bcd8739ae039), {}) : filteredListOfRestaurants.map((restaurant)=>/*#__PURE__*/ (0, $5aRSq.jsx)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                        to: "/restaurants/" + restaurant.info.id,
                        children: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $80d248f504e512cb$export$2e2bcd8739ae039), {
                            resData: restaurant
                        })
                    }, restaurant.info.id))
            })
        ]
    });
};
var $58044eda1763adcb$export$2e2bcd8739ae039 = $58044eda1763adcb$var$Body;




var $5aRSq = parcelRequire("5aRSq");

var $4Iuzv = parcelRequire("4Iuzv");

var $5aRSq = parcelRequire("5aRSq");

var $4Iuzv = parcelRequire("4Iuzv");
const $61cd4eee7344e0df$var$User = (props)=>{
    const [count, setCount] = (0, $4Iuzv.useState)(0);
    const { name: name, location: location } = props;
    return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
        className: "user-card",
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsxs)("h1", {
                children: [
                    "Count: ",
                    count
                ]
            }),
            /*#__PURE__*/ (0, $5aRSq.jsxs)("h2", {
                children: [
                    "Name: ",
                    name
                ]
            }),
            /*#__PURE__*/ (0, $5aRSq.jsxs)("h3", {
                children: [
                    "Location: ",
                    location
                ]
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("h4", {
                children: "Contact: @saurabhsinghkumar"
            })
        ]
    });
};
var $61cd4eee7344e0df$export$2e2bcd8739ae039 = $61cd4eee7344e0df$var$User;



var $5aRSq = parcelRequire("5aRSq");

var $4Iuzv = parcelRequire("4Iuzv");
class $4a43ebff0e2881d0$var$UserClass extends (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).Component {
    constructor(props){
        super(props); //This is mandatory for class based components
        this.state = {
            userInfo: {
                name: "Dummy",
                location: "default"
            }
        };
    // console.log("Child Constructor")
    }
    async componentDidMount() {
        // console.log("Child ComponentDidMount")
        const data = await fetch("https://api.github.com/users/saurabh-singh-9090");
        const json = await data.json();
        this.setState({
            userInfo: json
        });
        this.timer = setInterval(()=>{
            console.log("HELLO REACT");
        }, 100);
    }
    componentDidUpdate() {
        console.log("ComponentDidUpdate called");
    }
    componentWillUnmount() {
        clearInterval(this.timer);
        console.log("componentWillUnmount");
    }
    render() {
        //   console.log("Child Render")
        //   const {name, location} = this.props;
        const { count: count, userInfo: { name: name, location: location } } = this.state;
        return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
            className: "user-card",
            children: [
                /*#__PURE__*/ (0, $5aRSq.jsx)("button", {
                    onClick: ()=>{
                        //Here,only count variable will be updated and rest other state variable will remain same
                        this.setState({
                            count: this.state.count + 1
                        });
                    },
                    children: "Increase count"
                }),
                /*#__PURE__*/ (0, $5aRSq.jsxs)("h2", {
                    children: [
                        "Name: ",
                        name
                    ]
                }),
                /*#__PURE__*/ (0, $5aRSq.jsxs)("h3", {
                    children: [
                        "Location: ",
                        location
                    ]
                }),
                /*#__PURE__*/ (0, $5aRSq.jsx)("h4", {
                    children: "Contact: @saurabhsinghkumar"
                })
            ]
        });
    }
}
var $4a43ebff0e2881d0$export$2e2bcd8739ae039 = $4a43ebff0e2881d0$var$UserClass;



class $2982f87537b17e94$var$About extends (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).Component {
    constructor(props){
        super(props);
    // console.log("Parent Constructor")
    }
    componentDidMount() {
    // console.log("Parent ComponentDidMount")
    }
    render() {
        // console.log("Parent Render")
        return /*#__PURE__*/ (0, $5aRSq.jsx)((0, $5aRSq.Fragment), {
            children: /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
                        children: "About Page (Class Based Component)"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)((0, $b302a4cdaf1c8188$export$2e2bcd8739ae039).Consumer, {
                        children: ({ loggedInUser: loggedInUser })=>/*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
                                className: "text-xl font-bold",
                                children: loggedInUser
                            })
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)((0, $61cd4eee7344e0df$export$2e2bcd8739ae039), {
                        name: "Saurabh Singh(Functional based)",
                        location: "Bangalore"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)((0, $4a43ebff0e2881d0$export$2e2bcd8739ae039), {
                        name: "Saurabh Singh(class based)",
                        location: "Bangalore"
                    })
                ]
            })
        });
    }
}
var $2982f87537b17e94$export$2e2bcd8739ae039 = $2982f87537b17e94$var$About;



var $5aRSq = parcelRequire("5aRSq");
parcelRequire("4Iuzv");
const $9eeccf2b46d57cec$var$ContactUs = ()=>{
    return /*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
        children: "ContactUs Page"
    });
};
var $9eeccf2b46d57cec$export$2e2bcd8739ae039 = $9eeccf2b46d57cec$var$ContactUs;



var $5aRSq = parcelRequire("5aRSq");

const $7e935ac5b2f1db10$var$Error = ()=>{
    //below hook is used to get more information about the error
    const err = (0, $175a2504a1bf07a5$export$ed527bf60f6e05f2)();
    console.log(err);
    return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
                children: "Ooops!!!"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("h2", {
                children: "Something went wrong!!"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsxs)("h4", {
                children: [
                    err.status,
                    ": ",
                    err.statusText
                ]
            })
        ]
    });
};
var $7e935ac5b2f1db10$export$2e2bcd8739ae039 = $7e935ac5b2f1db10$var$Error;



var $5aRSq = parcelRequire("5aRSq");

var $4Iuzv = parcelRequire("4Iuzv");

var $5aRSq = parcelRequire("5aRSq");
const $b82d2fd6d6d98fde$var$ShimmerMenu = ()=>{
    return /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
        className: "flex flex-col flex-wrap justify-center",
        children: Array(8).fill(0).map((ele, index)=>/*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "flex justify-between rounded-lg w-8/12 h-[80px] bg-gray-100 shadow-lg p-4 mx-auto my-4"
            }, index))
    });
};
var $b82d2fd6d6d98fde$export$2e2bcd8739ae039 = $b82d2fd6d6d98fde$var$ShimmerMenu;





var $4Iuzv = parcelRequire("4Iuzv");


const $6a9db8a30167c416$export$30ae66c29c137334 = (resId)=>{
    const [resInfo, setResInfo] = (0, $4Iuzv.useState)(null);
    //fetch the data from API
    (0, $4Iuzv.useEffect)(()=>{
        fetchData();
    }, []);
    const fetchData = async ()=>{
        // const data = await fetch(MENU_API_URL + resId);
        // const json = await data.json();
        setResInfo((0, $7f2c384ac384527b$export$befc3081f5a05f32).data);
    };
    return resInfo;
};



var $5aRSq = parcelRequire("5aRSq");
parcelRequire("4Iuzv");

var $5aRSq = parcelRequire("5aRSq");


// src/utils/formatProdErrorMessage.ts
function $b0c9b171c350de9c$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $b0c9b171c350de9c$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $b0c9b171c350de9c$var$symbol_observable_default = $b0c9b171c350de9c$var$$$observable;
// src/utils/actionTypes.ts
var $b0c9b171c350de9c$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $b0c9b171c350de9c$var$ActionTypes = {
    INIT: `@@redux/INIT${$b0c9b171c350de9c$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$b0c9b171c350de9c$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$b0c9b171c350de9c$var$randomString()}`
};
var $b0c9b171c350de9c$export$4219e499db7ca678 = $b0c9b171c350de9c$var$ActionTypes;
// src/utils/isPlainObject.ts
function $b0c9b171c350de9c$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $b0c9b171c350de9c$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($b0c9b171c350de9c$var$isDate(val)) return "date";
    if ($b0c9b171c350de9c$var$isError(val)) return "error";
    const constructorName = $b0c9b171c350de9c$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $b0c9b171c350de9c$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $b0c9b171c350de9c$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $b0c9b171c350de9c$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $b0c9b171c350de9c$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $b0c9b171c350de9c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(1));
        return enhancer($b0c9b171c350de9c$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$b0c9b171c350de9c$export$53b83ca8eaab0383(action)) throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $b0c9b171c350de9c$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$b0c9b171c350de9c$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $b0c9b171c350de9c$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$b0c9b171c350de9c$var$symbol_observable_default]: observable
    };
    return store;
}
function $b0c9b171c350de9c$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $b0c9b171c350de9c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $b0c9b171c350de9c$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $b0c9b171c350de9c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $b0c9b171c350de9c$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$b0c9b171c350de9c$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$b0c9b171c350de9c$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $b0c9b171c350de9c$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $b0c9b171c350de9c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $b0c9b171c350de9c$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $b0c9b171c350de9c$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(13));
    });
}
function $b0c9b171c350de9c$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $b0c9b171c350de9c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $b0c9b171c350de9c$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $b0c9b171c350de9c$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $b0c9b171c350de9c$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $b0c9b171c350de9c$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $b0c9b171c350de9c$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $b0c9b171c350de9c$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $b0c9b171c350de9c$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $b0c9b171c350de9c$export$b956e38827fca970(action) {
    return $b0c9b171c350de9c$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $7e93f60b48cb9fdf$var$__defProp = Object.defineProperty;
var $7e93f60b48cb9fdf$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7e93f60b48cb9fdf$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7e93f60b48cb9fdf$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7e93f60b48cb9fdf$var$__defNormalProp = (obj, key, value)=>key in obj ? $7e93f60b48cb9fdf$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7e93f60b48cb9fdf$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7e93f60b48cb9fdf$var$__hasOwnProp.call(b, prop)) $7e93f60b48cb9fdf$var$__defNormalProp(a, prop, b[prop]);
    if ($7e93f60b48cb9fdf$var$__getOwnPropSymbols) {
        for (var prop of $7e93f60b48cb9fdf$var$__getOwnPropSymbols(b))if ($7e93f60b48cb9fdf$var$__propIsEnum.call(b, prop)) $7e93f60b48cb9fdf$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $7e93f60b48cb9fdf$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $7e93f60b48cb9fdf$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $7e93f60b48cb9fdf$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $7e93f60b48cb9fdf$var$errors = [];
function $7e93f60b48cb9fdf$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $7e93f60b48cb9fdf$var$getPrototypeOf = Object.getPrototypeOf;
function $7e93f60b48cb9fdf$export$541ac630993a4c84(value) {
    return !!value && !!value[$7e93f60b48cb9fdf$var$DRAFT_STATE];
}
function $7e93f60b48cb9fdf$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $7e93f60b48cb9fdf$var$isPlainObject(value) || Array.isArray(value) || !!value[$7e93f60b48cb9fdf$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$7e93f60b48cb9fdf$export$6ee2082928bcb0ee]) || $7e93f60b48cb9fdf$var$isMap(value) || $7e93f60b48cb9fdf$var$isSet(value);
}
var $7e93f60b48cb9fdf$var$objectCtorString = Object.prototype.constructor.toString();
function $7e93f60b48cb9fdf$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $7e93f60b48cb9fdf$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $7e93f60b48cb9fdf$var$objectCtorString;
}
function $7e93f60b48cb9fdf$export$22e8af3f75a010e3(value) {
    if (!$7e93f60b48cb9fdf$export$541ac630993a4c84(value)) $7e93f60b48cb9fdf$var$die(15, value);
    return value[$7e93f60b48cb9fdf$var$DRAFT_STATE].base_;
}
function $7e93f60b48cb9fdf$var$each(obj, iter) {
    if ($7e93f60b48cb9fdf$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $7e93f60b48cb9fdf$var$getArchtype(thing) {
    const state = thing[$7e93f60b48cb9fdf$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $7e93f60b48cb9fdf$var$isMap(thing) ? 2 /* Map */  : $7e93f60b48cb9fdf$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $7e93f60b48cb9fdf$var$has(thing, prop) {
    return $7e93f60b48cb9fdf$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $7e93f60b48cb9fdf$var$get(thing, prop) {
    return $7e93f60b48cb9fdf$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $7e93f60b48cb9fdf$var$set(thing, propOrOldValue, value) {
    const t = $7e93f60b48cb9fdf$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $7e93f60b48cb9fdf$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $7e93f60b48cb9fdf$var$isMap(target) {
    return target instanceof Map;
}
function $7e93f60b48cb9fdf$var$isSet(target) {
    return target instanceof Set;
}
function $7e93f60b48cb9fdf$var$latest(state) {
    return state.copy_ || state.base_;
}
function $7e93f60b48cb9fdf$var$shallowCopy(base, strict) {
    if ($7e93f60b48cb9fdf$var$isMap(base)) return new Map(base);
    if ($7e93f60b48cb9fdf$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $7e93f60b48cb9fdf$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$7e93f60b48cb9fdf$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($7e93f60b48cb9fdf$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $7e93f60b48cb9fdf$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $7e93f60b48cb9fdf$var$__spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $7e93f60b48cb9fdf$export$792f3d81ea979f55(obj, deep = false) {
    if ($7e93f60b48cb9fdf$var$isFrozen(obj) || $7e93f60b48cb9fdf$export$541ac630993a4c84(obj) || !$7e93f60b48cb9fdf$export$16e3aed3edb85946(obj)) return obj;
    if ($7e93f60b48cb9fdf$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $7e93f60b48cb9fdf$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$7e93f60b48cb9fdf$export$792f3d81ea979f55(value, true));
    return obj;
}
function $7e93f60b48cb9fdf$var$dontMutateFrozenCollections() {
    $7e93f60b48cb9fdf$var$die(2);
}
function $7e93f60b48cb9fdf$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $7e93f60b48cb9fdf$var$plugins = {};
function $7e93f60b48cb9fdf$var$getPlugin(pluginKey) {
    const plugin = $7e93f60b48cb9fdf$var$plugins[pluginKey];
    if (!plugin) $7e93f60b48cb9fdf$var$die(0, pluginKey);
    return plugin;
}
function $7e93f60b48cb9fdf$var$loadPlugin(pluginKey, implementation) {
    if (!$7e93f60b48cb9fdf$var$plugins[pluginKey]) $7e93f60b48cb9fdf$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $7e93f60b48cb9fdf$var$currentScope;
function $7e93f60b48cb9fdf$var$getCurrentScope() {
    return $7e93f60b48cb9fdf$var$currentScope;
}
function $7e93f60b48cb9fdf$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $7e93f60b48cb9fdf$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $7e93f60b48cb9fdf$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $7e93f60b48cb9fdf$var$revokeScope(scope) {
    $7e93f60b48cb9fdf$var$leaveScope(scope);
    scope.drafts_.forEach($7e93f60b48cb9fdf$var$revokeDraft);
    scope.drafts_ = null;
}
function $7e93f60b48cb9fdf$var$leaveScope(scope) {
    if (scope === $7e93f60b48cb9fdf$var$currentScope) $7e93f60b48cb9fdf$var$currentScope = scope.parent_;
}
function $7e93f60b48cb9fdf$var$enterScope(immer2) {
    return $7e93f60b48cb9fdf$var$currentScope = $7e93f60b48cb9fdf$var$createScope($7e93f60b48cb9fdf$var$currentScope, immer2);
}
function $7e93f60b48cb9fdf$var$revokeDraft(draft) {
    const state = draft[$7e93f60b48cb9fdf$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $7e93f60b48cb9fdf$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$7e93f60b48cb9fdf$var$DRAFT_STATE].modified_) {
            $7e93f60b48cb9fdf$var$revokeScope(scope);
            $7e93f60b48cb9fdf$var$die(4);
        }
        if ($7e93f60b48cb9fdf$export$16e3aed3edb85946(result)) {
            result = $7e93f60b48cb9fdf$var$finalize(scope, result);
            if (!scope.parent_) $7e93f60b48cb9fdf$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $7e93f60b48cb9fdf$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$7e93f60b48cb9fdf$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $7e93f60b48cb9fdf$var$finalize(scope, baseDraft, []);
    $7e93f60b48cb9fdf$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $7e93f60b48cb9fdf$export$45b790e32b2810ee ? result : void 0;
}
function $7e93f60b48cb9fdf$var$finalize(rootScope, value, path) {
    if ($7e93f60b48cb9fdf$var$isFrozen(value)) return value;
    const state = value[$7e93f60b48cb9fdf$var$DRAFT_STATE];
    if (!state) {
        $7e93f60b48cb9fdf$var$each(value, (key, childValue)=>$7e93f60b48cb9fdf$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $7e93f60b48cb9fdf$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $7e93f60b48cb9fdf$var$each(resultEach, (key, childValue)=>$7e93f60b48cb9fdf$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $7e93f60b48cb9fdf$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $7e93f60b48cb9fdf$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $7e93f60b48cb9fdf$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($7e93f60b48cb9fdf$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$7e93f60b48cb9fdf$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $7e93f60b48cb9fdf$var$finalize(rootScope, childValue, path);
        $7e93f60b48cb9fdf$var$set(targetObject, prop, res);
        if ($7e93f60b48cb9fdf$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($7e93f60b48cb9fdf$export$16e3aed3edb85946(childValue) && !$7e93f60b48cb9fdf$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $7e93f60b48cb9fdf$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $7e93f60b48cb9fdf$var$maybeFreeze(rootScope, childValue);
    }
}
function $7e93f60b48cb9fdf$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $7e93f60b48cb9fdf$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $7e93f60b48cb9fdf$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $7e93f60b48cb9fdf$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $7e93f60b48cb9fdf$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $7e93f60b48cb9fdf$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $7e93f60b48cb9fdf$var$objectTraps = {
    get (state, prop) {
        if (prop === $7e93f60b48cb9fdf$var$DRAFT_STATE) return state;
        const source = $7e93f60b48cb9fdf$var$latest(state);
        if (!$7e93f60b48cb9fdf$var$has(source, prop)) return $7e93f60b48cb9fdf$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$7e93f60b48cb9fdf$export$16e3aed3edb85946(value)) return value;
        if (value === $7e93f60b48cb9fdf$var$peek(state.base_, prop)) {
            $7e93f60b48cb9fdf$var$prepareCopy(state);
            return state.copy_[prop] = $7e93f60b48cb9fdf$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $7e93f60b48cb9fdf$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($7e93f60b48cb9fdf$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $7e93f60b48cb9fdf$var$getDescriptorFromProto($7e93f60b48cb9fdf$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $7e93f60b48cb9fdf$var$peek($7e93f60b48cb9fdf$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($7e93f60b48cb9fdf$var$is(value, current2) && (value !== void 0 || $7e93f60b48cb9fdf$var$has(state.base_, prop))) return true;
            $7e93f60b48cb9fdf$var$prepareCopy(state);
            $7e93f60b48cb9fdf$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($7e93f60b48cb9fdf$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $7e93f60b48cb9fdf$var$prepareCopy(state);
            $7e93f60b48cb9fdf$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $7e93f60b48cb9fdf$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $7e93f60b48cb9fdf$var$die(11);
    },
    getPrototypeOf (state) {
        return $7e93f60b48cb9fdf$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $7e93f60b48cb9fdf$var$die(12);
    }
};
var $7e93f60b48cb9fdf$var$arrayTraps = {};
$7e93f60b48cb9fdf$var$each($7e93f60b48cb9fdf$var$objectTraps, (key, fn)=>{
    $7e93f60b48cb9fdf$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$7e93f60b48cb9fdf$var$arrayTraps.deleteProperty = function(state, prop) {
    return $7e93f60b48cb9fdf$var$arrayTraps.set.call(this, state, prop, void 0);
};
$7e93f60b48cb9fdf$var$arrayTraps.set = function(state, prop, value) {
    return $7e93f60b48cb9fdf$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $7e93f60b48cb9fdf$var$peek(draft, prop) {
    const state = draft[$7e93f60b48cb9fdf$var$DRAFT_STATE];
    const source = state ? $7e93f60b48cb9fdf$var$latest(state) : draft;
    return source[prop];
}
function $7e93f60b48cb9fdf$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $7e93f60b48cb9fdf$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $7e93f60b48cb9fdf$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $7e93f60b48cb9fdf$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $7e93f60b48cb9fdf$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $7e93f60b48cb9fdf$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $7e93f60b48cb9fdf$var$markChanged(state.parent_);
    }
}
function $7e93f60b48cb9fdf$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $7e93f60b48cb9fdf$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $7e93f60b48cb9fdf$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $7e93f60b48cb9fdf$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $7e93f60b48cb9fdf$var$die(7);
            let result;
            if ($7e93f60b48cb9fdf$export$16e3aed3edb85946(base)) {
                const scope = $7e93f60b48cb9fdf$var$enterScope(this);
                const proxy = $7e93f60b48cb9fdf$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $7e93f60b48cb9fdf$var$revokeScope(scope);
                    else $7e93f60b48cb9fdf$var$leaveScope(scope);
                }
                $7e93f60b48cb9fdf$var$usePatchesInScope(scope, patchListener);
                return $7e93f60b48cb9fdf$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $7e93f60b48cb9fdf$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $7e93f60b48cb9fdf$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $7e93f60b48cb9fdf$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $7e93f60b48cb9fdf$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$7e93f60b48cb9fdf$export$16e3aed3edb85946(base)) $7e93f60b48cb9fdf$var$die(8);
        if ($7e93f60b48cb9fdf$export$541ac630993a4c84(base)) base = $7e93f60b48cb9fdf$export$97aac956da55dae9(base);
        const scope = $7e93f60b48cb9fdf$var$enterScope(this);
        const proxy = $7e93f60b48cb9fdf$var$createProxy(base, void 0);
        proxy[$7e93f60b48cb9fdf$var$DRAFT_STATE].isManual_ = true;
        $7e93f60b48cb9fdf$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$7e93f60b48cb9fdf$var$DRAFT_STATE];
        if (!state || !state.isManual_) $7e93f60b48cb9fdf$var$die(9);
        const { scope_: scope } = state;
        $7e93f60b48cb9fdf$var$usePatchesInScope(scope, patchListener);
        return $7e93f60b48cb9fdf$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $7e93f60b48cb9fdf$var$getPlugin("Patches").applyPatches_;
        if ($7e93f60b48cb9fdf$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $7e93f60b48cb9fdf$var$createProxy(value, parent) {
    const draft = $7e93f60b48cb9fdf$var$isMap(value) ? $7e93f60b48cb9fdf$var$getPlugin("MapSet").proxyMap_(value, parent) : $7e93f60b48cb9fdf$var$isSet(value) ? $7e93f60b48cb9fdf$var$getPlugin("MapSet").proxySet_(value, parent) : $7e93f60b48cb9fdf$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $7e93f60b48cb9fdf$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $7e93f60b48cb9fdf$export$97aac956da55dae9(value) {
    if (!$7e93f60b48cb9fdf$export$541ac630993a4c84(value)) $7e93f60b48cb9fdf$var$die(10, value);
    return $7e93f60b48cb9fdf$var$currentImpl(value);
}
function $7e93f60b48cb9fdf$var$currentImpl(value) {
    if (!$7e93f60b48cb9fdf$export$16e3aed3edb85946(value) || $7e93f60b48cb9fdf$var$isFrozen(value)) return value;
    const state = value[$7e93f60b48cb9fdf$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $7e93f60b48cb9fdf$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $7e93f60b48cb9fdf$var$shallowCopy(value, true);
    $7e93f60b48cb9fdf$var$each(copy, (key, childValue)=>{
        $7e93f60b48cb9fdf$var$set(copy, key, $7e93f60b48cb9fdf$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $7e93f60b48cb9fdf$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $7e93f60b48cb9fdf$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $7e93f60b48cb9fdf$var$get(base_, key);
            const value = $7e93f60b48cb9fdf$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $7e93f60b48cb9fdf$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $7e93f60b48cb9fdf$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $7e93f60b48cb9fdf$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $7e93f60b48cb9fdf$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $7e93f60b48cb9fdf$var$die(errorOffset + 3);
                base = $7e93f60b48cb9fdf$var$get(base, p);
                if (typeof base !== "object") $7e93f60b48cb9fdf$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $7e93f60b48cb9fdf$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $7e93f60b48cb9fdf$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $7e93f60b48cb9fdf$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$7e93f60b48cb9fdf$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($7e93f60b48cb9fdf$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($7e93f60b48cb9fdf$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($7e93f60b48cb9fdf$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($7e93f60b48cb9fdf$var$has(obj, $7e93f60b48cb9fdf$export$6ee2082928bcb0ee)) cloned[$7e93f60b48cb9fdf$export$6ee2082928bcb0ee] = obj[$7e93f60b48cb9fdf$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($7e93f60b48cb9fdf$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $7e93f60b48cb9fdf$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $7e93f60b48cb9fdf$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$7e93f60b48cb9fdf$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $7e93f60b48cb9fdf$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $7e93f60b48cb9fdf$var$latest(this[$7e93f60b48cb9fdf$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $7e93f60b48cb9fdf$var$latest(this[$7e93f60b48cb9fdf$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$7e93f60b48cb9fdf$var$latest(state).has(key) || $7e93f60b48cb9fdf$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $7e93f60b48cb9fdf$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $7e93f60b48cb9fdf$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($7e93f60b48cb9fdf$var$latest(state).size) {
                prepareMapCopy(state);
                $7e93f60b48cb9fdf$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $7e93f60b48cb9fdf$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            $7e93f60b48cb9fdf$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $7e93f60b48cb9fdf$var$latest(state).get(key);
            if (state.finalized_ || !$7e93f60b48cb9fdf$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $7e93f60b48cb9fdf$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $7e93f60b48cb9fdf$var$latest(this[$7e93f60b48cb9fdf$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($7e93f60b48cb9fdf$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$7e93f60b48cb9fdf$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $7e93f60b48cb9fdf$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $7e93f60b48cb9fdf$var$latest(this[$7e93f60b48cb9fdf$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $7e93f60b48cb9fdf$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $7e93f60b48cb9fdf$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($7e93f60b48cb9fdf$var$latest(state).size) {
                prepareSetCopy(state);
                $7e93f60b48cb9fdf$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($7e93f60b48cb9fdf$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($7e93f60b48cb9fdf$export$16e3aed3edb85946(value)) {
                    const draft = $7e93f60b48cb9fdf$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $7e93f60b48cb9fdf$var$die(3, JSON.stringify($7e93f60b48cb9fdf$var$latest(state)));
    }
    $7e93f60b48cb9fdf$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $7e93f60b48cb9fdf$var$immer = new $7e93f60b48cb9fdf$export$aaadc6ff0f822719();
var $7e93f60b48cb9fdf$export$b46cabe22e78bc00 = $7e93f60b48cb9fdf$var$immer.produce;
var $7e93f60b48cb9fdf$export$4da66d41c9492c78 = $7e93f60b48cb9fdf$var$immer.produceWithPatches.bind($7e93f60b48cb9fdf$var$immer);
var $7e93f60b48cb9fdf$export$573f26f60825c493 = $7e93f60b48cb9fdf$var$immer.setAutoFreeze.bind($7e93f60b48cb9fdf$var$immer);
var $7e93f60b48cb9fdf$export$333ce65961cbe047 = $7e93f60b48cb9fdf$var$immer.setUseStrictShallowCopy.bind($7e93f60b48cb9fdf$var$immer);
var $7e93f60b48cb9fdf$export$a8b8e03e6bbe5473 = $7e93f60b48cb9fdf$var$immer.applyPatches.bind($7e93f60b48cb9fdf$var$immer);
var $7e93f60b48cb9fdf$export$3c3214997190395f = $7e93f60b48cb9fdf$var$immer.createDraft.bind($7e93f60b48cb9fdf$var$immer);
var $7e93f60b48cb9fdf$export$c60f5e69c521b528 = $7e93f60b48cb9fdf$var$immer.finishDraft.bind($7e93f60b48cb9fdf$var$immer);
function $7e93f60b48cb9fdf$export$c05b21e3257751e5(value) {
    return value;
}
function $7e93f60b48cb9fdf$export$20f911b3f8cf0b74(value) {
    return value;
}


var $be917d30338e5bfc$var$__defProp = Object.defineProperty;
var $be917d30338e5bfc$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $be917d30338e5bfc$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $be917d30338e5bfc$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $be917d30338e5bfc$var$__defNormalProp = (obj, key, value)=>key in obj ? $be917d30338e5bfc$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $be917d30338e5bfc$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($be917d30338e5bfc$var$__hasOwnProp.call(b, prop)) $be917d30338e5bfc$var$__defNormalProp(a, prop, b[prop]);
    if ($be917d30338e5bfc$var$__getOwnPropSymbols) {
        for (var prop of $be917d30338e5bfc$var$__getOwnPropSymbols(b))if ($be917d30338e5bfc$var$__propIsEnum.call(b, prop)) $be917d30338e5bfc$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $be917d30338e5bfc$var$__publicField = (obj, key, value)=>{
    $be917d30338e5bfc$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $be917d30338e5bfc$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $be917d30338e5bfc$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $be917d30338e5bfc$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $be917d30338e5bfc$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($be917d30338e5bfc$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $be917d30338e5bfc$var$NOT_FOUND = "NOT_FOUND";
function $be917d30338e5bfc$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $be917d30338e5bfc$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $be917d30338e5bfc$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $be917d30338e5bfc$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $be917d30338e5bfc$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $be917d30338e5bfc$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $be917d30338e5bfc$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $be917d30338e5bfc$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $be917d30338e5bfc$var$__spreadValues($be917d30338e5bfc$var$__spreadValues({}, $be917d30338e5bfc$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $be917d30338e5bfc$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $be917d30338e5bfc$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $be917d30338e5bfc$var$$REVISION = 0;
var $be917d30338e5bfc$var$CURRENT_TRACKER = null;
var $be917d30338e5bfc$var$Cell = class {
    constructor(initialValue, isEqual = $be917d30338e5bfc$var$tripleEq){
        $be917d30338e5bfc$var$__publicField(this, "revision", $be917d30338e5bfc$var$$REVISION);
        $be917d30338e5bfc$var$__publicField(this, "_value");
        $be917d30338e5bfc$var$__publicField(this, "_lastValue");
        $be917d30338e5bfc$var$__publicField(this, "_isEqual", $be917d30338e5bfc$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $be917d30338e5bfc$var$CURRENT_TRACKER == null || $be917d30338e5bfc$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$be917d30338e5bfc$var$$REVISION;
    }
};
function $be917d30338e5bfc$var$tripleEq(a, b) {
    return a === b;
}
var $be917d30338e5bfc$var$TrackingCache = class {
    constructor(fn){
        $be917d30338e5bfc$var$__publicField(this, "_cachedValue");
        $be917d30338e5bfc$var$__publicField(this, "_cachedRevision", -1);
        $be917d30338e5bfc$var$__publicField(this, "_deps", []);
        $be917d30338e5bfc$var$__publicField(this, "hits", 0);
        $be917d30338e5bfc$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $be917d30338e5bfc$var$CURRENT_TRACKER;
            $be917d30338e5bfc$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $be917d30338e5bfc$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $be917d30338e5bfc$var$CURRENT_TRACKER == null || $be917d30338e5bfc$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $be917d30338e5bfc$var$getValue(cell) {
    if (!(cell instanceof $be917d30338e5bfc$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $be917d30338e5bfc$var$setValue(storage, value) {
    if (!(storage instanceof $be917d30338e5bfc$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $be917d30338e5bfc$var$createCell(initialValue, isEqual = $be917d30338e5bfc$var$tripleEq) {
    return new $be917d30338e5bfc$var$Cell(initialValue, isEqual);
}
function $be917d30338e5bfc$var$createCache(fn) {
    $be917d30338e5bfc$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $be917d30338e5bfc$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $be917d30338e5bfc$var$neverEq = (a, b)=>false;
function $be917d30338e5bfc$var$createTag() {
    return $be917d30338e5bfc$var$createCell(null, $be917d30338e5bfc$var$neverEq);
}
function $be917d30338e5bfc$var$dirtyTag(tag, value) {
    $be917d30338e5bfc$var$setValue(tag, value);
}
var $be917d30338e5bfc$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $be917d30338e5bfc$var$createTag();
    $be917d30338e5bfc$var$getValue(tag);
};
var $be917d30338e5bfc$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $be917d30338e5bfc$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $be917d30338e5bfc$var$REDUX_PROXY_LABEL = Symbol();
var $be917d30338e5bfc$var$nextId = 0;
var $be917d30338e5bfc$var$proto = Object.getPrototypeOf({});
var $be917d30338e5bfc$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $be917d30338e5bfc$var$__publicField(this, "proxy", new Proxy(this, $be917d30338e5bfc$var$objectProxyHandler));
        $be917d30338e5bfc$var$__publicField(this, "tag", $be917d30338e5bfc$var$createTag());
        $be917d30338e5bfc$var$__publicField(this, "tags", {});
        $be917d30338e5bfc$var$__publicField(this, "children", {});
        $be917d30338e5bfc$var$__publicField(this, "collectionTag", null);
        $be917d30338e5bfc$var$__publicField(this, "id", $be917d30338e5bfc$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $be917d30338e5bfc$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $be917d30338e5bfc$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $be917d30338e5bfc$var$createNode(childValue);
                if (childNode.tag) $be917d30338e5bfc$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $be917d30338e5bfc$var$createTag();
                    tag.value = childValue;
                }
                $be917d30338e5bfc$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $be917d30338e5bfc$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $be917d30338e5bfc$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $be917d30338e5bfc$var$__publicField(this, "proxy", new Proxy([
            this
        ], $be917d30338e5bfc$var$arrayProxyHandler));
        $be917d30338e5bfc$var$__publicField(this, "tag", $be917d30338e5bfc$var$createTag());
        $be917d30338e5bfc$var$__publicField(this, "tags", {});
        $be917d30338e5bfc$var$__publicField(this, "children", {});
        $be917d30338e5bfc$var$__publicField(this, "collectionTag", null);
        $be917d30338e5bfc$var$__publicField(this, "id", $be917d30338e5bfc$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $be917d30338e5bfc$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $be917d30338e5bfc$var$consumeCollection(node);
        return $be917d30338e5bfc$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $be917d30338e5bfc$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $be917d30338e5bfc$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $be917d30338e5bfc$var$objectProxyHandler.has(node, prop);
    }
};
function $be917d30338e5bfc$var$createNode(value) {
    if (Array.isArray(value)) return new $be917d30338e5bfc$var$ArrayTreeNode(value);
    return new $be917d30338e5bfc$var$ObjectTreeNode(value);
}
function $be917d30338e5bfc$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $be917d30338e5bfc$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $be917d30338e5bfc$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $be917d30338e5bfc$var$dirtyCollection(node);
            $be917d30338e5bfc$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $be917d30338e5bfc$var$updateNode(childNode, newChildValue);
        else {
            $be917d30338e5bfc$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $be917d30338e5bfc$var$deleteNode(node) {
    if (node.tag) $be917d30338e5bfc$var$dirtyTag(node.tag, null);
    $be917d30338e5bfc$var$dirtyCollection(node);
    for(const key in node.tags)$be917d30338e5bfc$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$be917d30338e5bfc$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $be917d30338e5bfc$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $be917d30338e5bfc$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $be917d30338e5bfc$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $be917d30338e5bfc$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $be917d30338e5bfc$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $be917d30338e5bfc$export$3f025202a230c6dd = (a, b)=>a === b;
function $be917d30338e5bfc$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $be917d30338e5bfc$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $be917d30338e5bfc$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $be917d30338e5bfc$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize === 1 ? $be917d30338e5bfc$var$createSingletonCache(comparator) : $be917d30338e5bfc$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $be917d30338e5bfc$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $be917d30338e5bfc$export$c8f9cf88d9fdee55(func) {
    const node = $be917d30338e5bfc$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $be917d30338e5bfc$var$createCacheKeyComparator($be917d30338e5bfc$export$3f025202a230c6dd);
    const cache = $be917d30338e5bfc$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $be917d30338e5bfc$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $be917d30338e5bfc$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $be917d30338e5bfc$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $be917d30338e5bfc$var$StrongRef;
var $be917d30338e5bfc$var$UNTERMINATED = 0;
var $be917d30338e5bfc$var$TERMINATED = 1;
function $be917d30338e5bfc$var$createCacheNode() {
    return {
        s: $be917d30338e5bfc$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $be917d30338e5bfc$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $be917d30338e5bfc$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $be917d30338e5bfc$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $be917d30338e5bfc$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $be917d30338e5bfc$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
        }
        terminatedNode.s = $be917d30338e5bfc$var$TERMINATED;
        if (resultEqualityCheck) {
            const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
            if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                result = lastResultValue;
                resultsCount !== 0 && resultsCount--;
            }
            const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
            lastResult = needsWeakRef ? new $be917d30338e5bfc$var$Ref(result) : result;
        }
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $be917d30338e5bfc$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $be917d30338e5bfc$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $be917d30338e5bfc$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $be917d30338e5bfc$var$__spreadValues($be917d30338e5bfc$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $be917d30338e5bfc$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $be917d30338e5bfc$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $be917d30338e5bfc$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $be917d30338e5bfc$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $be917d30338e5bfc$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $be917d30338e5bfc$export$595d22ed68ca2841 = /* @__PURE__ */ $be917d30338e5bfc$export$5943f4447f6ef248($be917d30338e5bfc$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $be917d30338e5bfc$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $be917d30338e5bfc$export$595d22ed68ca2841)=>{
    $be917d30338e5bfc$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$be917d30338e5bfc$export$75979cfcd91bf38f
});


// src/index.ts
function $b9d54142851513e7$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $b9d54142851513e7$export$dd164f5517779f15 = $b9d54142851513e7$var$createThunkMiddleware();
var $b9d54142851513e7$export$16d06542a1949d9e = $b9d54142851513e7$var$createThunkMiddleware;


var $5671edd534fa79c4$exports = {};
// shim for using process in browser
var $5671edd534fa79c4$var$process = $5671edd534fa79c4$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $5671edd534fa79c4$var$cachedSetTimeout;
var $5671edd534fa79c4$var$cachedClearTimeout;
function $5671edd534fa79c4$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $5671edd534fa79c4$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $5671edd534fa79c4$var$cachedSetTimeout = setTimeout;
        else $5671edd534fa79c4$var$cachedSetTimeout = $5671edd534fa79c4$var$defaultSetTimout;
    } catch (e) {
        $5671edd534fa79c4$var$cachedSetTimeout = $5671edd534fa79c4$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $5671edd534fa79c4$var$cachedClearTimeout = clearTimeout;
        else $5671edd534fa79c4$var$cachedClearTimeout = $5671edd534fa79c4$var$defaultClearTimeout;
    } catch (e) {
        $5671edd534fa79c4$var$cachedClearTimeout = $5671edd534fa79c4$var$defaultClearTimeout;
    }
})();
function $5671edd534fa79c4$var$runTimeout(fun) {
    if ($5671edd534fa79c4$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($5671edd534fa79c4$var$cachedSetTimeout === $5671edd534fa79c4$var$defaultSetTimout || !$5671edd534fa79c4$var$cachedSetTimeout) && setTimeout) {
        $5671edd534fa79c4$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $5671edd534fa79c4$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $5671edd534fa79c4$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $5671edd534fa79c4$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $5671edd534fa79c4$var$runClearTimeout(marker) {
    if ($5671edd534fa79c4$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($5671edd534fa79c4$var$cachedClearTimeout === $5671edd534fa79c4$var$defaultClearTimeout || !$5671edd534fa79c4$var$cachedClearTimeout) && clearTimeout) {
        $5671edd534fa79c4$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $5671edd534fa79c4$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $5671edd534fa79c4$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $5671edd534fa79c4$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $5671edd534fa79c4$var$queue = [];
var $5671edd534fa79c4$var$draining = false;
var $5671edd534fa79c4$var$currentQueue;
var $5671edd534fa79c4$var$queueIndex = -1;
function $5671edd534fa79c4$var$cleanUpNextTick() {
    if (!$5671edd534fa79c4$var$draining || !$5671edd534fa79c4$var$currentQueue) return;
    $5671edd534fa79c4$var$draining = false;
    if ($5671edd534fa79c4$var$currentQueue.length) $5671edd534fa79c4$var$queue = $5671edd534fa79c4$var$currentQueue.concat($5671edd534fa79c4$var$queue);
    else $5671edd534fa79c4$var$queueIndex = -1;
    if ($5671edd534fa79c4$var$queue.length) $5671edd534fa79c4$var$drainQueue();
}
function $5671edd534fa79c4$var$drainQueue() {
    if ($5671edd534fa79c4$var$draining) return;
    var timeout = $5671edd534fa79c4$var$runTimeout($5671edd534fa79c4$var$cleanUpNextTick);
    $5671edd534fa79c4$var$draining = true;
    var len = $5671edd534fa79c4$var$queue.length;
    while(len){
        $5671edd534fa79c4$var$currentQueue = $5671edd534fa79c4$var$queue;
        $5671edd534fa79c4$var$queue = [];
        while(++$5671edd534fa79c4$var$queueIndex < len)if ($5671edd534fa79c4$var$currentQueue) $5671edd534fa79c4$var$currentQueue[$5671edd534fa79c4$var$queueIndex].run();
        $5671edd534fa79c4$var$queueIndex = -1;
        len = $5671edd534fa79c4$var$queue.length;
    }
    $5671edd534fa79c4$var$currentQueue = null;
    $5671edd534fa79c4$var$draining = false;
    $5671edd534fa79c4$var$runClearTimeout(timeout);
}
$5671edd534fa79c4$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $5671edd534fa79c4$var$queue.push(new $5671edd534fa79c4$var$Item(fun, args));
    if ($5671edd534fa79c4$var$queue.length === 1 && !$5671edd534fa79c4$var$draining) $5671edd534fa79c4$var$runTimeout($5671edd534fa79c4$var$drainQueue);
};
// v8 likes predictible objects
function $5671edd534fa79c4$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$5671edd534fa79c4$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$5671edd534fa79c4$var$process.title = "browser";
$5671edd534fa79c4$var$process.browser = true;
$5671edd534fa79c4$var$process.env = {};
$5671edd534fa79c4$var$process.argv = [];
$5671edd534fa79c4$var$process.version = ""; // empty string to avoid regexp issues
$5671edd534fa79c4$var$process.versions = {};
function $5671edd534fa79c4$var$noop() {}
$5671edd534fa79c4$var$process.on = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.addListener = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.once = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.off = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.removeListener = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.removeAllListeners = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.emit = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.prependListener = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.prependOnceListener = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.listeners = function(name) {
    return [];
};
$5671edd534fa79c4$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$5671edd534fa79c4$var$process.cwd = function() {
    return "/";
};
$5671edd534fa79c4$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$5671edd534fa79c4$var$process.umask = function() {
    return 0;
};


var $0005262392d89a41$var$__defProp = Object.defineProperty;
var $0005262392d89a41$var$__defProps = Object.defineProperties;
var $0005262392d89a41$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $0005262392d89a41$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0005262392d89a41$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0005262392d89a41$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0005262392d89a41$var$__defNormalProp = (obj, key, value)=>key in obj ? $0005262392d89a41$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0005262392d89a41$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0005262392d89a41$var$__hasOwnProp.call(b, prop)) $0005262392d89a41$var$__defNormalProp(a, prop, b[prop]);
    if ($0005262392d89a41$var$__getOwnPropSymbols) {
        for (var prop of $0005262392d89a41$var$__getOwnPropSymbols(b))if ($0005262392d89a41$var$__propIsEnum.call(b, prop)) $0005262392d89a41$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0005262392d89a41$var$__spreadProps = (a, b)=>$0005262392d89a41$var$__defProps(a, $0005262392d89a41$var$__getOwnPropDescs(b));
var $0005262392d89a41$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($0005262392d89a41$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $0005262392d89a41$var$__getOwnPropSymbols) {
        for (var prop of $0005262392d89a41$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $0005262392d89a41$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $0005262392d89a41$var$__publicField = (obj, key, value)=>{
    $0005262392d89a41$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
var $0005262392d89a41$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $be917d30338e5bfc$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $7e93f60b48cb9fdf$export$541ac630993a4c84)(value) ? (0, $7e93f60b48cb9fdf$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $0005262392d89a41$export$a5d3c27355e35910 = $0005262392d89a41$export$aab6de9e3dbb1473((0, $be917d30338e5bfc$export$8402dc26d96f6902));
var $0005262392d89a41$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $b0c9b171c350de9c$export$f672e0b6f7222cd7;
    return (0, $b0c9b171c350de9c$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $0005262392d89a41$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $0005262392d89a41$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $0005262392d89a41$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($0005262392d89a41$export$378fa86b259c0280(0));
            return $0005262392d89a41$var$__spreadValues($0005262392d89a41$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $b0c9b171c350de9c$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $0005262392d89a41$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $0005262392d89a41$var$hasMatchFunction(action);
}
function $0005262392d89a41$export$ebd532f9034651f3(action) {
    return (0, $b0c9b171c350de9c$export$b956e38827fca970)(action) && Object.keys(action).every($0005262392d89a41$var$isValidKey);
}
function $0005262392d89a41$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $0005262392d89a41$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $0005262392d89a41$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $0005262392d89a41$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
function $0005262392d89a41$var$find(iterable, comparator) {
    for (const entry of iterable){
        if (comparator(entry)) return entry;
    }
    return void 0;
}
var $0005262392d89a41$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $0005262392d89a41$var$freezeDraftable(val) {
    return (0, $7e93f60b48cb9fdf$export$16e3aed3edb85946)(val) ? (0, $7e93f60b48cb9fdf$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $0005262392d89a41$var$emplace(map, key, handler) {
    if (map.has(key)) {
        let value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($0005262392d89a41$export$378fa86b259c0280(10));
    const inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $0005262392d89a41$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $0005262392d89a41$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $0005262392d89a41$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $0005262392d89a41$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $0005262392d89a41$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $0005262392d89a41$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $0005262392d89a41$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $0005262392d89a41$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $0005262392d89a41$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $0005262392d89a41$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $b0c9b171c350de9c$export$53b83ca8eaab0383)(val);
}
function $0005262392d89a41$export$ada5dca0b571bc7(value, path = "", isSerializable = $0005262392d89a41$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $0005262392d89a41$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $0005262392d89a41$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $0005262392d89a41$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$0005262392d89a41$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $0005262392d89a41$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $0005262392d89a41$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $0005262392d89a41$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $0005262392d89a41$export$1908877435b1d5e9();
        if (thunk) {
            if ($0005262392d89a41$var$isBoolean(thunk)) middlewareArray.push((0, $b9d54142851513e7$export$dd164f5517779f15));
            else middlewareArray.push((0, $b9d54142851513e7$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $0005262392d89a41$export$8fb31c0f05df007b = "RTK_autoBatch";
var $0005262392d89a41$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$0005262392d89a41$export$8fb31c0f05df007b]: true
            }
        });
var $0005262392d89a41$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $0005262392d89a41$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $0005262392d89a41$var$createQueueWithTimer(10);
var $0005262392d89a41$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $0005262392d89a41$var$rAF : options.type === "callback" ? options.queueNotification : $0005262392d89a41$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$0005262392d89a41$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $0005262392d89a41$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $0005262392d89a41$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($0005262392d89a41$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
var $0005262392d89a41$var$IS_PRODUCTION = true;
function $0005262392d89a41$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $0005262392d89a41$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $b0c9b171c350de9c$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $b0c9b171c350de9c$export$66e4520cdb265d18)(reducer);
    else throw new Error($0005262392d89a41$export$378fa86b259c0280(1));
    if (!$0005262392d89a41$var$IS_PRODUCTION && middleware && typeof middleware !== "function") throw new Error($0005262392d89a41$export$378fa86b259c0280(2));
    let finalMiddleware;
    if (typeof middleware === "function") {
        finalMiddleware = middleware(getDefaultMiddleware);
        if (!$0005262392d89a41$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error($0005262392d89a41$export$378fa86b259c0280(3));
    } else finalMiddleware = getDefaultMiddleware();
    if (!$0005262392d89a41$var$IS_PRODUCTION && finalMiddleware.some((item)=>typeof item !== "function")) throw new Error($0005262392d89a41$export$378fa86b259c0280(4));
    let finalCompose = (0, $b0c9b171c350de9c$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $0005262392d89a41$var$composeWithDevTools($0005262392d89a41$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: !$0005262392d89a41$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $b0c9b171c350de9c$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $0005262392d89a41$var$buildGetDefaultEnhancers(middlewareEnhancer);
    if (!$0005262392d89a41$var$IS_PRODUCTION && enhancers && typeof enhancers !== "function") throw new Error($0005262392d89a41$export$378fa86b259c0280(5));
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    if (!$0005262392d89a41$var$IS_PRODUCTION && !Array.isArray(storeEnhancers)) throw new Error($0005262392d89a41$export$378fa86b259c0280(6));
    if (!$0005262392d89a41$var$IS_PRODUCTION && storeEnhancers.some((item)=>typeof item !== "function")) throw new Error($0005262392d89a41$export$378fa86b259c0280(7));
    if (!$0005262392d89a41$var$IS_PRODUCTION && finalMiddleware.length && !storeEnhancers.includes(middlewareEnhancer)) console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $b0c9b171c350de9c$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $0005262392d89a41$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($0005262392d89a41$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($0005262392d89a41$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $0005262392d89a41$var$isStateFunction(x) {
    return typeof x === "function";
}
function $0005262392d89a41$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $0005262392d89a41$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($0005262392d89a41$var$isStateFunction(initialState)) getInitialState = ()=>$0005262392d89a41$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $0005262392d89a41$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $7e93f60b48cb9fdf$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $7e93f60b48cb9fdf$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($0005262392d89a41$export$378fa86b259c0280(9));
                    }
                    return result;
                } else return (0, $7e93f60b48cb9fdf$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/nanoid.ts
var $0005262392d89a41$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $0005262392d89a41$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $0005262392d89a41$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/matchers.ts
var $0005262392d89a41$var$matches = (matcher, action)=>{
    if ($0005262392d89a41$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $0005262392d89a41$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$0005262392d89a41$var$matches(matcher, action));
    };
}
function $0005262392d89a41$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$0005262392d89a41$var$matches(matcher, action));
    };
}
function $0005262392d89a41$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $0005262392d89a41$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $0005262392d89a41$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$0005262392d89a41$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$0005262392d89a41$var$isAsyncThunkArray(asyncThunks)) return $0005262392d89a41$export$872dec21e9a69476()(asyncThunks[0]);
    return $0005262392d89a41$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $0005262392d89a41$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$0005262392d89a41$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$0005262392d89a41$var$isAsyncThunkArray(asyncThunks)) return $0005262392d89a41$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $0005262392d89a41$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $0005262392d89a41$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $0005262392d89a41$export$9dd1fb32974da385($0005262392d89a41$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$0005262392d89a41$var$isAsyncThunkArray(asyncThunks)) return $0005262392d89a41$export$fcc3388fb56de601()(asyncThunks[0]);
    return $0005262392d89a41$export$9dd1fb32974da385($0005262392d89a41$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $0005262392d89a41$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$0005262392d89a41$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$0005262392d89a41$var$isAsyncThunkArray(asyncThunks)) return $0005262392d89a41$export$1da80a6ef1307441()(asyncThunks[0]);
    return $0005262392d89a41$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $0005262392d89a41$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$0005262392d89a41$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$0005262392d89a41$var$isAsyncThunkArray(asyncThunks)) return $0005262392d89a41$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $0005262392d89a41$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/createAsyncThunk.ts
var $0005262392d89a41$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $0005262392d89a41$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $0005262392d89a41$var$__publicField(this, "_type");
    }
};
var $0005262392d89a41$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $0005262392d89a41$var$__publicField(this, "_type");
    }
};
var $0005262392d89a41$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $0005262392d89a41$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $0005262392d89a41$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $0005262392d89a41$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $0005262392d89a41$var$__spreadProps($0005262392d89a41$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $0005262392d89a41$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $0005262392d89a41$var$__spreadProps($0005262392d89a41$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $0005262392d89a41$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $0005262392d89a41$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $0005262392d89a41$var$__spreadProps($0005262392d89a41$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $0005262392d89a41$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($0005262392d89a41$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $0005262392d89a41$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $0005262392d89a41$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $0005262392d89a41$var$RejectWithValue) throw result;
                                if (result instanceof $0005262392d89a41$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $0005262392d89a41$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($0005262392d89a41$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $0005262392d89a41$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $0005262392d89a41$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $0005262392d89a41$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $0005262392d89a41$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $0005262392d89a41$export$343355ed40c51c46 = {
    [$0005262392d89a41$var$asyncThunkSymbol]: $0005262392d89a41$export$6abd22dc03e5063f
};
var $0005262392d89a41$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($0005262392d89a41$export$23a094319a4b586 || {});
function $0005262392d89a41$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $0005262392d89a41$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$0005262392d89a41$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($0005262392d89a41$export$378fa86b259c0280(11));
        typeof $5671edd534fa79c4$exports;
        const reducers = (typeof options.reducers === "function" ? options.reducers($0005262392d89a41$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($0005262392d89a41$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($0005262392d89a41$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $0005262392d89a41$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($0005262392d89a41$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $0005262392d89a41$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $0005262392d89a41$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $0005262392d89a41$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $0005262392d89a41$var$__spreadValues($0005262392d89a41$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $0005262392d89a41$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $0005262392d89a41$var$emplace(injectedSelectorCache, injected, {
                    insert: ()=>/* @__PURE__ */ new WeakMap()
                });
                return $0005262392d89a41$var$emplace(selectorCache, selectState, {
                    insert: ()=>{
                        var _a2;
                        const map = {};
                        for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $0005262392d89a41$var$wrapSelector(selector, selectState, getInitialState, injected);
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $0005262392d89a41$var$__spreadProps($0005262392d89a41$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $0005262392d89a41$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $0005262392d89a41$var$__spreadValues($0005262392d89a41$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $0005262392d89a41$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $0005262392d89a41$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $0005262392d89a41$export$affdea4146de9cf5();
function $0005262392d89a41$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $0005262392d89a41$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $0005262392d89a41$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$0005262392d89a41$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($0005262392d89a41$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $0005262392d89a41$export$309c7a02b0b0bc62(type, prepareCallback) : $0005262392d89a41$export$309c7a02b0b0bc62(type));
}
function $0005262392d89a41$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $0005262392d89a41$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $0005262392d89a41$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($0005262392d89a41$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $0005262392d89a41$var$noop,
        pending: pending || $0005262392d89a41$var$noop,
        rejected: rejected || $0005262392d89a41$var$noop,
        settled: settled || $0005262392d89a41$var$noop
    });
}
function $0005262392d89a41$var$noop() {}
// src/entities/entity_state.ts
function $0005262392d89a41$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $0005262392d89a41$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($0005262392d89a41$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $0005262392d89a41$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $0005262392d89a41$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $0005262392d89a41$var$isDraftTyped = (0, $7e93f60b48cb9fdf$export$541ac630993a4c84);
function $0005262392d89a41$var$createSingleArgumentStateOperator(mutator) {
    const operator = $0005262392d89a41$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $0005262392d89a41$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $0005262392d89a41$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($0005262392d89a41$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $7e93f60b48cb9fdf$export$b46cabe22e78bc00)(state, runMutator);
    };
}
function $0005262392d89a41$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $0005262392d89a41$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $0005262392d89a41$var$getCurrent(value) {
    return (0, $7e93f60b48cb9fdf$export$541ac630993a4c84)(value) ? (0, $7e93f60b48cb9fdf$export$97aac956da55dae9)(value) : value;
}
function $0005262392d89a41$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $0005262392d89a41$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $0005262392d89a41$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = $0005262392d89a41$var$selectIdValue(entity, selectId);
        if (existingIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $0005262392d89a41$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $0005262392d89a41$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $0005262392d89a41$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $0005262392d89a41$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $0005262392d89a41$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $0005262392d89a41$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $0005262392d89a41$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $0005262392d89a41$var$__spreadValues($0005262392d89a41$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$0005262392d89a41$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $0005262392d89a41$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $0005262392d89a41$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $0005262392d89a41$var$createStateOperator(addOneMutably),
        addMany: $0005262392d89a41$var$createStateOperator(addManyMutably),
        setOne: $0005262392d89a41$var$createStateOperator(setOneMutably),
        setMany: $0005262392d89a41$var$createStateOperator(setManyMutably),
        setAll: $0005262392d89a41$var$createStateOperator(setAllMutably),
        updateOne: $0005262392d89a41$var$createStateOperator(updateOneMutably),
        updateMany: $0005262392d89a41$var$createStateOperator(updateManyMutably),
        upsertOne: $0005262392d89a41$var$createStateOperator(upsertOneMutably),
        upsertMany: $0005262392d89a41$var$createStateOperator(upsertManyMutably),
        removeOne: $0005262392d89a41$var$createStateOperator(removeOneMutably),
        removeMany: $0005262392d89a41$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $0005262392d89a41$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $0005262392d89a41$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $0005262392d89a41$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $0005262392d89a41$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $0005262392d89a41$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $0005262392d89a41$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : (0, $7e93f60b48cb9fdf$export$97aac956da55dae9)(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has($0005262392d89a41$var$selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $0005262392d89a41$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $0005262392d89a41$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $0005262392d89a41$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeInsertion = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $0005262392d89a41$var$getCurrent(state.entities);
        const currentIds = $0005262392d89a41$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = Array.from(new Set(currentIds));
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $0005262392d89a41$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    const mergeFunction = mergeInsertion;
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $0005262392d89a41$var$createStateOperator(addOneMutably),
        updateOne: $0005262392d89a41$var$createStateOperator(updateOneMutably),
        upsertOne: $0005262392d89a41$var$createStateOperator(upsertOneMutably),
        setOne: $0005262392d89a41$var$createStateOperator(setOneMutably),
        setMany: $0005262392d89a41$var$createStateOperator(setManyMutably),
        setAll: $0005262392d89a41$var$createStateOperator(setAllMutably),
        addMany: $0005262392d89a41$var$createStateOperator(addManyMutably),
        updateMany: $0005262392d89a41$var$createStateOperator(updateManyMutably),
        upsertMany: $0005262392d89a41$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $0005262392d89a41$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $0005262392d89a41$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $0005262392d89a41$var$createSortedStateAdapter(selectId, sortComparer) : $0005262392d89a41$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $0005262392d89a41$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $0005262392d89a41$var$createSelectorsFactory();
    return $0005262392d89a41$var$__spreadValues($0005262392d89a41$var$__spreadValues($0005262392d89a41$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $0005262392d89a41$var$task = "task";
var $0005262392d89a41$var$listener = "listener";
var $0005262392d89a41$var$completed = "completed";
var $0005262392d89a41$var$cancelled = "cancelled";
var $0005262392d89a41$var$taskCancelled = `task-${$0005262392d89a41$var$cancelled}`;
var $0005262392d89a41$var$taskCompleted = `task-${$0005262392d89a41$var$completed}`;
var $0005262392d89a41$var$listenerCancelled = `${$0005262392d89a41$var$listener}-${$0005262392d89a41$var$cancelled}`;
var $0005262392d89a41$var$listenerCompleted = `${$0005262392d89a41$var$listener}-${$0005262392d89a41$var$completed}`;
var $0005262392d89a41$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $0005262392d89a41$var$__publicField(this, "name", "TaskAbortError");
        $0005262392d89a41$var$__publicField(this, "message");
        this.message = `${$0005262392d89a41$var$task} ${$0005262392d89a41$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $0005262392d89a41$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new Error($0005262392d89a41$export$378fa86b259c0280(32));
};
var $0005262392d89a41$var$noop2 = ()=>{};
var $0005262392d89a41$var$catchRejection = (promise, onError = $0005262392d89a41$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $0005262392d89a41$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $0005262392d89a41$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $0005262392d89a41$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $0005262392d89a41$export$cb1bdac908fed7f(reason);
    }
};
function $0005262392d89a41$var$raceWithSignal(signal, promise) {
    let cleanup = $0005262392d89a41$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $0005262392d89a41$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $0005262392d89a41$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $0005262392d89a41$var$noop2;
    });
}
var $0005262392d89a41$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $0005262392d89a41$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $0005262392d89a41$var$createPause = (signal)=>{
    return (promise)=>{
        return $0005262392d89a41$var$catchRejection($0005262392d89a41$var$raceWithSignal(signal, promise).then((output)=>{
            $0005262392d89a41$var$validateActive(signal);
            return output;
        }));
    };
};
var $0005262392d89a41$var$createDelay = (signal)=>{
    const pause = $0005262392d89a41$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $0005262392d89a41$var$assign } = Object;
var $0005262392d89a41$var$INTERNAL_NIL_TOKEN = {};
var $0005262392d89a41$var$alm = "listenerMiddleware";
var $0005262392d89a41$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$0005262392d89a41$var$addAbortSignalListener(parentAbortSignal, ()=>$0005262392d89a41$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $0005262392d89a41$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $0005262392d89a41$var$runTask(async ()=>{
            $0005262392d89a41$var$validateActive(parentAbortSignal);
            $0005262392d89a41$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $0005262392d89a41$var$createPause(childAbortController.signal),
                delay: $0005262392d89a41$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $0005262392d89a41$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$0005262392d89a41$var$abortControllerWithReason(childAbortController, $0005262392d89a41$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($0005262392d89a41$var$noop2));
        return {
            result: $0005262392d89a41$var$createPause(parentAbortSignal)(result),
            cancel () {
                $0005262392d89a41$var$abortControllerWithReason(childAbortController, $0005262392d89a41$var$taskCancelled);
            }
        };
    };
};
var $0005262392d89a41$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $0005262392d89a41$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $0005262392d89a41$var$raceWithSignal(signal, Promise.race(promises));
            $0005262392d89a41$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$0005262392d89a41$var$catchRejection(take(predicate, timeout));
};
var $0005262392d89a41$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $0005262392d89a41$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($0005262392d89a41$export$378fa86b259c0280(21));
    $0005262392d89a41$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $0005262392d89a41$var$createListenerEntry = Object.assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $0005262392d89a41$var$getListenerEntryPropsFrom(options);
    const id = $0005262392d89a41$export$ac4959f4f1338dfc();
    const entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($0005262392d89a41$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$0005262392d89a41$var$createListenerEntry
});
var $0005262392d89a41$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $0005262392d89a41$var$abortControllerWithReason(controller, $0005262392d89a41$var$listenerCancelled);
    });
};
var $0005262392d89a41$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($0005262392d89a41$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $0005262392d89a41$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $0005262392d89a41$export$f03a6b845d3fb58b = Object.assign($0005262392d89a41$export$309c7a02b0b0bc62(`${$0005262392d89a41$var$alm}/add`), {
    withTypes: ()=>$0005262392d89a41$export$f03a6b845d3fb58b
});
var $0005262392d89a41$export$b1b8022855fb2b71 = $0005262392d89a41$export$309c7a02b0b0bc62(`${$0005262392d89a41$var$alm}/removeAll`);
var $0005262392d89a41$export$b03e9483f936dccb = Object.assign($0005262392d89a41$export$309c7a02b0b0bc62(`${$0005262392d89a41$var$alm}/remove`), {
    withTypes: ()=>$0005262392d89a41$export$b03e9483f936dccb
});
var $0005262392d89a41$var$defaultErrorHandler = (...args)=>{
    console.error(`${$0005262392d89a41$var$alm}/error`, ...args);
};
var $0005262392d89a41$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $0005262392d89a41$var$defaultErrorHandler } = middlewareOptions;
    $0005262392d89a41$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $0005262392d89a41$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        let entry = $0005262392d89a41$var$find(Array.from(listenerMap.values()), (existingEntry)=>existingEntry.effect === options.effect);
        if (!entry) entry = $0005262392d89a41$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    Object.assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const { type: type, effect: effect, predicate: predicate } = $0005262392d89a41$var$getListenerEntryPropsFrom(options);
        const entry = $0005262392d89a41$var$find(Array.from(listenerMap.values()), (entry2)=>{
            const matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $0005262392d89a41$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    Object.assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $0005262392d89a41$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $0005262392d89a41$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $0005262392d89a41$var$createDelay(internalTaskController.signal),
                pause: $0005262392d89a41$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $0005262392d89a41$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $0005262392d89a41$var$abortControllerWithReason(controller, $0005262392d89a41$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $0005262392d89a41$var$abortControllerWithReason(internalTaskController, $0005262392d89a41$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $0005262392d89a41$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $0005262392d89a41$export$cb1bdac908fed7f)) $0005262392d89a41$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $0005262392d89a41$var$abortControllerWithReason(internalTaskController, $0005262392d89a41$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $0005262392d89a41$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $b0c9b171c350de9c$export$b956e38827fca970)(action)) return next(action);
                if ($0005262392d89a41$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($0005262392d89a41$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($0005262392d89a41$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $0005262392d89a41$var$INTERNAL_NIL_TOKEN) throw new Error($0005262392d89a41$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $0005262392d89a41$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $0005262392d89a41$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $0005262392d89a41$var$createMiddlewareEntry = (middleware)=>({
        id: $0005262392d89a41$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $0005262392d89a41$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $0005262392d89a41$export$4bb1606a79445586 = ()=>{
    const instanceId = $0005262392d89a41$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($0005262392d89a41$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            let entry = $0005262392d89a41$var$find(Array.from(middlewareMap.values()), (entry2)=>entry2.middleware === middleware2);
            if (!entry) entry = $0005262392d89a41$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$0005262392d89a41$var$emplace(entry.applied, api, {
                insert: ()=>entry.middleware(api)
            }));
        return (0, $b0c9b171c350de9c$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $0005262392d89a41$export$9dd1fb32974da385(withMiddleware, $0005262392d89a41$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $0005262392d89a41$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $0005262392d89a41$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$0005262392d89a41$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $0005262392d89a41$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $0005262392d89a41$var$isStateProxy = (value)=>!!value && !!value[$0005262392d89a41$var$ORIGINAL_STATE];
var $0005262392d89a41$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $0005262392d89a41$var$createStateProxy = (state, reducerMap)=>$0005262392d89a41$var$emplace($0005262392d89a41$var$stateProxyMap, state, {
        insert: ()=>new Proxy(state, {
                get: (target, prop, receiver)=>{
                    if (prop === $0005262392d89a41$var$ORIGINAL_STATE) return target;
                    const result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        const reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            const reducerResult = reducer(void 0, {
                                type: $0005262392d89a41$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($0005262392d89a41$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            })
    });
var $0005262392d89a41$var$original = (state)=>{
    if (!$0005262392d89a41$var$isStateProxy(state)) throw new Error($0005262392d89a41$export$378fa86b259c0280(25));
    return state[$0005262392d89a41$var$ORIGINAL_STATE];
};
var $0005262392d89a41$var$noopReducer = (state = {})=>state;
function $0005262392d89a41$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($0005262392d89a41$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $b0c9b171c350de9c$export$66e4520cdb265d18)(reducerMap) : $0005262392d89a41$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $5671edd534fa79c4$exports;
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($0005262392d89a41$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original: $0005262392d89a41$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $0005262392d89a41$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


const $f9ee2b4ae9fa584a$var$cartSlice = (0, $0005262392d89a41$export$4d8d9bd83c24ae8b)({
    name: "cart",
    initialState: {
        items: []
    },
    reducers: {
        //below fns are the reducer functions which are mapped to corresponding actions. 'state' refers to the current state of the reducer
        // action is an object which contains data into the 'payload' key which is passed during dispatching a function from any component
        addItem: (state, action)=>{
            //mutating the redux state here
            state.items.push(action.payload);
        },
        removeItem: (state, action)=>{
            state.items.pop();
        },
        clearCart: (state, action)=>{
            state.items.length = 0; // []
        // state=[]; // original state won't change by assigning [] to the state.
        // NOTE: in RTK, we either mutate the existing state or return a new state.
        // return {items:[]} // this replaces the original state of the redux
        }
    }
});
const { addItem: $f9ee2b4ae9fa584a$export$fb9705de59d96855, removeItem: $f9ee2b4ae9fa584a$export$fe2d9b4e03920b4c, clearCart: $f9ee2b4ae9fa584a$export$810121176e3e3671 } = $f9ee2b4ae9fa584a$var$cartSlice.actions;
var // 'reducer' is the combination of many small reducer functions like addItem, removeItem, clearCart
$f9ee2b4ae9fa584a$export$2e2bcd8739ae039 = $f9ee2b4ae9fa584a$var$cartSlice.reducer;


const $eb611041b313b99b$var$ItemList = (props)=>{
    const { items: items } = props;
    // console.log("ITEMS----->>>>", items);
    const dispatch = (0, $25d342665550a083$export$8ad76b76a4c905f8)();
    const addItemHandler = (item)=>{
        //Dispatch an action
        dispatch((0, $f9ee2b4ae9fa584a$export$fb9705de59d96855)(item));
    };
    return /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
        children: items.map((item)=>/*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                className: "flex flex-col sm:flex-row justify-between p-3 m-1 sm:m-2 border-gray-200 border-b-2",
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                        className: "w-10/12 m-4",
                        children: [
                            /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                                className: "py-2",
                                children: [
                                    /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                        children: item.card.info.name
                                    }),
                                    /*#__PURE__*/ (0, $5aRSq.jsxs)("span", {
                                        children: [
                                            " ",
                                            "- \u20B9",
                                            item.card.info.price ? item.card.info.price / 100 : item.card.info.defaultPrice / 100
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $5aRSq.jsx)("p", {
                                className: "text-xs hidden md:block",
                                children: item.card.info.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                        className: " flex flex-wrap justify-between relative w-12/12 sm:w-4/12 ml-2",
                        children: [
                            /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                                className: "rounded-lg",
                                src: (0, $1449da937569f1f7$export$31adfacaf07ffe63) + item.card.info.imageId
                            }),
                            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                                className: "absolute bottom-0 right-0 mb-[-10px] mr-[-10px]",
                                children: /*#__PURE__*/ (0, $5aRSq.jsx)("button", {
                                    className: "p-1 m-1 rounded-lg bg-green-500 text-white shadow-lg",
                                    onClick: ()=>addItemHandler(item),
                                    children: "Add +"
                                })
                            })
                        ]
                    })
                ]
            }, item.card.info.id))
    });
};
var $eb611041b313b99b$export$2e2bcd8739ae039 = $eb611041b313b99b$var$ItemList;


const $8e2ebdb1389817d3$var$RestaurantCategory = (props)=>{
    // console.log("Restaurant Category data--->>>",props.data)
    const { data: data, showItems: showItems, setShowIndex: setShowIndex } = props;
    const onClickHandler = ()=>{
        setShowIndex((showItems)=>!showItems);
    };
    return /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
        children: /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
            className: "flex flex-col justify-between w-8/12 bg-gray-100 shadow-lg p-4 mx-auto my-4 cursor-pointer",
            children: [
                /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                    className: "flex flex-row justify-between ",
                    onClick: onClickHandler,
                    children: [
                        /*#__PURE__*/ (0, $5aRSq.jsxs)("span", {
                            className: "font-bold",
                            children: [
                                data?.title,
                                " (",
                                data.itemCards.length,
                                ")"
                            ]
                        }),
                        !showItems ? /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                            children: "\u2B07\uFE0F"
                        }) : /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                            children: "\u2B06\uFE0F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                    className: "flex justify-center",
                    children: showItems && /*#__PURE__*/ (0, $5aRSq.jsx)((0, $eb611041b313b99b$export$2e2bcd8739ae039), {
                        items: data.itemCards
                    })
                })
            ]
        })
    });
};
var $8e2ebdb1389817d3$export$2e2bcd8739ae039 = $8e2ebdb1389817d3$var$RestaurantCategory;


const $89035d1904005ab7$var$RestaurantMenu = ()=>{
    const [showIndex, setShowIndex] = (0, $4Iuzv.useState)(0);
    const { resId: resId } = (0, $175a2504a1bf07a5$export$99eaa27ddbbb95ef)();
    const resInfo = (0, $6a9db8a30167c416$export$30ae66c29c137334)(resId);
    if (resInfo === null) return /*#__PURE__*/ (0, $5aRSq.jsx)((0, $b82d2fd6d6d98fde$export$2e2bcd8739ae039), {});
    const { name: name, cuisines: cuisines, costForTwoMessage: costForTwoMessage } = resInfo?.cards[2]?.card?.card?.info;
    const { itemCards: itemCards } = resInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards[2]?.card?.card;
    // console.log("itemCards--->>>",resInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards)
    const categories = resInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards.filter((c)=>c.card?.card?.["@type"] === "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory");
    return resInfo === null ? /*#__PURE__*/ (0, $5aRSq.jsx)((0, $b82d2fd6d6d98fde$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                className: "flex flex-col items-center",
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
                        className: "font-bold text-2xl py-4",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsxs)("p", {
                        className: "font-bold text-lg",
                        children: [
                            cuisines.join(", "),
                            " - ",
                            costForTwoMessage
                        ]
                    })
                ]
            }),
            categories.map((category, index)=>// Controlled component
                /*#__PURE__*/ (0, $5aRSq.jsx)((0, $8e2ebdb1389817d3$export$2e2bcd8739ae039), {
                    data: category?.card?.card,
                    setShowIndex: ()=>{
                        index === showIndex ? setShowIndex(null) : setShowIndex(index);
                    },
                    showItems: index === showIndex
                }, category?.card?.card?.title))
        ]
    });
};
var $89035d1904005ab7$export$2e2bcd8739ae039 = $89035d1904005ab7$var$RestaurantMenu;






const $4a3d3f82ec7c4964$var$appStore = (0, $0005262392d89a41$export$7d8a5b498da695ac)({
    //'reducer' is the main reducer function for modifying the main redux store
    // cartReducer is responsible for modifying a particular slice of the redux store
    reducer: {
        cart: (0, $f9ee2b4ae9fa584a$export$2e2bcd8739ae039)
    }
});
var $4a3d3f82ec7c4964$export$2e2bcd8739ae039 = $4a3d3f82ec7c4964$var$appStore;



var $5aRSq = parcelRequire("5aRSq");



const $acd6f3583186c4a7$var$Cart = ()=>{
    const cartItems = (0, $25d342665550a083$export$2105062e25df4afe)((store)=>store.cart.items);
    const dispatch = (0, $25d342665550a083$export$8ad76b76a4c905f8)();
    const clearCartHandler = ()=>{
        dispatch((0, $f9ee2b4ae9fa584a$export$810121176e3e3671)());
    };
    return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
        className: "m-5 p-4 text-center",
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
                className: "font-bold text-2xl",
                children: "Cart Page"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                className: "w-8/12 m-auto",
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsx)("button", {
                        className: "m-2 p-1 bg-red-600 text-white rounded-lg",
                        onClick: clearCartHandler,
                        children: "Clear cart"
                    }),
                    cartItems.length === 0 && /*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
                        className: "font-light",
                        children: "Your Cart is empty. Please add items to your cart!!"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)((0, $eb611041b313b99b$export$2e2bcd8739ae039), {
                        items: cartItems
                    })
                ]
            })
        ]
    });
};
var $acd6f3583186c4a7$export$2e2bcd8739ae039 = $acd6f3583186c4a7$var$Cart;



var $5aRSq = parcelRequire("5aRSq");
const $4f481b2edf11cb85$var$Footer = ()=>{
    return /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
        className: "flex justify-center bg-gray-200 p-10 ",
        children: /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
            className: "flex justify-center flex-wrap items-center bottom-0",
            children: [
                /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                    className: "m-5",
                    children: /*#__PURE__*/ (0, $5aRSq.jsx)("b", {
                        children: "For better experience, Download our App now"
                    })
                }),
                /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                    className: "flex flex-wrap",
                    children: [
                        /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                            className: "m-5 h-12",
                            src: "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/portal/m/play_store.png"
                        }),
                        /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                            className: "m-5 h-12",
                            src: "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/portal/m/app_store.png"
                        })
                    ]
                })
            ]
        })
    });
};
var $4f481b2edf11cb85$export$2e2bcd8739ae039 = $4f481b2edf11cb85$var$Footer;



// import Grocery from './components/Grocery';
// Lazy loading for Grocery component
const $fd878d1a2b2f022b$var$Grocery = /*#__PURE__*/ (0, $4Iuzv.lazy)(()=>(parcelRequire("cnbGx")));
const $fd878d1a2b2f022b$var$AppLayout = ()=>{
    const [userName, setUserName] = (0, $4Iuzv.useState)();
    (0, $4Iuzv.useEffect)(()=>{
        //Some authentication code logic
        //Make an API call and send username and password
        const data = {
            name: "Saurabh"
        };
        setUserName(data.name);
    }, []);
    return /*#__PURE__*/ (0, $5aRSq.jsx)((0, $25d342665550a083$export$2881499e37b75b9a), {
        store: (0, $4a3d3f82ec7c4964$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $b302a4cdaf1c8188$export$2e2bcd8739ae039).Provider, {
            value: {
                loggedInUser: userName,
                setUserName: setUserName
            },
            children: /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                className: "bg-white",
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsx)((0, $ca2c91bf6756c02e$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $5aRSq.jsx)((0, $175a2504a1bf07a5$export$910ae8079b2c2852), {}),
                    /*#__PURE__*/ (0, $5aRSq.jsx)((0, $4f481b2edf11cb85$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
};
const $fd878d1a2b2f022b$var$appRouter = (0, $c34e9f2261c19895$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $5aRSq.jsx)($fd878d1a2b2f022b$var$AppLayout, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $58044eda1763adcb$export$2e2bcd8739ae039), {})
            },
            // {
            //     path: "/about",
            //     element: <About/>
            // },
            // {
            //     path: "/contact",
            //     element: <ContactUs/>
            // },
            // {
            //     path: "/grocery",
            //     element:<Suspense fallback={<h1>Loading......</h1>}><Grocery/></Suspense> 
            // },
            {
                path: "/restaurants/:resId",
                element: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $89035d1904005ab7$export$2e2bcd8739ae039), {})
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $acd6f3583186c4a7$export$2e2bcd8739ae039), {})
            }
        ],
        errorElement: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $7e935ac5b2f1db10$export$2e2bcd8739ae039), {})
    }
]);
// Every rendering in React will happen inside root node
const $fd878d1a2b2f022b$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($21fa618cfc67d6ae$exports))).createRoot(document.getElementById("root"));
// While rendering on the browser, the React element object gets converted into html element 
// root.render(jsxHeading);
$fd878d1a2b2f022b$var$root.render(/*#__PURE__*/ (0, $5aRSq.jsx)((0, $c34e9f2261c19895$export$323e4fc2fa4753fb), {
    router: $fd878d1a2b2f022b$var$appRouter
}));


//# sourceMappingURL=index.3e8ad745.js.map
